/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	// CSS requires: just putting them here for now as CSS is going to be
	// refactored soon anyway
	__webpack_require__(151);
	__webpack_require__(148);
	__webpack_require__(149);
	__webpack_require__(150);
	
	var RunModernizrTests = __webpack_require__(179); // this side-effects a global
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(111);
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	sdk.loadSkin(__webpack_require__(153));
	var VectorConferenceHandler = __webpack_require__(91);
	var configJson = __webpack_require__(152);
	var UpdateChecker = __webpack_require__(180);
	
	var qs = __webpack_require__(360);
	
	var lastLocationHashSet = null;
	
	var CallHandler = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/CallHandler\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	CallHandler.setConferenceHandler(VectorConferenceHandler);
	
	function checkBrowserFeatures(featureList) {
	    if (!window.Modernizr) {
	        console.error("Cannot check features - Modernizr global is missing.");
	        return false;
	    }
	    var featureComplete = true;
	    for (var i = 0; i < featureList.length; i++) {
	        if (window.Modernizr[featureList[i]] === undefined) {
	            console.error("Looked for feature '%s' but Modernizr has no results for this. " + "Has it been configured correctly?", featureList[i]);
	            return false;
	        }
	        if (window.Modernizr[featureList[i]] === false) {
	            console.error("Browser missing feature: '%s'", featureList[i]);
	            // toggle flag rather than return early so we log all missing features
	            // rather than just the first.
	            featureComplete = false;
	        }
	    }
	    return featureComplete;
	}
	
	var validBrowser = checkBrowserFeatures(["displaytable", "flexbox", "es5object", "es5function", "localstorage", "objectfit"]);
	
	// We want to support some name / value pairs in the fragment
	// so we're re-using query string like format
	function parseQsFromFragment(location) {
	    var hashparts = location.hash.split('?');
	    if (hashparts.length > 1) {
	        return qs.parse(hashparts[1]);
	    }
	    return {};
	}
	
	function parseQs(location) {
	    return qs.parse(location.search.substring(1));
	}
	
	// Here, we do some crude URL analysis to allow
	// deep-linking. We only support registration
	// deep-links in this example.
	function routeUrl(location) {
	    var params = parseQs(location);
	    var loginToken = params.loginToken;
	    if (loginToken) {
	        window.matrixChat.showScreen('token_login', parseQs(location));
	    } else if (location.hash.indexOf('#/register') == 0) {
	        window.matrixChat.showScreen('register', parseQsFromFragment(location));
	    } else {
	        window.matrixChat.showScreen(location.hash.substring(2));
	    }
	}
	
	function onHashChange(ev) {
	    if (decodeURIComponent(window.location.hash) == lastLocationHashSet) {
	        // we just set this: no need to route it!
	        return;
	    }
	    routeUrl(window.location);
	}
	
	function onVersion(current, latest) {
	    window.matrixChat.onVersion(current, latest);
	}
	
	var loaded = false;
	var lastLoadedScreen = null;
	
	// This will be called whenever the SDK changes screens,
	// so a web page can update the URL bar appropriately.
	var onNewScreen = function onNewScreen(screen) {
	    if (!loaded) {
	        lastLoadedScreen = screen;
	    } else {
	        var hash = '#/' + screen;
	        lastLocationHashSet = hash;
	        window.location.hash = hash;
	        if (ga) ga('send', 'pageview', window.location.pathname + window.location.search + window.location.hash);
	    }
	};
	
	// We use this to work out what URL the SDK should
	// pass through when registering to allow the user to
	// click back to the client having registered.
	// It's up to us to recognise if we're loaded with
	// this URL and tell MatrixClient to resume registration.
	var makeRegistrationUrl = function makeRegistrationUrl() {
	    return window.location.protocol + '//' + window.location.host + window.location.pathname + '#/register';
	};
	
	window.addEventListener('hashchange', onHashChange);
	window.onload = function () {
	    if (!validBrowser) {
	        return;
	    }
	    UpdateChecker.setVersionListener(onVersion);
	    UpdateChecker.run();
	    routeUrl(window.location);
	    loaded = true;
	    if (lastLoadedScreen) {
	        onNewScreen(lastLoadedScreen);
	        lastLoadedScreen = null;
	    }
	};
	
	function loadApp() {
	    if (validBrowser) {
	        var MatrixChat = sdk.getComponent('structures.MatrixChat');
	        window.matrixChat = ReactDOM.render(React.createElement(MatrixChat, {
	            onNewScreen: onNewScreen,
	            registrationUrl: makeRegistrationUrl(),
	            ConferenceHandler: VectorConferenceHandler,
	            config: configJson,
	            startingQueryParams: parseQsFromFragment(window.location),
	            enableGuest: true }), document.getElementById('matrixchat'));
	    } else {
	        console.error("Browser is missing required features.");
	        // take to a different landing page to AWOOOOOGA at the user
	        var CompatibilityPage = sdk.getComponent("structures.CompatibilityPage");
	        window.matrixChat = ReactDOM.render(React.createElement(CompatibilityPage, { onAccept: function () {
	                validBrowser = true;
	                console.log("User accepts the compatibility risks.");
	                loadApp();
	                window.onload(); // still do the same code paths for compatible clients
	            } }), document.getElementById('matrixchat'));
	    }
	}
	
	loadApp();


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(299);


/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(12);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 5 */
/***/ function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module.
	 * @module utils
	 */
	
	/**
	 * Encode a dictionary of query parameters.
	 * @param {Object} params A dict of key/values to encode e.g.
	 * {"foo": "bar", "baz": "taz"}
	 * @return {string} The encoded string e.g. foo=bar&baz=taz
	 */
	module.exports.encodeParams = function(params) {
	    var qs = "";
	    for (var key in params) {
	        if (!params.hasOwnProperty(key)) { continue; }
	        qs += "&" + encodeURIComponent(key) + "=" +
	                encodeURIComponent(params[key]);
	    }
	    return qs.substring(1);
	};
	
	/**
	 * Encodes a URI according to a set of template variables. Variables will be
	 * passed through encodeURIComponent.
	 * @param {string} pathTemplate The path with template variables e.g. '/foo/$bar'.
	 * @param {Object} variables The key/value pairs to replace the template
	 * variables with. E.g. { "$bar": "baz" }.
	 * @return {string} The result of replacing all template variables e.g. '/foo/baz'.
	 */
	module.exports.encodeUri = function(pathTemplate, variables) {
	    for (var key in variables) {
	        if (!variables.hasOwnProperty(key)) { continue; }
	        pathTemplate = pathTemplate.replace(
	            key, encodeURIComponent(variables[key])
	        );
	    }
	    return pathTemplate;
	};
	
	/**
	 * Applies a map function to the given array.
	 * @param {Array} array The array to apply the function to.
	 * @param {Function} fn The function that will be invoked for each element in
	 * the array with the signature <code>fn(element){...}</code>
	 * @return {Array} A new array with the results of the function.
	 */
	module.exports.map = function(array, fn) {
	    var results = new Array(array.length);
	    for (var i = 0; i < array.length; i++) {
	        results[i] = fn(array[i]);
	    }
	    return results;
	};
	
	/**
	 * Applies a filter function to the given array.
	 * @param {Array} array The array to apply the function to.
	 * @param {Function} fn The function that will be invoked for each element in
	 * the array. It should return true to keep the element. The function signature
	 * looks like <code>fn(element, index, array){...}</code>.
	 * @return {Array} A new array with the results of the function.
	 */
	module.exports.filter = function(array, fn) {
	    var results = [];
	    for (var i = 0; i < array.length; i++) {
	        if (fn(array[i], i, array)) {
	            results.push(array[i]);
	        }
	    }
	    return results;
	};
	
	/**
	 * Get the keys for an object. Same as <code>Object.keys()</code>.
	 * @param {Object} obj The object to get the keys for.
	 * @return {string[]} The keys of the object.
	 */
	module.exports.keys = function(obj) {
	    var keys = [];
	    for (var key in obj) {
	        if (!obj.hasOwnProperty(key)) { continue; }
	        keys.push(key);
	    }
	    return keys;
	};
	
	/**
	 * Get the values for an object.
	 * @param {Object} obj The object to get the values for.
	 * @return {Array<*>} The values of the object.
	 */
	module.exports.values = function(obj) {
	    var values = [];
	    for (var key in obj) {
	        if (!obj.hasOwnProperty(key)) { continue; }
	        values.push(obj[key]);
	    }
	    return values;
	};
	
	/**
	 * Invoke a function for each item in the array.
	 * @param {Array} array The array.
	 * @param {Function} fn The function to invoke for each element. Has the
	 * function signature <code>fn(element, index)</code>.
	 */
	module.exports.forEach = function(array, fn) {
	    for (var i = 0; i < array.length; i++) {
	        fn(array[i], i);
	    }
	};
	
	/**
	 * The findElement() method returns a value in the array, if an element in the array
	 * satisfies (returns true) the provided testing function. Otherwise undefined
	 * is returned.
	 * @param {Array} array The array.
	 * @param {Function} fn Function to execute on each value in the array, with the
	 * function signature <code>fn(element, index, array)</code>
	 * @param {boolean} reverse True to search in reverse order.
	 * @return {*} The first value in the array which returns <code>true</code> for
	 * the given function.
	 */
	module.exports.findElement = function(array, fn, reverse) {
	    var i;
	    if (reverse) {
	        for (i = array.length - 1; i >= 0; i--) {
	            if (fn(array[i], i, array)) {
	                return array[i];
	            }
	        }
	    }
	    else {
	        for (i = 0; i < array.length; i++) {
	            if (fn(array[i], i, array)) {
	                return array[i];
	            }
	        }
	    }
	};
	
	/**
	 * The removeElement() method removes the first element in the array that
	 * satisfies (returns true) the provided testing function.
	 * @param {Array} array The array.
	 * @param {Function} fn Function to execute on each value in the array, with the
	 * function signature <code>fn(element, index, array)</code>. Return true to
	 * remove this element and break.
	 * @param {boolean} reverse True to search in reverse order.
	 * @return {boolean} True if an element was removed.
	 */
	module.exports.removeElement = function(array, fn, reverse) {
	    var i;
	    var removed;
	    if (reverse) {
	        for (i = array.length - 1; i >= 0; i--) {
	            if (fn(array[i], i, array)) {
	                removed = array[i];
	                array.splice(i, 1);
	                return removed;
	            }
	        }
	    }
	    else {
	        for (i = 0; i < array.length; i++) {
	            if (fn(array[i], i, array)) {
	                removed = array[i];
	                array.splice(i, 1);
	                return removed;
	            }
	        }
	    }
	    return false;
	};
	
	/**
	 * Checks if the given thing is a function.
	 * @param {*} value The thing to check.
	 * @return {boolean} True if it is a function.
	 */
	module.exports.isFunction = function(value) {
	    return Object.prototype.toString.call(value) == "[object Function]";
	};
	
	/**
	 * Checks if the given thing is an array.
	 * @param {*} value The thing to check.
	 * @return {boolean} True if it is an array.
	 */
	module.exports.isArray = function(value) {
	    return Boolean(value && value.constructor === Array);
	};
	
	/**
	 * Checks that the given object has the specified keys.
	 * @param {Object} obj The object to check.
	 * @param {string[]} keys The list of keys that 'obj' must have.
	 * @throws If the object is missing keys.
	 */
	module.exports.checkObjectHasKeys = function(obj, keys) {
	    for (var i = 0; i < keys.length; i++) {
	        if (!obj.hasOwnProperty(keys[i])) {
	            throw new Error("Missing required key: " + keys[i]);
	        }
	    }
	};
	
	/**
	 * Checks that the given object has no extra keys other than the specified ones.
	 * @param {Object} obj The object to check.
	 * @param {string[]} allowedKeys The list of allowed key names.
	 * @throws If there are extra keys.
	 */
	module.exports.checkObjectHasNoAdditionalKeys = function(obj, allowedKeys) {
	    for (var key in obj) {
	        if (!obj.hasOwnProperty(key)) { continue; }
	        if (allowedKeys.indexOf(key) === -1) {
	            throw new Error("Unknown key: " + key);
	        }
	    }
	};
	
	/**
	 * Deep copy the given object. The object MUST NOT have circular references and
	 * MUST NOT have functions.
	 * @param {Object} obj The object to deep copy.
	 * @return {Object} A copy of the object without any references to the original.
	 */
	module.exports.deepCopy = function(obj) {
	    return JSON.parse(JSON.stringify(obj));
	};
	
	
	/**
	 * Run polyfills to add Array.map and Array.filter if they are missing.
	 */
	module.exports.runPolyfills = function() {
	    //                Array.prototype.filter
	    // ========================================================
	    // SOURCE:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
	    if (!Array.prototype.filter) {
	      Array.prototype.filter = function(fun/*, thisArg*/) {
	
	        if (this === void 0 || this === null) {
	          throw new TypeError();
	        }
	
	        var t = Object(this);
	        var len = t.length >>> 0;
	        if (typeof fun !== 'function') {
	          throw new TypeError();
	        }
	
	        var res = [];
	        var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
	        for (var i = 0; i < len; i++) {
	          if (i in t) {
	            var val = t[i];
	
	            // NOTE: Technically this should Object.defineProperty at
	            //       the next index, as push can be affected by
	            //       properties on Object.prototype and Array.prototype.
	            //       But that method's new, and collisions should be
	            //       rare, so use the more-compatible alternative.
	            if (fun.call(thisArg, val, i, t)) {
	              res.push(val);
	            }
	          }
	        }
	
	        return res;
	      };
	    }
	
	    //                Array.prototype.map
	    // ========================================================
	    // SOURCE:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map
	    // Production steps of ECMA-262, Edition 5, 15.4.4.19
	    // Reference: http://es5.github.io/#x15.4.4.19
	    if (!Array.prototype.map) {
	
	      Array.prototype.map = function(callback, thisArg) {
	
	        var T, A, k;
	
	        if (this === null || this === undefined) {
	          throw new TypeError(' this is null or not defined');
	        }
	
	        // 1. Let O be the result of calling ToObject passing the |this|
	        //    value as the argument.
	        var O = Object(this);
	
	        // 2. Let lenValue be the result of calling the Get internal
	        //    method of O with the argument "length".
	        // 3. Let len be ToUint32(lenValue).
	        var len = O.length >>> 0;
	
	        // 4. If IsCallable(callback) is false, throw a TypeError exception.
	        // See: http://es5.github.com/#x9.11
	        if (typeof callback !== 'function') {
	          throw new TypeError(callback + ' is not a function');
	        }
	
	        // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
	        if (arguments.length > 1) {
	          T = thisArg;
	        }
	
	        // 6. Let A be a new array created as if by the expression new Array(len)
	        //    where Array is the standard built-in constructor with that name and
	        //    len is the value of len.
	        A = new Array(len);
	
	        // 7. Let k be 0
	        k = 0;
	
	        // 8. Repeat, while k < len
	        while (k < len) {
	
	          var kValue, mappedValue;
	
	          // a. Let Pk be ToString(k).
	          //   This is implicit for LHS operands of the in operator
	          // b. Let kPresent be the result of calling the HasProperty internal
	          //    method of O with argument Pk.
	          //   This step can be combined with c
	          // c. If kPresent is true, then
	          if (k in O) {
	
	            // i. Let kValue be the result of calling the Get internal
	            //    method of O with argument Pk.
	            kValue = O[k];
	
	            // ii. Let mappedValue be the result of calling the Call internal
	            //     method of callback with T as the this value and argument
	            //     list containing kValue, k, and O.
	            mappedValue = callback.call(T, kValue, k, O);
	
	            // iii. Call the DefineOwnProperty internal method of A with arguments
	            // Pk, Property Descriptor
	            // { Value: mappedValue,
	            //   Writable: true,
	            //   Enumerable: true,
	            //   Configurable: true },
	            // and false.
	
	            // In browsers that support Object.defineProperty, use the following:
	            // Object.defineProperty(A, k, {
	            //   value: mappedValue,
	            //   writable: true,
	            //   enumerable: true,
	            //   configurable: true
	            // });
	
	            // For best browser support, use the following:
	            A[k] = mappedValue;
	          }
	          // d. Increase k by 1.
	          k++;
	        }
	
	        // 9. return A
	        return A;
	      };
	    }
	
	    //                Array.prototype.forEach
	    // ========================================================
	    // SOURCE:
	  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
	    // Production steps of ECMA-262, Edition 5, 15.4.4.18
	    // Reference: http://es5.github.io/#x15.4.4.18
	    if (!Array.prototype.forEach) {
	
	      Array.prototype.forEach = function(callback, thisArg) {
	
	        var T, k;
	
	        if (this === null || this === undefined) {
	          throw new TypeError(' this is null or not defined');
	        }
	
	        // 1. Let O be the result of calling ToObject passing the |this| value as the
	        // argument.
	        var O = Object(this);
	
	        // 2. Let lenValue be the result of calling the Get internal method of O with the
	        // argument "length".
	        // 3. Let len be ToUint32(lenValue).
	        var len = O.length >>> 0;
	
	        // 4. If IsCallable(callback) is false, throw a TypeError exception.
	        // See: http://es5.github.com/#x9.11
	        if (typeof callback !== "function") {
	          throw new TypeError(callback + ' is not a function');
	        }
	
	        // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
	        if (arguments.length > 1) {
	          T = thisArg;
	        }
	
	        // 6. Let k be 0
	        k = 0;
	
	        // 7. Repeat, while k < len
	        while (k < len) {
	
	          var kValue;
	
	          // a. Let Pk be ToString(k).
	          //   This is implicit for LHS operands of the in operator
	          // b. Let kPresent be the result of calling the HasProperty internal
	          //    method of O with
	          //    argument Pk.
	          //   This step can be combined with c
	          // c. If kPresent is true, then
	          if (k in O) {
	
	            // i. Let kValue be the result of calling the Get internal method of O with
	            // argument Pk
	            kValue = O[k];
	
	            // ii. Call the Call internal method of callback with T as the this value and
	            // argument list containing kValue, k, and O.
	            callback.call(T, kValue, k, O);
	          }
	          // d. Increase k by 1.
	          k++;
	        }
	        // 8. return undefined
	      };
	    }
	};
	
	/**
	 * Inherit the prototype methods from one constructor into another. This is a
	 * port of the Node.js implementation with an Object.create polyfill.
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	module.exports.inherits = function(ctor, superCtor) {
	    // Add Object.create polyfill for IE8
	    // Source:
	    // https://developer.mozilla.org/en-US/docs/Web/JavaScript
	    // /Reference/Global_Objects/Object/create#Polyfill
	    if (typeof Object.create != 'function') {
	      // Production steps of ECMA-262, Edition 5, 15.2.3.5
	      // Reference: http://es5.github.io/#x15.2.3.5
	      Object.create = (function() {
	        // To save on memory, use a shared constructor
	        function Temp() {}
	
	        // make a safe reference to Object.prototype.hasOwnProperty
	        var hasOwn = Object.prototype.hasOwnProperty;
	
	        return function(O) {
	          // 1. If Type(O) is not Object or Null throw a TypeError exception.
	          if (typeof O != 'object') {
	            throw new TypeError('Object prototype may only be an Object or null');
	          }
	
	          // 2. Let obj be the result of creating a new object as if by the
	          //    expression new Object() where Object is the standard built-in
	          //    constructor with that name
	          // 3. Set the [[Prototype]] internal property of obj to O.
	          Temp.prototype = O;
	          var obj = new Temp();
	          Temp.prototype = null; // Let's not keep a stray reference to O...
	
	          // 4. If the argument Properties is present and not undefined, add
	          //    own properties to obj as if by calling the standard built-in
	          //    function Object.defineProperties with arguments obj and
	          //    Properties.
	          if (arguments.length > 1) {
	            // Object.defineProperties does ToObject on its first argument.
	            var Properties = Object(arguments[1]);
	            for (var prop in Properties) {
	              if (hasOwn.call(Properties, prop)) {
	                obj[prop] = Properties[prop];
	              }
	            }
	          }
	
	          // 5. Return obj
	          return obj;
	        };
	      })();
	    }
	    // END polyfill
	
	    // Add util.inherits from Node.js
	    // Source:
	    // https://github.com/joyent/node/blob/master/lib/util.js
	    // Copyright Joyent, Inc. and other Node contributors.
	    //
	    // Permission is hereby granted, free of charge, to any person obtaining a
	    // copy of this software and associated documentation files (the
	    // "Software"), to deal in the Software without restriction, including
	    // without limitation the rights to use, copy, modify, merge, publish,
	    // distribute, sublicense, and/or sell copies of the Software, and to permit
	    // persons to whom the Software is furnished to do so, subject to the
	    // following conditions:
	    //
	    // The above copyright notice and this permission notice shall be included
	    // in all copies or substantial portions of the Software.
	    //
	    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	    // USE OR OTHER DEALINGS IN THE SOFTWARE.
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	        constructor: {
	            value: ctor,
	            enumerable: false,
	            writable: true,
	            configurable: true
	        }
	    });
	};


/***/ },
/* 6 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	var ReactBrowserEventEmitter = __webpack_require__(48);
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactDOMFeatureFlags = __webpack_require__(119);
	var ReactElement = __webpack_require__(9);
	var ReactEmptyComponentRegistry = __webpack_require__(126);
	var ReactInstanceHandles = __webpack_require__(26);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactMarkupChecksum = __webpack_require__(129);
	var ReactPerf = __webpack_require__(10);
	var ReactReconciler = __webpack_require__(19);
	var ReactUpdateQueue = __webpack_require__(77);
	var ReactUpdates = __webpack_require__(11);
	
	var assign = __webpack_require__(3);
	var emptyObject = __webpack_require__(33);
	var containsNode = __webpack_require__(141);
	var instantiateReactComponent = __webpack_require__(84);
	var invariant = __webpack_require__(1);
	var setInnerHTML = __webpack_require__(55);
	var shouldUpdateReactComponent = __webpack_require__(87);
	var validateDOMNesting = __webpack_require__(89);
	var warning = __webpack_require__(4);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(14);
	
	var assign = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(53);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(71);
	var PooledClass = __webpack_require__(16);
	var ReactPerf = __webpack_require__(10);
	var ReactReconciler = __webpack_require__(19);
	var Transaction = __webpack_require__(52);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 12 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(56);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 15 */
/***/ function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * This is an internal module. See {@link MatrixEvent} and {@link RoomEvent} for
	 * the public classes.
	 * @module models/event
	 */
	
	
	/**
	 * Enum for event statuses.
	 * @readonly
	 * @enum {string}
	 */
	module.exports.EventStatus = {
	    /** The event was not sent and will no longer be retried. */
	    NOT_SENT: "not_sent",
	    /** The event is in the process of being sent. */
	    SENDING: "sending",
	    /** The event is in a queue waiting to be sent. */
	    QUEUED: "queued"
	};
	
	/**
	 * Construct a Matrix Event object
	 * @constructor
	 * @param {Object} event The raw event to be wrapped in this DAO
	 * @param {boolean} encrypted Was the event encrypted
	 * @prop {Object} event The raw event. <b>Do not access this property</b>
	 * directly unless you absolutely have to. Prefer the getter methods defined on
	 * this class. Using the getter methods shields your app from
	 * changes to event JSON between Matrix versions.
	 * @prop {RoomMember} sender The room member who sent this event, or null e.g.
	 * this is a presence event.
	 * @prop {RoomMember} target The room member who is the target of this event, e.g.
	 * the invitee, the person being banned, etc.
	 * @prop {EventStatus} status The sending status of the event.
	 * @prop {boolean} forwardLooking True if this event is 'forward looking', meaning
	 * that getDirectionalContent() will return event.content and not event.prev_content.
	 * Default: true. <strong>This property is experimental and may change.</strong>
	 */
	module.exports.MatrixEvent = function MatrixEvent(event, encrypted) {
	    this.event = event || {};
	    this.sender = null;
	    this.target = null;
	    this.status = null;
	    this.forwardLooking = true;
	    this.encrypted = Boolean(encrypted);
	};
	module.exports.MatrixEvent.prototype = {
	
	    /**
	     * Get the event_id for this event.
	     * @return {string} The event ID, e.g. <code>$143350589368169JsLZx:localhost
	     * </code>
	     */
	    getId: function() {
	        return this.event.event_id;
	    },
	
	    /**
	     * Get the user_id for this event.
	     * @return {string} The user ID, e.g. <code>@alice:matrix.org</code>
	     */
	    getSender: function() {
	        return this.event.sender || this.event.user_id; // v2 / v1
	    },
	
	    /**
	     * Get the type of event.
	     * @return {string} The event type, e.g. <code>m.room.message</code>
	     */
	    getType: function() {
	        return this.event.type;
	    },
	
	    /**
	     * Get the type of the event that will be sent to the homeserver.
	     * @return {string} The event type.
	     */
	    getWireType: function() {
	        return this.encryptedType || this.event.type;
	    },
	
	    /**
	     * Get the room_id for this event. This will return <code>undefined</code>
	     * for <code>m.presence</code> events.
	     * @return {string} The room ID, e.g. <code>!cURbafjkfsMDVwdRDQ:matrix.org
	     * </code>
	     */
	    getRoomId: function() {
	        return this.event.room_id;
	    },
	
	    /**
	     * Get the timestamp of this event.
	     * @return {Number} The event timestamp, e.g. <code>1433502692297</code>
	     */
	    getTs: function() {
	        return this.event.origin_server_ts;
	    },
	
	    /**
	     * Get the event content JSON.
	     * @return {Object} The event content JSON, or an empty object.
	     */
	    getContent: function() {
	        return this.event.content || {};
	    },
	
	    /**
	     * Get the event content JSON that will be sent to the homeserver.
	     * @return {Object} The event content JSON, or an empty object.
	     */
	    getWireContent: function() {
	        return this.encryptedContent || this.event.content || {};
	    },
	
	    /**
	     * Get the previous event content JSON. This will only return something for
	     * state events which exist in the timeline.
	     * @return {Object} The previous event content JSON, or an empty object.
	     */
	    getPrevContent: function() {
	        // v2 then v1 then default
	        return this.getUnsigned().prev_content || this.event.prev_content || {};
	    },
	
	    /**
	     * Get either 'content' or 'prev_content' depending on if this event is
	     * 'forward-looking' or not. This can be modified via event.forwardLooking.
	     * <strong>This method is experimental and may change.</strong>
	     * @return {Object} event.content if this event is forward-looking, else
	     * event.prev_content.
	     */
	    getDirectionalContent: function() {
	        return this.forwardLooking ? this.getContent() : this.getPrevContent();
	    },
	
	    /**
	     * Get the age of this event. This represents the age of the event when the
	     * event arrived at the device, and not the age of the event when this
	     * function was called.
	     * @return {Number} The age of this event in milliseconds.
	     */
	    getAge: function() {
	        return this.getUnsigned().age || this.event.age; // v2 / v1
	    },
	
	    /**
	     * Get the event state_key if it has one. This will return <code>undefined
	     * </code> for message events.
	     * @return {string} The event's <code>state_key</code>.
	     */
	    getStateKey: function() {
	        return this.event.state_key;
	    },
	
	    /**
	     * Check if this event is a state event.
	     * @return {boolean} True if this is a state event.
	     */
	    isState: function() {
	        return this.event.state_key !== undefined;
	    },
	
	    /**
	     * Check if the event is encrypted.
	     * @return {boolean} True if this event is encrypted.
	     */
	    isEncrypted: function() {
	        return this.encrypted;
	    },
	
	    getUnsigned: function() {
	        return this.event.unsigned || {};
	    }
	};


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate) {// vim:ts=4:sts=4:sw=4:
	/*!
	 *
	 * Copyright 2009-2012 Kris Kowal under the terms of the MIT
	 * license found at http://github.com/kriskowal/q/raw/master/LICENSE
	 *
	 * With parts by Tyler Close
	 * Copyright 2007-2009 Tyler Close under the terms of the MIT X license found
	 * at http://www.opensource.org/licenses/mit-license.html
	 * Forked at ref_send.js version: 2009-05-11
	 *
	 * With parts by Mark Miller
	 * Copyright (C) 2011 Google Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 */
	
	(function (definition) {
	    "use strict";
	
	    // This file will function properly as a <script> tag, or a module
	    // using CommonJS and NodeJS or RequireJS module formats.  In
	    // Common/Node/RequireJS, the module exports the Q API and when
	    // executed as a simple <script>, it creates a Q global instead.
	
	    // Montage Require
	    if (typeof bootstrap === "function") {
	        bootstrap("promise", definition);
	
	    // CommonJS
	    } else if (true) {
	        module.exports = definition();
	
	    // RequireJS
	    } else if (typeof define === "function" && define.amd) {
	        define(definition);
	
	    // SES (Secure EcmaScript)
	    } else if (typeof ses !== "undefined") {
	        if (!ses.ok()) {
	            return;
	        } else {
	            ses.makeQ = definition;
	        }
	
	    // <script>
	    } else if (typeof window !== "undefined" || typeof self !== "undefined") {
	        // Prefer window over self for add-on scripts. Use self for
	        // non-windowed contexts.
	        var global = typeof window !== "undefined" ? window : self;
	
	        // Get the `window` object, save the previous Q global
	        // and initialize Q as a global.
	        var previousQ = global.Q;
	        global.Q = definition();
	
	        // Add a noConflict function so Q can be removed from the
	        // global namespace.
	        global.Q.noConflict = function () {
	            global.Q = previousQ;
	            return this;
	        };
	
	    } else {
	        throw new Error("This environment was not anticipated by Q. Please file a bug.");
	    }
	
	})(function () {
	"use strict";
	
	var hasStacks = false;
	try {
	    throw new Error();
	} catch (e) {
	    hasStacks = !!e.stack;
	}
	
	// All code after this point will be filtered from stack traces reported
	// by Q.
	var qStartingLine = captureLine();
	var qFileName;
	
	// shims
	
	// used for fallback in "allResolved"
	var noop = function () {};
	
	// Use the fastest possible means to execute a task in a future turn
	// of the event loop.
	var nextTick =(function () {
	    // linked list of tasks (single, with head node)
	    var head = {task: void 0, next: null};
	    var tail = head;
	    var flushing = false;
	    var requestTick = void 0;
	    var isNodeJS = false;
	    // queue for late tasks, used by unhandled rejection tracking
	    var laterQueue = [];
	
	    function flush() {
	        /* jshint loopfunc: true */
	        var task, domain;
	
	        while (head.next) {
	            head = head.next;
	            task = head.task;
	            head.task = void 0;
	            domain = head.domain;
	
	            if (domain) {
	                head.domain = void 0;
	                domain.enter();
	            }
	            runSingle(task, domain);
	
	        }
	        while (laterQueue.length) {
	            task = laterQueue.pop();
	            runSingle(task);
	        }
	        flushing = false;
	    }
	    // runs a single function in the async queue
	    function runSingle(task, domain) {
	        try {
	            task();
	
	        } catch (e) {
	            if (isNodeJS) {
	                // In node, uncaught exceptions are considered fatal errors.
	                // Re-throw them synchronously to interrupt flushing!
	
	                // Ensure continuation if the uncaught exception is suppressed
	                // listening "uncaughtException" events (as domains does).
	                // Continue in next event to avoid tick recursion.
	                if (domain) {
	                    domain.exit();
	                }
	                setTimeout(flush, 0);
	                if (domain) {
	                    domain.enter();
	                }
	
	                throw e;
	
	            } else {
	                // In browsers, uncaught exceptions are not fatal.
	                // Re-throw them asynchronously to avoid slow-downs.
	                setTimeout(function () {
	                    throw e;
	                }, 0);
	            }
	        }
	
	        if (domain) {
	            domain.exit();
	        }
	    }
	
	    nextTick = function (task) {
	        tail = tail.next = {
	            task: task,
	            domain: isNodeJS && process.domain,
	            next: null
	        };
	
	        if (!flushing) {
	            flushing = true;
	            requestTick();
	        }
	    };
	
	    if (typeof process === "object" &&
	        process.toString() === "[object process]" && process.nextTick) {
	        // Ensure Q is in a real Node environment, with a `process.nextTick`.
	        // To see through fake Node environments:
	        // * Mocha test runner - exposes a `process` global without a `nextTick`
	        // * Browserify - exposes a `process.nexTick` function that uses
	        //   `setTimeout`. In this case `setImmediate` is preferred because
	        //    it is faster. Browserify's `process.toString()` yields
	        //   "[object Object]", while in a real Node environment
	        //   `process.nextTick()` yields "[object process]".
	        isNodeJS = true;
	
	        requestTick = function () {
	            process.nextTick(flush);
	        };
	
	    } else if (typeof setImmediate === "function") {
	        // In IE10, Node.js 0.9+, or https://github.com/NobleJS/setImmediate
	        if (typeof window !== "undefined") {
	            requestTick = setImmediate.bind(window, flush);
	        } else {
	            requestTick = function () {
	                setImmediate(flush);
	            };
	        }
	
	    } else if (typeof MessageChannel !== "undefined") {
	        // modern browsers
	        // http://www.nonblocking.io/2011/06/windownexttick.html
	        var channel = new MessageChannel();
	        // At least Safari Version 6.0.5 (8536.30.1) intermittently cannot create
	        // working message ports the first time a page loads.
	        channel.port1.onmessage = function () {
	            requestTick = requestPortTick;
	            channel.port1.onmessage = flush;
	            flush();
	        };
	        var requestPortTick = function () {
	            // Opera requires us to provide a message payload, regardless of
	            // whether we use it.
	            channel.port2.postMessage(0);
	        };
	        requestTick = function () {
	            setTimeout(flush, 0);
	            requestPortTick();
	        };
	
	    } else {
	        // old browsers
	        requestTick = function () {
	            setTimeout(flush, 0);
	        };
	    }
	    // runs a task after all other tasks have been run
	    // this is useful for unhandled rejection tracking that needs to happen
	    // after all `then`d tasks have been run.
	    nextTick.runAfter = function (task) {
	        laterQueue.push(task);
	        if (!flushing) {
	            flushing = true;
	            requestTick();
	        }
	    };
	    return nextTick;
	})();
	
	// Attempt to make generics safe in the face of downstream
	// modifications.
	// There is no situation where this is necessary.
	// If you need a security guarantee, these primordials need to be
	// deeply frozen anyway, and if you don’t need a security guarantee,
	// this is just plain paranoid.
	// However, this **might** have the nice side-effect of reducing the size of
	// the minified code by reducing x.call() to merely x()
	// See Mark Miller’s explanation of what this does.
	// http://wiki.ecmascript.org/doku.php?id=conventions:safe_meta_programming
	var call = Function.call;
	function uncurryThis(f) {
	    return function () {
	        return call.apply(f, arguments);
	    };
	}
	// This is equivalent, but slower:
	// uncurryThis = Function_bind.bind(Function_bind.call);
	// http://jsperf.com/uncurrythis
	
	var array_slice = uncurryThis(Array.prototype.slice);
	
	var array_reduce = uncurryThis(
	    Array.prototype.reduce || function (callback, basis) {
	        var index = 0,
	            length = this.length;
	        // concerning the initial value, if one is not provided
	        if (arguments.length === 1) {
	            // seek to the first value in the array, accounting
	            // for the possibility that is is a sparse array
	            do {
	                if (index in this) {
	                    basis = this[index++];
	                    break;
	                }
	                if (++index >= length) {
	                    throw new TypeError();
	                }
	            } while (1);
	        }
	        // reduce
	        for (; index < length; index++) {
	            // account for the possibility that the array is sparse
	            if (index in this) {
	                basis = callback(basis, this[index], index);
	            }
	        }
	        return basis;
	    }
	);
	
	var array_indexOf = uncurryThis(
	    Array.prototype.indexOf || function (value) {
	        // not a very good shim, but good enough for our one use of it
	        for (var i = 0; i < this.length; i++) {
	            if (this[i] === value) {
	                return i;
	            }
	        }
	        return -1;
	    }
	);
	
	var array_map = uncurryThis(
	    Array.prototype.map || function (callback, thisp) {
	        var self = this;
	        var collect = [];
	        array_reduce(self, function (undefined, value, index) {
	            collect.push(callback.call(thisp, value, index, self));
	        }, void 0);
	        return collect;
	    }
	);
	
	var object_create = Object.create || function (prototype) {
	    function Type() { }
	    Type.prototype = prototype;
	    return new Type();
	};
	
	var object_hasOwnProperty = uncurryThis(Object.prototype.hasOwnProperty);
	
	var object_keys = Object.keys || function (object) {
	    var keys = [];
	    for (var key in object) {
	        if (object_hasOwnProperty(object, key)) {
	            keys.push(key);
	        }
	    }
	    return keys;
	};
	
	var object_toString = uncurryThis(Object.prototype.toString);
	
	function isObject(value) {
	    return value === Object(value);
	}
	
	// generator related shims
	
	// FIXME: Remove this function once ES6 generators are in SpiderMonkey.
	function isStopIteration(exception) {
	    return (
	        object_toString(exception) === "[object StopIteration]" ||
	        exception instanceof QReturnValue
	    );
	}
	
	// FIXME: Remove this helper and Q.return once ES6 generators are in
	// SpiderMonkey.
	var QReturnValue;
	if (typeof ReturnValue !== "undefined") {
	    QReturnValue = ReturnValue;
	} else {
	    QReturnValue = function (value) {
	        this.value = value;
	    };
	}
	
	// long stack traces
	
	var STACK_JUMP_SEPARATOR = "From previous event:";
	
	function makeStackTraceLong(error, promise) {
	    // If possible, transform the error stack trace by removing Node and Q
	    // cruft, then concatenating with the stack trace of `promise`. See #57.
	    if (hasStacks &&
	        promise.stack &&
	        typeof error === "object" &&
	        error !== null &&
	        error.stack &&
	        error.stack.indexOf(STACK_JUMP_SEPARATOR) === -1
	    ) {
	        var stacks = [];
	        for (var p = promise; !!p; p = p.source) {
	            if (p.stack) {
	                stacks.unshift(p.stack);
	            }
	        }
	        stacks.unshift(error.stack);
	
	        var concatedStacks = stacks.join("\n" + STACK_JUMP_SEPARATOR + "\n");
	        error.stack = filterStackString(concatedStacks);
	    }
	}
	
	function filterStackString(stackString) {
	    var lines = stackString.split("\n");
	    var desiredLines = [];
	    for (var i = 0; i < lines.length; ++i) {
	        var line = lines[i];
	
	        if (!isInternalFrame(line) && !isNodeFrame(line) && line) {
	            desiredLines.push(line);
	        }
	    }
	    return desiredLines.join("\n");
	}
	
	function isNodeFrame(stackLine) {
	    return stackLine.indexOf("(module.js:") !== -1 ||
	           stackLine.indexOf("(node.js:") !== -1;
	}
	
	function getFileNameAndLineNumber(stackLine) {
	    // Named functions: "at functionName (filename:lineNumber:columnNumber)"
	    // In IE10 function name can have spaces ("Anonymous function") O_o
	    var attempt1 = /at .+ \((.+):(\d+):(?:\d+)\)$/.exec(stackLine);
	    if (attempt1) {
	        return [attempt1[1], Number(attempt1[2])];
	    }
	
	    // Anonymous functions: "at filename:lineNumber:columnNumber"
	    var attempt2 = /at ([^ ]+):(\d+):(?:\d+)$/.exec(stackLine);
	    if (attempt2) {
	        return [attempt2[1], Number(attempt2[2])];
	    }
	
	    // Firefox style: "function@filename:lineNumber or @filename:lineNumber"
	    var attempt3 = /.*@(.+):(\d+)$/.exec(stackLine);
	    if (attempt3) {
	        return [attempt3[1], Number(attempt3[2])];
	    }
	}
	
	function isInternalFrame(stackLine) {
	    var fileNameAndLineNumber = getFileNameAndLineNumber(stackLine);
	
	    if (!fileNameAndLineNumber) {
	        return false;
	    }
	
	    var fileName = fileNameAndLineNumber[0];
	    var lineNumber = fileNameAndLineNumber[1];
	
	    return fileName === qFileName &&
	        lineNumber >= qStartingLine &&
	        lineNumber <= qEndingLine;
	}
	
	// discover own file name and line number range for filtering stack
	// traces
	function captureLine() {
	    if (!hasStacks) {
	        return;
	    }
	
	    try {
	        throw new Error();
	    } catch (e) {
	        var lines = e.stack.split("\n");
	        var firstLine = lines[0].indexOf("@") > 0 ? lines[1] : lines[2];
	        var fileNameAndLineNumber = getFileNameAndLineNumber(firstLine);
	        if (!fileNameAndLineNumber) {
	            return;
	        }
	
	        qFileName = fileNameAndLineNumber[0];
	        return fileNameAndLineNumber[1];
	    }
	}
	
	function deprecate(callback, name, alternative) {
	    return function () {
	        if (typeof console !== "undefined" &&
	            typeof console.warn === "function") {
	            console.warn(name + " is deprecated, use " + alternative +
	                         " instead.", new Error("").stack);
	        }
	        return callback.apply(callback, arguments);
	    };
	}
	
	// end of shims
	// beginning of real work
	
	/**
	 * Constructs a promise for an immediate reference, passes promises through, or
	 * coerces promises from different systems.
	 * @param value immediate reference or promise
	 */
	function Q(value) {
	    // If the object is already a Promise, return it directly.  This enables
	    // the resolve function to both be used to created references from objects,
	    // but to tolerably coerce non-promises to promises.
	    if (value instanceof Promise) {
	        return value;
	    }
	
	    // assimilate thenables
	    if (isPromiseAlike(value)) {
	        return coerce(value);
	    } else {
	        return fulfill(value);
	    }
	}
	Q.resolve = Q;
	
	/**
	 * Performs a task in a future turn of the event loop.
	 * @param {Function} task
	 */
	Q.nextTick = nextTick;
	
	/**
	 * Controls whether or not long stack traces will be on
	 */
	Q.longStackSupport = false;
	
	// enable long stacks if Q_DEBUG is set
	if (typeof process === "object" && process && ({"NODE_ENV":"production"}) && ({"NODE_ENV":"production"}).Q_DEBUG) {
	    Q.longStackSupport = true;
	}
	
	/**
	 * Constructs a {promise, resolve, reject} object.
	 *
	 * `resolve` is a callback to invoke with a more resolved value for the
	 * promise. To fulfill the promise, invoke `resolve` with any value that is
	 * not a thenable. To reject the promise, invoke `resolve` with a rejected
	 * thenable, or invoke `reject` with the reason directly. To resolve the
	 * promise to another thenable, thus putting it in the same state, invoke
	 * `resolve` with that other thenable.
	 */
	Q.defer = defer;
	function defer() {
	    // if "messages" is an "Array", that indicates that the promise has not yet
	    // been resolved.  If it is "undefined", it has been resolved.  Each
	    // element of the messages array is itself an array of complete arguments to
	    // forward to the resolved promise.  We coerce the resolution value to a
	    // promise using the `resolve` function because it handles both fully
	    // non-thenable values and other thenables gracefully.
	    var messages = [], progressListeners = [], resolvedPromise;
	
	    var deferred = object_create(defer.prototype);
	    var promise = object_create(Promise.prototype);
	
	    promise.promiseDispatch = function (resolve, op, operands) {
	        var args = array_slice(arguments);
	        if (messages) {
	            messages.push(args);
	            if (op === "when" && operands[1]) { // progress operand
	                progressListeners.push(operands[1]);
	            }
	        } else {
	            Q.nextTick(function () {
	                resolvedPromise.promiseDispatch.apply(resolvedPromise, args);
	            });
	        }
	    };
	
	    // XXX deprecated
	    promise.valueOf = function () {
	        if (messages) {
	            return promise;
	        }
	        var nearerValue = nearer(resolvedPromise);
	        if (isPromise(nearerValue)) {
	            resolvedPromise = nearerValue; // shorten chain
	        }
	        return nearerValue;
	    };
	
	    promise.inspect = function () {
	        if (!resolvedPromise) {
	            return { state: "pending" };
	        }
	        return resolvedPromise.inspect();
	    };
	
	    if (Q.longStackSupport && hasStacks) {
	        try {
	            throw new Error();
	        } catch (e) {
	            // NOTE: don't try to use `Error.captureStackTrace` or transfer the
	            // accessor around; that causes memory leaks as per GH-111. Just
	            // reify the stack trace as a string ASAP.
	            //
	            // At the same time, cut off the first line; it's always just
	            // "[object Promise]\n", as per the `toString`.
	            promise.stack = e.stack.substring(e.stack.indexOf("\n") + 1);
	        }
	    }
	
	    // NOTE: we do the checks for `resolvedPromise` in each method, instead of
	    // consolidating them into `become`, since otherwise we'd create new
	    // promises with the lines `become(whatever(value))`. See e.g. GH-252.
	
	    function become(newPromise) {
	        resolvedPromise = newPromise;
	        promise.source = newPromise;
	
	        array_reduce(messages, function (undefined, message) {
	            Q.nextTick(function () {
	                newPromise.promiseDispatch.apply(newPromise, message);
	            });
	        }, void 0);
	
	        messages = void 0;
	        progressListeners = void 0;
	    }
	
	    deferred.promise = promise;
	    deferred.resolve = function (value) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        become(Q(value));
	    };
	
	    deferred.fulfill = function (value) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        become(fulfill(value));
	    };
	    deferred.reject = function (reason) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        become(reject(reason));
	    };
	    deferred.notify = function (progress) {
	        if (resolvedPromise) {
	            return;
	        }
	
	        array_reduce(progressListeners, function (undefined, progressListener) {
	            Q.nextTick(function () {
	                progressListener(progress);
	            });
	        }, void 0);
	    };
	
	    return deferred;
	}
	
	/**
	 * Creates a Node-style callback that will resolve or reject the deferred
	 * promise.
	 * @returns a nodeback
	 */
	defer.prototype.makeNodeResolver = function () {
	    var self = this;
	    return function (error, value) {
	        if (error) {
	            self.reject(error);
	        } else if (arguments.length > 2) {
	            self.resolve(array_slice(arguments, 1));
	        } else {
	            self.resolve(value);
	        }
	    };
	};
	
	/**
	 * @param resolver {Function} a function that returns nothing and accepts
	 * the resolve, reject, and notify functions for a deferred.
	 * @returns a promise that may be resolved with the given resolve and reject
	 * functions, or rejected by a thrown exception in resolver
	 */
	Q.Promise = promise; // ES6
	Q.promise = promise;
	function promise(resolver) {
	    if (typeof resolver !== "function") {
	        throw new TypeError("resolver must be a function.");
	    }
	    var deferred = defer();
	    try {
	        resolver(deferred.resolve, deferred.reject, deferred.notify);
	    } catch (reason) {
	        deferred.reject(reason);
	    }
	    return deferred.promise;
	}
	
	promise.race = race; // ES6
	promise.all = all; // ES6
	promise.reject = reject; // ES6
	promise.resolve = Q; // ES6
	
	// XXX experimental.  This method is a way to denote that a local value is
	// serializable and should be immediately dispatched to a remote upon request,
	// instead of passing a reference.
	Q.passByCopy = function (object) {
	    //freeze(object);
	    //passByCopies.set(object, true);
	    return object;
	};
	
	Promise.prototype.passByCopy = function () {
	    //freeze(object);
	    //passByCopies.set(object, true);
	    return this;
	};
	
	/**
	 * If two promises eventually fulfill to the same value, promises that value,
	 * but otherwise rejects.
	 * @param x {Any*}
	 * @param y {Any*}
	 * @returns {Any*} a promise for x and y if they are the same, but a rejection
	 * otherwise.
	 *
	 */
	Q.join = function (x, y) {
	    return Q(x).join(y);
	};
	
	Promise.prototype.join = function (that) {
	    return Q([this, that]).spread(function (x, y) {
	        if (x === y) {
	            // TODO: "===" should be Object.is or equiv
	            return x;
	        } else {
	            throw new Error("Can't join: not the same: " + x + " " + y);
	        }
	    });
	};
	
	/**
	 * Returns a promise for the first of an array of promises to become settled.
	 * @param answers {Array[Any*]} promises to race
	 * @returns {Any*} the first promise to be settled
	 */
	Q.race = race;
	function race(answerPs) {
	    return promise(function (resolve, reject) {
	        // Switch to this once we can assume at least ES5
	        // answerPs.forEach(function (answerP) {
	        //     Q(answerP).then(resolve, reject);
	        // });
	        // Use this in the meantime
	        for (var i = 0, len = answerPs.length; i < len; i++) {
	            Q(answerPs[i]).then(resolve, reject);
	        }
	    });
	}
	
	Promise.prototype.race = function () {
	    return this.then(Q.race);
	};
	
	/**
	 * Constructs a Promise with a promise descriptor object and optional fallback
	 * function.  The descriptor contains methods like when(rejected), get(name),
	 * set(name, value), post(name, args), and delete(name), which all
	 * return either a value, a promise for a value, or a rejection.  The fallback
	 * accepts the operation name, a resolver, and any further arguments that would
	 * have been forwarded to the appropriate method above had a method been
	 * provided with the proper name.  The API makes no guarantees about the nature
	 * of the returned object, apart from that it is usable whereever promises are
	 * bought and sold.
	 */
	Q.makePromise = Promise;
	function Promise(descriptor, fallback, inspect) {
	    if (fallback === void 0) {
	        fallback = function (op) {
	            return reject(new Error(
	                "Promise does not support operation: " + op
	            ));
	        };
	    }
	    if (inspect === void 0) {
	        inspect = function () {
	            return {state: "unknown"};
	        };
	    }
	
	    var promise = object_create(Promise.prototype);
	
	    promise.promiseDispatch = function (resolve, op, args) {
	        var result;
	        try {
	            if (descriptor[op]) {
	                result = descriptor[op].apply(promise, args);
	            } else {
	                result = fallback.call(promise, op, args);
	            }
	        } catch (exception) {
	            result = reject(exception);
	        }
	        if (resolve) {
	            resolve(result);
	        }
	    };
	
	    promise.inspect = inspect;
	
	    // XXX deprecated `valueOf` and `exception` support
	    if (inspect) {
	        var inspected = inspect();
	        if (inspected.state === "rejected") {
	            promise.exception = inspected.reason;
	        }
	
	        promise.valueOf = function () {
	            var inspected = inspect();
	            if (inspected.state === "pending" ||
	                inspected.state === "rejected") {
	                return promise;
	            }
	            return inspected.value;
	        };
	    }
	
	    return promise;
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.then = function (fulfilled, rejected, progressed) {
	    var self = this;
	    var deferred = defer();
	    var done = false;   // ensure the untrusted promise makes at most a
	                        // single call to one of the callbacks
	
	    function _fulfilled(value) {
	        try {
	            return typeof fulfilled === "function" ? fulfilled(value) : value;
	        } catch (exception) {
	            return reject(exception);
	        }
	    }
	
	    function _rejected(exception) {
	        if (typeof rejected === "function") {
	            makeStackTraceLong(exception, self);
	            try {
	                return rejected(exception);
	            } catch (newException) {
	                return reject(newException);
	            }
	        }
	        return reject(exception);
	    }
	
	    function _progressed(value) {
	        return typeof progressed === "function" ? progressed(value) : value;
	    }
	
	    Q.nextTick(function () {
	        self.promiseDispatch(function (value) {
	            if (done) {
	                return;
	            }
	            done = true;
	
	            deferred.resolve(_fulfilled(value));
	        }, "when", [function (exception) {
	            if (done) {
	                return;
	            }
	            done = true;
	
	            deferred.resolve(_rejected(exception));
	        }]);
	    });
	
	    // Progress propagator need to be attached in the current tick.
	    self.promiseDispatch(void 0, "when", [void 0, function (value) {
	        var newValue;
	        var threw = false;
	        try {
	            newValue = _progressed(value);
	        } catch (e) {
	            threw = true;
	            if (Q.onerror) {
	                Q.onerror(e);
	            } else {
	                throw e;
	            }
	        }
	
	        if (!threw) {
	            deferred.notify(newValue);
	        }
	    }]);
	
	    return deferred.promise;
	};
	
	Q.tap = function (promise, callback) {
	    return Q(promise).tap(callback);
	};
	
	/**
	 * Works almost like "finally", but not called for rejections.
	 * Original resolution value is passed through callback unaffected.
	 * Callback may return a promise that will be awaited for.
	 * @param {Function} callback
	 * @returns {Q.Promise}
	 * @example
	 * doSomething()
	 *   .then(...)
	 *   .tap(console.log)
	 *   .then(...);
	 */
	Promise.prototype.tap = function (callback) {
	    callback = Q(callback);
	
	    return this.then(function (value) {
	        return callback.fcall(value).thenResolve(value);
	    });
	};
	
	/**
	 * Registers an observer on a promise.
	 *
	 * Guarantees:
	 *
	 * 1. that fulfilled and rejected will be called only once.
	 * 2. that either the fulfilled callback or the rejected callback will be
	 *    called, but not both.
	 * 3. that fulfilled and rejected will not be called in this turn.
	 *
	 * @param value      promise or immediate reference to observe
	 * @param fulfilled  function to be called with the fulfilled value
	 * @param rejected   function to be called with the rejection exception
	 * @param progressed function to be called on any progress notifications
	 * @return promise for the return value from the invoked callback
	 */
	Q.when = when;
	function when(value, fulfilled, rejected, progressed) {
	    return Q(value).then(fulfilled, rejected, progressed);
	}
	
	Promise.prototype.thenResolve = function (value) {
	    return this.then(function () { return value; });
	};
	
	Q.thenResolve = function (promise, value) {
	    return Q(promise).thenResolve(value);
	};
	
	Promise.prototype.thenReject = function (reason) {
	    return this.then(function () { throw reason; });
	};
	
	Q.thenReject = function (promise, reason) {
	    return Q(promise).thenReject(reason);
	};
	
	/**
	 * If an object is not a promise, it is as "near" as possible.
	 * If a promise is rejected, it is as "near" as possible too.
	 * If it’s a fulfilled promise, the fulfillment value is nearer.
	 * If it’s a deferred promise and the deferred has been resolved, the
	 * resolution is "nearer".
	 * @param object
	 * @returns most resolved (nearest) form of the object
	 */
	
	// XXX should we re-do this?
	Q.nearer = nearer;
	function nearer(value) {
	    if (isPromise(value)) {
	        var inspected = value.inspect();
	        if (inspected.state === "fulfilled") {
	            return inspected.value;
	        }
	    }
	    return value;
	}
	
	/**
	 * @returns whether the given object is a promise.
	 * Otherwise it is a fulfilled value.
	 */
	Q.isPromise = isPromise;
	function isPromise(object) {
	    return object instanceof Promise;
	}
	
	Q.isPromiseAlike = isPromiseAlike;
	function isPromiseAlike(object) {
	    return isObject(object) && typeof object.then === "function";
	}
	
	/**
	 * @returns whether the given object is a pending promise, meaning not
	 * fulfilled or rejected.
	 */
	Q.isPending = isPending;
	function isPending(object) {
	    return isPromise(object) && object.inspect().state === "pending";
	}
	
	Promise.prototype.isPending = function () {
	    return this.inspect().state === "pending";
	};
	
	/**
	 * @returns whether the given object is a value or fulfilled
	 * promise.
	 */
	Q.isFulfilled = isFulfilled;
	function isFulfilled(object) {
	    return !isPromise(object) || object.inspect().state === "fulfilled";
	}
	
	Promise.prototype.isFulfilled = function () {
	    return this.inspect().state === "fulfilled";
	};
	
	/**
	 * @returns whether the given object is a rejected promise.
	 */
	Q.isRejected = isRejected;
	function isRejected(object) {
	    return isPromise(object) && object.inspect().state === "rejected";
	}
	
	Promise.prototype.isRejected = function () {
	    return this.inspect().state === "rejected";
	};
	
	//// BEGIN UNHANDLED REJECTION TRACKING
	
	// This promise library consumes exceptions thrown in handlers so they can be
	// handled by a subsequent promise.  The exceptions get added to this array when
	// they are created, and removed when they are handled.  Note that in ES6 or
	// shimmed environments, this would naturally be a `Set`.
	var unhandledReasons = [];
	var unhandledRejections = [];
	var reportedUnhandledRejections = [];
	var trackUnhandledRejections = true;
	
	function resetUnhandledRejections() {
	    unhandledReasons.length = 0;
	    unhandledRejections.length = 0;
	
	    if (!trackUnhandledRejections) {
	        trackUnhandledRejections = true;
	    }
	}
	
	function trackRejection(promise, reason) {
	    if (!trackUnhandledRejections) {
	        return;
	    }
	    if (typeof process === "object" && typeof process.emit === "function") {
	        Q.nextTick.runAfter(function () {
	            if (array_indexOf(unhandledRejections, promise) !== -1) {
	                process.emit("unhandledRejection", reason, promise);
	                reportedUnhandledRejections.push(promise);
	            }
	        });
	    }
	
	    unhandledRejections.push(promise);
	    if (reason && typeof reason.stack !== "undefined") {
	        unhandledReasons.push(reason.stack);
	    } else {
	        unhandledReasons.push("(no stack) " + reason);
	    }
	}
	
	function untrackRejection(promise) {
	    if (!trackUnhandledRejections) {
	        return;
	    }
	
	    var at = array_indexOf(unhandledRejections, promise);
	    if (at !== -1) {
	        if (typeof process === "object" && typeof process.emit === "function") {
	            Q.nextTick.runAfter(function () {
	                var atReport = array_indexOf(reportedUnhandledRejections, promise);
	                if (atReport !== -1) {
	                    process.emit("rejectionHandled", unhandledReasons[at], promise);
	                    reportedUnhandledRejections.splice(atReport, 1);
	                }
	            });
	        }
	        unhandledRejections.splice(at, 1);
	        unhandledReasons.splice(at, 1);
	    }
	}
	
	Q.resetUnhandledRejections = resetUnhandledRejections;
	
	Q.getUnhandledReasons = function () {
	    // Make a copy so that consumers can't interfere with our internal state.
	    return unhandledReasons.slice();
	};
	
	Q.stopUnhandledRejectionTracking = function () {
	    resetUnhandledRejections();
	    trackUnhandledRejections = false;
	};
	
	resetUnhandledRejections();
	
	//// END UNHANDLED REJECTION TRACKING
	
	/**
	 * Constructs a rejected promise.
	 * @param reason value describing the failure
	 */
	Q.reject = reject;
	function reject(reason) {
	    var rejection = Promise({
	        "when": function (rejected) {
	            // note that the error has been handled
	            if (rejected) {
	                untrackRejection(this);
	            }
	            return rejected ? rejected(reason) : this;
	        }
	    }, function fallback() {
	        return this;
	    }, function inspect() {
	        return { state: "rejected", reason: reason };
	    });
	
	    // Note that the reason has not been handled.
	    trackRejection(rejection, reason);
	
	    return rejection;
	}
	
	/**
	 * Constructs a fulfilled promise for an immediate reference.
	 * @param value immediate reference
	 */
	Q.fulfill = fulfill;
	function fulfill(value) {
	    return Promise({
	        "when": function () {
	            return value;
	        },
	        "get": function (name) {
	            return value[name];
	        },
	        "set": function (name, rhs) {
	            value[name] = rhs;
	        },
	        "delete": function (name) {
	            delete value[name];
	        },
	        "post": function (name, args) {
	            // Mark Miller proposes that post with no name should apply a
	            // promised function.
	            if (name === null || name === void 0) {
	                return value.apply(void 0, args);
	            } else {
	                return value[name].apply(value, args);
	            }
	        },
	        "apply": function (thisp, args) {
	            return value.apply(thisp, args);
	        },
	        "keys": function () {
	            return object_keys(value);
	        }
	    }, void 0, function inspect() {
	        return { state: "fulfilled", value: value };
	    });
	}
	
	/**
	 * Converts thenables to Q promises.
	 * @param promise thenable promise
	 * @returns a Q promise
	 */
	function coerce(promise) {
	    var deferred = defer();
	    Q.nextTick(function () {
	        try {
	            promise.then(deferred.resolve, deferred.reject, deferred.notify);
	        } catch (exception) {
	            deferred.reject(exception);
	        }
	    });
	    return deferred.promise;
	}
	
	/**
	 * Annotates an object such that it will never be
	 * transferred away from this process over any promise
	 * communication channel.
	 * @param object
	 * @returns promise a wrapping of that object that
	 * additionally responds to the "isDef" message
	 * without a rejection.
	 */
	Q.master = master;
	function master(object) {
	    return Promise({
	        "isDef": function () {}
	    }, function fallback(op, args) {
	        return dispatch(object, op, args);
	    }, function () {
	        return Q(object).inspect();
	    });
	}
	
	/**
	 * Spreads the values of a promised array of arguments into the
	 * fulfillment callback.
	 * @param fulfilled callback that receives variadic arguments from the
	 * promised array
	 * @param rejected callback that receives the exception if the promise
	 * is rejected.
	 * @returns a promise for the return value or thrown exception of
	 * either callback.
	 */
	Q.spread = spread;
	function spread(value, fulfilled, rejected) {
	    return Q(value).spread(fulfilled, rejected);
	}
	
	Promise.prototype.spread = function (fulfilled, rejected) {
	    return this.all().then(function (array) {
	        return fulfilled.apply(void 0, array);
	    }, rejected);
	};
	
	/**
	 * The async function is a decorator for generator functions, turning
	 * them into asynchronous generators.  Although generators are only part
	 * of the newest ECMAScript 6 drafts, this code does not cause syntax
	 * errors in older engines.  This code should continue to work and will
	 * in fact improve over time as the language improves.
	 *
	 * ES6 generators are currently part of V8 version 3.19 with the
	 * --harmony-generators runtime flag enabled.  SpiderMonkey has had them
	 * for longer, but under an older Python-inspired form.  This function
	 * works on both kinds of generators.
	 *
	 * Decorates a generator function such that:
	 *  - it may yield promises
	 *  - execution will continue when that promise is fulfilled
	 *  - the value of the yield expression will be the fulfilled value
	 *  - it returns a promise for the return value (when the generator
	 *    stops iterating)
	 *  - the decorated function returns a promise for the return value
	 *    of the generator or the first rejected promise among those
	 *    yielded.
	 *  - if an error is thrown in the generator, it propagates through
	 *    every following yield until it is caught, or until it escapes
	 *    the generator function altogether, and is translated into a
	 *    rejection for the promise returned by the decorated generator.
	 */
	Q.async = async;
	function async(makeGenerator) {
	    return function () {
	        // when verb is "send", arg is a value
	        // when verb is "throw", arg is an exception
	        function continuer(verb, arg) {
	            var result;
	
	            // Until V8 3.19 / Chromium 29 is released, SpiderMonkey is the only
	            // engine that has a deployed base of browsers that support generators.
	            // However, SM's generators use the Python-inspired semantics of
	            // outdated ES6 drafts.  We would like to support ES6, but we'd also
	            // like to make it possible to use generators in deployed browsers, so
	            // we also support Python-style generators.  At some point we can remove
	            // this block.
	
	            if (typeof StopIteration === "undefined") {
	                // ES6 Generators
	                try {
	                    result = generator[verb](arg);
	                } catch (exception) {
	                    return reject(exception);
	                }
	                if (result.done) {
	                    return Q(result.value);
	                } else {
	                    return when(result.value, callback, errback);
	                }
	            } else {
	                // SpiderMonkey Generators
	                // FIXME: Remove this case when SM does ES6 generators.
	                try {
	                    result = generator[verb](arg);
	                } catch (exception) {
	                    if (isStopIteration(exception)) {
	                        return Q(exception.value);
	                    } else {
	                        return reject(exception);
	                    }
	                }
	                return when(result, callback, errback);
	            }
	        }
	        var generator = makeGenerator.apply(this, arguments);
	        var callback = continuer.bind(continuer, "next");
	        var errback = continuer.bind(continuer, "throw");
	        return callback();
	    };
	}
	
	/**
	 * The spawn function is a small wrapper around async that immediately
	 * calls the generator and also ends the promise chain, so that any
	 * unhandled errors are thrown instead of forwarded to the error
	 * handler. This is useful because it's extremely common to run
	 * generators at the top-level to work with libraries.
	 */
	Q.spawn = spawn;
	function spawn(makeGenerator) {
	    Q.done(Q.async(makeGenerator)());
	}
	
	// FIXME: Remove this interface once ES6 generators are in SpiderMonkey.
	/**
	 * Throws a ReturnValue exception to stop an asynchronous generator.
	 *
	 * This interface is a stop-gap measure to support generator return
	 * values in older Firefox/SpiderMonkey.  In browsers that support ES6
	 * generators like Chromium 29, just use "return" in your generator
	 * functions.
	 *
	 * @param value the return value for the surrounding generator
	 * @throws ReturnValue exception with the value.
	 * @example
	 * // ES6 style
	 * Q.async(function* () {
	 *      var foo = yield getFooPromise();
	 *      var bar = yield getBarPromise();
	 *      return foo + bar;
	 * })
	 * // Older SpiderMonkey style
	 * Q.async(function () {
	 *      var foo = yield getFooPromise();
	 *      var bar = yield getBarPromise();
	 *      Q.return(foo + bar);
	 * })
	 */
	Q["return"] = _return;
	function _return(value) {
	    throw new QReturnValue(value);
	}
	
	/**
	 * The promised function decorator ensures that any promise arguments
	 * are settled and passed as values (`this` is also settled and passed
	 * as a value).  It will also ensure that the result of a function is
	 * always a promise.
	 *
	 * @example
	 * var add = Q.promised(function (a, b) {
	 *     return a + b;
	 * });
	 * add(Q(a), Q(B));
	 *
	 * @param {function} callback The function to decorate
	 * @returns {function} a function that has been decorated.
	 */
	Q.promised = promised;
	function promised(callback) {
	    return function () {
	        return spread([this, all(arguments)], function (self, args) {
	            return callback.apply(self, args);
	        });
	    };
	}
	
	/**
	 * sends a message to a value in a future turn
	 * @param object* the recipient
	 * @param op the name of the message operation, e.g., "when",
	 * @param args further arguments to be forwarded to the operation
	 * @returns result {Promise} a promise for the result of the operation
	 */
	Q.dispatch = dispatch;
	function dispatch(object, op, args) {
	    return Q(object).dispatch(op, args);
	}
	
	Promise.prototype.dispatch = function (op, args) {
	    var self = this;
	    var deferred = defer();
	    Q.nextTick(function () {
	        self.promiseDispatch(deferred.resolve, op, args);
	    });
	    return deferred.promise;
	};
	
	/**
	 * Gets the value of a property in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of property to get
	 * @return promise for the property value
	 */
	Q.get = function (object, key) {
	    return Q(object).dispatch("get", [key]);
	};
	
	Promise.prototype.get = function (key) {
	    return this.dispatch("get", [key]);
	};
	
	/**
	 * Sets the value of a property in a future turn.
	 * @param object    promise or immediate reference for object object
	 * @param name      name of property to set
	 * @param value     new value of property
	 * @return promise for the return value
	 */
	Q.set = function (object, key, value) {
	    return Q(object).dispatch("set", [key, value]);
	};
	
	Promise.prototype.set = function (key, value) {
	    return this.dispatch("set", [key, value]);
	};
	
	/**
	 * Deletes a property in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of property to delete
	 * @return promise for the return value
	 */
	Q.del = // XXX legacy
	Q["delete"] = function (object, key) {
	    return Q(object).dispatch("delete", [key]);
	};
	
	Promise.prototype.del = // XXX legacy
	Promise.prototype["delete"] = function (key) {
	    return this.dispatch("delete", [key]);
	};
	
	/**
	 * Invokes a method in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of method to invoke
	 * @param value     a value to post, typically an array of
	 *                  invocation arguments for promises that
	 *                  are ultimately backed with `resolve` values,
	 *                  as opposed to those backed with URLs
	 *                  wherein the posted value can be any
	 *                  JSON serializable object.
	 * @return promise for the return value
	 */
	// bound locally because it is used by other methods
	Q.mapply = // XXX As proposed by "Redsandro"
	Q.post = function (object, name, args) {
	    return Q(object).dispatch("post", [name, args]);
	};
	
	Promise.prototype.mapply = // XXX As proposed by "Redsandro"
	Promise.prototype.post = function (name, args) {
	    return this.dispatch("post", [name, args]);
	};
	
	/**
	 * Invokes a method in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @param name      name of method to invoke
	 * @param ...args   array of invocation arguments
	 * @return promise for the return value
	 */
	Q.send = // XXX Mark Miller's proposed parlance
	Q.mcall = // XXX As proposed by "Redsandro"
	Q.invoke = function (object, name /*...args*/) {
	    return Q(object).dispatch("post", [name, array_slice(arguments, 2)]);
	};
	
	Promise.prototype.send = // XXX Mark Miller's proposed parlance
	Promise.prototype.mcall = // XXX As proposed by "Redsandro"
	Promise.prototype.invoke = function (name /*...args*/) {
	    return this.dispatch("post", [name, array_slice(arguments, 1)]);
	};
	
	/**
	 * Applies the promised function in a future turn.
	 * @param object    promise or immediate reference for target function
	 * @param args      array of application arguments
	 */
	Q.fapply = function (object, args) {
	    return Q(object).dispatch("apply", [void 0, args]);
	};
	
	Promise.prototype.fapply = function (args) {
	    return this.dispatch("apply", [void 0, args]);
	};
	
	/**
	 * Calls the promised function in a future turn.
	 * @param object    promise or immediate reference for target function
	 * @param ...args   array of application arguments
	 */
	Q["try"] =
	Q.fcall = function (object /* ...args*/) {
	    return Q(object).dispatch("apply", [void 0, array_slice(arguments, 1)]);
	};
	
	Promise.prototype.fcall = function (/*...args*/) {
	    return this.dispatch("apply", [void 0, array_slice(arguments)]);
	};
	
	/**
	 * Binds the promised function, transforming return values into a fulfilled
	 * promise and thrown errors into a rejected one.
	 * @param object    promise or immediate reference for target function
	 * @param ...args   array of application arguments
	 */
	Q.fbind = function (object /*...args*/) {
	    var promise = Q(object);
	    var args = array_slice(arguments, 1);
	    return function fbound() {
	        return promise.dispatch("apply", [
	            this,
	            args.concat(array_slice(arguments))
	        ]);
	    };
	};
	Promise.prototype.fbind = function (/*...args*/) {
	    var promise = this;
	    var args = array_slice(arguments);
	    return function fbound() {
	        return promise.dispatch("apply", [
	            this,
	            args.concat(array_slice(arguments))
	        ]);
	    };
	};
	
	/**
	 * Requests the names of the owned properties of a promised
	 * object in a future turn.
	 * @param object    promise or immediate reference for target object
	 * @return promise for the keys of the eventually settled object
	 */
	Q.keys = function (object) {
	    return Q(object).dispatch("keys", []);
	};
	
	Promise.prototype.keys = function () {
	    return this.dispatch("keys", []);
	};
	
	/**
	 * Turns an array of promises into a promise for an array.  If any of
	 * the promises gets rejected, the whole array is rejected immediately.
	 * @param {Array*} an array (or promise for an array) of values (or
	 * promises for values)
	 * @returns a promise for an array of the corresponding values
	 */
	// By Mark Miller
	// http://wiki.ecmascript.org/doku.php?id=strawman:concurrency&rev=1308776521#allfulfilled
	Q.all = all;
	function all(promises) {
	    return when(promises, function (promises) {
	        var pendingCount = 0;
	        var deferred = defer();
	        array_reduce(promises, function (undefined, promise, index) {
	            var snapshot;
	            if (
	                isPromise(promise) &&
	                (snapshot = promise.inspect()).state === "fulfilled"
	            ) {
	                promises[index] = snapshot.value;
	            } else {
	                ++pendingCount;
	                when(
	                    promise,
	                    function (value) {
	                        promises[index] = value;
	                        if (--pendingCount === 0) {
	                            deferred.resolve(promises);
	                        }
	                    },
	                    deferred.reject,
	                    function (progress) {
	                        deferred.notify({ index: index, value: progress });
	                    }
	                );
	            }
	        }, void 0);
	        if (pendingCount === 0) {
	            deferred.resolve(promises);
	        }
	        return deferred.promise;
	    });
	}
	
	Promise.prototype.all = function () {
	    return all(this);
	};
	
	/**
	 * Returns the first resolved promise of an array. Prior rejected promises are
	 * ignored.  Rejects only if all promises are rejected.
	 * @param {Array*} an array containing values or promises for values
	 * @returns a promise fulfilled with the value of the first resolved promise,
	 * or a rejected promise if all promises are rejected.
	 */
	Q.any = any;
	
	function any(promises) {
	    if (promises.length === 0) {
	        return Q.resolve();
	    }
	
	    var deferred = Q.defer();
	    var pendingCount = 0;
	    array_reduce(promises, function (prev, current, index) {
	        var promise = promises[index];
	
	        pendingCount++;
	
	        when(promise, onFulfilled, onRejected, onProgress);
	        function onFulfilled(result) {
	            deferred.resolve(result);
	        }
	        function onRejected() {
	            pendingCount--;
	            if (pendingCount === 0) {
	                deferred.reject(new Error(
	                    "Can't get fulfillment value from any promise, all " +
	                    "promises were rejected."
	                ));
	            }
	        }
	        function onProgress(progress) {
	            deferred.notify({
	                index: index,
	                value: progress
	            });
	        }
	    }, undefined);
	
	    return deferred.promise;
	}
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	/**
	 * Waits for all promises to be settled, either fulfilled or
	 * rejected.  This is distinct from `all` since that would stop
	 * waiting at the first rejection.  The promise returned by
	 * `allResolved` will never be rejected.
	 * @param promises a promise for an array (or an array) of promises
	 * (or values)
	 * @return a promise for an array of promises
	 */
	Q.allResolved = deprecate(allResolved, "allResolved", "allSettled");
	function allResolved(promises) {
	    return when(promises, function (promises) {
	        promises = array_map(promises, Q);
	        return when(all(array_map(promises, function (promise) {
	            return when(promise, noop, noop);
	        })), function () {
	            return promises;
	        });
	    });
	}
	
	Promise.prototype.allResolved = function () {
	    return allResolved(this);
	};
	
	/**
	 * @see Promise#allSettled
	 */
	Q.allSettled = allSettled;
	function allSettled(promises) {
	    return Q(promises).allSettled();
	}
	
	/**
	 * Turns an array of promises into a promise for an array of their states (as
	 * returned by `inspect`) when they have all settled.
	 * @param {Array[Any*]} values an array (or promise for an array) of values (or
	 * promises for values)
	 * @returns {Array[State]} an array of states for the respective values.
	 */
	Promise.prototype.allSettled = function () {
	    return this.then(function (promises) {
	        return all(array_map(promises, function (promise) {
	            promise = Q(promise);
	            function regardless() {
	                return promise.inspect();
	            }
	            return promise.then(regardless, regardless);
	        }));
	    });
	};
	
	/**
	 * Captures the failure of a promise, giving an oportunity to recover
	 * with a callback.  If the given promise is fulfilled, the returned
	 * promise is fulfilled.
	 * @param {Any*} promise for something
	 * @param {Function} callback to fulfill the returned promise if the
	 * given promise is rejected
	 * @returns a promise for the return value of the callback
	 */
	Q.fail = // XXX legacy
	Q["catch"] = function (object, rejected) {
	    return Q(object).then(void 0, rejected);
	};
	
	Promise.prototype.fail = // XXX legacy
	Promise.prototype["catch"] = function (rejected) {
	    return this.then(void 0, rejected);
	};
	
	/**
	 * Attaches a listener that can respond to progress notifications from a
	 * promise's originating deferred. This listener receives the exact arguments
	 * passed to ``deferred.notify``.
	 * @param {Any*} promise for something
	 * @param {Function} callback to receive any progress notifications
	 * @returns the given promise, unchanged
	 */
	Q.progress = progress;
	function progress(object, progressed) {
	    return Q(object).then(void 0, void 0, progressed);
	}
	
	Promise.prototype.progress = function (progressed) {
	    return this.then(void 0, void 0, progressed);
	};
	
	/**
	 * Provides an opportunity to observe the settling of a promise,
	 * regardless of whether the promise is fulfilled or rejected.  Forwards
	 * the resolution to the returned promise when the callback is done.
	 * The callback can return a promise to defer completion.
	 * @param {Any*} promise
	 * @param {Function} callback to observe the resolution of the given
	 * promise, takes no arguments.
	 * @returns a promise for the resolution of the given promise when
	 * ``fin`` is done.
	 */
	Q.fin = // XXX legacy
	Q["finally"] = function (object, callback) {
	    return Q(object)["finally"](callback);
	};
	
	Promise.prototype.fin = // XXX legacy
	Promise.prototype["finally"] = function (callback) {
	    callback = Q(callback);
	    return this.then(function (value) {
	        return callback.fcall().then(function () {
	            return value;
	        });
	    }, function (reason) {
	        // TODO attempt to recycle the rejection with "this".
	        return callback.fcall().then(function () {
	            throw reason;
	        });
	    });
	};
	
	/**
	 * Terminates a chain of promises, forcing rejections to be
	 * thrown as exceptions.
	 * @param {Any*} promise at the end of a chain of promises
	 * @returns nothing
	 */
	Q.done = function (object, fulfilled, rejected, progress) {
	    return Q(object).done(fulfilled, rejected, progress);
	};
	
	Promise.prototype.done = function (fulfilled, rejected, progress) {
	    var onUnhandledError = function (error) {
	        // forward to a future turn so that ``when``
	        // does not catch it and turn it into a rejection.
	        Q.nextTick(function () {
	            makeStackTraceLong(error, promise);
	            if (Q.onerror) {
	                Q.onerror(error);
	            } else {
	                throw error;
	            }
	        });
	    };
	
	    // Avoid unnecessary `nextTick`ing via an unnecessary `when`.
	    var promise = fulfilled || rejected || progress ?
	        this.then(fulfilled, rejected, progress) :
	        this;
	
	    if (typeof process === "object" && process && process.domain) {
	        onUnhandledError = process.domain.bind(onUnhandledError);
	    }
	
	    promise.then(void 0, onUnhandledError);
	};
	
	/**
	 * Causes a promise to be rejected if it does not get fulfilled before
	 * some milliseconds time out.
	 * @param {Any*} promise
	 * @param {Number} milliseconds timeout
	 * @param {Any*} custom error message or Error object (optional)
	 * @returns a promise for the resolution of the given promise if it is
	 * fulfilled before the timeout, otherwise rejected.
	 */
	Q.timeout = function (object, ms, error) {
	    return Q(object).timeout(ms, error);
	};
	
	Promise.prototype.timeout = function (ms, error) {
	    var deferred = defer();
	    var timeoutId = setTimeout(function () {
	        if (!error || "string" === typeof error) {
	            error = new Error(error || "Timed out after " + ms + " ms");
	            error.code = "ETIMEDOUT";
	        }
	        deferred.reject(error);
	    }, ms);
	
	    this.then(function (value) {
	        clearTimeout(timeoutId);
	        deferred.resolve(value);
	    }, function (exception) {
	        clearTimeout(timeoutId);
	        deferred.reject(exception);
	    }, deferred.notify);
	
	    return deferred.promise;
	};
	
	/**
	 * Returns a promise for the given value (or promised value), some
	 * milliseconds after it resolved. Passes rejections immediately.
	 * @param {Any*} promise
	 * @param {Number} milliseconds
	 * @returns a promise for the resolution of the given promise after milliseconds
	 * time has elapsed since the resolution of the given promise.
	 * If the given promise rejects, that is passed immediately.
	 */
	Q.delay = function (object, timeout) {
	    if (timeout === void 0) {
	        timeout = object;
	        object = void 0;
	    }
	    return Q(object).delay(timeout);
	};
	
	Promise.prototype.delay = function (timeout) {
	    return this.then(function (value) {
	        var deferred = defer();
	        setTimeout(function () {
	            deferred.resolve(value);
	        }, timeout);
	        return deferred.promise;
	    });
	};
	
	/**
	 * Passes a continuation to a Node function, which is called with the given
	 * arguments provided as an array, and returns a promise.
	 *
	 *      Q.nfapply(FS.readFile, [__filename])
	 *      .then(function (content) {
	 *      })
	 *
	 */
	Q.nfapply = function (callback, args) {
	    return Q(callback).nfapply(args);
	};
	
	Promise.prototype.nfapply = function (args) {
	    var deferred = defer();
	    var nodeArgs = array_slice(args);
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.fapply(nodeArgs).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * Passes a continuation to a Node function, which is called with the given
	 * arguments provided individually, and returns a promise.
	 * @example
	 * Q.nfcall(FS.readFile, __filename)
	 * .then(function (content) {
	 * })
	 *
	 */
	Q.nfcall = function (callback /*...args*/) {
	    var args = array_slice(arguments, 1);
	    return Q(callback).nfapply(args);
	};
	
	Promise.prototype.nfcall = function (/*...args*/) {
	    var nodeArgs = array_slice(arguments);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.fapply(nodeArgs).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * Wraps a NodeJS continuation passing function and returns an equivalent
	 * version that returns a promise.
	 * @example
	 * Q.nfbind(FS.readFile, __filename)("utf-8")
	 * .then(console.log)
	 * .done()
	 */
	Q.nfbind =
	Q.denodeify = function (callback /*...args*/) {
	    var baseArgs = array_slice(arguments, 1);
	    return function () {
	        var nodeArgs = baseArgs.concat(array_slice(arguments));
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        Q(callback).fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	};
	
	Promise.prototype.nfbind =
	Promise.prototype.denodeify = function (/*...args*/) {
	    var args = array_slice(arguments);
	    args.unshift(this);
	    return Q.denodeify.apply(void 0, args);
	};
	
	Q.nbind = function (callback, thisp /*...args*/) {
	    var baseArgs = array_slice(arguments, 2);
	    return function () {
	        var nodeArgs = baseArgs.concat(array_slice(arguments));
	        var deferred = defer();
	        nodeArgs.push(deferred.makeNodeResolver());
	        function bound() {
	            return callback.apply(thisp, arguments);
	        }
	        Q(bound).fapply(nodeArgs).fail(deferred.reject);
	        return deferred.promise;
	    };
	};
	
	Promise.prototype.nbind = function (/*thisp, ...args*/) {
	    var args = array_slice(arguments, 0);
	    args.unshift(this);
	    return Q.nbind.apply(void 0, args);
	};
	
	/**
	 * Calls a method of a Node-style object that accepts a Node-style
	 * callback with a given array of arguments, plus a provided callback.
	 * @param object an object that has the named method
	 * @param {String} name name of the method of object
	 * @param {Array} args arguments to pass to the method; the callback
	 * will be provided by Q and appended to these arguments.
	 * @returns a promise for the value or error
	 */
	Q.nmapply = // XXX As proposed by "Redsandro"
	Q.npost = function (object, name, args) {
	    return Q(object).npost(name, args);
	};
	
	Promise.prototype.nmapply = // XXX As proposed by "Redsandro"
	Promise.prototype.npost = function (name, args) {
	    var nodeArgs = array_slice(args || []);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * Calls a method of a Node-style object that accepts a Node-style
	 * callback, forwarding the given variadic arguments, plus a provided
	 * callback argument.
	 * @param object an object that has the named method
	 * @param {String} name name of the method of object
	 * @param ...args arguments to pass to the method; the callback will
	 * be provided by Q and appended to these arguments.
	 * @returns a promise for the value or error
	 */
	Q.nsend = // XXX Based on Mark Miller's proposed "send"
	Q.nmcall = // XXX Based on "Redsandro's" proposal
	Q.ninvoke = function (object, name /*...args*/) {
	    var nodeArgs = array_slice(arguments, 2);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    Q(object).dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};
	
	Promise.prototype.nsend = // XXX Based on Mark Miller's proposed "send"
	Promise.prototype.nmcall = // XXX Based on "Redsandro's" proposal
	Promise.prototype.ninvoke = function (name /*...args*/) {
	    var nodeArgs = array_slice(arguments, 1);
	    var deferred = defer();
	    nodeArgs.push(deferred.makeNodeResolver());
	    this.dispatch("post", [name, nodeArgs]).fail(deferred.reject);
	    return deferred.promise;
	};
	
	/**
	 * If a function would like to support both Node continuation-passing-style and
	 * promise-returning-style, it can end its internal promise chain with
	 * `nodeify(nodeback)`, forwarding the optional nodeback argument.  If the user
	 * elects to use a nodeback, the result will be sent there.  If they do not
	 * pass a nodeback, they will receive the result promise.
	 * @param object a result (or a promise for a result)
	 * @param {Function} nodeback a Node.js-style callback
	 * @returns either the promise or nothing
	 */
	Q.nodeify = nodeify;
	function nodeify(object, nodeback) {
	    return Q(object).nodeify(nodeback);
	}
	
	Promise.prototype.nodeify = function (nodeback) {
	    if (nodeback) {
	        this.then(function (value) {
	            Q.nextTick(function () {
	                nodeback(null, value);
	            });
	        }, function (error) {
	            Q.nextTick(function () {
	                nodeback(error);
	            });
	        });
	    } else {
	        return this;
	    }
	};
	
	Q.noConflict = function() {
	    throw new Error("Q.noConflict only works when Q is used as a global");
	};
	
	// All code before this point will be filtered from stack traces.
	var qEndingLine = captureLine();
	
	return Q;
	
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(147), __webpack_require__(90).setImmediate))

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(318);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(16);
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(12);
	var warning = __webpack_require__(4);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(69),
	    isLength = __webpack_require__(70),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 23 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(275),
	    isArguments = __webpack_require__(110),
	    isObjectLike = __webpack_require__(47);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(134);
	
	var invariant = __webpack_require__(1);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ },
/* 27 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      }
	      throw TypeError('Uncaught, unspecified "error" event.');
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(223),
	    isLength = __webpack_require__(40);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(114);
	var EventPluginUtils = __webpack_require__(296);
	var ReactErrorUtils = __webpack_require__(127);
	
	var accumulateInto = __webpack_require__(136);
	var forEachAccumulated = __webpack_require__(137);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var EventPluginHub = __webpack_require__(29);
	
	var warning = __webpack_require__(4);
	
	var accumulateInto = __webpack_require__(136);
	var forEachAccumulated = __webpack_require__(137);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 31 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(20);
	
	var getEventTarget = __webpack_require__(82);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	/**
	 * @module content-repo
	 */
	var utils = __webpack_require__(5);
	
	/** Content Repo utility functions */
	module.exports = {
	    /**
	     * Get the HTTP URL for an MXC URI.
	     * @param {string} baseUrl The base homeserver url which has a content repo.
	     * @param {string} mxc The mxc:// URI.
	     * @param {Number} width The desired width of the thumbnail.
	     * @param {Number} height The desired height of the thumbnail.
	     * @param {string} resizeMethod The thumbnail resize method to use, either
	     * "crop" or "scale".
	     * @param {Boolean} allowDirectLinks If true, return any non-mxc URLs
	     * directly. Fetching such URLs will leak information about the user to
	     * anyone they share a room with. If false, will return the emptry string
	     * for such URLs.
	     * @return {string} The complete URL to the content.
	     */
	    getHttpUriForMxc: function(baseUrl, mxc, width, height,
	                               resizeMethod, allowDirectLinks) {
	        if (typeof mxc !== "string" || !mxc) {
	            return '';
	        }
	        if (mxc.indexOf("mxc://") !== 0) {
	            if (allowDirectLinks) {
	                return mxc;
	            } else {
	                return '';
	            }
	        }
	        var serverAndMediaId = mxc.slice(6); // strips mxc://
	        var prefix = "/_matrix/media/v1/download/";
	        var params = {};
	
	        if (width) {
	            params.width = width;
	        }
	        if (height) {
	            params.height = height;
	        }
	        if (resizeMethod) {
	            params.method = resizeMethod;
	        }
	        if (utils.keys(params).length > 0) {
	            // these are thumbnailing params so they probably want the
	            // thumbnailing API...
	            prefix = "/_matrix/media/v1/thumbnail/";
	        }
	
	        var fragmentOffset = serverAndMediaId.indexOf("#"),
	            fragment = "";
	        if (fragmentOffset >= 0) {
	            fragment = serverAndMediaId.substr(fragmentOffset);
	            serverAndMediaId = serverAndMediaId.substr(0, fragmentOffset);
	        }
	        return baseUrl + prefix + serverAndMediaId +
	            (utils.keys(params).length === 0 ? "" :
	            ("?" + utils.encodeParams(params))) + fragment;
	    },
	
	    /**
	     * Get an identicon URL from an arbitrary string.
	     * @param {string} baseUrl The base homeserver url which has a content repo.
	     * @param {string} identiconString The string to create an identicon for.
	     * @param {Number} width The desired width of the image in pixels. Default: 96.
	     * @param {Number} height The desired height of the image in pixels. Default: 96.
	     * @return {string} The complete URL to the identicon.
	     */
	    getIdenticonUri: function(baseUrl, identiconString, width, height) {
	        if (!identiconString) {
	            return null;
	        }
	        if (!width) { width = 96; }
	        if (!height) { height = 96; }
	        var params = {
	            width: width,
	            height: height
	        };
	
	        var path = utils.encodeUri("/_matrix/media/v1/identicon/$ident", {
	            $ident: identiconString
	        });
	        return baseUrl + path +
	            (utils.keys(params).length === 0 ? "" :
	                ("?" + utils.encodeParams(params)));
	    }
	};


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module. See {@link MatrixHttpApi} for the public class.
	 * @module http-api
	 */
	var q = __webpack_require__(18);
	var utils = __webpack_require__(5);
	
	/*
	TODO:
	- CS: complete register function (doing stages)
	- Identity server: linkEmail, authEmail, bindEmail, lookup3pid
	*/
	
	/**
	 * A constant representing the URI path for version 1 of the Client-Server HTTP API.
	 */
	module.exports.PREFIX_V1 = "/_matrix/client/api/v1";
	
	/**
	 * A constant representing the URI path for version 2 alpha of the Client-Server
	 * HTTP API.
	 */
	module.exports.PREFIX_V2_ALPHA = "/_matrix/client/v2_alpha";
	
	/**
	 * URI path for the identity API
	 */
	module.exports.PREFIX_IDENTITY_V1 = "/_matrix/identity/api/v1";
	
	/**
	 * A constant representing the URI path for release 0 of the Client-Server HTTP API.
	 */
	module.exports.PREFIX_R0 = "/_matrix/client/r0";
	
	/**
	 * Construct a MatrixHttpApi.
	 * @constructor
	 * @param {Object} opts The options to use for this HTTP API.
	 * @param {string} opts.baseUrl Required. The base client-server URL e.g.
	 * 'http://localhost:8008'.
	 * @param {Function} opts.request Required. The function to call for HTTP
	 * requests. This function must look like function(opts, callback){ ... }.
	 * @param {string} opts.prefix Required. The matrix client prefix to use, e.g.
	 * '/_matrix/client/api/v1'. See PREFIX_V1 and PREFIX_V2_ALPHA for constants.
	 * @param {bool} opts.onlyData True to return only the 'data' component of the
	 * response (e.g. the parsed HTTP body). If false, requests will return status
	 * codes and headers in addition to data. Default: false.
	 * @param {string} opts.accessToken The access_token to send with requests. Can be
	 * null to not send an access token.
	 * @param {Object} opts.extraParams Optional. Extra query parameters to send on
	 * requests.
	 */
	module.exports.MatrixHttpApi = function MatrixHttpApi(opts) {
	    utils.checkObjectHasKeys(opts, ["baseUrl", "request", "prefix"]);
	    opts.onlyData = opts.onlyData || false;
	    this.opts = opts;
	    this.uploads = [];
	};
	
	module.exports.MatrixHttpApi.prototype = {
	
	    /**
	     * Get the content repository url with query parameters.
	     * @return {Object} An object with a 'base', 'path' and 'params' for base URL,
	     *          path and query parameters respectively.
	     */
	    getContentUri: function() {
	        var params = {
	            access_token: this.opts.accessToken
	        };
	        return {
	            base: this.opts.baseUrl,
	            path: "/_matrix/media/v1/upload",
	            params: params
	        };
	    },
	
	    /**
	     * Upload content to the Home Server
	     * @param {File} file A File object (in a browser) or in Node,
	                                 an object with properties:
	                                 name: The file's name
	                                 stream: A read stream
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     */
	    uploadContent: function(file, callback) {
	        if (callback !== undefined && !utils.isFunction(callback)) {
	            throw Error(
	                "Expected callback to be a function but got " + typeof callback
	            );
	        }
	        var defer = q.defer();
	        var url = this.opts.baseUrl + "/_matrix/media/v1/upload";
	        // browser-request doesn't support File objects because it deep-copies
	        // the options using JSON.parse(JSON.stringify(options)). Instead of
	        // loading the whole file into memory as a string and letting
	        // browser-request base64 encode and then decode it again, we just
	        // use XMLHttpRequest directly.
	        // (browser-request doesn't support progress either, which is also kind
	        // of important here)
	
	        var upload = { loaded: 0, total: 0 };
	
	        if (global.XMLHttpRequest) {
	            var xhr = new global.XMLHttpRequest();
	            upload.xhr = xhr;
	            var cb = requestCallback(defer, callback, this.opts.onlyData);
	
	            var timeout_fn = function() {
	                xhr.abort();
	                cb(new Error('Timeout'));
	            };
	
	            xhr.timeout_timer = setTimeout(timeout_fn, 30000);
	
	            xhr.onreadystatechange = function() {
	                switch (xhr.readyState) {
	                    case global.XMLHttpRequest.DONE:
	                        clearTimeout(xhr.timeout_timer);
	                        var err;
	                        if (!xhr.responseText) {
	                            err = new Error('No response body.');
	                            err.http_status = xhr.status;
	                            cb(err);
	                            return;
	                        }
	
	                        var resp = JSON.parse(xhr.responseText);
	                        if (resp.content_uri === undefined) {
	                            err = Error('Bad response');
	                            err.http_status = xhr.status;
	                            cb(err);
	                            return;
	                        }
	
	                        cb(undefined, xhr, resp.content_uri);
	                        break;
	                }
	            };
	            xhr.upload.addEventListener("progress", function(ev) {
	                clearTimeout(xhr.timeout_timer);
	                upload.loaded = ev.loaded;
	                upload.total = ev.total;
	                xhr.timeout_timer = setTimeout(timeout_fn, 30000);
	                defer.notify(ev);
	            });
	            url += "?access_token=" + encodeURIComponent(this.opts.accessToken);
	            url += "&filename=" + encodeURIComponent(file.name);
	
	            xhr.open("POST", url);
	            if (file.type) {
	                xhr.setRequestHeader("Content-Type", file.type);
	            } else {
	                // if the file doesn't have a mime type, use a default since
	                // the HS errors if we don't supply one.
	                xhr.setRequestHeader("Content-Type", 'application/octet-stream');
	            }
	            xhr.send(file);
	        } else {
	            var queryParams = {
	                filename: file.name,
	                access_token: this.opts.accessToken
	            };
	            upload.request = this.opts.request({
	                uri: url,
	                qs: queryParams,
	                method: "POST"
	            }, requestCallback(defer, callback, this.opts.onlyData));
	            file.stream.pipe(this.opts.request);
	        }
	
	        this.uploads.push(upload);
	
	        var self = this;
	        upload.promise = defer.promise.finally(function() {
	            var uploadsKeys = Object.keys(self.uploads);
	            for (var i = 0; i < uploadsKeys.length; ++i) {
	                if (self.uploads[uploadsKeys[i]].promise === defer.promise) {
	                    self.uploads.splice(uploadsKeys[i], 1);
	                }
	            }
	        });
	        return upload.promise;
	    },
	
	    cancelUpload: function(promise) {
	        var uploadsKeys = Object.keys(this.uploads);
	        for (var i = 0; i < uploadsKeys.length; ++i) {
	            var upload = this.uploads[uploadsKeys[i]];
	            if (upload.promise === promise) {
	                if (upload.xhr !== undefined) {
	                    upload.xhr.abort();
	                    return true;
	                } else if (upload.request !== undefined) {
	                    upload.request.abort();
	                    return true;
	                }
	            }
	        }
	        return false;
	    },
	
	    getCurrentUploads: function() {
	        return this.uploads;
	    },
	
	    idServerRequest: function(callback, method, path, params, prefix) {
	        var fullUri = this.opts.idBaseUrl + prefix + path;
	
	        if (callback !== undefined && !utils.isFunction(callback)) {
	            throw Error(
	                "Expected callback to be a function but got " + typeof callback
	            );
	        }
	
	        var opts = {
	            uri: fullUri,
	            method: method,
	            withCredentials: false,
	            json: false,
	            _matrix_opts: this.opts
	        };
	        if (method == 'GET') {
	            opts.qs = params;
	        } else {
	            opts.form = params;
	        }
	
	        var defer = q.defer();
	        this.opts.request(
	            opts,
	            requestCallback(defer, callback, this.opts.onlyData)
	        );
	        return defer.promise;
	    },
	
	    /**
	     * Perform an authorised request to the homeserver.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {Object} data The HTTP JSON body.
	     * @param {Number=} localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     */
	    authedRequest: function(callback, method, path, queryParams, data, localTimeoutMs) {
	        if (!queryParams) { queryParams = {}; }
	        queryParams.access_token = this.opts.accessToken;
	        return this.request(callback, method, path, queryParams, data, localTimeoutMs);
	    },
	
	    /**
	     * Perform a request to the homeserver without any credentials.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {Object} data The HTTP JSON body.
	     * @param {Number=} localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     */
	    request: function(callback, method, path, queryParams, data, localTimeoutMs) {
	        return this.requestWithPrefix(
	            callback, method, path, queryParams, data, this.opts.prefix, localTimeoutMs
	        );
	    },
	
	    /**
	     * Perform an authorised request to the homeserver with a specific path
	     * prefix which overrides the default for this call only. Useful for hitting
	     * different Matrix Client-Server versions.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {Object} data The HTTP JSON body.
	     * @param {string} prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha".
	     * @param {Number=} localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     */
	    authedRequestWithPrefix: function(callback, method, path, queryParams, data,
	                                      prefix, localTimeoutMs) {
	        var fullUri = this.opts.baseUrl + prefix + path;
	        if (!queryParams) {
	            queryParams = {};
	        }
	        queryParams.access_token = this.opts.accessToken;
	        return this._request(
	            callback, method, fullUri, queryParams, data, localTimeoutMs
	        );
	    },
	
	    /**
	     * Perform a request to the homeserver without any credentials but with a
	     * specific path prefix which overrides the default for this call only.
	     * Useful for hitting different Matrix Client-Server versions.
	     * @param {Function} callback Optional. The callback to invoke on
	     * success/failure. See the promise return values for more information.
	     * @param {string} method The HTTP method e.g. "GET".
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {Object} data The HTTP JSON body.
	     * @param {string} prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha".
	     * @param {Number=} localTimeoutMs The maximum amount of time to wait before
	     * timing out the request. If not specified, there is no timeout.
	     * @return {module:client.Promise} Resolves to <code>{data: {Object},
	     * headers: {Object}, code: {Number}}</code>.
	     * If <code>onlyData</code> is set, this will resolve to the <code>data</code>
	     * object only.
	     * @return {module:http-api.MatrixError} Rejects with an error if a problem
	     * occurred. This includes network problems and Matrix-specific error JSON.
	     */
	    requestWithPrefix: function(callback, method, path, queryParams, data, prefix,
	                                localTimeoutMs) {
	        var fullUri = this.opts.baseUrl + prefix + path;
	        if (!queryParams) {
	            queryParams = {};
	        }
	        return this._request(
	            callback, method, fullUri, queryParams, data, localTimeoutMs
	        );
	    },
	
	    /**
	     * Form and return a homeserver request URL based on the given path
	     * params and prefix.
	     * @param {string} path The HTTP path <b>after</b> the supplied prefix e.g.
	     * "/createRoom".
	     * @param {Object} queryParams A dict of query params (these will NOT be
	     * urlencoded).
	     * @param {string} prefix The full prefix to use e.g.
	     * "/_matrix/client/v2_alpha".
	     * @return {string} URL
	     */
	    getUrl: function(path, queryParams, prefix) {
	        var queryString = "";
	        if (queryParams) {
	            queryString = "?" + utils.encodeParams(queryParams);
	        }
	        return this.opts.baseUrl + prefix + path + queryString;
	    },
	
	    _request: function(callback, method, uri, queryParams, data, localTimeoutMs) {
	        if (callback !== undefined && !utils.isFunction(callback)) {
	            throw Error(
	                "Expected callback to be a function but got " + typeof callback
	            );
	        }
	        var self = this;
	        if (!queryParams) {
	            queryParams = {};
	        }
	        if (this.opts.extraParams) {
	            for (var key in this.opts.extraParams) {
	                if (!this.opts.extraParams.hasOwnProperty(key)) { continue; }
	                queryParams[key] = this.opts.extraParams[key];
	            }
	        }
	        var defer = q.defer();
	
	        var timeoutId;
	        var timedOut = false;
	        if (localTimeoutMs) {
	            timeoutId = setTimeout(function() {
	                timedOut = true;
	                defer.reject(new module.exports.MatrixError({
	                    error: "Locally timed out waiting for a response",
	                    errcode: "ORG.MATRIX.JSSDK_TIMEOUT",
	                    timeout: localTimeoutMs
	                }));
	            }, localTimeoutMs);
	        }
	
	        var reqPromise = defer.promise;
	
	        try {
	            var req = this.opts.request(
	                {
	                    uri: uri,
	                    method: method,
	                    withCredentials: false,
	                    qs: queryParams,
	                    body: data,
	                    json: true,
	                    timeout: localTimeoutMs,
	                    _matrix_opts: this.opts
	                },
	                function(err, response, body) {
	                    if (localTimeoutMs) {
	                        clearTimeout(timeoutId);
	                        if (timedOut) {
	                            return; // already rejected promise
	                        }
	                    }
	                    var handlerFn = requestCallback(defer, callback, self.opts.onlyData);
	                    handlerFn(err, response, body);
	                }
	            );
	            if (req && req.abort) {
	                // FIXME: This is EVIL, but I can't think of a better way to expose
	                // abort() operations on underlying HTTP requests :(
	                reqPromise.abort = req.abort.bind(req);
	            }
	        }
	        catch (ex) {
	            defer.reject(ex);
	            if (callback) {
	                callback(ex);
	            }
	        }
	        return reqPromise;
	    }
	};
	
	/*
	 * Returns a callback that can be invoked by an HTTP request on completion,
	 * that will either resolve or reject the given defer as well as invoke the
	 * given userDefinedCallback (if any).
	 *
	 * If onlyData is true, the defer/callback is invoked with the body of the
	 * response, otherwise the result code.
	 */
	var requestCallback = function(defer, userDefinedCallback, onlyData) {
	    userDefinedCallback = userDefinedCallback || function() {};
	
	    return function(err, response, body) {
	        if (!err && response.statusCode >= 400) {
	            err = new module.exports.MatrixError(body);
	            err.httpStatus = response.statusCode;
	        }
	
	        if (err) {
	            defer.reject(err);
	            userDefinedCallback(err);
	        }
	        else {
	            var res = {
	                code: response.statusCode,
	                headers: response.headers,
	                data: body
	            };
	            defer.resolve(onlyData ? body : res);
	            userDefinedCallback(null, onlyData ? body : res);
	        }
	    };
	};
	
	/**
	 * Construct a Matrix error. This is a JavaScript Error with additional
	 * information specific to the standard Matrix error response.
	 * @constructor
	 * @param {Object} errorJson The Matrix error JSON returned from the homeserver.
	 * @prop {string} errcode The Matrix 'errcode' value, e.g. "M_FORBIDDEN".
	 * @prop {string} name Same as MatrixError.errcode but with a default unknown string.
	 * @prop {string} message The Matrix 'error' value, e.g. "Missing token."
	 * @prop {Object} data The raw Matrix error JSON used to construct this object.
	 * @prop {integer} httpStatus The numeric HTTP status code given
	 */
	module.exports.MatrixError = function MatrixError(errorJson) {
	    this.errcode = errorJson.errcode;
	    this.name = errorJson.errcode || "Unknown error code";
	    this.message = errorJson.error || "Unknown message";
	    this.data = errorJson;
	};
	module.exports.MatrixError.prototype = Object.create(Error.prototype);
	/** */
	module.exports.MatrixError.prototype.constructor = module.exports.MatrixError;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * @module models/event-timeline
	 */
	
	var RoomState = __webpack_require__(94);
	var utils = __webpack_require__(5);
	var MatrixEvent = __webpack_require__(15).MatrixEvent;
	
	/**
	 * Construct a new EventTimeline
	 *
	 * <p>An EventTimeline represents a contiguous sequence of events in a room.
	 *
	 * <p>As well as keeping track of the events themselves, it stores the state of
	 * the room at the beginning and end of the timeline, and pagination tokens for
	 * going backwards and forwards in the timeline.
	 *
	 * <p>In order that clients can meaningfully maintain an index into a timeline,
	 * the EventTimeline object tracks a 'baseIndex'. This starts at zero, but is
	 * incremented when events are prepended to the timeline. The index of an event
	 * relative to baseIndex therefore remains constant.
	 *
	 * <p>Once a timeline joins up with its neighbour, they are linked together into a
	 * doubly-linked list.
	 *
	 * @param {string} roomId    the ID of the room where this timeline came from
	 * @constructor
	 */
	function EventTimeline(roomId) {
	    this._roomId = roomId;
	    this._events = [];
	    this._baseIndex = -1;
	    this._startState = new RoomState(roomId);
	    this._startState.paginationToken = null;
	    this._endState = new RoomState(roomId);
	    this._endState.paginationToken = null;
	
	    this._prevTimeline = null;
	    this._nextTimeline = null;
	
	    // this is used by client.js
	    this._paginationRequests = {'b': null, 'f': null};
	}
	
	/**
	 * Symbolic constant for methods which take a 'direction' argument:
	 * refers to the start of the timeline, or backwards in time.
	 */
	EventTimeline.BACKWARDS = "b";
	
	/**
	 * Symbolic constant for methods which take a 'direction' argument:
	 * refers to the end of the timeline, or forwards in time.
	 */
	EventTimeline.FORWARDS = "f";
	
	/**
	 * Initialise the start and end state with the given events
	 *
	 * <p>This can only be called before any events are added.
	 *
	 * @param {MatrixEvent[]} stateEvents list of state events to initialise the
	 * state with.
	 * @throws {Error} if an attempt is made to call this after addEvent is called.
	 */
	EventTimeline.prototype.initialiseState = function(stateEvents) {
	    if (this._events.length > 0) {
	        throw new Error("Cannot initialise state after events are added");
	    }
	
	    // we deep-copy the events here, in case they get changed later - we don't
	    // want changes to the start state leaking through to the end state.
	    var oldStateEvents = utils.map(
	        utils.deepCopy(
	            stateEvents.map(function(mxEvent) { return mxEvent.event; })
	        ), function(ev) { return new MatrixEvent(ev); });
	
	    this._startState.setStateEvents(oldStateEvents);
	    this._endState.setStateEvents(stateEvents);
	};
	
	/**
	 * Get the ID of the room for this timeline
	 * @return {string} room ID
	 */
	EventTimeline.prototype.getRoomId = function() {
	    return this._roomId;
	};
	
	/**
	 * Get the base index.
	 *
	 * <p>This is an index which is incremented when events are prepended to the
	 * timeline. An individual event therefore stays at the same index in the array
	 * relative to the base index (although note that a given event's index may
	 * well be less than the base index, thus giving that event a negative relative
	 * index).
	 *
	 * @return {number}
	 */
	EventTimeline.prototype.getBaseIndex = function() {
	    return this._baseIndex;
	};
	
	/**
	 * Get the list of events in this context
	 *
	 * @return {MatrixEvent[]} An array of MatrixEvents
	 */
	EventTimeline.prototype.getEvents = function() {
	    return this._events;
	};
	
	/**
	 * Get the room state at the start/end of the timeline
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to get the state at the
	 *   start of the timeline; EventTimeline.FORWARDS to get the state at the end
	 *   of the timeline.
	 *
	 * @return {RoomState} state at the start/end of the timeline
	 */
	EventTimeline.prototype.getState = function(direction) {
	    if (direction == EventTimeline.BACKWARDS) {
	        return this._startState;
	    } else if (direction == EventTimeline.FORWARDS) {
	        return this._endState;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	};
	
	/**
	 * Get a pagination token
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to get the pagination
	 *   token for going backwards in time; EventTimeline.FORWARDS to get the
	 *   pagination token for going forwards in time.
	 *
	 * @return {?string} pagination token
	 */
	EventTimeline.prototype.getPaginationToken = function(direction) {
	    return this.getState(direction).paginationToken;
	};
	
	/**
	 * Set a pagination token
	 *
	 * @param {?string} token       pagination token
	 *
	 * @param {string} direction    EventTimeline.BACKWARDS to set the pagination
	 *   token for going backwards in time; EventTimeline.FORWARDS to set the
	 *   pagination token for going forwards in time.
	 */
	EventTimeline.prototype.setPaginationToken = function(token, direction) {
	    this.getState(direction).paginationToken = token;
	};
	
	/**
	 * Get the next timeline in the series
	 *
	 * @param {string} direction EventTimeline.BACKWARDS to get the previous
	 *   timeline; EventTimeline.FORWARDS to get the next timeline.
	 *
	 * @return {?EventTimeline} previous or following timeline, if they have been
	 * joined up.
	 */
	EventTimeline.prototype.getNeighbouringTimeline = function(direction) {
	    if (direction == EventTimeline.BACKWARDS) {
	        return this._prevTimeline;
	    } else if (direction == EventTimeline.FORWARDS) {
	        return this._nextTimeline;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	};
	
	/**
	 * Set the next timeline in the series
	 *
	 * @param {EventTimeline} neighbour previous/following timeline
	 *
	 * @param {string} direction EventTimeline.BACKWARDS to set the previous
	 *   timeline; EventTimeline.FORWARDS to set the next timeline.
	 *
	 * @throws {Error} if an attempt is made to set the neighbouring timeline when
	 * it is already set.
	 */
	EventTimeline.prototype.setNeighbouringTimeline = function(neighbour, direction) {
	    if (this.getNeighbouringTimeline(direction)) {
	        throw new Error("timeline already has a neighbouring timeline - " +
	                        "cannot reset neighbour");
	    }
	
	    if (direction == EventTimeline.BACKWARDS) {
	        this._prevTimeline = neighbour;
	    } else if (direction == EventTimeline.FORWARDS) {
	        this._nextTimeline = neighbour;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	
	    // make sure we don't try to paginate this timeline
	    this.setPaginationToken(null, direction);
	};
	
	/**
	 * Add a new event to the timeline, and update the state
	 *
	 * @param {MatrixEvent} event   new event
	 * @param {boolean}  atStart     true to insert new event at the start
	 * @param {boolean}  [spliceBeforeLocalEcho = false] insert this event before any
	 *     localecho events at the end of the timeline. Ignored if atStart == true
	 */
	EventTimeline.prototype.addEvent = function(event, atStart, spliceBeforeLocalEcho) {
	    var stateContext = atStart ? this._startState : this._endState;
	
	    setEventMetadata(event, stateContext, atStart);
	
	    // modify state
	    if (event.isState()) {
	        stateContext.setStateEvents([event]);
	        // it is possible that the act of setting the state event means we
	        // can set more metadata (specifically sender/target props), so try
	        // it again if the prop wasn't previously set. It may also mean that
	        // the sender/target is updated (if the event set was a room member event)
	        // so we want to use the *updated* member (new avatar/name) instead.
	        if (!event.sender || event.getType() === "m.room.member") {
	            setEventMetadata(event, stateContext, atStart);
	        }
	    }
	
	    var insertIndex;
	
	    if (atStart) {
	        insertIndex = 0;
	    } else {
	        insertIndex = this._events.length;
	
	        // if this is a real event, we might need to splice it in before any pending
	        // local echo events.
	        if (spliceBeforeLocalEcho) {
	            for (var j = this._events.length - 1; j >= 0; j--) {
	                if (!this._events[j].status) { // real events don't have a status
	                    insertIndex = j + 1;
	                    break;
	                }
	            }
	        }
	    }
	
	    this._events.splice(insertIndex, 0, event); // insert element
	    if (insertIndex <= this._baseIndex || this._baseIndex == -1) {
	        this._baseIndex++;
	    }
	};
	
	function setEventMetadata(event, stateContext, toStartOfTimeline) {
	    // set sender and target properties
	    event.sender = stateContext.getSentinelMember(
	        event.getSender()
	    );
	    if (event.getType() === "m.room.member") {
	        event.target = stateContext.getSentinelMember(
	            event.getStateKey()
	        );
	    }
	    if (event.isState()) {
	        // room state has no concept of 'old' or 'current', but we want the
	        // room state to regress back to previous values if toStartOfTimeline
	        // is set, which means inspecting prev_content if it exists. This
	        // is done by toggling the forwardLooking flag.
	        if (toStartOfTimeline) {
	            event.forwardLooking = false;
	        }
	    }
	}
	
	/**
	 * Remove an event from the timeline
	 *
	 * @param {string} eventId  ID of event to be removed
	 * @return {?MatrixEvent} removed event, or null if not found
	 */
	EventTimeline.prototype.removeEvent = function(eventId) {
	    for (var i = this._events.length - 1; i >= 0; i--) {
	        var ev = this._events[i];
	        if (ev.getId() == eventId) {
	            this._events.splice(i, 1);
	            if (i < this._baseIndex) {
	                this._baseIndex--;
	            }
	            return ev;
	        }
	    }
	    return null;
	};
	
	
	/**
	 * The EventTimeline class
	 */
	module.exports = EventTimeline;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/user
	 */
	 var EventEmitter = __webpack_require__(27).EventEmitter;
	 var utils = __webpack_require__(5);
	
	/**
	 * Construct a new User. A User must have an ID and can optionally have extra
	 * information associated with it.
	 * @constructor
	 * @param {string} userId Required. The ID of this user.
	 * @prop {string} userId The ID of the user.
	 * @prop {Object} info The info object supplied in the constructor.
	 * @prop {string} displayName The 'displayname' of the user if known.
	 * @prop {string} avatarUrl The 'avatar_url' of the user if known.
	 * @prop {string} presence The presence enum if known.
	 * @prop {Number} lastActiveAgo The last time the user performed some action in ms.
	 * @prop {Object} events The events describing this user.
	 * @prop {MatrixEvent} events.presence The m.presence event for this user.
	 */
	function User(userId) {
	    this.userId = userId;
	    this.presence = "offline";
	    this.displayName = userId;
	    this.avatarUrl = null;
	    this.lastActiveAgo = 0;
	    this.events = {
	        presence: null,
	        profile: null
	    };
	    this._updateModifiedTime();
	}
	utils.inherits(User, EventEmitter);
	
	/**
	 * Update this User with the given presence event. May fire "User.presence",
	 * "User.avatarUrl" and/or "User.displayName" if this event updates this user's
	 * properties.
	 * @param {MatrixEvent} event The <code>m.presence</code> event.
	 * @fires module:client~MatrixClient#event:"User.presence"
	 * @fires module:client~MatrixClient#event:"User.displayName"
	 * @fires module:client~MatrixClient#event:"User.avatarUrl"
	 */
	User.prototype.setPresenceEvent = function(event) {
	    if (event.getType() !== "m.presence") {
	        return;
	    }
	    var firstFire = this.events.presence === null;
	    this.events.presence = event;
	
	    var eventsToFire = [];
	    if (event.getContent().presence !== this.presence || firstFire) {
	        eventsToFire.push("User.presence");
	    }
	    if (event.getContent().avatar_url !== this.avatarUrl) {
	        eventsToFire.push("User.avatarUrl");
	    }
	    if (event.getContent().displayname !== this.displayName) {
	        eventsToFire.push("User.displayName");
	    }
	
	    this.presence = event.getContent().presence;
	    this.displayName = event.getContent().displayname;
	    this.avatarUrl = event.getContent().avatar_url;
	    this.lastActiveAgo = event.getContent().last_active_ago;
	
	    if (eventsToFire.length > 0) {
	        this._updateModifiedTime();
	    }
	
	    for (var i = 0; i < eventsToFire.length; i++) {
	        this.emit(eventsToFire[i], event, this);
	    }
	};
	
	/**
	 * Manually set this user's display name. No event is emitted in response to this
	 * as there is no underlying MatrixEvent to emit with.
	 * @param {string} name The new display name.
	 */
	User.prototype.setDisplayName = function(name) {
	    var oldName = this.displayName;
	    this.displayName = name;
	    if (name !== oldName) {
	        this._updateModifiedTime();
	    }
	};
	
	/**
	 * Manually set this user's avatar URL. No event is emitted in response to this
	 * as there is no underlying MatrixEvent to emit with.
	 * @param {string} url The new avatar URL.
	 */
	User.prototype.setAvatarUrl = function(url) {
	    var oldUrl = this.avatarUrl;
	    this.avatarUrl = url;
	    if (url !== oldUrl) {
	        this._updateModifiedTime();
	    }
	};
	
	/**
	 * Update the last modified time to the current time.
	 */
	User.prototype._updateModifiedTime = function() {
	    this._modified = Date.now();
	};
	
	/**
	 * Get the timestamp when this User was last updated. This timestamp is
	 * updated when this User receives a new Presence event which has updated a
	 * property on this object. It is updated <i>before</i> firing events.
	 * @return {number} The timestamp
	 */
	User.prototype.getLastModifiedTime = function() {
	    return this._modified;
	};
	
	/**
	 * The User class.
	 */
	module.exports = User;
	
	/**
	 * Fires whenever any user's presence changes.
	 * @event module:client~MatrixClient#"User.presence"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.presence changed.
	 * @example
	 * matrixClient.on("User.presence", function(event, user){
	 *   var newPresence = user.presence;
	 * });
	 */
	
	/**
	 * Fires whenever any user's display name changes.
	 * @event module:client~MatrixClient#"User.displayName"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.displayName changed.
	 * @example
	 * matrixClient.on("User.displayName", function(event, user){
	 *   var newName = user.displayName;
	 * });
	 */
	
	/**
	 * Fires whenever any user's avatar URL changes.
	 * @event module:client~MatrixClient#"User.avatarUrl"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {User} user The user whose User.avatarUrl changed.
	 * @example
	 * matrixClient.on("User.avatarUrl", function(event, user){
	 *   var newUrl = user.avatarUrl;
	 * });
	 */


/***/ },
/* 38 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(232);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _DragDropContext = __webpack_require__(237);
	
	exports.DragDropContext = _interopRequire(_DragDropContext);
	
	var _DragLayer = __webpack_require__(238);
	
	exports.DragLayer = _interopRequire(_DragLayer);
	
	var _DragSource = __webpack_require__(239);
	
	exports.DragSource = _interopRequire(_DragSource);
	
	var _DropTarget = __webpack_require__(240);
	
	exports.DropTarget = _interopRequire(_DropTarget);
	
	if (false) {
	  Object.defineProperty(exports, 'default', {
	    get: function get() {
	      console.error( // eslint-disable-line no-console
	      'React DnD does not provide a default export. ' + 'You are probably missing the curly braces in the import statement. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-troubleshooting.html#react-dnd-does-not-provide-a-default-export');
	    }
	  });
	}

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = checkDecoratorArguments;
	
	function checkDecoratorArguments(functionName, signature) {
	  if (false) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    for (var i = 0; i < args.length; i++) {
	      var arg = args[i];
	      if (arg && arg.prototype && arg.prototype.render) {
	        console.error( // eslint-disable-line no-console
	        'You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://gaearon.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
	        return;
	      }
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.beginDrag = beginDrag;
	exports.publishDragSource = publishDragSource;
	exports.hover = hover;
	exports.drop = drop;
	exports.endDrag = endDrag;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsMatchesType = __webpack_require__(107);
	
	var _utilsMatchesType2 = _interopRequireDefault(_utilsMatchesType);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsArray = __webpack_require__(22);
	
	var _lodashLangIsArray2 = _interopRequireDefault(_lodashLangIsArray);
	
	var _lodashLangIsObject = __webpack_require__(23);
	
	var _lodashLangIsObject2 = _interopRequireDefault(_lodashLangIsObject);
	
	var BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
	exports.BEGIN_DRAG = BEGIN_DRAG;
	var PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
	exports.PUBLISH_DRAG_SOURCE = PUBLISH_DRAG_SOURCE;
	var HOVER = 'dnd-core/HOVER';
	exports.HOVER = HOVER;
	var DROP = 'dnd-core/DROP';
	exports.DROP = DROP;
	var END_DRAG = 'dnd-core/END_DRAG';
	
	exports.END_DRAG = END_DRAG;
	
	function beginDrag(sourceIds) {
	  var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var _ref$publishSource = _ref.publishSource;
	  var publishSource = _ref$publishSource === undefined ? true : _ref$publishSource;
	  var _ref$clientOffset = _ref.clientOffset;
	  var clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;
	  var getSourceClientOffset = _ref.getSourceClientOffset;
	
	  _invariant2['default'](_lodashLangIsArray2['default'](sourceIds), 'Expected sourceIds to be an array.');
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  _invariant2['default'](!monitor.isDragging(), 'Cannot call beginDrag while dragging.');
	
	  for (var i = 0; i < sourceIds.length; i++) {
	    _invariant2['default'](registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	  }
	
	  var sourceId = null;
	  for (var i = sourceIds.length - 1; i >= 0; i--) {
	    if (monitor.canDragSource(sourceIds[i])) {
	      sourceId = sourceIds[i];
	      break;
	    }
	  }
	  if (sourceId === null) {
	    return;
	  }
	
	  var sourceClientOffset = null;
	  if (clientOffset) {
	    _invariant2['default'](typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
	    sourceClientOffset = getSourceClientOffset(sourceId);
	  }
	
	  var source = registry.getSource(sourceId);
	  var item = source.beginDrag(monitor, sourceId);
	  _invariant2['default'](_lodashLangIsObject2['default'](item), 'Item must be an object.');
	
	  registry.pinSource(sourceId);
	
	  var itemType = registry.getSourceType(sourceId);
	  return {
	    type: BEGIN_DRAG,
	    itemType: itemType,
	    item: item,
	    sourceId: sourceId,
	    clientOffset: clientOffset,
	    sourceClientOffset: sourceClientOffset,
	    isSourcePublic: publishSource
	  };
	}
	
	function publishDragSource(manager) {
	  var monitor = this.getMonitor();
	  if (!monitor.isDragging()) {
	    return;
	  }
	
	  return {
	    type: PUBLISH_DRAG_SOURCE
	  };
	}
	
	function hover(targetIds) {
	  var _ref2 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  var _ref2$clientOffset = _ref2.clientOffset;
	  var clientOffset = _ref2$clientOffset === undefined ? null : _ref2$clientOffset;
	
	  _invariant2['default'](_lodashLangIsArray2['default'](targetIds), 'Expected targetIds to be an array.');
	  targetIds = targetIds.slice(0);
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  _invariant2['default'](monitor.isDragging(), 'Cannot call hover while not dragging.');
	  _invariant2['default'](!monitor.didDrop(), 'Cannot call hover after drop.');
	
	  var draggedItemType = monitor.getItemType();
	  for (var i = 0; i < targetIds.length; i++) {
	    var targetId = targetIds[i];
	    _invariant2['default'](targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');
	
	    var target = registry.getTarget(targetId);
	    _invariant2['default'](target, 'Expected targetIds to be registered.');
	
	    var targetType = registry.getTargetType(targetId);
	    if (_utilsMatchesType2['default'](targetType, draggedItemType)) {
	      target.hover(monitor, targetId);
	    }
	  }
	
	  return {
	    type: HOVER,
	    targetIds: targetIds,
	    clientOffset: clientOffset
	  };
	}
	
	function drop() {
	  var _this = this;
	
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  _invariant2['default'](monitor.isDragging(), 'Cannot call drop while not dragging.');
	  _invariant2['default'](!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');
	
	  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
	
	  targetIds.reverse();
	  targetIds.forEach(function (targetId, index) {
	    var target = registry.getTarget(targetId);
	
	    var dropResult = target.drop(monitor, targetId);
	    _invariant2['default'](typeof dropResult === 'undefined' || _lodashLangIsObject2['default'](dropResult), 'Drop result must either be an object or undefined.');
	    if (typeof dropResult === 'undefined') {
	      dropResult = index === 0 ? {} : monitor.getDropResult();
	    }
	
	    _this.store.dispatch({
	      type: DROP,
	      dropResult: dropResult
	    });
	  });
	}
	
	function endDrag() {
	  var monitor = this.getMonitor();
	  var registry = this.getRegistry();
	  _invariant2['default'](monitor.isDragging(), 'Cannot call endDrag while not dragging.');
	
	  var sourceId = monitor.getSourceId();
	  var source = registry.getSource(sourceId, true);
	  source.endDrag(monitor, sourceId);
	
	  registry.unpinSource();
	
	  return {
	    type: END_DRAG
	  };
	}

/***/ },
/* 45 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addSource = addSource;
	exports.addTarget = addTarget;
	exports.removeSource = removeSource;
	exports.removeTarget = removeTarget;
	var ADD_SOURCE = 'dnd-core/ADD_SOURCE';
	exports.ADD_SOURCE = ADD_SOURCE;
	var ADD_TARGET = 'dnd-core/ADD_TARGET';
	exports.ADD_TARGET = ADD_TARGET;
	var REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
	exports.REMOVE_SOURCE = REMOVE_SOURCE;
	var REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';
	
	exports.REMOVE_TARGET = REMOVE_TARGET;
	
	function addSource(sourceId) {
	  return {
	    type: ADD_SOURCE,
	    sourceId: sourceId
	  };
	}
	
	function addTarget(targetId) {
	  return {
	    type: ADD_TARGET,
	    targetId: targetId
	  };
	}
	
	function removeSource(sourceId) {
	  return {
	    type: REMOVE_SOURCE,
	    sourceId: sourceId
	  };
	}
	
	function removeTarget(targetId) {
	  return {
	    type: REMOVE_TARGET,
	    targetId: targetId
	  };
	}

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(280),
	    isLength = __webpack_require__(70);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var EventPluginHub = __webpack_require__(29);
	var EventPluginRegistry = __webpack_require__(114);
	var ReactEventEmitterMixin = __webpack_require__(311);
	var ReactPerf = __webpack_require__(10);
	var ViewportMetrics = __webpack_require__(135);
	
	var assign = __webpack_require__(3);
	var isEventSupported = __webpack_require__(85);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(56);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	var ViewportMetrics = __webpack_require__(135);
	
	var getEventModifierState = __webpack_require__(81);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 57 */
/***/ function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module filter
	 */
	
	/**
	 * @param {Object} obj
	 * @param {string} keyNesting
	 * @param {*} val
	 */
	function setProp(obj, keyNesting, val) {
	    var nestedKeys = keyNesting.split(".");
	    var currentObj = obj;
	    for (var i = 0; i < (nestedKeys.length - 1); i++) {
	        if (!currentObj[nestedKeys[i]]) {
	            currentObj[nestedKeys[i]] = {};
	        }
	        currentObj = currentObj[nestedKeys[i]];
	    }
	    currentObj[nestedKeys[nestedKeys.length - 1]] = val;
	}
	
	/**
	 * Construct a new Filter.
	 * @constructor
	 * @param {string} userId The user ID for this filter.
	 * @param {string=} filterId The filter ID if known.
	 * @prop {string} userId The user ID of the filter
	 * @prop {?string} filterId The filter ID
	 */
	function Filter(userId, filterId) {
	    this.userId = userId;
	    this.filterId = filterId;
	    this.definition = {};
	}
	
	/**
	 * Get the JSON body of the filter.
	 * @return {Object} The filter definition
	 */
	Filter.prototype.getDefinition = function() {
	    return this.definition;
	};
	
	/**
	 * Set the JSON body of the filter
	 * @param {Object} definition The filter definition
	 */
	Filter.prototype.setDefinition = function(definition) {
	    this.definition = definition;
	};
	
	/**
	 * Set the max number of events to return for each room's timeline.
	 * @param {Number} limit The max number of events to return for each room.
	 */
	Filter.prototype.setTimelineLimit = function(limit) {
	    setProp(this.definition, "room.timeline.limit", limit);
	};
	
	/**
	 * Control whether left rooms should be included in responses.
	 * @param {boolean} includeLeave True to make rooms the user has left appear
	 * in responses.
	 */
	Filter.prototype.setIncludeLeaveRooms = function(includeLeave) {
	    setProp(this.definition, "room.include_leave", includeLeave);
	};
	
	/**
	 * Create a filter from existing data.
	 * @static
	 * @param {string} userId
	 * @param {string} filterId
	 * @param {Object} jsonObj
	 * @return {Filter}
	 */
	Filter.fromJson = function(userId, filterId, jsonObj) {
	    var filter = new Filter(userId, filterId);
	    filter.setDefinition(jsonObj);
	    return filter;
	};
	
	/** The Filter class */
	module.exports = Filter;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room
	 */
	var EventEmitter = __webpack_require__(27).EventEmitter;
	
	var EventStatus = __webpack_require__(15).EventStatus;
	var RoomSummary = __webpack_require__(186);
	var MatrixEvent = __webpack_require__(15).MatrixEvent;
	var utils = __webpack_require__(5);
	var ContentRepo = __webpack_require__(34);
	var EventTimeline = __webpack_require__(36);
	
	function synthesizeReceipt(userId, event, receiptType) {
	    // console.log("synthesizing receipt for "+event.getId());
	    // This is really ugly because JS has no way to express an object literal
	    // where the name of a key comes from an expression
	    var fakeReceipt = {
	        content: {},
	        type: "m.receipt",
	        room_id: event.getRoomId()
	    };
	    fakeReceipt.content[event.getId()] = {};
	    fakeReceipt.content[event.getId()][receiptType] = {};
	    fakeReceipt.content[event.getId()][receiptType][userId] = {
	        ts: event.getTs()
	    };
	    return new MatrixEvent(fakeReceipt);
	}
	
	
	/**
	 * Construct a new Room.
	 *
	 * <p>For a room, we store an ordered sequence of timelines, which may or may not
	 * be continuous. Each timeline lists a series of events, as well as tracking
	 * the room state at the start and the end of the timeline. It also tracks
	 * forward and backward pagination tokens, as well as containing links to the
	 * next timeline in the sequence.
	 *
	 * <p>There is one special timeline - the 'live' timeline, which represents the
	 * timeline to which events are being added in real-time as they are received
	 * from the /sync API. Note that you should not retain references to this
	 * timeline - even if it is the current timeline right now, it may not remain
	 * so if the server gives us a timeline gap in /sync.
	 *
	 * <p>In order that we can find events from their ids later, we also maintain a
	 * map from event_id to timeline and index.
	 *
	 * @constructor
	 * @param {string} roomId Required. The ID of this room.
	 * @param {Object=} opts Configuration options
	 * @param {*} opts.storageToken Optional. The token which a data store can use
	 * to remember the state of the room. What this means is dependent on the store
	 * implementation.
	 * @param {String=} opts.pendingEventOrdering Controls where pending messages appear
	 * in a room's timeline. If "<b>chronological</b>", messages will appear in the timeline
	 * when the call to <code>sendEvent</code> was made. If "<b>end</b>", pending messages
	 * will always appear at the end of the timeline (multiple pending messages will be sorted
	 * chronologically). Default: "chronological".
	 * @param {boolean} [opts.timelineSupport = false] Set to true to enable improved
	 * timeline support.
	 *
	 * @prop {string} roomId The ID of this room.
	 * @prop {string} name The human-readable display name for this room.
	 * @prop {Array<MatrixEvent>} timeline The live event timeline for this room,
	 * with the oldest event at index 0. Present for backwards compatibility -
	 * prefer getLiveTimeline().getEvents().
	 * @prop {object} tags Dict of room tags; the keys are the tag name and the values
	 * are any metadata associated with the tag - e.g. { "fav" : { order: 1 } }
	 * @prop {object} accountData Dict of per-room account_data events; the keys are the
	 * event type and the values are the events.
	 * @prop {RoomState} oldState The state of the room at the time of the oldest
	 * event in the live timeline. Present for backwards compatibility -
	 * prefer getLiveTimeline().getState(true).
	 * @prop {RoomState} currentState The state of the room at the time of the
	 * newest event in the timeline. Present for backwards compatibility -
	 * prefer getLiveTimeline().getState(false).
	 * @prop {RoomSummary} summary The room summary.
	 * @prop {*} storageToken A token which a data store can use to remember
	 * the state of the room.
	 */
	function Room(roomId, opts) {
	    opts = opts || {};
	    opts.pendingEventOrdering = opts.pendingEventOrdering || "chronological";
	
	    if (["chronological", "end"].indexOf(opts.pendingEventOrdering) === -1) {
	        throw new Error(
	            "opts.pendingEventOrdering MUST be either 'chronological' or " +
	            "'end'. Got: '" + opts.pendingEventOrdering + "'"
	        );
	    }
	
	    this.roomId = roomId;
	    this.name = roomId;
	    this.tags = {
	        // $tagName: { $metadata: $value },
	        // $tagName: { $metadata: $value },
	    };
	    this.accountData = {
	        // $eventType: $event
	    };
	    this.summary = null;
	    this.storageToken = opts.storageToken;
	    this._opts = opts;
	    this._redactions = [];
	    this._txnToEvent = {}; // Pending in-flight requests { string: MatrixEvent }
	    // receipts should clobber based on receipt_type and user_id pairs hence
	    // the form of this structure. This is sub-optimal for the exposed APIs
	    // which pass in an event ID and get back some receipts, so we also store
	    // a pre-cached list for this purpose.
	    this._receipts = {
	        // receipt_type: {
	        //   user_id: {
	        //     eventId: <event_id>,
	        //     data: <receipt_data>
	        //   }
	        // }
	    };
	    this._receiptCacheByEventId = {
	        // $event_id: [{
	        //   type: $type,
	        //   userId: $user_id,
	        //   data: <receipt data>
	        // }]
	    };
	
	    this._notificationCounts = {};
	
	    // just a list - *not* ordered.
	    this._timelines = [];
	    this._eventIdToTimeline = {};
	    this._timelineSupport = Boolean(opts.timelineSupport);
	
	    this.resetLiveTimeline();
	}
	utils.inherits(Room, EventEmitter);
	
	/**
	 * Get the live timeline for this room.
	 *
	 * @return {module:models/event-timeline~EventTimeline} live timeline
	 */
	Room.prototype.getLiveTimeline = function() {
	    return this._liveTimeline;
	};
	
	/**
	 * Reset the live timeline, and start a new one.
	 *
	 * <p>This is used when /sync returns a 'limited' timeline.
	 */
	Room.prototype.resetLiveTimeline = function() {
	    var newTimeline;
	
	    if (!this._timelineSupport) {
	        // if timeline support is disabled, forget about the old timelines
	        newTimeline = new EventTimeline(this.roomId);
	        this._timelines = [newTimeline];
	        this._eventIdToTimeline = {};
	    } else {
	        newTimeline = this.addTimeline();
	    }
	
	    if (this._liveTimeline) {
	        // we have an existing timeline. This will always be true, except when
	        // this method is called by our own constructor.
	
	        // initialise the state in the new timeline from our last known state
	        var evMap = this._liveTimeline.getState(EventTimeline.FORWARDS).events;
	        var events = [];
	        for (var evtype in evMap) {
	            if (!evMap.hasOwnProperty(evtype)) { continue; }
	            for (var stateKey in evMap[evtype]) {
	                if (!evMap[evtype].hasOwnProperty(stateKey)) { continue; }
	                events.push(evMap[evtype][stateKey]);
	            }
	        }
	        newTimeline.initialiseState(events);
	    }
	    this._liveTimeline = newTimeline;
	
	    // maintain this.timeline as a reference to the live timeline,
	    // and this.oldState and this.currentState as references to the
	    // state at the start and end of that timeline. These are more
	    // for backwards-compatibility than anything else.
	    this.timeline = this._liveTimeline.getEvents();
	    this.oldState = this._liveTimeline.getState(EventTimeline.BACKWARDS);
	    this.currentState = this._liveTimeline.getState(EventTimeline.FORWARDS);
	};
	
	/**
	 * Get the timeline which contains the given event, if any
	 *
	 * @param {string} eventId  event ID to look for
	 * @return {?module:models/event-timeline~EventTimeline} timeline containing
	 * the given event, or null if unknown
	 */
	Room.prototype.getTimelineForEvent = function(eventId) {
	    var res = this._eventIdToTimeline[eventId];
	    return (res === undefined) ? null : res;
	};
	
	/**
	 * Get one of the notification counts for this room
	 * @param {String} type The type of notification count to get. default: 'total'
	 * @return {Number} The notification count, or undefined if there is no count
	 *                  for this type.
	 */
	Room.prototype.getUnreadNotificationCount = function(type) {
	    type = type || 'total';
	    return this._notificationCounts[type];
	};
	
	/**
	 * Set one of the notification counts for this room
	 * @param {String} type The type of notification count to set.
	 * @param {Number} count The new count
	 */
	Room.prototype.setUnreadNotificationCount = function(type, count) {
	    this._notificationCounts[type] = count;
	};
	
	/**
	 * Get the avatar URL for a room if one was set.
	 * @param {String} baseUrl The homeserver base URL. See
	 * {@link module:client~MatrixClient#getHomeserverUrl}.
	 * @param {Number} width The desired width of the thumbnail.
	 * @param {Number} height The desired height of the thumbnail.
	 * @param {string} resizeMethod The thumbnail resize method to use, either
	 * "crop" or "scale".
	 * @param {boolean} allowDefault True to allow an identicon for this room if an
	 * avatar URL wasn't explicitly set. Default: true.
	 * @return {?string} the avatar URL or null.
	 */
	Room.prototype.getAvatarUrl = function(baseUrl, width, height, resizeMethod,
	                                       allowDefault) {
	    var roomAvatarEvent = this.currentState.getStateEvents("m.room.avatar", "");
	    if (allowDefault === undefined) { allowDefault = true; }
	    if (!roomAvatarEvent && !allowDefault) {
	        return null;
	    }
	
	    var mainUrl = roomAvatarEvent ? roomAvatarEvent.getContent().url : null;
	    if (mainUrl) {
	        return ContentRepo.getHttpUriForMxc(
	            baseUrl, mainUrl, width, height, resizeMethod
	        );
	    }
	    else if (allowDefault) {
	        return ContentRepo.getIdenticonUri(
	            baseUrl, this.roomId, width, height
	        );
	    }
	
	    return null;
	};
	
	/**
	 * Get a member from the current room state.
	 * @param {string} userId The user ID of the member.
	 * @return {RoomMember} The member or <code>null</code>.
	 */
	 Room.prototype.getMember = function(userId) {
	    var member = this.currentState.members[userId];
	    if (!member) {
	        return null;
	    }
	    return member;
	 };
	
	/**
	 * Get a list of members whose membership state is "join".
	 * @return {RoomMember[]} A list of currently joined members.
	 */
	 Room.prototype.getJoinedMembers = function() {
	    return this.getMembersWithMembership("join");
	 };
	
	/**
	 * Get a list of members with given membership state.
	 * @param {string} membership The membership state.
	 * @return {RoomMember[]} A list of members with the given membership state.
	 */
	 Room.prototype.getMembersWithMembership = function(membership) {
	    return utils.filter(this.currentState.getMembers(), function(m) {
	        return m.membership === membership;
	    });
	 };
	
	 /**
	  * Get the default room name (i.e. what a given user would see if the
	  * room had no m.room.name)
	  * @param {string} userId The userId from whose perspective we want
	  * to calculate the default name
	  * @return {string} The default room name
	  */
	 Room.prototype.getDefaultRoomName = function(userId) {
	    return calculateRoomName(this, userId, true);
	 };
	
	
	 /**
	 * Check if the given user_id has the given membership state.
	 * @param {string} userId The user ID to check.
	 * @param {string} membership The membership e.g. <code>'join'</code>
	 * @return {boolean} True if this user_id has the given membership state.
	 */
	 Room.prototype.hasMembershipState = function(userId, membership) {
	    var member = this.getMember(userId);
	    if (!member) {
	        return false;
	    }
	    return member.membership === membership;
	 };
	
	/**
	 * Add a new timeline to this room
	 *
	 * @return {module:models/event-timeline~EventTimeline} newly-created timeline
	 */
	Room.prototype.addTimeline = function() {
	    if (!this._timelineSupport) {
	        throw Error("timeline support is disabled. Set the 'timelineSupport'" +
	                    " parameter to true when creating MatrixClient to enable" +
	                    " it.");
	    }
	
	    var timeline = new EventTimeline(this.roomId);
	    this._timelines.push(timeline);
	    return timeline;
	};
	
	
	/**
	 * Add events to a timeline
	 *
	 * <p>Will fire "Room.timeline" for each event added.
	 *
	 * @param {MatrixEvent[]} events A list of events to add.
	 *
	 * @param {boolean} toStartOfTimeline   True to add these events to the start
	 * (oldest) instead of the end (newest) of the timeline. If true, the oldest
	 * event will be the <b>last</b> element of 'events'.
	 *
	 * @param {module:models/event-timeline~EventTimeline=} timeline   timeline to
	 *    add events to. If not given, events will be added to the live timeline
	 *
	 * @param {string=} paginationToken   token for the next batch of events
	 *
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 *
	 */
	Room.prototype.addEventsToTimeline = function(events, toStartOfTimeline,
	                                              timeline, paginationToken) {
	    if (!timeline) {
	        timeline = this._liveTimeline;
	    }
	
	    if (!toStartOfTimeline && timeline == this._liveTimeline) {
	        // special treatment for live events
	        this._addLiveEvents(events);
	        return;
	    }
	
	    var direction = toStartOfTimeline ? EventTimeline.BACKWARDS :
	        EventTimeline.FORWARDS;
	    var inverseDirection = toStartOfTimeline ? EventTimeline.FORWARDS :
	        EventTimeline.BACKWARDS;
	
	    // Adding events to timelines can be quite complicated. The following
	    // illustrates some of the corner-cases.
	    //
	    // Let's say we start by knowing about four timelines. timeline3 and
	    // timeline4 are neighbours:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M]          [P]          [S] <------> [T]
	    //
	    // Now we paginate timeline1, and get the following events from the server:
	    // [M, N, P, R, S, T, U].
	    //
	    // 1. First, we ignore event M, since we already know about it.
	    //
	    // 2. Next, we append N to timeline 1.
	    //
	    // 3. Next, we don't add event P, since we already know about it,
	    //    but we do link together the timelines. We now have:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P]          [S] <------> [T]
	    //
	    // 4. Now we add event R to timeline2:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P, R]       [S] <------> [T]
	    //
	    //    Note that we have switched the timeline we are working on from
	    //    timeline1 to timeline2.
	    //
	    // 5. We ignore event S, but again join the timelines:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P, R] <---> [S] <------> [T]
	    //
	    // 6. We ignore event T, and the timelines are already joined, so there
	    //    is nothing to do.
	    //
	    // 7. Finally, we add event U to timeline4:
	    //
	    //    timeline1    timeline2    timeline3    timeline4
	    //      [M, N] <---> [P, R] <---> [S] <------> [T, U]
	    //
	    // The important thing to note in the above is what happened when we
	    // already knew about a given event:
	    //
	    //   - if it was appropriate, we joined up the timelines (steps 3, 5).
	    //   - in any case, we started adding further events to the timeline which
	    //       contained the event we knew about (steps 3, 5, 6).
	    //
	    //
	    // Finally, consider what we want to do with the pagination token. In the
	    // case above, we will be given a pagination token which tells us how to
	    // get events beyond 'U' - in this case, it makes sense to store this
	    // against timeline4. But what if timeline4 already had 'U' and beyond? in
	    // that case, our best bet is to throw away the pagination token we were
	    // given and stick with whatever token timeline4 had previously. In short,
	    // we want to only store the pagination token if the last event we receive
	    // is one we didn't previously know about.
	
	    var updateToken = false;
	    for (var i = 0; i < events.length; i++) {
	        var event = events[i];
	        var eventId = event.getId();
	
	        var existingTimeline = this._eventIdToTimeline[eventId];
	
	        if (!existingTimeline) {
	            // we don't know about this event yet. Just add it to the timeline.
	            this._addEventToTimeline(event, timeline, toStartOfTimeline);
	            updateToken = true;
	            continue;
	        }
	
	        // we already know about this event. We don't want to use the pagination
	        // token if this is the last event, as per the text above.
	        updateToken = false;
	
	        if (existingTimeline == timeline) {
	            console.log("Event " + eventId + " already in timeline " + timeline);
	            continue;
	        }
	
	        var neighbour = timeline.getNeighbouringTimeline(direction);
	        if (neighbour) {
	            // this timeline already has a neighbour in the relevant direction;
	            // let's assume the timelines are already correctly linked up, and
	            // skip over to it.
	            //
	            // there's probably some edge-case here where we end up with an
	            // event which is in a timeline a way down the chain, and there is
	            // a break in the chain somewhere. But I can't really imagine how
	            // that would happen, so I'm going to ignore it for now.
	            //
	            if (existingTimeline == neighbour) {
	                console.log("Event " + eventId + " in neighbouring timeline - " +
	                            "switching to " + existingTimeline);
	            } else {
	                console.log("Event " + eventId + " already in a different " +
	                            "timeline " + existingTimeline);
	            }
	            timeline = existingTimeline;
	            continue;
	        }
	
	        // time to join the timelines.
	        console.info("Already have timeline for " + eventId +
	                     " - joining timeline " + timeline + " to " +
	                     existingTimeline);
	        timeline.setNeighbouringTimeline(existingTimeline, direction);
	        existingTimeline.setNeighbouringTimeline(timeline, inverseDirection);
	        timeline = existingTimeline;
	    }
	
	    if (updateToken) {
	        timeline.setPaginationToken(paginationToken, direction);
	    }
	};
	
	/**
	 * Check for redactions, and otherwise add event to the given timeline. Assumes
	 * we have already checked we don't know about this event.
	 *
	 * Will fire "Room.timeline" for each event added.
	 *
	 * @param {MatrixEvent} event
	 * @param {EventTimeline} timeline
	 * @param {boolean} toStartOfTimeline
	 *
	 * @param {boolean} spliceBeforeLocalEcho   if true, insert this event before
	 *     any localecho events at the end of the timeline. Ignored if
	 *     toStartOfTimeline == true.
	 *
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 *
	 * @private
	 */
	Room.prototype._addEventToTimeline = function(event, timeline, toStartOfTimeline,
	                                              spliceBeforeLocalEcho) {
	    var eventId = event.getId();
	
	    if (this._redactions.indexOf(eventId) >= 0) {
	        return; // do not add the redacted event.
	    }
	
	    if (event.getType() === "m.room.redaction") {
	        var redactId = event.event.redacts;
	
	        // try to remove the element
	        var removed = this.removeEvent(redactId);
	        if (!removed) {
	            // redactions will trickle in BEFORE the event redacted so make
	            // a note of the redacted event; we'll check it later.
	            this._redactions.push(event.event.redacts);
	        }
	        // NB: We continue to add the redaction event to the timeline so clients
	        // can say "so and so redacted an event" if they wish to.
	    }
	
	    if (this._redactions.indexOf(eventId) < 0) {
	        timeline.addEvent(event, toStartOfTimeline, spliceBeforeLocalEcho);
	        this._eventIdToTimeline[eventId] = timeline;
	    }
	
	    var data = {
	        timeline: timeline,
	        liveEvent: !toStartOfTimeline && timeline == this._liveTimeline,
	    };
	    this.emit("Room.timeline", event, this, Boolean(toStartOfTimeline), false, data);
	};
	
	
	/**
	 * Add some events to the end of this room's live timeline. Will fire
	 * "Room.timeline" for each event added.
	 *
	 * @param {MatrixEvent[]} events A list of events to add.
	 * @fires module:client~MatrixClient#event:"Room.timeline"
	 * @private
	 */
	Room.prototype._addLiveEvents = function(events) {
	    var addLocalEchoToEnd = this._opts.pendingEventOrdering === "end";
	
	    for (var i = 0; i < events.length; i++) {
	        var isLocalEcho = (
	                events[i].status === EventStatus.SENDING ||
	                events[i].status === EventStatus.QUEUED
	        );
	
	        // FIXME: HORRIBLE ASSUMPTION THAT THIS PROP EXISTS
	        // Exists due to client.js:815 (MatrixClient.sendEvent)
	        // We should make txnId a first class citizen.
	        if (events[i]._txnId) {
	            // this is the outgoing copy of the event (ie, the local echo).
	            this._txnToEvent[events[i]._txnId] = events[i];
	        }
	        else if (events[i].getUnsigned().transaction_id) {
	            // remote echo of an event we sent earlier
	            var existingEvent = this._txnToEvent[events[i].getUnsigned().transaction_id];
	            if (existingEvent) {
	                // no longer pending
	                delete this._txnToEvent[events[i].getUnsigned().transaction_id];
	
	                // update the timeline map, because the event id has changed
	                var existingTimeline = this._eventIdToTimeline[existingEvent.getId()];
	                if (existingTimeline) {
	                    delete this._eventIdToTimeline[existingEvent.getId()];
	                    this._eventIdToTimeline[events[i].getId()] = existingTimeline;
	                }
	
	                // replace the event source
	                existingEvent.event = events[i].event;
	                continue;
	            }
	        }
	
	        var spliceBeforeLocalEcho = !isLocalEcho && addLocalEchoToEnd;
	
	        if (!this._eventIdToTimeline[events[i].getId()]) {
	            // TODO: pass through filter to see if this should be added to the timeline.
	            this._addEventToTimeline(events[i], this._liveTimeline, false,
	                                     spliceBeforeLocalEcho);
	        }
	
	        // synthesize and inject implicit read receipts
	        // Done after adding the event because otherwise the app would get a read receipt
	        // pointing to an event that wasn't yet in the timeline
	        //
	        // (we don't do this for local echoes, as they have temporary event
	        // ids, which don't make much sense as RRs).
	        if (events[i].sender && !isLocalEcho) {
	            this.addReceipt(synthesizeReceipt(
	                events[i].sender.userId, events[i], "m.read"
	            ));
	        }
	    }
	};
	
	/**
	 * Add some events to this room. This can include state events, message
	 * events and typing notifications. These events are treated as "live" so
	 * they will go to the end of the timeline.
	 * @param {MatrixEvent[]} events A list of events to add.
	 * @param {string} duplicateStrategy Optional. Applies to events in the
	 * timeline only. If this is not specified, no duplicate suppression is
	 * performed (this improves performance). If this is 'replace' then if a
	 * duplicate is encountered, the event passed to this function will replace the
	 * existing event in the timeline. If this is 'ignore', then the event passed to
	 * this function will be ignored entirely, preserving the existing event in the
	 * timeline. Events are identical based on their event ID <b>only</b>.
	 * @throws If <code>duplicateStrategy</code> is not falsey, 'replace' or 'ignore'.
	 */
	Room.prototype.addEvents = function(events, duplicateStrategy) {
	    if (duplicateStrategy && ["replace", "ignore"].indexOf(duplicateStrategy) === -1) {
	        throw new Error("duplicateStrategy MUST be either 'replace' or 'ignore'");
	    }
	    for (var i = 0; i < events.length; i++) {
	        if (events[i].getType() === "m.typing") {
	            this.currentState.setTypingEvent(events[i]);
	        }
	        else if (events[i].getType() === "m.receipt") {
	            this.addReceipt(events[i]);
	        }
	        // N.B. account_data is added directly by /sync to avoid
	        // having to maintain an event.isAccountData() here
	        else {
	            var timeline = this._eventIdToTimeline[events[i].getId()];
	            if (timeline && duplicateStrategy) {
	                // is there a duplicate?
	                var shouldIgnore = false;
	                var tlEvents = timeline.getEvents();
	                for (var j = 0; j < tlEvents.length; j++) {
	                    if (tlEvents[j].getId() === events[i].getId()) {
	                        if (duplicateStrategy === "replace") {
	                            // still need to set the right metadata on this event
	                            setEventMetadata(
	                                events[i],
	                                timeline.getState(EventTimeline.FORWARDS),
	                                false
	                            );
	
	                            if (!tlEvents[j].encryptedType) {
	                                tlEvents[j] = events[i];
	                            }
	                            // skip the insert so we don't add this event twice.
	                            // Don't break in case we replace multiple events.
	                            shouldIgnore = true;
	                        }
	                        else if (duplicateStrategy === "ignore") {
	                            shouldIgnore = true;
	                            break; // stop searching, we're skipping the insert
	                        }
	                    }
	                }
	                if (shouldIgnore) {
	                    continue; // skip the insertion of this event.
	                }
	            }
	            // TODO: We should have a filter to say "only add state event
	            // types X Y Z to the timeline".
	            this._addLiveEvents([events[i]]);
	        }
	    }
	};
	
	/**
	 * Removes events from this room.
	 * @param {String[]} event_ids A list of event_ids to remove.
	 */
	Room.prototype.removeEvents = function(event_ids) {
	    for (var i = 0; i < event_ids.length; ++i) {
	        this.removeEvent(event_ids[i]);
	    }
	};
	
	/**
	 * Removes a single event from this room.
	 *
	 * @param {String} eventId  The id of the event to remove
	 *
	 * @return {?MatrixEvent} the removed event, or null if the event was not found
	 * in this room.
	 */
	Room.prototype.removeEvent = function(eventId) {
	    var timeline = this._eventIdToTimeline[eventId];
	    if (!timeline) {
	        return null;
	    }
	
	    var removed = timeline.removeEvent(eventId);
	    if (removed) {
	        delete this._eventIdToTimeline[eventId];
	        var data = {
	            timeline: timeline,
	        };
	        this.emit("Room.timeline", removed, this, undefined, true, data);
	    }
	    return removed;
	};
	
	/**
	 * Determine where two events appear in the timeline relative to one another
	 *
	 * @param {string} eventId1   The id of the first event
	 * @param {string} eventId2   The id of the second event
	
	 * @return {?number} a number less than zero if eventId1 precedes eventId2, and
	 *    greater than zero if eventId1 succeeds eventId2. zero if they are the
	 *    same event; null if we can't tell (either because we don't know about one
	 *    of the events, or because they are in separate timelines which don't join
	 *    up).
	 */
	Room.prototype.compareEventOrdering = function(eventId1, eventId2) {
	    if (eventId1 == eventId2) {
	        // optimise this case
	        return 0;
	    }
	
	    var timeline1 = this._eventIdToTimeline[eventId1];
	    var timeline2 = this._eventIdToTimeline[eventId2];
	
	    if (timeline1 === undefined) {
	        return null;
	    }
	    if (timeline2 === undefined) {
	        return null;
	    }
	
	    if (timeline1 === timeline2) {
	        // both events are in the same timeline - figure out their
	        // relative indices
	        var idx1, idx2;
	        var events = timeline1.getEvents();
	        for (var idx = 0; idx < events.length &&
	             (idx1 === undefined || idx2 === undefined); idx++) {
	            var evId = events[idx].getId();
	            if (evId == eventId1) {
	                idx1 = idx;
	            }
	            if (evId == eventId2) {
	                idx2 = idx;
	            }
	        }
	        return idx1 - idx2;
	    }
	
	    // the events are in different timelines. Iterate through the
	    // linkedlist to see which comes first.
	
	    // first work forwards from timeline1
	    var tl = timeline1;
	    while (tl) {
	        if (tl === timeline2) {
	            // timeline1 is before timeline2
	            return -1;
	        }
	        tl = tl.getNeighbouringTimeline(EventTimeline.FORWARDS);
	    }
	
	    // now try backwards from timeline1
	    tl = timeline1;
	    while (tl) {
	        if (tl === timeline2) {
	            // timeline2 is before timeline1
	            return 1;
	        }
	        tl = tl.getNeighbouringTimeline(EventTimeline.BACKWARDS);
	    }
	
	    // the timelines are not contiguous.
	    return null;
	};
	
	/**
	 * Recalculate various aspects of the room, including the room name and
	 * room summary. Call this any time the room's current state is modified.
	 * May fire "Room.name" if the room name is updated.
	 * @param {string} userId The client's user ID.
	 * @fires module:client~MatrixClient#event:"Room.name"
	 */
	Room.prototype.recalculate = function(userId) {
	    // set fake stripped state events if this is an invite room so logic remains
	    // consistent elsewhere.
	    var self = this;
	    var membershipEvent = this.currentState.getStateEvents(
	        "m.room.member", userId
	    );
	    if (membershipEvent && membershipEvent.getContent().membership === "invite") {
	        var strippedStateEvents = membershipEvent.event.invite_room_state || [];
	        utils.forEach(strippedStateEvents, function(strippedEvent) {
	            var existingEvent = self.currentState.getStateEvents(
	                strippedEvent.type, strippedEvent.state_key
	            );
	            if (!existingEvent) {
	                // set the fake stripped event instead
	                self.currentState.setStateEvents([new MatrixEvent({
	                    type: strippedEvent.type,
	                    state_key: strippedEvent.state_key,
	                    content: strippedEvent.content,
	                    event_id: "$fake" + Date.now(),
	                    room_id: self.roomId,
	                    user_id: userId // technically a lie
	                })]);
	            }
	        });
	    }
	
	
	
	    var oldName = this.name;
	    this.name = calculateRoomName(this, userId);
	    this.summary = new RoomSummary(this.roomId, {
	        title: this.name
	    });
	
	    if (oldName !== this.name) {
	        this.emit("Room.name", this);
	    }
	};
	
	
	/**
	 * Get a list of user IDs who have <b>read up to</b> the given event.
	 * @param {MatrixEvent} event the event to get read receipts for.
	 * @return {String[]} A list of user IDs.
	 */
	Room.prototype.getUsersReadUpTo = function(event) {
	    return this.getReceiptsForEvent(event).filter(function(receipt) {
	        return receipt.type === "m.read";
	    }).map(function(receipt) {
	        return receipt.userId;
	    });
	};
	
	/**
	 * Get the ID of the event that a given user has read up to, or null if we
	 * have received no read receipts from them.
	 * @param {String} userId The user ID to get read receipt event ID for
	 * @return {String} ID of the latest event that the given user has read, or null.
	 */
	Room.prototype.getEventReadUpTo = function(userId) {
	    if (
	        this._receipts["m.read"] === undefined ||
	        this._receipts["m.read"][userId] === undefined
	    ) {
	        return null;
	    }
	
	    return this._receipts["m.read"][userId].eventId;
	};
	
	/**
	 * Get a list of receipts for the given event.
	 * @param {MatrixEvent} event the event to get receipts for
	 * @return {Object[]} A list of receipts with a userId, type and data keys or
	 * an empty list.
	 */
	Room.prototype.getReceiptsForEvent = function(event) {
	    return this._receiptCacheByEventId[event.getId()] || [];
	};
	
	/**
	 * Add a receipt event to the room.
	 * @param {MatrixEvent} event The m.receipt event.
	 */
	Room.prototype.addReceipt = function(event) {
	    // event content looks like:
	    // content: {
	    //   $event_id: {
	    //     $receipt_type: {
	    //       $user_id: {
	    //         ts: $timestamp
	    //       }
	    //     }
	    //   }
	    // }
	    var self = this;
	    utils.keys(event.getContent()).forEach(function(eventId) {
	        utils.keys(event.getContent()[eventId]).forEach(function(receiptType) {
	            utils.keys(event.getContent()[eventId][receiptType]).forEach(
	            function(userId) {
	                var receipt = event.getContent()[eventId][receiptType][userId];
	
	                if (!self._receipts[receiptType]) {
	                    self._receipts[receiptType] = {};
	                }
	
	                var existingReceipt = self._receipts[receiptType][userId];
	
	                if (!existingReceipt) {
	                    self._receipts[receiptType][userId] = {};
	                } else {
	                    // we only want to add this receipt if we think it is later
	                    // than the one we already have. (This is managed
	                    // server-side, but because we synthesize RRs locally we
	                    // have to do it here too.)
	                    var ordering = self.compareEventOrdering(
	                        existingReceipt.eventId, eventId);
	                    if (ordering !== null && ordering >= 0) {
	                        return;
	                    }
	                }
	
	                self._receipts[receiptType][userId] = {
	                    eventId: eventId,
	                    data: receipt
	                };
	            });
	        });
	    });
	
	    // pre-cache receipts by event
	    self._receiptCacheByEventId = {};
	    utils.keys(self._receipts).forEach(function(receiptType) {
	        utils.keys(self._receipts[receiptType]).forEach(function(userId) {
	            var receipt = self._receipts[receiptType][userId];
	            if (!self._receiptCacheByEventId[receipt.eventId]) {
	                self._receiptCacheByEventId[receipt.eventId] = [];
	            }
	            self._receiptCacheByEventId[receipt.eventId].push({
	                userId: userId,
	                type: receiptType,
	                data: receipt.data
	            });
	        });
	    });
	
	    // send events after we've regenerated the cache, otherwise things that
	    // listened for the event would read from a stale cache
	    this.emit("Room.receipt", event, this);
	};
	
	/**
	 * Add a temporary local-echo receipt to the room to reflect in the
	 * client the fact that we've sent one.
	 * @param {string} userId The user ID if the receipt sender
	 * @param {MatrixEvent} e The event that is to be acknowledged
	 * @param {string} receiptType The type of receipt
	 */
	Room.prototype._addLocalEchoReceipt = function(userId, e, receiptType) {
	    this.addReceipt(synthesizeReceipt(userId, e, receiptType));
	};
	
	/**
	 * Update the room-tag event for the room.  The previous one is overwritten.
	 * @param {MatrixEvent} event the m.tag event
	 */
	Room.prototype.addTags = function(event) {
	    // event content looks like:
	    // content: {
	    //    tags: {
	    //       $tagName: { $metadata: $value },
	    //       $tagName: { $metadata: $value },
	    //    }
	    // }
	
	    // XXX: do we need to deep copy here?
	    this.tags = event.getContent().tags;
	
	    // XXX: we could do a deep-comparison to see if the tags have really
	    // changed - but do we want to bother?
	    this.emit("Room.tags", event, this);
	};
	
	/**
	 * Update the account_data events for this room, overwriting events of the same type.
	 * @param {Array<MatrixEvent>} events an array of account_data events to add
	 */
	Room.prototype.addAccountData = function(events) {
	    for (var i = 0; i < events.length; i++) {
	        var event = events[i];
	        if (event.getType() === "m.tag") {
	            this.addTags(event);
	        }
	        this.accountData[event.getType()] = event;
	        this.emit("Room.accountData", event, this);
	    }
	};
	
	/**
	 * Access account_data event of given event type for this room
	 * @param {string} type the type of account_data event to be accessed
	 * @return {?MatrixEvent} the account_data event in question
	 */
	Room.prototype.getAccountData = function(type) {
	    return this.accountData[type];
	};
	
	function setEventMetadata(event, stateContext, toStartOfTimeline) {
	    // set sender and target properties
	    event.sender = stateContext.getSentinelMember(
	        event.getSender()
	    );
	    if (event.getType() === "m.room.member") {
	        event.target = stateContext.getSentinelMember(
	            event.getStateKey()
	        );
	    }
	    if (event.isState()) {
	        // room state has no concept of 'old' or 'current', but we want the
	        // room state to regress back to previous values if toStartOfTimeline
	        // is set, which means inspecting prev_content if it exists. This
	        // is done by toggling the forwardLooking flag.
	        if (toStartOfTimeline) {
	            event.forwardLooking = false;
	        }
	    }
	}
	
	/**
	 * This is an internal method. Calculates the name of the room from the current
	 * room state.
	 * @param {Room} room The matrix room.
	 * @param {string} userId The client's user ID. Used to filter room members
	 * correctly.
	 * @param {bool} ignoreRoomNameEvent Return the implicit room name that we'd see if there
	 * was no m.room.name event.
	 * @return {string} The calculated room name.
	 */
	function calculateRoomName(room, userId, ignoreRoomNameEvent) {
	    if (!ignoreRoomNameEvent) {
	        // check for an alias, if any. for now, assume first alias is the
	        // official one.
	        var mRoomName = room.currentState.getStateEvents("m.room.name", "");
	        if (mRoomName && mRoomName.getContent() && mRoomName.getContent().name) {
	            return mRoomName.getContent().name;
	        }
	    }
	
	    var alias;
	    var canonicalAlias = room.currentState.getStateEvents("m.room.canonical_alias", "");
	    if (canonicalAlias) {
	        alias = canonicalAlias.getContent().alias;
	    }
	
	    if (!alias) {
	        var mRoomAliases = room.currentState.getStateEvents("m.room.aliases")[0];
	        if (mRoomAliases && utils.isArray(mRoomAliases.getContent().aliases)) {
	            alias = mRoomAliases.getContent().aliases[0];
	        }
	    }
	    if (alias) {
	        return alias;
	    }
	
	    // get members that are NOT ourselves and are actually in the room.
	    var members = utils.filter(room.currentState.getMembers(), function(m) {
	        return (m.userId !== userId && m.membership !== "leave");
	    });
	    // TODO: Localisation
	    if (members.length === 0) {
	        var memberList = utils.filter(room.currentState.getMembers(), function(m) {
	            return (m.membership !== "leave");
	        });
	        if (memberList.length === 1) {
	            // self-chat, peeked room with 1 participant, or invite.
	            if (memberList[0].membership === "invite") {
	                if (memberList[0].events.member) {
	                    // extract who invited us to the room
	                    return "Invite from " + memberList[0].events.member.getSender();
	                }
	                else {
	                    return "Room Invite";
	                }
	            }
	            else {
	                if (memberList[0].userId === userId) {
	                    return "Empty room";
	                }
	                else {
	                    return memberList[0].name;
	                }
	            }
	        }
	        else {
	            // there really isn't anyone in this room...
	            return "Empty room";
	        }
	    }
	    else if (members.length === 1) {
	        return members[0].name;
	    }
	    else if (members.length === 2) {
	        return (
	            members[0].name + " and " + members[1].name
	        );
	    }
	    else {
	        return (
	            members[0].name + " and " + (members.length - 1) + " others"
	        );
	    }
	}
	
	/**
	 * The Room class.
	 */
	module.exports = Room;
	
	/**
	 * Fires whenever the timeline in a room is updated.
	 * @event module:client~MatrixClient#"Room.timeline"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {Room} room The room whose Room.timeline was updated.
	 * @param {boolean} toStartOfTimeline True if this event was added to the start
	 * @param {boolean} removed True if this event has just been removed from the timeline
	 * (beginning; oldest) of the timeline e.g. due to pagination.
	 *
	 * @param {object} data  more data about the event
	 *
	 * @param {module:event-timeline.EventTimeline} data.timeline the timeline the
	 * event was added to/removed from
	 *
	 * @param {boolean} data.liveEvent true if the event was a real-time event
	 * added to the end of the live timeline
	 *
	 * @example
	 * matrixClient.on("Room.timeline", function(event, room, toStartOfTimeline, data){
	 *   if (!toStartOfTimeline && data.liveEvent) {
	 *     var messageToAppend = room.timeline.[room.timeline.length - 1];
	 *   }
	 * });
	 */
	
	/**
	 * Fires whenever the name of a room is updated.
	 * @event module:client~MatrixClient#"Room.name"
	 * @param {Room} room The room whose Room.name was updated.
	 * @example
	 * matrixClient.on("Room.name", function(room){
	 *   var newName = room.name;
	 * });
	 */
	
	/**
	 * Fires whenever a receipt is received for a room
	 * @event module:client~MatrixClient#"Room.receipt"
	 * @param {event} event The receipt event
	 * @param {Room} room The room whose receipts was updated.
	 * @example
	 * matrixClient.on("Room.receipt", function(event, room){
	 *   var receiptContent = event.getContent();
	 * });
	 */
	
	/**
	 * Fires whenever a room's tags are updated.
	 * @event module:client~MatrixClient#"Room.tags"
	 * @param {event} event The tags event
	 * @param {Room} room The room whose Room.tags was updated.
	 * @example
	 * matrixClient.on("Room.tags", function(event, room){
	 *   var newTags = event.getContent().tags;
	 *   if (newTags["favourite"]) showStar(room);
	 * });
	 */
	
	/**
	 * Fires whenever a room's account_data is updated.
	 * @event module:client~MatrixClient#"Room.accountData"
	 * @param {event} event The account_data event
	 * @param {Room} room The room whose account_data was updated.
	 * @example
	 * matrixClient.on("Room.accountData", function(event, room){
	 *   if (event.getType() === "m.room.colorscheme") {
	 *       applyColorScheme(event.getContents());
	 *   }
	 * });
	 */


/***/ },
/* 59 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var FILE = '__NATIVE_FILE__';
	exports.FILE = FILE;
	var URL = '__NATIVE_URL__';
	exports.URL = URL;
	var TEXT = '__NATIVE_TEXT__';
	exports.TEXT = TEXT;

/***/ },
/* 60 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(28),
	    isObjectLike = __webpack_require__(41);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39),
	    isLength = __webpack_require__(40),
	    isObjectLike = __webpack_require__(41);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 63 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports["default"];

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	exports.__esModule = true;
	
	var _isDisposable2 = __webpack_require__(65);
	
	var _isDisposable3 = _interopRequireWildcard(_isDisposable2);
	
	exports.isDisposable = _isDisposable3['default'];
	
	var _Disposable2 = __webpack_require__(253);
	
	var _Disposable3 = _interopRequireWildcard(_Disposable2);
	
	exports.Disposable = _Disposable3['default'];
	
	var _CompositeDisposable2 = __webpack_require__(252);
	
	var _CompositeDisposable3 = _interopRequireWildcard(_CompositeDisposable2);
	
	exports.CompositeDisposable = _CompositeDisposable3['default'];
	
	var _SerialDisposable2 = __webpack_require__(254);
	
	var _SerialDisposable3 = _interopRequireWildcard(_SerialDisposable2);
	
	exports.SerialDisposable = _SerialDisposable3['default'];

/***/ },
/* 65 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isDisposable;
	
	function isDisposable(obj) {
	  return Boolean(obj && typeof obj.dispose === 'function');
	}
	
	module.exports = exports['default'];

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(281);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(272),
	    getNative = __webpack_require__(69);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(285);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 70 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(16);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	var ReactPerf = __webpack_require__(10);
	
	var quoteAttributeValueForBrowser = __webpack_require__(341);
	var warning = __webpack_require__(4);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(133);
	var ReactPropTypeLocations = __webpack_require__(50);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(76);
	var ReactMount = __webpack_require__(7);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(113);
	var DOMPropertyOperations = __webpack_require__(72);
	var ReactMount = __webpack_require__(7);
	var ReactPerf = __webpack_require__(10);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactElement = __webpack_require__(9);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactUpdates = __webpack_require__(11);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 78 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.7';

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactMount = __webpack_require__(7);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ },
/* 80 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(302);
	var ReactEmptyComponent = __webpack_require__(125);
	var ReactNativeComponent = __webpack_require__(131);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	var escapeTextContentForBrowser = __webpack_require__(54);
	var setInnerHTML = __webpack_require__(55);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 87 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactElement = __webpack_require__(9);
	var ReactInstanceHandles = __webpack_require__(26);
	
	var getIteratorFn = __webpack_require__(83);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(12);
	var warning = __webpack_require__(4);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(147).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90).setImmediate, __webpack_require__(90).clearImmediate))

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	"use strict";
	
	var q = __webpack_require__(18);
	var Matrix = __webpack_require__(183);
	var Room = Matrix.Room;
	var CallHandler = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/CallHandler\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	// FIXME: This currently forces Vector to try to hit the matrix.org AS for conferencing.
	// This is bad because it prevents people running their own ASes from being used.
	// This isn't permanent and will be customisable in the future: see the proposal
	// at docs/conferencing.md for more info.
	var USER_PREFIX = "fs_";
	var DOMAIN = "matrix.org";
	
	function ConferenceCall(matrixClient, groupChatRoomId) {
	    this.client = matrixClient;
	    this.groupRoomId = groupChatRoomId;
	    this.confUserId = module.exports.getConferenceUserIdForRoom(this.groupRoomId);
	}
	
	ConferenceCall.prototype.setup = function () {
	    var self = this;
	    return this._joinConferenceUser().then(function () {
	        return self._getConferenceUserRoom();
	    }).then(function (room) {
	        // return a call for *this* room to be placed. We also tack on
	        // confUserId to speed up lookups (else we'd need to loop every room
	        // looking for a 1:1 room with this conf user ID!)
	        var call = Matrix.createNewMatrixCall(self.client, room.roomId);
	        call.confUserId = self.confUserId;
	        return call;
	    });
	};
	
	ConferenceCall.prototype._joinConferenceUser = function () {
	    // Make sure the conference user is in the group chat room
	    var groupRoom = this.client.getRoom(this.groupRoomId);
	    if (!groupRoom) {
	        return q.reject("Bad group room ID");
	    }
	    var member = groupRoom.getMember(this.confUserId);
	    if (member && member.membership === "join") {
	        return q();
	    }
	    return this.client.invite(this.groupRoomId, this.confUserId);
	};
	
	ConferenceCall.prototype._getConferenceUserRoom = function () {
	    // Use an existing 1:1 with the conference user; else make one
	    var rooms = this.client.getRooms();
	    var confRoom = null;
	    for (var i = 0; i < rooms.length; i++) {
	        var confUser = rooms[i].getMember(this.confUserId);
	        if (confUser && confUser.membership === "join" && rooms[i].getJoinedMembers().length === 2) {
	            confRoom = rooms[i];
	            break;
	        }
	    }
	    if (confRoom) {
	        return q(confRoom);
	    }
	    return this.client.createRoom({
	        preset: "private_chat",
	        invite: [this.confUserId]
	    }).then(function (res) {
	        return new Room(res.room_id);
	    });
	};
	
	/**
	 * Check if this user ID is in fact a conference bot.
	 * @param {string} userId The user ID to check.
	 * @return {boolean} True if it is a conference bot.
	 */
	module.exports.isConferenceUser = function (userId) {
	    if (userId.indexOf("@" + USER_PREFIX) !== 0) {
	        return false;
	    }
	    var base64part = userId.split(":")[0].substring(1 + USER_PREFIX.length);
	    if (base64part) {
	        var decoded = new Buffer(base64part, "base64").toString();
	        // ! $STUFF : $STUFF
	        return (/^!.+:.+/.test(decoded)
	        );
	    }
	    return false;
	};
	
	module.exports.getConferenceUserIdForRoom = function (roomId) {
	    // abuse browserify's core node Buffer support (strip padding ='s)
	    var base64RoomId = new Buffer(roomId).toString("base64").replace(/=/g, "");
	    return "@" + USER_PREFIX + base64RoomId + ":" + DOMAIN;
	};
	
	module.exports.createNewMatrixCall = function (client, roomId) {
	    var confCall = new ConferenceCall(client, roomId);
	    return confCall.setup();
	};
	
	module.exports.getConferenceCallForRoom = function (roomId) {
	    // search for a conference 1:1 call for this group chat room ID
	    var activeCall = CallHandler.getAnyActiveCall();
	    if (activeCall && activeCall.confUserId) {
	        var thisRoomConfUserId = module.exports.getConferenceUserIdForRoom(roomId);
	        if (thisRoomConfUserId === activeCall.confUserId) {
	            return activeCall;
	        }
	    }
	    return null;
	};
	
	module.exports.ConferenceCall = ConferenceCall;
	
	module.exports.slot = 'conference';
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146).Buffer))

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	var PushProcessor = __webpack_require__(188);
	
	/**
	 * This is an internal module. See {@link MatrixClient} for the public class.
	 * @module client
	 */
	var EventEmitter = __webpack_require__(27).EventEmitter;
	var q = __webpack_require__(18);
	
	var httpApi = __webpack_require__(35);
	var MatrixEvent = __webpack_require__(15).MatrixEvent;
	var EventStatus = __webpack_require__(15).EventStatus;
	var EventTimeline = __webpack_require__(36);
	var SearchResult = __webpack_require__(187);
	var StubStore = __webpack_require__(192);
	var webRtcCall = __webpack_require__(95);
	var utils = __webpack_require__(5);
	var contentRepo = __webpack_require__(34);
	var Filter = __webpack_require__(57);
	var SyncApi = __webpack_require__(194);
	var MatrixError = httpApi.MatrixError;
	
	var SCROLLBACK_DELAY_MS = 3000;
	var CRYPTO_ENABLED = false;
	
	try {
	    var Olm = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"olm\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	    if (Olm.Account && Olm.Session) {
	        CRYPTO_ENABLED = true;
	    }
	} catch (e) {
	    // Olm not installed.
	}
	
	var OLM_ALGORITHM = "m.olm.v1.curve25519-aes-sha2";
	
	/**
	 * Construct a Matrix Client. Only directly construct this if you want to use
	 * custom modules. Normally, {@link createClient} should be used
	 * as it specifies 'sensible' defaults for these modules.
	 * @constructor
	 * @extends {external:EventEmitter}
	 *
	 * @param {Object} opts The configuration options for this client.
	 * @param {string} opts.baseUrl Required. The base URL to the client-server
	 * HTTP API.
	 * @param {string} opts.idBaseUrl Optional. The base identity server URL for
	 * identity server requests.
	 * @param {Function} opts.request Required. The function to invoke for HTTP
	 * requests. The value of this property is typically <code>require("request")
	 * </code> as it returns a function which meets the required interface. See
	 * {@link requestFunction} for more information.
	 *
	 * @param {string} opts.accessToken The access_token for this user.
	 * @param {string} opts.userId The user ID for this user.
	 * @param {Object} opts.store Optional. The data store to use. If not specified,
	 * this client will not store any HTTP responses.
	 *
	 * @param {Object} opts.scheduler Optional. The scheduler to use. If not
	 * specified, this client will not retry requests on failure. This client
	 * will supply its own processing function to
	 * {@link module:scheduler~MatrixScheduler#setProcessFunction}.
	 *
	 * @param {Object} opts.queryParams Optional. Extra query parameters to append
	 * to all requests with this client. Useful for application services which require
	 * <code>?user_id=</code>.
	 *
	 * @param {boolean} [opts.timelineSupport = false] Set to true to enable
	 * improved timeline support ({@link
	 * module:client~MatrixClient#getEventTimeline getEventTimeline}). It is
	 * disabled by default for compatibility with older clients - in particular to
	 * maintain support for back-paginating the live timeline after a '/sync'
	 * result with a gap.
	 */
	function MatrixClient(opts) {
	    utils.checkObjectHasKeys(opts, ["baseUrl", "request"]);
	
	    this.baseUrl = opts.baseUrl;
	    this.idBaseUrl = opts.idBaseUrl;
	
	    this.store = opts.store || new StubStore();
	    this.sessionStore = opts.sessionStore || null;
	    this.accountKey = "DEFAULT_KEY";
	    this.deviceId = opts.deviceId;
	    if (CRYPTO_ENABLED && this.sessionStore !== null) {
	        var e2eAccount = this.sessionStore.getEndToEndAccount();
	        var account = new Olm.Account();
	        try {
	            if (e2eAccount === null) {
	                account.create();
	            } else {
	                account.unpickle(this.accountKey, e2eAccount);
	            }
	            var e2eKeys = JSON.parse(account.identity_keys());
	            var json = '{"algorithms":["' + OLM_ALGORITHM + '"]';
	            json += ',"device_id":"' + this.deviceId + '"';
	            json += ',"keys":';
	            json += '{"ed25519:' + this.deviceId + '":';
	            json += JSON.stringify(e2eKeys.ed25519);
	            json += ',"curve25519:' + this.deviceId + '":';
	            json += JSON.stringify(e2eKeys.curve25519);
	            json += '}';
	            json += ',"user_id":' + JSON.stringify(opts.userId);
	            json += '}';
	            var signature = account.sign(json);
	            this.deviceKeys = JSON.parse(json);
	            var signatures = {};
	            signatures[opts.userId] = {};
	            signatures[opts.userId]["ed25519:" + this.deviceId] = signature;
	            this.deviceKeys.signatures = signatures;
	            this.deviceCurve25519Key = e2eKeys.curve25519;
	            var pickled = account.pickle(this.accountKey);
	            this.sessionStore.storeEndToEndAccount(pickled);
	            var myDevices = this.sessionStore.getEndToEndDevicesForUser(
	                opts.userId
	            ) || {};
	            myDevices[opts.deviceId] = this.deviceKeys;
	            this.sessionStore.storeEndToEndDevicesForUser(
	                opts.userId, myDevices
	            );
	        } finally {
	            account.free();
	        }
	    }
	    this.scheduler = opts.scheduler;
	    if (this.scheduler) {
	        var self = this;
	        this.scheduler.setProcessFunction(function(eventToSend) {
	            eventToSend.status = EventStatus.SENDING;
	            return _sendEventHttpRequest(self, eventToSend);
	        });
	    }
	    this.clientRunning = false;
	
	    var httpOpts = {
	        baseUrl: opts.baseUrl,
	        idBaseUrl: opts.idBaseUrl,
	        accessToken: opts.accessToken,
	        request: opts.request,
	        prefix: httpApi.PREFIX_V1,
	        onlyData: true,
	        extraParams: opts.queryParams
	    };
	    this.credentials = {
	        userId: (opts.userId || null)
	    };
	    this._http = new httpApi.MatrixHttpApi(httpOpts);
	    this.callList = {
	        // callId: MatrixCall
	    };
	
	    // try constructing a MatrixCall to see if we are running in an environment
	    // which has WebRTC. If we are, listen for and handle m.call.* events.
	    var call = webRtcCall.createNewMatrixCall(this);
	    this._supportsVoip = false;
	    if (call) {
	        setupCallEventHandler(this);
	        this._supportsVoip = true;
	    }
	    this._syncState = null;
	    this._syncingRetry = null;
	    this._peekSync = null;
	    this._isGuest = false;
	    this._ongoingScrollbacks = {};
	
	    this.timelineSupport = Boolean(opts.timelineSupport);
	}
	utils.inherits(MatrixClient, EventEmitter);
	
	/**
	 * Get the Homserver URL of this client
	 * @return {string} Homeserver URL of this client
	 */
	MatrixClient.prototype.getHomeserverUrl = function() {
	    return this.baseUrl;
	};
	
	/**
	 * Get the Identity Server URL of this client
	 * @return {string} Identity Server URL of this client
	 */
	MatrixClient.prototype.getIdentityServerUrl = function() {
	    return this.idBaseUrl;
	};
	
	/**
	 * Get the domain for this client's MXID
	 * @return {?string} Domain of this MXID
	 */
	MatrixClient.prototype.getDomain = function() {
	    if (this.credentials && this.credentials.userId) {
	        return this.credentials.userId.replace(/^.*?:/, '');
	    }
	    return null;
	};
	
	/**
	 * Get the access token associated with this account.
	 * @return {?String} The access_token or null
	 */
	MatrixClient.prototype.getAccessToken = function() {
	    return this._http.opts.accessToken || null;
	};
	
	/**
	 * Get the local part of the current user ID e.g. "foo" in "@foo:bar".
	 * @return {?string} The user ID localpart or null.
	 */
	MatrixClient.prototype.getUserIdLocalpart = function() {
	    if (this.credentials && this.credentials.userId) {
	        return this.credentials.userId.split(":")[0].substring(1);
	    }
	    return null;
	};
	
	/**
	 * Check if the runtime environment supports VoIP calling.
	 * @return {boolean} True if VoIP is supported.
	 */
	MatrixClient.prototype.supportsVoip = function() {
	    return this._supportsVoip;
	};
	
	/**
	 * Get the current sync state.
	 * @return {?string} the sync state, which may be null.
	 * @see module:client~MatrixClient#event:"sync"
	 */
	MatrixClient.prototype.getSyncState = function() {
	    return this._syncState;
	};
	
	/**
	 * Return whether the client is configured for a guest account.
	 * @return {boolean} True if this is a guest access_token (or no token is supplied).
	 */
	MatrixClient.prototype.isGuest = function() {
	    return this._isGuest;
	};
	
	/**
	 * Return the provided scheduler, if any.
	 * @return {?module:scheduler~MatrixScheduler} The scheduler or null
	 */
	MatrixClient.prototype.getScheduler = function() {
	    return this.scheduler;
	};
	
	/**
	 * Set whether this client is a guest account. <b>This method is experimental
	 * and may change without warning.</b>
	 * @param {boolean} isGuest True if this is a guest account.
	 */
	MatrixClient.prototype.setGuest = function(isGuest) {
	    // EXPERIMENTAL:
	    // If the token is a macaroon, it should be encoded in it that it is a 'guest'
	    // access token, which means that the SDK can determine this entirely without
	    // the dev manually flipping this flag.
	    this._isGuest = isGuest;
	};
	
	/**
	 * Retry a backed off syncing request immediately. This should only be used when
	 * the user <b>explicitly</b> attempts to retry their lost connection.
	 * @return {boolean} True if this resulted in a request being retried.
	 */
	MatrixClient.prototype.retryImmediately = function() {
	    if (!this._syncingRetry) {
	        return false;
	    }
	    // stop waiting
	    clearTimeout(this._syncingRetry.timeoutId);
	    // invoke immediately
	    this._syncingRetry.fn(2); // FIXME: It shouldn't need to know about attempts :/
	    this._syncingRetry = null;
	    return true;
	};
	
	/**
	 * Is end-to-end crypto enabled for this client.
	 * @return {boolean} True if end-to-end is enabled.
	 */
	MatrixClient.prototype.isCryptoEnabled = function() {
	    return CRYPTO_ENABLED && this.sessionStore !== null;
	};
	
	
	/**
	 * Upload the device keys to the homeserver and ensure that the
	 * homeserver has enough one-time keys.
	 * @param {number} maxKeys The maximum number of keys to generate
	 * @param {object} deferred A deferred to resolve when the keys are uploaded.
	 * @return {object} A promise that will resolve when the keys are uploaded.
	 */
	MatrixClient.prototype.uploadKeys = function(maxKeys, deferred) {
	    if (!CRYPTO_ENABLED || this.sessionStore === null) {
	        return q.reject(new Error("End-to-end encryption disabled"));
	    }
	    var first_time = deferred === undefined;
	    deferred = deferred || q.defer();
	    var path = "/keys/upload/" + this.deviceId;
	    var pickled = this.sessionStore.getEndToEndAccount();
	    if (!pickled) {
	        return q.reject(new Error("End-to-end account not found"));
	    }
	    var account = new Olm.Account();
	    var oneTimeKeys;
	    try {
	        account.unpickle(this.accountKey, pickled);
	        oneTimeKeys = JSON.parse(account.one_time_keys());
	        var maxOneTimeKeys = account.max_number_of_one_time_keys();
	    } finally {
	        account.free();
	    }
	    var oneTimeJson = {};
	
	    for (var keyId in oneTimeKeys.curve25519) {
	        if (oneTimeKeys.curve25519.hasOwnProperty(keyId)) {
	            oneTimeJson["curve25519:" + keyId] = oneTimeKeys.curve25519[keyId];
	        }
	    }
	    var content = {
	        device_keys: this.deviceKeys,
	        one_time_keys: oneTimeJson
	    };
	    var self = this;
	    this._http.authedRequestWithPrefix(
	        undefined, "POST", path, undefined, content, httpApi.PREFIX_V2_ALPHA
	    ).then(function(res) {
	        var keyLimit = Math.floor(maxOneTimeKeys / 2);
	        var keyCount = res.one_time_key_counts.curve25519 || 0;
	        var generateKeys = (keyCount < keyLimit);
	        var pickled = self.sessionStore.getEndToEndAccount();
	
	        var account = new Olm.Account();
	        try {
	            account.unpickle(self.accountKey, pickled);
	            account.mark_keys_as_published();
	            if (generateKeys) {
	                var numberToGenerate = keyLimit - keyCount;
	                if (maxKeys) {
	                    numberToGenerate = Math.min(numberToGenerate, maxKeys);
	                }
	                account.generate_one_time_keys(numberToGenerate);
	            }
	            pickled = account.pickle(self.accountKey);
	            self.sessionStore.storeEndToEndAccount(pickled);
	        } finally {
	            account.free();
	        }
	        if (generateKeys && first_time) {
	            self.uploadKeys(maxKeys, deferred);
	        } else {
	            deferred.resolve();
	        }
	    });
	    return deferred.promise;
	};
	
	
	/**
	 * Download the keys for a list of users and stores the keys in the session
	 * store.
	 * @param {Array} userIds The users to fetch.
	 * @param {bool} forceDownload Always download the keys even if cached.
	 * @return {object} A promise that will resolve when the keys are downloadded.
	 */
	MatrixClient.prototype.downloadKeys = function(userIds, forceDownload) {
	    if (!CRYPTO_ENABLED || this.sessionStore === null) {
	        return q.reject(new Error("End-to-end encryption disabled"));
	    }
	    var stored = {};
	    var notStored = {};
	    var downloadKeys = false;
	    for (var i = 0; i < userIds.length; ++i) {
	        var userId = userIds[i];
	        if (!forceDownload) {
	            var devices = this.sessionStore.getEndToEndDevicesForUser(userId);
	            if (devices) {
	                stored[userId] = devices;
	                continue;
	            }
	        }
	        downloadKeys = true;
	        notStored[userId] = {};
	    }
	    var deferred = q.defer();
	    if (downloadKeys) {
	        var path = "/keys/query";
	        var content = {device_keys: notStored};
	        var self = this;
	        this._http.authedRequestWithPrefix(
	            undefined, "POST", path, undefined, content,
	            httpApi.PREFIX_V2_ALPHA
	        ).then(function(res) {
	            for (var userId in res.device_keys) {
	                if (userId in notStored) {
	                    self.sessionStore.storeEndToEndDevicesForUser(
	                        userId, res.device_keys[userId]
	                    );
	                    // TODO: validate the ed25519 signature.
	                    stored[userId] = res.device_keys[userId];
	                }
	            }
	            deferred.resolve(stored);
	        });
	    } else {
	        deferred.resolve(stored);
	    }
	    return deferred.promise;
	};
	
	/**
	 * List the stored device keys for a user id
	 * @param {string} userId the user to list keys for.
	 * @return {Array} list of devices with "id" and "key" parameters.
	 */
	MatrixClient.prototype.listDeviceKeys = function(userId) {
	    if (!CRYPTO_ENABLED) {
	        return [];
	    }
	    var devices = this.sessionStore.getEndToEndDevicesForUser(userId);
	    var result = [];
	    if (devices) {
	        var deviceId;
	        var deviceIds = [];
	        for (deviceId in devices) {
	            if (devices.hasOwnProperty(deviceId)) {
	                deviceIds.push(deviceId);
	            }
	        }
	        deviceIds.sort();
	        for (var i = 0; i < deviceIds.length; ++i) {
	            deviceId = deviceIds[i];
	            var device = devices[deviceId];
	            var ed25519Key = device.keys["ed25519:" + deviceId];
	            if (ed25519Key) {
	                result.push({
	                    id: deviceId,
	                    key: ed25519Key
	                });
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Enable end-to-end encryption for a room.
	 * @param {string} roomId The room ID to enable encryption in.
	 * @param {object} config The encryption config for the room.
	 * @return {Object} A promise that will resolve when encryption is setup.
	 */
	MatrixClient.prototype.setRoomEncryption = function(roomId, config) {
	    if (!this.sessionStore || !CRYPTO_ENABLED) {
	        return q.reject(new Error("End-to-End encryption disabled"));
	    }
	    if (config.algorithm === OLM_ALGORITHM) {
	        if (!config.members) {
	            throw new Error(
	                "Config must include a 'members' list with a list of userIds"
	            );
	        }
	        var devicesWithoutSession = [];
	        var userWithoutDevices = [];
	        for (var i = 0; i < config.members.length; ++i) {
	            var userId = config.members[i];
	            var devices = this.sessionStore.getEndToEndDevicesForUser(userId);
	            if (!devices) {
	                userWithoutDevices.push(userId);
	            } else {
	                for (var deviceId in devices) {
	                    if (devices.hasOwnProperty(deviceId)) {
	                        var keys = devices[deviceId];
	                        var key = keys.keys["curve25519:" + deviceId];
	                        if (key == this.deviceCurve25519Key) {
	                            continue;
	                        }
	                        if (!this.sessionStore.getEndToEndSessions(key)) {
	                            devicesWithoutSession.push([userId, deviceId, key]);
	                        }
	                    }
	                }
	            }
	        }
	        var deferred = q.defer();
	        if (devicesWithoutSession.length > 0) {
	            var queries = {};
	            for (i = 0; i < devicesWithoutSession.length; ++i) {
	                var device = devicesWithoutSession[i];
	                var query = queries[device[0]] || {};
	                queries[device[0]] = query;
	                query[device[1]] = "curve25519";
	            }
	            var path = "/keys/claim";
	            var content = {one_time_keys: queries};
	            var self = this;
	            this._http.authedRequestWithPrefix(
	                undefined, "POST", path, undefined, content,
	                httpApi.PREFIX_V2_ALPHA
	            ).done(function(res) {
	                var missing = {};
	                for (i = 0; i < devicesWithoutSession.length; ++i) {
	                    var device = devicesWithoutSession[i];
	                    var userRes = res.one_time_keys[device[0]] || {};
	                    var deviceRes = userRes[device[1]];
	                    var oneTimeKey;
	                    for (var keyId in deviceRes) {
	                        if (keyId.indexOf("curve25519:") === 0) {
	                            oneTimeKey = deviceRes[keyId];
	                        }
	                    }
	                    if (oneTimeKey) {
	                        var session = new Olm.Session();
	                        var account = new Olm.Account();
	                        try {
	                            var pickled = self.sessionStore.getEndToEndAccount();
	                            account.unpickle(self.accountKey, pickled);
	                            session.create_outbound(account, device[2], oneTimeKey);
	                            var sessionId = session.session_id();
	                            pickled = session.pickle(self.accountKey);
	                            self.sessionStore.storeEndToEndSession(
	                                device[2], sessionId, pickled
	                            );
	                        } finally {
	                            session.free();
	                            account.free();
	                        }
	                    } else {
	                        missing[device[0]] = missing[device[0]] || [];
	                        missing[device[0]].push([device[1]]);
	                    }
	                }
	                deferred.resolve({
	                    missingUsers: userWithoutDevices,
	                    missingDevices: missing
	                });
	            });
	        } else {
	            deferred.resolve({
	                missingUsers: userWithoutDevices,
	                missingDevices: []
	            });
	        }
	        this.sessionStore.storeEndToEndRoom(roomId, config);
	        return deferred.promise;
	    } else {
	        throw new Error("Unknown algorithm: " + config.algorithm);
	    }
	};
	
	
	/**
	 * Disable encryption for a room.
	 * @param {string} roomId the room to disable encryption for.
	 */
	MatrixClient.prototype.disableRoomEncryption = function(roomId) {
	    if (this.sessionStore !== null) {
	        this.sessionStore.storeEndToEndRoom(roomId, null);
	    }
	};
	
	/**
	 * Whether encryption is enabled for a room.
	 * @param {string} roomId the room id to query.
	 * @return {bool} whether encryption is enabled.
	 */
	MatrixClient.prototype.isRoomEncrypted = function(roomId) {
	    if (CRYPTO_ENABLED && this.sessionStore !== null) {
	        return (this.sessionStore.getEndToEndRoom(roomId) && true) || false;
	    } else {
	        return false;
	    }
	};
	
	/**
	 * Get the room for the given room ID.
	 * This function will return a valid room for any room for which a Room event
	 * has been emitted. Note in particular that other events, eg. RoomState.members
	 * will be emitted for a room before this function will return the given room.
	 * @param {string} roomId The room ID
	 * @return {Room} The Room or null if it doesn't exist or there is no data store.
	 */
	MatrixClient.prototype.getRoom = function(roomId) {
	    return this.store.getRoom(roomId);
	};
	
	/**
	 * Retrieve all known rooms.
	 * @return {Room[]} A list of rooms, or an empty list if there is no data store.
	 */
	MatrixClient.prototype.getRooms = function() {
	    return this.store.getRooms();
	};
	
	/**
	 * Retrieve a user.
	 * @param {string} userId The user ID to retrieve.
	 * @return {?User} A user or null if there is no data store or the user does
	 * not exist.
	 */
	MatrixClient.prototype.getUser = function(userId) {
	    return this.store.getUser(userId);
	};
	
	/**
	 * Retrieve all known users.
	 * @return {User[]} A list of users, or an empty list if there is no data store.
	 */
	MatrixClient.prototype.getUsers = function() {
	    return this.store.getUsers();
	};
	
	// Room operations
	// ===============
	
	/**
	 * Create a new room.
	 * @param {Object} options a list of options to pass to the /createRoom API.
	 * @param {string} options.room_alias_name The alias localpart to assign to
	 * this room.
	 * @param {string} options.visibility Either 'public' or 'private'.
	 * @param {string[]} options.invite A list of user IDs to invite to this room.
	 * @param {string} options.name The name to give this room.
	 * @param {string} options.topic The topic to give this room.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: <code>{room_id: {string},
	 * room_alias: {string(opt)}}</code>
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.createRoom = function(options, callback) {
	    // valid options include: room_alias_name, visibility, invite
	    return this._http.authedRequest(
	        callback, "POST", "/createRoom", undefined, options
	    );
	};
	
	/**
	 * Join a room. If you have already joined the room, this will no-op.
	 * @param {string} roomIdOrAlias The room ID or room alias to join.
	 * @param {Object} opts Options when joining the room.
	 * @param {boolean} opts.syncRoom True to do a room initial sync on the resulting
	 * room. If false, the <strong>returned Room object will have no current state.
	 * </strong> Default: true.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Room object.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.joinRoom = function(roomIdOrAlias, opts, callback) {
	    // to help people when upgrading..
	    if (utils.isFunction(opts)) {
	        throw new Error("Expected 'opts' object, got function.");
	    }
	    opts = opts || {
	        syncRoom: true
	    };
	
	    var room = this.getRoom(roomIdOrAlias);
	    if (room && room.hasMembershipState(this.credentials.userId, "join")) {
	        return q(room);
	    }
	    var path = utils.encodeUri("/join/$roomid", { $roomid: roomIdOrAlias});
	    var defer = q.defer();
	    var self = this;
	    this._http.authedRequest(undefined, "POST", path, undefined, {}).then(
	    function(res) {
	        var roomId = res.room_id;
	        var syncApi = new SyncApi(self);
	        var room = syncApi.createRoom(roomId);
	        if (opts.syncRoom) {
	            // v2 will do this for us
	            // return syncApi.syncRoom(room);
	        }
	        return q(room);
	    }, function(err) {
	        _reject(callback, defer, err);
	    }).done(function(room) {
	        _resolve(callback, defer, room);
	    }, function(err) {
	        _reject(callback, defer, err);
	    });
	    return defer.promise;
	};
	
	/**
	 * Resend an event.
	 * @param {MatrixEvent} event The event to resend.
	 * @param {Room} room Optional. The room the event is in. Will update the
	 * timeline entry if provided.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.resendEvent = function(event, room) {
	    event.status = EventStatus.SENDING;
	    return _sendEvent(this, room, event);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} name
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomName = function(roomId, name, callback) {
	    return this.sendStateEvent(roomId, "m.room.name", {name: name},
	                               undefined, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} topic
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomTopic = function(roomId, topic, callback) {
	    return this.sendStateEvent(roomId, "m.room.topic", {topic: topic},
	                               undefined, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} tagName name of room tag to be set
	 * @param {object} metadata associated with that tag to be stored
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomTag = function(roomId, tagName, metadata, callback) {
	    var path = utils.encodeUri("/user/$userId/rooms/$roomId/tags/$tag", {
	        $userId: this.credentials.userId,
	        $roomId: roomId,
	        $tag: tagName,
	    });
	    return this._http.authedRequestWithPrefix(
	        callback, "PUT", path, undefined, metadata, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} tagName name of room tag to be removed
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.deleteRoomTag = function(roomId, tagName, callback) {
	    var path = utils.encodeUri("/user/$userId/rooms/$roomId/tags/$tag", {
	        $userId: this.credentials.userId,
	        $roomId: roomId,
	        $tag: tagName,
	    });
	    return this._http.authedRequestWithPrefix(
	        callback, "DELETE", path, undefined, undefined, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * @param {string} eventType event type to be set
	 * @param {object} content event content
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setAccountData = function(eventType, content, callback) {
	    var path = utils.encodeUri("/user/$userId/account_data/$type", {
	        $userId: this.credentials.userId,
	        $type: eventType,
	    });
	    return this._http.authedRequestWithPrefix(
	        callback, "PUT", path, undefined, content, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventType event type to be set
	 * @param {object} content event content
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomAccountData = function(roomId, eventType,
	                                                     content, callback) {
	    var path = utils.encodeUri("/user/$userId/rooms/$roomId/account_data/$type", {
	        $userId: this.credentials.userId,
	        $roomId: roomId,
	        $type: eventType,
	    });
	    return this._http.authedRequestWithPrefix(
	        callback, "PUT", path, undefined, content, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * Set a user's power level.
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {Number} powerLevel
	 * @param {MatrixEvent} event
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setPowerLevel = function(roomId, userId, powerLevel,
	                                                event, callback) {
	    var content = {
	        users: {}
	    };
	    if (event && event.getType() === "m.room.power_levels") {
	        // take a copy of the content to ensure we don't corrupt
	        // existing client state with a failed power level change
	        content = utils.deepCopy(event.getContent());
	    }
	    content.users[userId] = powerLevel;
	    var path = utils.encodeUri("/rooms/$roomId/state/m.room.power_levels", {
	        $roomId: roomId
	    });
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, content
	    );
	};
	
	/**
	 * Retrieve a state event.
	 * @param {string} roomId
	 * @param {string} eventType
	 * @param {string} stateKey
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getStateEvent = function(roomId, eventType, stateKey, callback) {
	    var pathParams = {
	        $roomId: roomId,
	        $eventType: eventType,
	        $stateKey: stateKey
	    };
	    var path = utils.encodeUri("/rooms/$roomId/state/$eventType", pathParams);
	    if (stateKey !== undefined) {
	        path = utils.encodeUri(path + "/$stateKey", pathParams);
	    }
	    return this._http.authedRequest(
	        callback, "GET", path
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventType
	 * @param {Object} content
	 * @param {string} stateKey
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendStateEvent = function(roomId, eventType, content, stateKey, 
	                                                 callback) {
	    var pathParams = {
	        $roomId: roomId,
	        $eventType: eventType,
	        $stateKey: stateKey
	    };
	    var path = utils.encodeUri("/rooms/$roomId/state/$eventType", pathParams);
	    if (stateKey !== undefined) {
	        path = utils.encodeUri(path + "/$stateKey", pathParams);
	    }
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, content
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventType
	 * @param {Object} content
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendEvent = function(roomId, eventType, content, txnId,
	                                            callback) {
	    if (utils.isFunction(txnId)) { callback = txnId; txnId = undefined; }
	
	    if (!txnId) {
	        txnId = "m" + new Date().getTime();
	    }
	
	    // we always construct a MatrixEvent when sending because the store and
	    // scheduler use them. We'll extract the params back out if it turns out
	    // the client has no scheduler or store.
	    var room = this.getRoom(roomId);
	    var localEvent = new MatrixEvent({
	        event_id: "~" + roomId + ":" + txnId,
	        user_id: this.credentials.userId,
	        room_id: roomId,
	        type: eventType,
	        origin_server_ts: new Date().getTime(),
	        content: content
	    });
	    localEvent._txnId = txnId;
	
	    // add this event immediately to the local store as 'sending'.
	    if (room) {
	        localEvent.status = EventStatus.SENDING;
	        room.addEventsToTimeline([localEvent]);
	    }
	
	    if (eventType === "m.room.message" && this.sessionStore && CRYPTO_ENABLED) {
	        var e2eRoomInfo = this.sessionStore.getEndToEndRoom(roomId);
	        if (e2eRoomInfo) {
	            var encryptedContent = _encryptMessage(
	                this, roomId, e2eRoomInfo, eventType, content, txnId, callback
	            );
	            localEvent.encryptedType = "m.room.encrypted";
	            localEvent.encryptedContent = encryptedContent;
	        }
	        // TODO: Specify this in the event constructor rather than fiddling
	        // with the event object internals.
	        localEvent.encrypted = true;
	    }
	
	    return _sendEvent(this, room, localEvent, callback);
	};
	
	function _encryptMessage(client, roomId, e2eRoomInfo, eventType, content,
	                               txnId, callback) {
	    if (!client.sessionStore) {
	        throw new Error(
	            "Client must have an end-to-end session store to encrypt messages"
	        );
	    }
	
	    if (e2eRoomInfo.algorithm === OLM_ALGORITHM) {
	        var participantKeys = [];
	        for (var i = 0; i < e2eRoomInfo.members.length; ++i) {
	            var userId = e2eRoomInfo.members[i];
	            var devices = client.sessionStore.getEndToEndDevicesForUser(userId);
	            for (var deviceId in devices) {
	                if (devices.hasOwnProperty(deviceId)) {
	                    var keys = devices[deviceId];
	                    for (var keyId in keys.keys) {
	                        if (keyId.indexOf("curve25519:") === 0) {
	                            participantKeys.push(keys.keys[keyId]);
	                        }
	                    }
	                }
	            }
	        }
	        participantKeys.sort();
	        var participantHash = ""; // Olm.sha256(participantKeys.join());
	        var payloadJson = {
	            room_id: roomId,
	            type: eventType,
	            fingerprint: participantHash,
	            sender_device: client.deviceId,
	            content: content
	        };
	        var ciphertext = {};
	        var payloadString = JSON.stringify(payloadJson);
	        for (i = 0; i < participantKeys.length; ++i) {
	            var deviceKey = participantKeys[i];
	            if (deviceKey == client.deviceCurve25519Key) {
	                continue;
	            }
	            var sessions = client.sessionStore.getEndToEndSessions(
	                deviceKey
	            );
	            var sessionIds = [];
	            for (var sessionId in sessions) {
	                if (sessions.hasOwnProperty(sessionId)) {
	                    sessionIds.push(sessionId);
	                }
	            }
	            // Use the session with the lowest ID.
	            sessionIds.sort();
	            if (sessionIds.length === 0) {
	                // If we don't have a session for a device then
	                // we can't encrypt a message for it.
	                continue;
	            }
	            sessionId = sessionIds[0];
	            var session = new Olm.Session();
	            try {
	                session.unpickle(client.accountKey, sessions[sessionId]);
	                ciphertext[deviceKey] = session.encrypt(payloadString);
	                var pickled = session.pickle(client.accountKey);
	                client.sessionStore.storeEndToEndSession(
	                    deviceKey, sessionId, pickled
	                );
	            } finally {
	                session.free();
	            }
	        }
	        var encryptedContent = {
	            algorithm: e2eRoomInfo.algorithm,
	            sender_key: client.deviceCurve25519Key,
	            ciphertext: ciphertext
	        };
	        return encryptedContent;
	    } else {
	        throw new Error("Unknown end-to-end algorithm: " + e2eRoomInfo.algorithm);
	    }
	}
	
	function _decryptMessage(client, event) {
	    if (client.sessionStore === null || !CRYPTO_ENABLED) {
	        // End to end encryption isn't enabled if we don't have a session
	        // store.
	        return _badEncryptedMessage(event, "**Encryption not enabled**");
	    }
	
	    var content = event.getContent();
	    if (content.algorithm === OLM_ALGORITHM) {
	        var deviceKey = content.sender_key;
	        var ciphertext = content.ciphertext;
	
	        if (!ciphertext) {
	            return _badEncryptedMessage(event, "**Missing ciphertext**");
	        }
	        if (!(client.deviceCurve25519Key in content.ciphertext)) {
	            return _badEncryptedMessage(event, "**Not included in recipients**");
	        }
	        var message = content.ciphertext[client.deviceCurve25519Key];
	        var sessions = client.sessionStore.getEndToEndSessions(deviceKey);
	        var payloadString = null;
	        var foundSession = false;
	        var session;
	        for (var sessionId in sessions) {
	            if (sessions.hasOwnProperty(sessionId)) {
	                session = new Olm.Session();
	                try {
	                    session.unpickle(client.accountKey, sessions[sessionId]);
	                    if (message.type === 0 && session.matches_inbound(message.body)) {
	                        foundSession = true;
	                    }
	                    payloadString = session.decrypt(message.type, message.body);
	                    var pickled = session.pickle(client.accountKey);
	                    client.sessionStore.storeEndToEndSession(
	                        deviceKey, sessionId, pickled
	                    );
	                } catch (e) {
	                    // Failed to decrypt with an existing session.
	                    console.log(
	                        "Failed to decrypt with an existing session: " + e.message
	                    );
	                } finally {
	                    session.free();
	                }
	            }
	        }
	
	        if (message.type === 0 && !foundSession && payloadString === null) {
	            var account = new Olm.Account();
	            session = new Olm.Session();
	            try {
	                var account_data = client.sessionStore.getEndToEndAccount();
	                account.unpickle(client.accountKey, account_data);
	                session.create_inbound_from(account, deviceKey, message.body);
	                payloadString = session.decrypt(message.type, message.body);
	                account.remove_one_time_keys(session);
	                var pickledSession = session.pickle(client.accountKey);
	                var pickledAccount = account.pickle(client.accountKey);
	                sessionId = session.session_id();
	                client.sessionStore.storeEndToEndSession(
	                    deviceKey, sessionId, pickledSession
	                );
	                client.sessionStore.storeEndToEndAccount(pickledAccount);
	            } catch (e) {
	                // Failed to decrypt with a new session.
	            } finally {
	                session.free();
	                account.free();
	            }
	        }
	
	        if (payloadString !== null) {
	            var payload = JSON.parse(payloadString);
	            return new MatrixEvent({
	                // TODO: Add a key to indicate that the event was encrypted.
	                // TODO: Check the sender user id matches the sender key.
	                origin_server_ts: event.getTs(),
	                room_id: payload.room_id,
	                user_id: event.getSender(),
	                event_id: event.getId(),
	                type: payload.type,
	                content: payload.content
	            }, "encrypted");
	        } else {
	            return _badEncryptedMessage(event, "**Bad Encrypted Message**");
	        }
	    }
	}
	
	function _badEncryptedMessage(event, reason) {
	    return new MatrixEvent({
	        type: "m.room.message",
	        // TODO: Add rest of the event keys.
	        origin_server_ts: event.getTs(),
	        room_id: event.getRoomId(),
	        user_id: event.getSender(),
	        event_id: event.getId(),
	        content: {
	            msgtype: "m.bad.encrypted",
	            body: reason,
	            content: event.getContent()
	        }
	    });
	}
	
	function _sendEvent(client, room, event, callback) {
	    // cache the local event ID here because if /sync returns before /send then
	    // event.getId() will return a REAL event ID which we will then incorrectly
	    // remove!
	    var localEventId = event.getId();
	
	    var defer = q.defer();
	    var promise;
	    // this event may be queued
	    if (client.scheduler) {
	        // if this returns a promsie then the scheduler has control now and will
	        // resolve/reject when it is done. Internally, the scheduler will invoke
	        // processFn which is set to this._sendEventHttpRequest so the same code
	        // path is executed regardless.
	        promise = client.scheduler.queueEvent(event);
	        if (promise && client.scheduler.getQueueForEvent(event).length > 1) {
	            // event is processed FIFO so if the length is 2 or more we know
	            // this event is stuck behind an earlier event.
	            event.status = EventStatus.QUEUED;
	        }
	    }
	
	    if (!promise) {
	        promise = _sendEventHttpRequest(client, event);
	    }
	
	    promise.done(function(res) {  // the request was sent OK
	        if (room) {
	            var eventId = res.event_id;
	            // try to find an event with this event_id. If we find it, this is
	            // the echo of this event *from the event stream* so we can remove
	            // the fake event we made above. If we don't find it, we're still
	            // waiting on the real event and so should assign the fake event
	            // with the real event_id for matching later.
	
	            // FIXME: This manipulation of the room should probably be done
	            // inside the room class, not by the client.
	            var matchingEvent = utils.findElement(room.timeline, function(ev) {
	                return ev.getId() === eventId;
	            }, true);
	            if (matchingEvent) {
	                if (event.encryptedType) {
	                    // Replace the content and type of the event with the
	                    // plaintext that we sent to the server.
	                    // TODO: Persist the changes if we storing events somewhere
	                    // otherthan in memory.
	                    matchingEvent.event.content = event.event.content;
	                    matchingEvent.event.type = event.event.type;
	                }
	                room.removeEvents([localEventId]);
	                matchingEvent.status = null; // make sure it's still marked as sent
	            }
	            else {
	                // best way to make sure the room timeline structures are updated
	                // correctly is to remove the event and add it again with the right
	                // ID.
	                //
	                // This will also make us synthesize our own read receipt for the
	                // sent message.
	                room.removeEvents([localEventId]);
	                event.event.event_id = res.event_id;
	                event.status = null;
	                room.addEventsToTimeline([event]);
	            }
	        }
	
	        _resolve(callback, defer, res);
	    }, function(err) {
	        // the request failed to send.
	        event.status = EventStatus.NOT_SENT;
	        _reject(callback, defer, err);
	    });
	
	    return defer.promise;
	}
	
	function _sendEventHttpRequest(client, event) {
	    var pathParams = {
	        $roomId: event.getRoomId(),
	        $eventType: event.getWireType(),
	        $stateKey: event.getStateKey(),
	        $txnId: event._txnId ? event._txnId : new Date().getTime()
	    };
	
	    var path;
	
	    if (event.isState()) {
	        var pathTemplate = "/rooms/$roomId/state/$eventType";
	        if (event.getStateKey() && event.getStateKey().length > 0) {
	            pathTemplate = "/rooms/$roomId/state/$eventType/$stateKey";
	        }
	        path = utils.encodeUri(pathTemplate, pathParams);
	    }
	    else {
	        path = utils.encodeUri(
	            "/rooms/$roomId/send/$eventType/$txnId", pathParams
	        );
	    }
	
	    return client._http.authedRequest(
	        undefined, "PUT", path, undefined, event.getWireContent()
	    );
	}
	
	/**
	 * @param {string} roomId
	 * @param {Object} content
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendMessage = function(roomId, content, txnId, callback) {
	    if (utils.isFunction(txnId)) { callback = txnId; txnId = undefined; }
	    return this.sendEvent(
	        roomId, "m.room.message", content, txnId, callback
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendTextMessage = function(roomId, body, txnId, callback) {
	    var content = {
	         msgtype: "m.text",
	         body: body
	    };
	    return this.sendMessage(roomId, content, txnId, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendNotice = function(roomId, body, txnId, callback) {
	    var content = {
	         msgtype: "m.notice",
	         body: body
	    };
	    return this.sendMessage(roomId, content, txnId, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} txnId Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendEmoteMessage = function(roomId, body, txnId, callback) {
	    var content = {
	         msgtype: "m.emote",
	         body: body
	    };
	    return this.sendMessage(roomId, content, txnId, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} url
	 * @param {Object} info
	 * @param {string} text
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendImageMessage = function(roomId, url, info, text, callback) {
	    if (utils.isFunction(text)) { callback = text; text = undefined; }
	    if (!text) { text = "Image"; }
	    var content = {
	         msgtype: "m.image",
	         url: url,
	         info: info,
	         body: text
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} htmlBody
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendHtmlMessage = function(roomId, body, htmlBody, callback) {
	    var content = {
	        msgtype: "m.text",
	        format: "org.matrix.custom.html",
	        body: body,
	        formatted_body: htmlBody
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} htmlBody
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendHtmlNotice = function(roomId, body, htmlBody, callback) {
	    var content = {
	        msgtype: "m.notice",
	        format: "org.matrix.custom.html",
	        body: body,
	        formatted_body: htmlBody
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} body
	 * @param {string} htmlBody
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendHtmlEmote = function(roomId, body, htmlBody, callback) {
	    var content = {
	        msgtype: "m.emote",
	        format: "org.matrix.custom.html",
	        body: body,
	        formatted_body: htmlBody
	    };
	    return this.sendMessage(roomId, content, callback);
	};
	
	/**
	 * Send a receipt.
	 * @param {Event} event The event being acknowledged
	 * @param {string} receiptType The kind of receipt e.g. "m.read"
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendReceipt = function(event, receiptType, callback) {
	    if (this.isGuest()) {
	        return q({}); // guests cannot send receipts so don't bother.
	    }
	
	    var path = utils.encodeUri("/rooms/$roomId/receipt/$receiptType/$eventId", {
	        $roomId: event.getRoomId(),
	        $receiptType: receiptType,
	        $eventId: event.getId()
	    });
	    var promise = this._http.authedRequestWithPrefix(
	        callback, "POST", path, undefined, {}, httpApi.PREFIX_V2_ALPHA
	    );
	
	    var room = this.getRoom(event.getRoomId());
	    if (room) {
	        room._addLocalEchoReceipt(this.credentials.userId, event, receiptType);
	    }
	    return promise;
	};
	
	/**
	 * Send a read receipt.
	 * @param {Event} event The event that has been read.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendReadReceipt = function(event, callback) {
	    return this.sendReceipt(event, "m.read", callback);
	};
	
	
	/**
	 * Upload a file to the media repository on the home server.
	 * @param {File} file object
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.uploadContent = function(file, callback) {
	    return this._http.uploadContent(file, callback);
	};
	
	/**
	 * Cancel a file upload in progress
	 * @param {module:client.Promise} promise The promise returned from uploadContent
	 * @return {boolean} true if canceled, otherwise false
	 */
	MatrixClient.prototype.cancelUpload = function(promise) {
	    return this._http.cancelUpload(promise);
	};
	
	/**
	 * Get a list of all file uploads in progress
	 * @return {array} Array of objects representing current uploads.
	 * Currently in progress is element 0. Keys:
	 *  - promise: The promise associated with the upload
	 *  - loaded: Number of bytes uploaded
	 *  - total: Total number of bytes to upload
	 */
	MatrixClient.prototype.getCurrentUploads = function() {
	    return this._http.getCurrentUploads();
	};
	
	/**
	 * @param {string} roomId
	 * @param {boolean} isTyping
	 * @param {Number} timeoutMs
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.sendTyping = function(roomId, isTyping, timeoutMs, callback) {
	    if (this.isGuest()) {
	        return q({}); // guests cannot send typing notifications so don't bother.
	    }
	
	    var path = utils.encodeUri("/rooms/$roomId/typing/$userId", {
	        $roomId: roomId,
	        $userId: this.credentials.userId
	    });
	    var data = {
	        typing: isTyping
	    };
	    if (isTyping) {
	        data.timeout = timeoutMs ? timeoutMs : 20000;
	    }
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, data
	    );
	};
	
	/**
	 * Create an alias to room ID mapping.
	 * @param {string} alias The room alias to create.
	 * @param {string} roomId The room ID to link the alias to.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.createAlias = function(alias, roomId, callback) {
	    var path = utils.encodeUri("/directory/room/$alias", {
	        $alias: alias
	    });
	    var data = {
	        room_id: roomId
	    };
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, data
	    );
	};
	
	/**
	 * Delete an alias to room ID mapping.  This alias must be on your local server
	 * and you must have sufficient access to do this operation.
	 * @param {string} alias The room alias to delete.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.deleteAlias = function(alias, callback) {
	    var path = utils.encodeUri("/directory/room/$alias", {
	        $alias: alias
	    });
	    return this._http.authedRequest(
	        callback, "DELETE", path, undefined, undefined
	    );
	};
	
	/**
	 * Get room info for the given alias.
	 * @param {string} alias The room alias to resolve.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Object with room_id and servers.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getRoomIdForAlias = function(alias, callback) {
	    var path = utils.encodeUri("/directory/room/$alias", {
	        $alias: alias
	    });
	    return this._http.authedRequest(
	        callback, "GET", path
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} eventId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.redactEvent = function(roomId, eventId, callback) {
	    var path = utils.encodeUri("/rooms/$roomId/redact/$eventId", {
	        $roomId: roomId,
	        $eventId: eventId
	    });
	    return this._http.authedRequest(callback, "POST", path, undefined, {});
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.invite = function(roomId, userId, callback) {
	    return _membershipChange(this, roomId, userId, "invite", undefined,
	        callback);
	};
	
	/**
	 * Invite a user to a room based on their email address.
	 * @param {string} roomId The room to invite the user to.
	 * @param {string} email The email address to invite.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.inviteByEmail = function(roomId, email, callback) {
	    return this.inviteByThreePid(
	        roomId, "email", email, callback
	    );
	};
	
	/**
	 * Invite a user to a room based on a third-party identifier.
	 * @param {string} roomId The room to invite the user to.
	 * @param {string} medium The medium to invite the user e.g. "email".
	 * @param {string} address The address for the specified medium.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.inviteByThreePid = function(roomId, medium, address, callback) {
	    var path = utils.encodeUri(
	        "/rooms/$roomId/invite",
	        { $roomId: roomId }
	    );
	
	    var identityServerUrl = this.getIdentityServerUrl();
	    if (!identityServerUrl) {
	        return q.reject(new MatrixError({
	            error: "No supplied identity server URL",
	            errcode: "ORG.MATRIX.JSSDK_MISSING_PARAM"
	        }));
	    }
	    if (identityServerUrl.indexOf("http://") === 0 ||
	            identityServerUrl.indexOf("https://") === 0) {
	        // this request must not have the protocol part because reasons
	        identityServerUrl = identityServerUrl.split("://")[1];
	    }
	
	    return this._http.authedRequest(callback, "POST", path, undefined, {
	        id_server: identityServerUrl,
	        medium: medium,
	        address: address
	    });
	};
	
	/**
	 * @param {string} roomId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.leave = function(roomId, callback) {
	    return _membershipChange(this, roomId, undefined, "leave", undefined,
	        callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} reason Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.ban = function(roomId, userId, reason, callback) {
	    return _membershipChange(this, roomId, userId, "ban", reason,
	        callback);
	};
	
	/**
	 * @param {string} roomId
	 * @param {boolean} deleteRoom True to delete the room from the store on success.
	 * Default: true.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.forget = function(roomId, deleteRoom, callback) {
	    if (deleteRoom === undefined) {
	        deleteRoom = true;
	    }
	    var promise = _membershipChange(this, roomId, undefined, "forget", undefined,
	        callback);
	    if (!deleteRoom) {
	        return promise;
	    }
	    var self = this;
	    return promise.then(function(response) {
	        self.store.removeRoom(roomId);
	        self.emit("deleteRoom", roomId);
	        return response;
	    });
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.unban = function(roomId, userId, callback) {
	    // unbanning = set their state to leave
	    return _setMembershipState(
	        this, roomId, userId, "leave", undefined, callback
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} reason Optional.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.kick = function(roomId, userId, reason, callback) {
	    return _setMembershipState(
	        this, roomId, userId, "leave", reason, callback
	    );
	};
	
	/**
	 * This is an internal method.
	 * @param {MatrixClient} client
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} membershipValue
	 * @param {string} reason
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	function _setMembershipState(client, roomId, userId, membershipValue, reason, 
	                             callback) {
	    if (utils.isFunction(reason)) { callback = reason; reason = undefined; }
	
	    var path = utils.encodeUri(
	        "/rooms/$roomId/state/m.room.member/$userId",
	        { $roomId: roomId, $userId: userId}
	    );
	
	    return client._http.authedRequest(callback, "PUT", path, undefined, {
	        membership: membershipValue,
	        reason: reason
	    });
	}
	
	/**
	 * This is an internal method.
	 * @param {MatrixClient} client
	 * @param {string} roomId
	 * @param {string} userId
	 * @param {string} membership
	 * @param {string} reason
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	function _membershipChange(client, roomId, userId, membership, reason, callback) {
	    if (utils.isFunction(reason)) { callback = reason; reason = undefined; }
	
	    var path = utils.encodeUri("/rooms/$room_id/$membership", {
	        $room_id: roomId,
	        $membership: membership
	    });
	    return client._http.authedRequest(
	        callback, "POST", path, undefined, {
	            user_id: userId,  // may be undefined e.g. on leave
	            reason: reason
	        }
	    );
	}
	
	/**
	 * Obtain a dict of actions which should be performed for this event according
	 * to the push rules for this user.
	 * @param {MatrixEvent} event The event to get push actions for.
	 * @return {module:pushprocessor~PushAction} A dict of actions to perform.
	 */
	MatrixClient.prototype.getPushActionsForEvent = function(event) {
	    if (event._pushActions === undefined) {
	        var pushProcessor = new PushProcessor(this);
	        event._pushActions = pushProcessor.actionsForEvent(event.event);
	    }
	    return event._pushActions;
	};
	
	// Profile operations
	// ==================
	
	/**
	 * @param {string} userId
	 * @param {string} info The kind of info to retrieve (e.g. 'displayname',
	 * 'avatar_url').
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getProfileInfo = function(userId, info, callback) {
	    if (utils.isFunction(info)) { callback = info; info = undefined; }
	
	    var path = info ?
	    utils.encodeUri("/profile/$userId/$info",
	             { $userId: userId, $info: info }) :
	    utils.encodeUri("/profile/$userId",
	             { $userId: userId });
	    return this._http.authedRequest(callback, "GET", path);
	};
	
	/**
	 * @param {string} info The kind of info to set (e.g. 'avatar_url')
	 * @param {Object} data The JSON object to set.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setProfileInfo = function(info, data, callback) {
	    var path = utils.encodeUri("/profile/$userId/$info", {
	        $userId: this.credentials.userId,
	        $info: info
	    });
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, data
	    );
	};
	
	/**
	 * @param {string} name
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setDisplayName = function(name, callback) {
	    return this.setProfileInfo(
	        "displayname", { displayname: name }, callback
	    );
	};
	
	/**
	 * @param {string} url
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setAvatarUrl = function(url, callback) {
	    return this.setProfileInfo(
	        "avatar_url", { avatar_url: url }, callback
	    );
	};
	
	/**
	 * Turn an MXC URL into an HTTP one. <strong>This method is experimental and
	 * may change.</strong>
	 * @param {string} mxcUrl The MXC URL
	 * @param {Number} width The desired width of the thumbnail.
	 * @param {Number} height The desired height of the thumbnail.
	 * @param {string} resizeMethod The thumbnail resize method to use, either
	 * "crop" or "scale".
	 * @param {Boolean} allowDirectLinks If true, return any non-mxc URLs
	 * directly. Fetching such URLs will leak information about the user to
	 * anyone they share a room with. If false, will return null for such URLs.
	 * @return {?string} the avatar URL or null.
	 */
	MatrixClient.prototype.mxcUrlToHttp =
	        function(mxcUrl, width, height, resizeMethod, allowDirectLinks) {
	    return contentRepo.getHttpUriForMxc(
	        this.baseUrl, mxcUrl, width, height, resizeMethod, allowDirectLinks
	    );
	};
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getThreePids = function(callback) {
	    var path = "/account/3pid";
	    return this._http.authedRequestWithPrefix(
	        callback, "GET", path, undefined, undefined, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * @param {Object} creds
	 * @param {boolean} bind
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.addThreePid = function(creds, bind, callback) {
	    var path = "/account/3pid";
	    var data = {
	        'threePidCreds': creds,
	        'bind': bind
	    };
	    return this._http.authedRequestWithPrefix(
	        callback, "POST", path, null, data, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * Make a request to change your password.
	 * @param {Object} authDict
	 * @param {string} newPassword The new desired password.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setPassword = function(authDict, newPassword, callback) {
	    var path = "/account/password";
	    var data = {
	        'auth': authDict,
	        'new_password': newPassword
	    };
	
	    return this._http.authedRequestWithPrefix(
	        callback, "POST", path, null, data, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * @param {string} presence
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 * @throws If 'presence' isn't a valid presence enum value.
	 */
	MatrixClient.prototype.setPresence = function(presence, callback) {
	    var path = utils.encodeUri("/presence/$userId/status", {
	        $userId: this.credentials.userId
	    });
	    var validStates = ["offline", "online", "unavailable"];
	    if (validStates.indexOf(presence) == -1) {
	        throw new Error("Bad presence value: " + presence);
	    }
	    var content = {
	        presence: presence
	    };
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, content
	    );
	};
	
	// Public (non-authed) operations
	// ==============================
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.publicRooms = function(callback) {
	    return this._http.authedRequest(callback, "GET", "/publicRooms");
	};
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.loginFlows = function(callback) {
	    return this._http.request(callback, "GET", "/login");
	};
	
	/**
	 * @param {string} roomAlias
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.resolveRoomAlias = function(roomAlias, callback) {
	    var path = utils.encodeUri("/directory/room/$alias", {$alias: roomAlias});
	    return this._http.request(callback, "GET", path);
	};
	
	/**
	 * @param {string} roomId
	 * @param {Number} limit
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.roomInitialSync = function(roomId, limit, callback) {
	    if (utils.isFunction(limit)) { callback = limit; limit = undefined; }
	    var path = utils.encodeUri("/rooms/$roomId/initialSync",
	        {$roomId: roomId}
	    );
	    if (!limit) {
	        limit = 30;
	    }
	    return this._http.authedRequest(
	        callback, "GET", path, { limit: limit }
	    );
	};
	
	/**
	 * @param {string} roomId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.roomState = function(roomId, callback) {
	    var path = utils.encodeUri("/rooms/$roomId/state", {$roomId: roomId});
	    return this._http.authedRequest(callback, "GET", path);
	};
	
	/**
	 * Retrieve older messages from the given room and put them in the timeline.
	 *
	 * If this is called multiple times whilst a request is ongoing, the <i>same</i>
	 * Promise will be returned. If there was a problem requesting scrollback, there
	 * will be a small delay before another request can be made (to prevent tight-looping
	 * when there is no connection).
	 *
	 * @param {Room} room The room to get older messages in.
	 * @param {Integer} limit Optional. The maximum number of previous events to
	 * pull in. Default: 30.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: Room. If you are at the beginning
	 * of the timeline, <code>Room.oldState.paginationToken</code> will be
	 * <code>null</code>.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.scrollback = function(room, limit, callback) {
	    if (utils.isFunction(limit)) { callback = limit; limit = undefined; }
	    limit = limit || 30;
	    var timeToWaitMs = 0;
	
	    var info = this._ongoingScrollbacks[room.roomId] || {};
	    if (info.promise) {
	        return info.promise;
	    }
	    else if (info.errorTs) {
	        var timeWaitedMs = Date.now() - info.errorTs;
	        timeToWaitMs = Math.max(SCROLLBACK_DELAY_MS - timeWaitedMs, 0);
	    }
	
	    if (room.oldState.paginationToken === null) {
	        return q(room); // already at the start.
	    }
	    // attempt to grab more events from the store first
	    var numAdded = this.store.scrollback(room, limit).length;
	    if (numAdded === limit) {
	        // store contained everything we needed.
	        return q(room);
	    }
	    // reduce the required number of events appropriately
	    limit = limit - numAdded;
	
	    var path = utils.encodeUri(
	        "/rooms/$roomId/messages", {$roomId: room.roomId}
	    );
	    var params = {
	        from: room.oldState.paginationToken,
	        limit: limit,
	        dir: 'b'
	    };
	    var defer = q.defer();
	    info = {
	        promise: defer.promise,
	        errorTs: null
	    };
	    var self = this;
	    // wait for a time before doing this request
	    // (which may be 0 in order not to special case the code paths)
	    q.delay(timeToWaitMs).then(function() {
	        return self._http.authedRequest(callback, "GET", path, params);
	    }).done(function(res) {
	        var matrixEvents = utils.map(res.chunk, _PojoToMatrixEventMapper(self));
	        room.addEventsToTimeline(matrixEvents, true);
	        room.oldState.paginationToken = res.end;
	        if (res.chunk.length === 0) {
	            room.oldState.paginationToken = null;
	        }
	        self.store.storeEvents(room, matrixEvents, res.end, true);
	        self._ongoingScrollbacks[room.roomId] = null;
	        _resolve(callback, defer, room);
	    }, function(err) {
	        self._ongoingScrollbacks[room.roomId] = {
	            errorTs: Date.now()
	        };
	        _reject(callback, defer, err);
	    });
	    this._ongoingScrollbacks[room.roomId] = info;
	    return defer.promise;
	};
	
	/**
	 * Take an EventContext, and back/forward-fill results.
	 *
	 * @param {module:models/event-context.EventContext} eventContext  context
	 *    object to be updated
	 * @param {Object}  opts
	 * @param {boolean} opts.backwards  true to fill backwards, false to go forwards
	 * @param {boolean} opts.limit      number of events to request
	 *
	 * @return {module:client.Promise} Resolves: updated EventContext object
	 * @return {Error} Rejects: with an error response.
	 */
	MatrixClient.prototype.paginateEventContext = function(eventContext, opts) {
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	    opts = opts || {};
	    var backwards = opts.backwards || false;
	
	    var token = eventContext.getPaginateToken(backwards);
	    if (!token) {
	        // no more results.
	        return q.reject(new Error("No paginate token"));
	    }
	
	    var dir = backwards ? 'b' : 'f';
	    var pendingRequest = eventContext._paginateRequests[dir];
	
	    if (pendingRequest) {
	        // already a request in progress - return the existing promise
	        return pendingRequest;
	    }
	
	    var path = utils.encodeUri(
	        "/rooms/$roomId/messages", {$roomId: eventContext.getEvent().getRoomId()}
	    );
	    var params = {
	        from: token,
	        limit: ('limit' in opts) ? opts.limit : 30,
	        dir: dir
	    };
	
	    var self = this;
	    var promise =
	        self._http.authedRequest(undefined, "GET", path, params
	    ).then(function(res) {
	        var token = res.end;
	        if (res.chunk.length === 0) {
	            token = null;
	        } else {
	            var matrixEvents = utils.map(res.chunk, self.getEventMapper());
	            if (backwards) {
	                // eventContext expects the events in timeline order, but
	                // back-pagination returns them in reverse order.
	                matrixEvents.reverse();
	            }
	            eventContext.addEvents(matrixEvents, backwards);
	        }
	        eventContext.setPaginateToken(token, backwards);
	        return eventContext;
	    }).finally(function() {
	        eventContext._paginateRequests[dir] = null;
	    });
	    eventContext._paginateRequests[dir] = promise;
	
	    return promise;
	};
	
	/**
	 * Get an EventTimeline for the given event
	 *
	 * <p>If the room object already has the given event in its store, the
	 * corresponding timeline will be returned. Otherwise, a /context request is
	 * made, and used to construct an EventTimeline.
	 *
	 * @param {Room} room  The room to look for the event in
	 * @param {string} eventId  The ID of the event to look for
	 *
	 * @return {module:client.Promise} Resolves:
	 *    {@link module:models/event-timeline~EventTimeline} including the given
	 *    event
	 */
	MatrixClient.prototype.getEventTimeline = function(room, eventId) {
	    // don't allow any timeline support unless it's been enabled.
	    if (!this.timelineSupport) {
	        throw new Error("timeline support is disabled. Set the 'timelineSupport'" +
	                    " parameter to true when creating MatrixClient to enable" +
	                    " it.");
	    }
	
	    if (room.getTimelineForEvent(eventId)) {
	        return q(room.getTimelineForEvent(eventId));
	    }
	
	    var path = utils.encodeUri(
	        "/rooms/$roomId/context/$eventId", {
	            $roomId: room.roomId,
	            $eventId: eventId,
	        }
	    );
	
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	    var self = this;
	    var promise =
	        self._http.authedRequest(undefined, "GET", path
	    ).then(function(res) {
	        if (!res.event) {
	            throw new Error("'event' not in '/context' result - homeserver too old?");
	        }
	
	        // by the time the request completes, the event might have ended up in
	        // the timeline.
	        if (room.getTimelineForEvent(eventId)) {
	            return room.getTimelineForEvent(eventId);
	        }
	
	        // we start with the last event, since that's the point at which we
	        // have known state.
	        var events = res.events_before
	            .concat([res.event])
	            .concat(res.events_after);
	        events.reverse();
	        var matrixEvents = utils.map(events, self.getEventMapper());
	
	        var timeline = room.getTimelineForEvent(matrixEvents[0].getId());
	        if (!timeline) {
	            timeline = room.addTimeline();
	            timeline.initialiseState(utils.map(res.state,
	                                               self.getEventMapper()));
	            timeline.getState(EventTimeline.FORWARDS).paginationToken = res.end;
	        }
	        room.addEventsToTimeline(matrixEvents, true, timeline, res.start);
	
	        // there is no guarantee that the event ended up in "timeline" (we
	        // might have switched to a neighbouring timeline) - so check the
	        // room's index again. On the other hand, there's no guarantee the
	        // event ended up anywhere, if it was later redacted, so we just
	        // return the timeline we first thought of.
	        return room.getTimelineForEvent(eventId) || timeline;
	    });
	    return promise;
	};
	
	
	/**
	 * Take an EventTimeline, and back/forward-fill results.
	 *
	 * @param {module:models/event-timeline~EventTimeline} eventTimeline timeline
	 *    object to be updated
	 * @param {Object}   [opts]
	 * @param {boolean}  [opts.backwards = false]  true to fill backwards,
	 *    false to go forwards
	 * @param {number}   [opts.limit = 30]         number of events to request
	 *
	 * @return {module:client.Promise} Resolves to a boolean: false if there are no
	 *    events and we reached either end of the timeline; else true.
	 */
	MatrixClient.prototype.paginateEventTimeline = function(eventTimeline, opts) {
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	    opts = opts || {};
	    var backwards = opts.backwards || false;
	
	    var room = this.getRoom(eventTimeline.getRoomId());
	    if (!room) {
	        throw new Error("Unknown room " + eventTimeline.getRoomId());
	    }
	
	    var dir = backwards ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS;
	
	    var token = eventTimeline.getPaginationToken(dir);
	    if (!token) {
	        // no token - no results.
	        return q(false);
	    }
	
	    var pendingRequest = eventTimeline._paginationRequests[dir];
	
	    if (pendingRequest) {
	        // already a request in progress - return the existing promise
	        return pendingRequest;
	    }
	
	    var path = utils.encodeUri(
	        "/rooms/$roomId/messages", {$roomId: eventTimeline.getRoomId()}
	    );
	    var params = {
	        from: token,
	        limit: ('limit' in opts) ? opts.limit : 30,
	        dir: dir
	    };
	
	    var self = this;
	
	    var promise =
	        this._http.authedRequest(undefined, "GET", path, params
	    ).then(function(res) {
	        var token = res.end;
	        var matrixEvents = utils.map(res.chunk, self.getEventMapper());
	        room.addEventsToTimeline(matrixEvents, backwards, eventTimeline, token);
	
	        // if we've hit the end of the timeline, we need to stop trying to
	        // paginate. We need to keep the 'forwards' token though, to make sure
	        // we can recover from gappy syncs.
	        if (backwards && res.end == res.start) {
	            eventTimeline.setPaginationToken(null, dir);
	        }
	        return res.end != res.start;
	    }).finally(function() {
	        eventTimeline._paginationRequests[dir] = null;
	    });
	    eventTimeline._paginationRequests[dir] = promise;
	
	    return promise;
	};
	
	// Registration/Login operations
	// =============================
	
	/**
	 * @param {string} loginType
	 * @param {Object} data
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.login = function(loginType, data, callback) {
	    data.type = loginType;
	    return this._http.authedRequest(
	        callback, "POST", "/login", undefined, data
	    );
	};
	
	/**
	 * Register a guest account.
	 * @param {Object=} opts Registration options
	 * @param {Object} opts.body JSON HTTP body to provide.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.registerGuest = function(opts, callback) {
	    opts = opts || {};
	    opts.body = opts.body || {};
	
	    return this._http.requestWithPrefix(
	        callback, "POST", "/register", {
	            kind: "guest"
	        },
	        opts.body, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * Peek into a room and receive updates about the room. This only works if the
	 * history visibility for the room is world_readable.
	 * @param {String} roomId The room to attempt to peek into.
	 * @return {module:client.Promise} Resolves: Room object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.peekInRoom = function(roomId) {
	    if (this._peekSync) {
	        this._peekSync.stopPeeking();
	    }
	    this._peekSync = new SyncApi(this);
	    return this._peekSync.peek(roomId);
	};
	
	/**
	 * Set r/w flags for guest access in a room.
	 * @param {string} roomId The room to configure guest access in.
	 * @param {Object} opts Options
	 * @param {boolean} opts.allowJoin True to allow guests to join this room. This
	 * implicitly gives guests write access. If false or not given, guests are
	 * explicitly forbidden from joining the room.
	 * @param {boolean} opts.allowRead True to set history visibility to
	 * be world_readable. This gives guests read access *from this point forward*.
	 * If false or not given, history visibility is not modified.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setGuestAccess = function(roomId, opts) {
	    var writePromise = this.sendStateEvent(roomId, "m.room.guest_access", {
	        guest_access: opts.allowJoin ? "can_join" : "forbidden"
	    });
	
	    var readPromise = q();
	    if (opts.allowRead) {
	        readPromise = this.sendStateEvent(roomId, "m.room.history_visibility", {
	            history_visibility: "world_readable"
	        });
	    }
	
	    return q.all(readPromise, writePromise);
	};
	
	/**
	 * @param {string} username
	 * @param {string} password
	 * @param {string} sessionId
	 * @param {Object} auth
	 * @param {boolean} bindEmail
	 * @param {string} guestAccessToken
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.register = function(username, password,
	                                           sessionId, auth, bindEmail, guestAccessToken,
	                                           callback) {
	    if (auth === undefined) { auth = {}; }
	    if (sessionId) { auth.session = sessionId; }
	
	    var params = {
	        auth: auth
	    };
	    if (username !== undefined) { params.username = username; }
	    if (password !== undefined) { params.password = password; }
	    if (bindEmail !== undefined) { params.bind_email = bindEmail; }
	    if (guestAccessToken !== undefined) { params.guest_access_token = guestAccessToken; }
	
	    return this._http.requestWithPrefix(
	        callback, "POST", "/register", undefined,
	        params, httpApi.PREFIX_V2_ALPHA
	    );
	};
	
	/**
	 * @param {string} user
	 * @param {string} password
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.loginWithPassword = function(user, password, callback) {
	    return this.login("m.login.password", {
	        user: user,
	        password: password
	    }, callback);
	};
	
	/**
	 * @param {string} relayState URL Callback after SAML2 Authentication
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.loginWithSAML2 = function(relayState, callback) {
	    return this.login("m.login.saml2", {
	        relay_state: relayState
	    }, callback);
	};
	
	/**
	 * @param {string} redirectUrl The URL to redirect to after the HS
	 * authenticates with CAS.
	 * @return {string} The HS URL to hit to begin the CAS login process.
	 */
	MatrixClient.prototype.getCasLoginUrl = function(redirectUrl) {
	    return this._http.getUrl("/login/cas/redirect", {
	        "redirectUrl": redirectUrl
	    }, httpApi.PREFIX_V1);
	};
	
	/**
	 * @param {string} token Login token previously received from homeserver
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.loginWithToken = function(token, callback) {
	    return this.login("m.login.token", {
	        token: token
	    }, callback);
	};
	
	// Push operations
	// ===============
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getPushRules = function(callback) {
	    return this._http.authedRequest(callback, "GET", "/pushrules/");
	};
	
	/**
	 * @param {string} scope
	 * @param {string} kind
	 * @param {string} ruleId
	 * @param {Object} body
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.addPushRule = function(scope, kind, ruleId, body, callback) {
	    // NB. Scope not uri encoded because devices need the '/'
	    var path = utils.encodeUri("/pushrules/" + scope + "/$kind/$ruleId", {
	        $kind: kind,
	        $ruleId: ruleId
	    });
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, body
	    );
	};
	
	/**
	 * @param {string} scope
	 * @param {string} kind
	 * @param {string} ruleId
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.deletePushRule = function(scope, kind, ruleId, callback) {
	    // NB. Scope not uri encoded because devices need the '/'
	    var path = utils.encodeUri("/pushrules/" + scope + "/$kind/$ruleId", {
	        $kind: kind,
	        $ruleId: ruleId
	    });
	    return this._http.authedRequest(callback, "DELETE", path);
	};
	
	/**
	 * Enable or disable a push notification rule.
	 * @param {string} scope
	 * @param {string} kind
	 * @param {string} ruleId
	 * @param {boolean} enabled
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setPushRuleEnabled = function(scope, kind,
	                                                     ruleId, enabled, callback) {
	    var path = utils.encodeUri("/pushrules/" + scope + "/$kind/$ruleId/enabled", {
	        $kind: kind,
	        $ruleId: ruleId
	    });
	    return this._http.authedRequest(
	        callback, "PUT", path, undefined, {"enabled": enabled}
	    );
	};
	
	/**
	 * Get the room-kind push rule associated with a room.
	 * @param {string} scope "global" or device-specific.
	 * @param {string} roomId the id of the room.
	 * @return {object} the rule or undefined.
	 */
	MatrixClient.prototype.getRoomPushRule = function(scope, roomId) {
	    // There can be only room-kind push rule per room
	    // and its id is the room id.
	    if (this.pushRules) {
	        for (var i = 0; i < this.pushRules[scope].room.length; i++) {
	            var rule = this.pushRules[scope].room[i];
	            if (rule.rule_id === roomId) {
	                return rule;
	            }
	        }
	    }
	    else {
	        throw new Error(
	            "SyncApi.sync() must be done before accessing to push rules."
	        );
	    }
	};
	
	/**
	 * Set a room-kind muting push rule in a room.
	 * The operation also updates MatrixClient.pushRules at the end.
	 * @param {string} scope "global" or device-specific.
	 * @param {string} roomId the id of the room.
	 * @param {string} mute the mute state.
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.setRoomMutePushRule = function(scope, roomId, mute) {
	    var self = this;
	    var deferred, hasDontNotifyRule;
	
	    // Get the existing room-kind push rule if any
	    var roomPushRule = this.getRoomPushRule(scope, roomId);
	    if (roomPushRule) {
	        if (0 <= roomPushRule.actions.indexOf("dont_notify")) {
	            hasDontNotifyRule = true;
	        }
	    }
	
	    if (!mute) {
	        // Remove the rule only if it is a muting rule
	        if (hasDontNotifyRule) {
	            deferred = this.deletePushRule(scope, "room", roomPushRule.rule_id);
	        }
	    }
	    else {
	        if (!roomPushRule) {
	            deferred = this.addPushRule(scope, "room", roomId, {
	                actions: ["dont_notify"]
	            });
	        }
	        else if (!hasDontNotifyRule) {
	            // Remove the existing one before setting the mute push rule
	            // This is a workaround to SYN-590 (Push rule update fails)
	            deferred = q.defer();
	            this.deletePushRule(scope, "room", roomPushRule.rule_id)
	            .done(function() {
	                self.addPushRule(scope, "room", roomId, {
	                    actions: ["dont_notify"]
	                }).done(function() {
	                    deferred.resolve();
	                }, function(err) {
	                    deferred.reject(err);
	                });
	            }, function(err) {
	                deferred.reject(err);
	            });
	
	            deferred = deferred.promise;
	        }
	    }
	
	    if (deferred) {
	        // Update this.pushRules when the operation completes
	        var ruleRefreshDeferred = q.defer();
	        deferred.done(function() {
	            self.getPushRules().done(function(result) {
	                self.pushRules = result;
	                ruleRefreshDeferred.resolve();
	            }, function(err) {
	                ruleRefreshDeferred.reject(err);
	            });
	        }, function(err) {
	            // Update it even if the previous operation fails. This can help the
	            // app to recover when push settings has been modifed from another client
	            self.getPushRules().done(function(result) {
	                self.pushRules = result;
	                ruleRefreshDeferred.reject(err);
	            }, function(err2) {
	                ruleRefreshDeferred.reject(err);
	            });
	        });
	        return ruleRefreshDeferred.promise;
	    }
	};
	
	/**
	 * Perform a server-side search for messages containing the given text.
	 * @param {Object} opts Options for the search.
	 * @param {string} opts.query The text to query.
	 * @param {string=} opts.keys The keys to search on. Defaults to all keys. One
	 * of "content.body", "content.name", "content.topic".
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.searchMessageText = function(opts, callback) {
	    return this.search({
	        body: {
	            search_categories: {
	                room_events: {
	                    keys: opts.keys,
	                    search_term: opts.query
	                }
	            }
	        }
	    }, callback);
	};
	
	/**
	 * Perform a server-side search for room events.
	 *
	 * The returned promise resolves to an object containing the fields:
	 *
	 *  * {number}  count:       estimate of the number of results
	 *  * {string}  next_batch:  token for back-pagination; if undefined, there are
	 *                           no more results
	 *  * {Array}   highlights:  a list of words to highlight from the stemming
	 *                           algorithm
	 *  * {Array}   results:     a list of results
	 *
	 * Each entry in the results list is a {module:models/search-result.SearchResult}.
	 *
	 * @param {Object} opts
	 * @param {string} opts.term     the term to search for
	 * @param {Object} opts.filter   a JSON filter object to pass in the request
	 * @return {module:client.Promise} Resolves: result object
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.searchRoomEvents = function(opts) {
	    // TODO: support groups
	
	    var body = {
	        search_categories: {
	            room_events: {
	                search_term: opts.term,
	                filter: opts.filter,
	                order_by: "recent",
	                event_context: {
	                    before_limit: 1,
	                    after_limit: 1,
	                    include_profile: true,
	                }
	            }
	        }
	    };
	
	    var searchResults = {
	        _query: body,
	        results: [],
	        highlights: [],
	    };
	
	    return this.search({body: body}).then(
	        this._processRoomEventsSearch.bind(this, searchResults)
	    );
	};
	
	/**
	 * Take a result from an earlier searchRoomEvents call, and backfill results.
	 *
	 * @param  {object} searchResults  the results object to be updated
	 * @return {module:client.Promise} Resolves: updated result object
	 * @return {Error} Rejects: with an error response.
	 */
	MatrixClient.prototype.backPaginateRoomEventsSearch = function(searchResults) {
	    // TODO: we should implement a backoff (as per scrollback()) to deal more
	    // nicely with HTTP errors.
	
	    if (!searchResults.next_batch) {
	        return q.reject(new Error("Cannot backpaginate event search any further"));
	    }
	
	    if (searchResults.pendingRequest) {
	        // already a request in progress - return the existing promise
	        return searchResults.pendingRequest;
	    }
	
	    var searchOpts = {
	        body: searchResults._query,
	        next_batch: searchResults.next_batch,
	    };
	
	    var promise = this.search(searchOpts).then(
	        this._processRoomEventsSearch.bind(this, searchResults)
	    ).finally(function() {
	        searchResults.pendingRequest = null;
	    });
	    searchResults.pendingRequest = promise;
	
	    return promise;
	};
	
	/**
	 * helper for searchRoomEvents and backPaginateRoomEventsSearch. Processes the
	 * response from the API call and updates the searchResults
	 *
	 * @param {Object} searchResults
	 * @param {Object} response
	 * @return {Object} searchResults
	 * @private
	 */
	MatrixClient.prototype._processRoomEventsSearch = function(searchResults, response) {
	    var room_events = response.search_categories.room_events;
	
	    searchResults.count = room_events.count;
	    searchResults.next_batch = room_events.next_batch;
	
	    // combine the highlight list with our existing list; build an object
	    // to avoid O(N^2) fail
	    var highlights = {};
	    room_events.highlights.forEach(function(hl) { highlights[hl] = 1; });
	    searchResults.highlights.forEach(function(hl) { highlights[hl] = 1; });
	
	    // turn it back into a list.
	    searchResults.highlights = Object.keys(highlights);
	
	    // append the new results to our existing results
	    for (var i = 0; i < room_events.results.length; i++) {
	        var sr = SearchResult.fromJson(room_events.results[i], this.getEventMapper());
	        searchResults.results.push(sr);
	    }
	    return searchResults;
	};
	
	/**
	 * Perform a server-side search.
	 * @param {Object} opts
	 * @param {string} opts.next_batch the batch token to pass in the query string
	 * @param {Object} opts.body the JSON object to pass to the request body.
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.search = function(opts, callback) {
	    var queryparams = {};
	    if (opts.next_batch) {
	        queryparams.next_batch = opts.next_batch;
	    }
	    return this._http.authedRequest(
	        callback, "POST", "/search", queryparams, opts.body
	    );
	};
	
	
	/**
	 * Populate the store with rooms the user has left.
	 * @return {module:client.Promise} Resolves: TODO - Resolved when the rooms have
	 * been added to the data store.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.syncLeftRooms = function() {
	    // Guard against multiple calls whilst ongoing and multiple calls post success
	    if (this._syncedLeftRooms) {
	        return q([]); // don't call syncRooms again if it succeeded.
	    }
	    if (this._syncLeftRoomsPromise) {
	        return this._syncLeftRoomsPromise; // return the ongoing request
	    }
	    var self = this;
	    var syncApi = new SyncApi(this);
	    this._syncLeftRoomsPromise = syncApi.syncLeftRooms();
	
	    // cleanup locks
	    this._syncLeftRoomsPromise.then(function(res) {
	        console.log("Marking success of sync left room request");
	        self._syncedLeftRooms = true; // flip the bit on success
	    }).finally(function() {
	        self._syncLeftRoomsPromise = null; // cleanup ongoing request state
	    });
	
	    return this._syncLeftRoomsPromise;
	};
	
	
	/**
	 * Create a new filter.
	 * @param {Object} content The HTTP body for the request
	 * @return {Filter} Resolves to a Filter object.
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.createFilter = function(content) {
	    var self = this;
	    var path = utils.encodeUri("/user/$userId/filter", {
	        $userId: this.credentials.userId
	    });
	    return this._http.authedRequestWithPrefix(
	        undefined, "POST", path, undefined, content, httpApi.PREFIX_V2_ALPHA
	    ).then(function(response) {
	        // persist the filter
	        var filter = Filter.fromJson(
	            self.credentials.userId, response.filter_id, content
	        );
	        self.store.storeFilter(filter);
	        return filter;
	    });
	};
	
	/**
	 * Retrieve a filter.
	 * @param {string} userId The user ID of the filter owner
	 * @param {string} filterId The filter ID to retrieve
	 * @param {boolean} allowCached True to allow cached filters to be returned.
	 * Default: True.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.getFilter = function(userId, filterId, allowCached) {
	    if (allowCached) {
	        var filter = this.store.getFilter(userId, filterId);
	        if (filter) {
	            return q(filter);
	        }
	    }
	
	    var self = this;
	    var path = utils.encodeUri("/user/$userId/filter/$filterId", {
	        $userId: userId,
	        $filterId: filterId
	    });
	
	    return this._http.authedRequestWithPrefix(
	        undefined, "GET", path, undefined, undefined, httpApi.PREFIX_V2_ALPHA
	    ).then(function(response) {
	        // persist the filter
	        var filter = Filter.fromJson(
	            userId, filterId, response
	        );
	        self.store.storeFilter(filter);
	        return filter;
	    });
	};
	
	
	// VoIP operations
	// ===============
	
	/**
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.turnServer = function(callback) {
	    return this._http.authedRequest(callback, "GET", "/voip/turnServer");
	};
	
	/**
	 * Get the TURN servers for this home server.
	 * @return {Array<Object>} The servers or an empty list.
	 */
	MatrixClient.prototype.getTurnServers = function() {
	    return this._turnServers || [];
	};
	
	/**
	 * @return {boolean} true if there is a valid access_token for this client.
	 */
	MatrixClient.prototype.isLoggedIn = function() {
	    return this._http.opts.accessToken !== undefined;
	};
	
	
	// Higher level APIs
	// =================
	
	// TODO: stuff to handle:
	//   local echo
	//   event dup suppression? - apparently we should still be doing this
	//   tracking current display name / avatar per-message
	//   pagination
	//   re-sending (including persisting pending messages to be sent)
	//   - Need a nice way to callback the app for arbitrary events like
	//     displayname changes
	//   due to ambiguity (or should this be on a chat-specific layer)?
	//   reconnect after connectivity outages
	
	
	/**
	 * High level helper method to call initialSync, emit the resulting events,
	 * and then start polling the eventStream for new events. To listen for these
	 * events, add a listener for {@link module:client~MatrixClient#event:"event"}
	 * via {@link module:client~MatrixClient#on}.
	 * @param {Object=} opts Options to apply when syncing.
	 * @param {Number=} opts.initialSyncLimit The event <code>limit=</code> to apply
	 * to initial sync. Default: 8.
	 * @param {Boolean=} opts.includeArchivedRooms True to put <code>archived=true</code>
	 * on the <code>/initialSync</code> request. Default: false.
	 * @param {Boolean=} opts.resolveInvitesToProfiles True to do /profile requests
	 * on every invite event if the displayname/avatar_url is not known for this user ID.
	 * Default: false.
	 * @param {String=} opts.pendingEventOrdering Controls where pending messages appear
	 * in a room's timeline. If "<b>chronological</b>", messages will appear in the timeline
	 * when the call to <code>sendEvent</code> was made. If "<b>end</b>", pending messages
	 * will always appear at the end of the timeline (multiple pending messages will be sorted
	 * chronologically). Default: "chronological".
	 * @param {Number=} opts.pollTimeout The number of milliseconds to wait on /events.
	 * Default: 30000 (30 seconds).
	 */
	MatrixClient.prototype.startClient = function(opts) {
	    if (this.clientRunning) {
	        // client is already running.
	        return;
	    }
	    this.clientRunning = true;
	    // backwards compat for when 'opts' was 'historyLen'.
	    if (typeof opts === "number") {
	        opts = {
	            initialSyncLimit: opts
	        };
	    }
	
	    if (CRYPTO_ENABLED && this.sessionStore !== null) {
	        this.uploadKeys(5);
	    }
	
	    // periodically poll for turn servers if we support voip
	    checkTurnServers(this);
	
	    var syncApi = new SyncApi(this, opts);
	    syncApi.sync();
	};
	
	/**
	 * High level helper method to stop the client from polling and allow a
	 * clean shutdown.
	 */
	MatrixClient.prototype.stopClient = function() {
	    this.clientRunning = false;
	    // TODO: f.e. Room => self.store.storeRoom(room) ?
	    // TODO: Actually stop the SyncApi
	};
	
	function setupCallEventHandler(client) {
	    var candidatesByCall = {
	        // callId: [Candidate]
	    };
	
	    // Maintain a buffer of events before the client has synced for the first time.
	    // This buffer will be inspected to see if we should send incoming call
	    // notifications. It needs to be buffered to correctly determine if an
	    // incoming call has had a matching answer/hangup.
	    var callEventBuffer = [];
	    var isClientPrepared = false;
	    client.on("sync", function(state) {
	        if (state === "PREPARED") {
	            isClientPrepared = true;
	            var ignoreCallIds = {}; // Set<String>
	            // inspect the buffer and mark all calls which have been answered
	            // or hung up before passing them to the call event handler.
	            for (var i = callEventBuffer.length - 1; i >= 0; i--) {
	                var ev = callEventBuffer[i];
	                if (ev.getType() === "m.call.answer" ||
	                        ev.getType() === "m.call.hangup") {
	                    ignoreCallIds[ev.getContent().call_id] = "yep";
	                }
	            }
	            // now loop through the buffer chronologically and inject them
	            callEventBuffer.forEach(function(e) {
	                if (ignoreCallIds[e.getContent().call_id]) {
	                    return;
	                }
	                callEventHandler(e);
	            });
	            callEventBuffer = [];
	        }
	    });
	
	    client.on("event", function(event) {
	        if (!isClientPrepared) {
	            if (event.getType().indexOf("m.call.") === 0) {
	                callEventBuffer.push(event);
	            }
	            return;
	        }
	        callEventHandler(event);
	    });
	
	    function callEventHandler(event) {
	        if (event.getType().indexOf("m.call.") !== 0) {
	            return; // not a call event
	        }
	        var content = event.getContent();
	        var call = content.call_id ? client.callList[content.call_id] : undefined;
	        var i;
	        //console.log("RECV %s content=%s", event.getType(), JSON.stringify(content));
	
	        if (event.getType() === "m.call.invite") {
	            if (event.getSender() === client.credentials.userId) {
	                return; // ignore invites you send
	            }
	
	            if (event.getAge() > content.lifetime) {
	                return; // expired call
	            }
	
	            if (call && call.state === "ended") {
	                return; // stale/old invite event
	            }
	            if (call) {
	                console.log(
	                    "WARN: Already have a MatrixCall with id %s but got an " +
	                    "invite. Clobbering.",
	                    content.call_id
	                );
	            }
	
	            call = webRtcCall.createNewMatrixCall(client, event.getRoomId());
	            if (!call) {
	                console.log(
	                    "Incoming call ID " + content.call_id + " but this client " +
	                    "doesn't support WebRTC"
	                );
	                // don't hang up the call: there could be other clients
	                // connected that do support WebRTC and declining the
	                // the call on their behalf would be really annoying.
	                return;
	            }
	
	            call.callId = content.call_id;
	            call._initWithInvite(event);
	            client.callList[call.callId] = call;
	
	            // if we stashed candidate events for that call ID, play them back now
	            if (candidatesByCall[call.callId]) {
	                for (i = 0; i < candidatesByCall[call.callId].length; i++) {
	                    call._gotRemoteIceCandidate(
	                        candidatesByCall[call.callId][i]
	                    );
	                }
	            }
	
	            // Were we trying to call that user (room)?
	            var existingCall;
	            var existingCalls = utils.values(client.callList);
	            for (i = 0; i < existingCalls.length; ++i) {
	                var thisCall = existingCalls[i];
	                if (call.room_id === thisCall.room_id &&
	                        thisCall.direction === 'outbound' &&
	                        (["wait_local_media", "create_offer", "invite_sent"].indexOf(
	                            thisCall.state) !== -1)) {
	                    existingCall = thisCall;
	                    break;
	                }
	            }
	
	            if (existingCall) {
	                // If we've only got to wait_local_media or create_offer and
	                // we've got an invite, pick the incoming call because we know
	                // we haven't sent our invite yet otherwise, pick whichever
	                // call has the lowest call ID (by string comparison)
	                if (existingCall.state === 'wait_local_media' ||
	                        existingCall.state === 'create_offer' ||
	                        existingCall.callId > call.callId) {
	                    console.log(
	                        "Glare detected: answering incoming call " + call.callId +
	                        " and canceling outgoing call " + existingCall.callId
	                    );
	                    existingCall._replacedBy(call);
	                    call.answer();
	                }
	                else {
	                    console.log(
	                        "Glare detected: rejecting incoming call " + call.callId +
	                        " and keeping outgoing call " + existingCall.callId
	                    );
	                    call.hangup();
	                }
	            }
	            else {
	                client.emit("Call.incoming", call);
	            }
	        }
	        else if (event.getType() === 'm.call.answer') {
	            if (!call) {
	                return;
	            }
	            if (event.getSender() === client.credentials.userId) {
	                if (call.state === 'ringing') {
	                    call._onAnsweredElsewhere(content);
	                }
	            }
	            else {
	                call._receivedAnswer(content);
	            }
	        }
	        else if (event.getType() === 'm.call.candidates') {
	            if (event.getSender() === client.credentials.userId) {
	                return;
	            }
	            if (!call) {
	                // store the candidates; we may get a call eventually.
	                if (!candidatesByCall[content.call_id]) {
	                    candidatesByCall[content.call_id] = [];
	                }
	                candidatesByCall[content.call_id] = candidatesByCall[
	                    content.call_id
	                ].concat(content.candidates);
	            }
	            else {
	                for (i = 0; i < content.candidates.length; i++) {
	                    call._gotRemoteIceCandidate(content.candidates[i]);
	                }
	            }
	        }
	        else if (event.getType() === 'm.call.hangup') {
	            // Note that we also observe our own hangups here so we can see
	            // if we've already rejected a call that would otherwise be valid
	            if (!call) {
	                // if not live, store the fact that the call has ended because
	                // we're probably getting events backwards so
	                // the hangup will come before the invite
	                call = webRtcCall.createNewMatrixCall(client, event.getRoomId());
	                if (call) {
	                    call.callId = content.call_id;
	                    call._initWithHangup(event);
	                    client.callList[content.call_id] = call;
	                }
	            }
	            else {
	                if (call.state !== 'ended') {
	                    call._onHangupReceived(content);
	                    delete client.callList[content.call_id];
	                }
	            }
	        }
	    }
	}
	
	function checkTurnServers(client) {
	    if (!client._supportsVoip) {
	        return;
	    }
	    if (client.isGuest()) {
	        return; // guests can't access TURN servers
	    }
	
	    client.turnServer().done(function(res) {
	        if (res.uris) {
	            console.log("Got TURN URIs: " + res.uris + " refresh in " +
	                res.ttl + " secs");
	            // map the response to a format that can be fed to
	            // RTCPeerConnection
	            var servers = {
	                urls: res.uris,
	                username: res.username,
	                credential: res.password
	            };
	            client._turnServers = [servers];
	            // re-fetch when we're about to reach the TTL
	            setTimeout(function() { checkTurnServers(client); },
	                (res.ttl || (60 * 60)) * 1000 * 0.9
	            );
	        }
	    }, function(err) {
	        console.error("Failed to get TURN URIs");
	        setTimeout(function() { checkTurnServers(client); }, 60000);
	    });
	}
	
	function _reject(callback, defer, err) {
	    if (callback) {
	        callback(err);
	    }
	    defer.reject(err);
	}
	
	function _resolve(callback, defer, res) {
	    if (callback) {
	        callback(null, res);
	    }
	    defer.resolve(res);
	}
	
	function _PojoToMatrixEventMapper(client) {
	    function mapper(plainOldJsObject) {
	        var event = new MatrixEvent(plainOldJsObject);
	        if (event.getType() === "m.room.encrypted") {
	            return _decryptMessage(client, event);
	        } else {
	            return event;
	        }
	    }
	    return mapper;
	}
	
	/**
	 * @return {Function}
	 */
	MatrixClient.prototype.getEventMapper = function() {
	    return _PojoToMatrixEventMapper(this);
	};
	
	// Identity Server Operations
	// ==========================
	
	/**
	 * @param {string} email
	 * @param {string} clientSecret
	 * @param {string} sendAttempt
	 * @param {string} nextLink Optional
	 * @param {module:client.callback} callback Optional.
	 * @return {module:client.Promise} Resolves: TODO
	 * @return {module:http-api.MatrixError} Rejects: with an error response.
	 */
	MatrixClient.prototype.requestEmailToken = function(email, clientSecret,
	                                                    sendAttempt, nextLink, callback) {
	    var params = {
	        client_secret: clientSecret,
	        email: email,
	        send_attempt: sendAttempt,
	        next_link: nextLink
	    };
	    return this._http.idServerRequest(
	        callback, "POST", "/validate/email/requestToken",
	        params, httpApi.PREFIX_IDENTITY_V1
	    ).then(function(res) {
	        if (typeof res === "string") {
	            return JSON.parse(res);
	        }
	        return res;
	    });
	};
	
	/**
	 * Generates a random string suitable for use as a client secret. <strong>This
	 * method is experimental and may change.</strong>
	 * @return {string} A new client secret
	 */
	MatrixClient.prototype.generateClientSecret = function() {
	    var ret = "";
	    var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
	
	    for (var i = 0; i < 32; i++) {
	        ret += chars.charAt(Math.floor(Math.random() * chars.length));
	    }
	
	    return ret;
	};
	
	/** */
	module.exports.MatrixClient = MatrixClient;
	/** */
	module.exports.CRYPTO_ENABLED = CRYPTO_ENABLED;
	
	// MatrixClient Event JSDocs
	
	/**
	 * Fires whenever the SDK receives a new event.
	 * @event module:client~MatrixClient#"event"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @example
	 * matrixClient.on("event", function(event){
	 *   var sender = event.getSender();
	 * });
	 */
	
	/**
	 * Fires whenever the SDK's syncing state is updated. The state can be one of:
	 * <ul>
	 * <li>PREPARED : The client has synced with the server at least once and is
	 * ready for methods to be called on it. This will be immediately followed by
	 * a state of SYNCING. <i>This is the equivalent of "syncComplete" in the
	 * previous API.</i></li>
	 * <li>SYNCING : The client is currently polling for new events from the server.
	 * This will be called <i>after</i> processing latest events from a sync.</li>
	 * <li>ERROR : The client has had a problem syncing with the server. If this is
	 * called <i>before</i> PREPARED then there was a problem performing the initial
	 * sync. If this is called <i>after</i> PREPARED then there was a problem polling
	 * the server for updates. This may be called multiple times even if the state is
	 * already ERROR. <i>This is the equivalent of "syncError" in the previous
	 * API.</i></li>
	 * </ul>
	 * State transition diagram:
	 * <pre>
	 *              +----->PREPARED -------> SYNCING <--+
	 *              |        ^                  |       |
	 *   null ------+        |  +---------------+       |
	 *              |        |  V                       |
	 *              +------->ERROR ---------------------+
	 *
	 * NB: 'null' will never be emitted by this event.
	 * </pre>
	 * Transitions:
	 * <ul>
	 * <li><code>null -> PREPARED</code> : Occurs when the initial sync is completed
	 * first time. This involves setting up filters and obtaining push rules.
	 * <li><code>null -> ERROR</code> : Occurs when the initial sync failed first time.
	 * <li><code>ERROR -> PREPARED</code> : Occurs when the initial sync succeeds
	 * after previously failing.
	 * <li><code>PREPARED -> SYNCING</code> : Occurs immediately after transitioning
	 * to PREPARED. Starts listening for live updates rather than catching up.
	 * <li><code>SYNCING -> ERROR</code> : Occurs the first time a client cannot perform a
	 * live update.
	 * <li><code>ERROR -> SYNCING</code> : Occurs when the client has performed a
	 * live update after having previously failed.
	 * <li><code>ERROR -> ERROR</code> : Occurs when the client has failed to sync
	 * for a second time or more.</li>
	 * <li><code>SYNCING -> SYNCING</code> : Occurs when the client has performed a live
	 * update. This is called <i>after</i> processing.</li>
	 * </ul>
	 *
	 * @event module:client~MatrixClient#"sync"
	 * @param {string} state An enum representing the syncing state. One of "PREPARED",
	 * "SYNCING", "ERROR".
	 * @param {?string} prevState An enum representing the previous syncing state.
	 * One of "PREPARED", "SYNCING", "ERROR" <b>or null</b>.
	 * @param {?Object} data Data about this transition.
	 * @param {MatrixError} data.err The matrix error if <code>state=ERROR</code>.
	 * @example
	 * matrixClient.on("sync", function(state, prevState, data) {
	 *   switch (state) {
	 *     case "ERROR":
	 *       // update UI to say "Connection Lost"
	 *       break;
	 *     case "SYNCING":
	 *       // update UI to remove any "Connection Lost" message
	 *       break;
	 *     case "PREPARED":
	 *       // the client instance is ready to be queried.
	 *       var rooms = matrixClient.getRooms();
	 *       break;
	 *   }
	 * });
	 */
	
	 /**
	 * Fires whenever a new Room is added. This will fire when you are invited to a
	 * room, as well as when you join a room. <strong>This event is experimental and
	 * may change.</strong>
	 * @event module:client~MatrixClient#"Room"
	 * @param {Room} room The newly created, fully populated room.
	 * @example
	 * matrixClient.on("Room", function(room){
	 *   var roomId = room.roomId;
	 * });
	 */
	
	 /**
	 * Fires whenever a Room is removed. This will fire when you forget a room.
	 * <strong>This event is experimental and may change.</strong>
	 * @event module:client~MatrixClient#"deleteRoom"
	 * @param {string} roomId The deleted room ID.
	 * @example
	 * matrixClient.on("deleteRoom", function(roomId){
	 *   // update UI from getRooms()
	 * });
	 */
	
	/**
	 * Fires whenever an incoming call arrives.
	 * @event module:client~MatrixClient#"Call.incoming"
	 * @param {module:webrtc/call~MatrixCall} call The incoming call.
	 * @example
	 * matrixClient.on("Call.incoming", function(call){
	 *   call.answer(); // auto-answer
	 * });
	 */
	
	// EventEmitter JSDocs
	
	/**
	 * The {@link https://nodejs.org/api/events.html|EventEmitter} class.
	 * @external EventEmitter
	 * @see {@link https://nodejs.org/api/events.html}
	 */
	
	/**
	 * Adds a listener to the end of the listeners array for the specified event.
	 * No checks are made to see if the listener has already been added. Multiple
	 * calls passing the same combination of event and listener will result in the
	 * listener being added multiple times.
	 * @function external:EventEmitter#on
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Alias for {@link external:EventEmitter#on}.
	 * @function external:EventEmitter#addListener
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Adds a <b>one time</b> listener for the event. This listener is invoked only
	 * the next time the event is fired, after which it is removed.
	 * @function external:EventEmitter#once
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Remove a listener from the listener array for the specified event.
	 * <b>Caution:</b> changes array indices in the listener array behind the
	 * listener.
	 * @function external:EventEmitter#removeListener
	 * @param {string} event The event to listen for.
	 * @param {Function} listener The function to invoke.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Removes all listeners, or those of the specified event. It's not a good idea
	 * to remove listeners that were added elsewhere in the code, especially when
	 * it's on an emitter that you didn't create (e.g. sockets or file streams).
	 * @function external:EventEmitter#removeAllListeners
	 * @param {string} event Optional. The event to remove listeners for.
	 * @return {EventEmitter} for call chaining.
	 */
	
	/**
	 * Execute each of the listeners in order with the supplied arguments.
	 * @function external:EventEmitter#emit
	 * @param {string} event The event to emit.
	 * @param {Function} listener The function to invoke.
	 * @return {boolean} true if event had listeners, false otherwise.
	 */
	
	/**
	 * By default EventEmitters will print a warning if more than 10 listeners are
	 * added for a particular event. This is a useful default which helps finding
	 * memory leaks. Obviously not all Emitters should be limited to 10. This
	 * function allows that to be increased. Set to zero for unlimited.
	 * @function external:EventEmitter#setMaxListeners
	 * @param {Number} n The max number of listeners.
	 * @return {EventEmitter} for call chaining.
	 */
	
	// MatrixClient Callback JSDocs
	
	/**
	 * The standard MatrixClient callback interface. Functions which accept this
	 * will specify 2 return arguments. These arguments map to the 2 parameters
	 * specified in this callback.
	 * @callback module:client.callback
	 * @param {Object} err The error value, the "rejected" value or null.
	 * @param {Object} data The data returned, the "resolved" value.
	 */
	
	 /**
	  * {@link https://github.com/kriskowal/q|A promise implementation (Q)}. Functions
	  * which return this will specify 2 return arguments. These arguments map to the
	  * "onFulfilled" and "onRejected" values of the Promise.
	  * @typedef {Object} Promise
	  * @static
	  * @property {Function} then promise.then(onFulfilled, onRejected, onProgress)
	  * @property {Function} catch promise.catch(onRejected)
	  * @property {Function} finally promise.finally(callback)
	  * @property {Function} done promise.done(onFulfilled, onRejected, onProgress)
	  */


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room-member
	 */
	var EventEmitter = __webpack_require__(27).EventEmitter;
	var ContentRepo = __webpack_require__(34);
	
	var utils = __webpack_require__(5);
	
	/**
	 * Construct a new room member.
	 * @constructor
	 * @param {string} roomId The room ID of the member.
	 * @param {string} userId The user ID of the member.
	 * @prop {string} roomId The room ID for this member.
	 * @prop {string} userId The user ID of this member.
	 * @prop {boolean} typing True if the room member is currently typing.
	 * @prop {string} name The human-readable name for this room member.
	 * @prop {Number} powerLevel The power level for this room member.
	 * @prop {Number} powerLevelNorm The normalised power level (0-100) for this
	 * room member.
	 * @prop {User} user The User object for this room member, if one exists.
	 * @prop {string} membership The membership state for this room member e.g. 'join'.
	 * @prop {Object} events The events describing this RoomMember.
	 * @prop {MatrixEvent} events.member The m.room.member event for this RoomMember.
	 */
	function RoomMember(roomId, userId) {
	    this.roomId = roomId;
	    this.userId = userId;
	    this.typing = false;
	    this.name = userId;
	    this.powerLevel = 0;
	    this.powerLevelNorm = 0;
	    this.user = null;
	    this.membership = null;
	    this.events = {
	        member: null
	    };
	    this._updateModifiedTime();
	}
	utils.inherits(RoomMember, EventEmitter);
	
	/**
	 * Update this room member's membership event. May fire "RoomMember.name" if
	 * this event updates this member's name.
	 * @param {MatrixEvent} event The <code>m.room.member</code> event
	 * @param {RoomState} roomState Optional. The room state to take into account
	 * when calculating (e.g. for disambiguating users with the same name).
	 * @fires module:client~MatrixClient#event:"RoomMember.name"
	 * @fires module:client~MatrixClient#event:"RoomMember.membership"
	 */
	RoomMember.prototype.setMembershipEvent = function(event, roomState) {
	    if (event.getType() !== "m.room.member") {
	        return;
	    }
	    this.events.member = event;
	
	    var oldMembership = this.membership;
	    this.membership = event.getDirectionalContent().membership;
	
	    var oldName = this.name;
	    this.name = calculateDisplayName(this, event, roomState);
	    if (oldMembership !== this.membership) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.membership", event, this);
	    }
	    if (oldName !== this.name) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.name", event, this);
	    }
	};
	
	/**
	 * Update this room member's power level event. May fire
	 * "RoomMember.powerLevel" if this event updates this member's power levels.
	 * @param {MatrixEvent} powerLevelEvent The <code>m.room.power_levels</code>
	 * event
	 * @fires module:client~MatrixClient#event:"RoomMember.powerLevel"
	 */
	RoomMember.prototype.setPowerLevelEvent = function(powerLevelEvent) {
	    if (powerLevelEvent.getType() !== "m.room.power_levels") {
	        return;
	    }
	    var maxLevel = powerLevelEvent.getContent().users_default || 0;
	    utils.forEach(utils.values(powerLevelEvent.getContent().users), function(lvl) {
	        maxLevel = Math.max(maxLevel, lvl);
	    });
	    var oldPowerLevel = this.powerLevel;
	    var oldPowerLevelNorm = this.powerLevelNorm;
	    this.powerLevel = (
	        powerLevelEvent.getContent().users[this.userId] ||
	        powerLevelEvent.getContent().users_default ||
	        0
	    );
	    this.powerLevelNorm = 0;
	    if (maxLevel > 0) {
	        this.powerLevelNorm = (this.powerLevel * 100) / maxLevel;
	    }
	
	    // emit for changes in powerLevelNorm as well (since the app will need to
	    // redraw everyone's level if the max has changed)
	    if (oldPowerLevel !== this.powerLevel || oldPowerLevelNorm !== this.powerLevelNorm) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.powerLevel", powerLevelEvent, this);
	    }
	};
	
	/**
	 * Update this room member's typing event. May fire "RoomMember.typing" if
	 * this event changes this member's typing state.
	 * @param {MatrixEvent} event The typing event
	 * @fires module:client~MatrixClient#event:"RoomMember.typing"
	 */
	RoomMember.prototype.setTypingEvent = function(event) {
	    if (event.getType() !== "m.typing") {
	        return;
	    }
	    var oldTyping = this.typing;
	    this.typing = false;
	    var typingList = event.getContent().user_ids;
	    if (!utils.isArray(typingList)) {
	        // malformed event :/ bail early. TODO: whine?
	        return;
	    }
	    if (typingList.indexOf(this.userId) !== -1) {
	        this.typing = true;
	    }
	    if (oldTyping !== this.typing) {
	        this._updateModifiedTime();
	        this.emit("RoomMember.typing", event, this);
	    }
	};
	
	/**
	 * Update the last modified time to the current time.
	 */
	RoomMember.prototype._updateModifiedTime = function() {
	    this._modified = Date.now();
	};
	
	/**
	 * Get the timestamp when this RoomMember was last updated. This timestamp is
	 * updated when properties on this RoomMember are updated.
	 * It is updated <i>before</i> firing events.
	 * @return {number} The timestamp
	 */
	RoomMember.prototype.getLastModifiedTime = function() {
	    return this._modified;
	};
	
	/**
	 * Get the avatar URL for a room member.
	 * @param {string} baseUrl The base homeserver URL See
	 * {@link module:client~MatrixClient#getHomeserverUrl}.
	 * @param {Number} width The desired width of the thumbnail.
	 * @param {Number} height The desired height of the thumbnail.
	 * @param {string} resizeMethod The thumbnail resize method to use, either
	 * "crop" or "scale".
	 * @param {Boolean} allowDefault (optional) Passing false causes this method to
	 * return null if the user has no avatar image. Otherwise, a default image URL
	 * will be returned. Default: true.
	 * @param {Boolean} allowDirectLinks (optional) If true, the avatar URL will be
	 * returned even if it is a direct hyperlink rather than a matrix content URL.
	 * If false, any non-matrix content URLs will be ignored. Setting this option to
	 * true will expose URLs that, if fetched, will leak information about the user
	 * to anyone who they share a room with.
	 * @return {?string} the avatar URL or null.
	 */
	RoomMember.prototype.getAvatarUrl =
	        function(baseUrl, width, height, resizeMethod, allowDefault, allowDirectLinks) {
	    if (allowDefault === undefined) { allowDefault = true; }
	    if (!this.events.member && !allowDefault) {
	        return null;
	    }
	    var rawUrl = this.events.member ? this.events.member.getContent().avatar_url : null;
	    var httpUrl = ContentRepo.getHttpUriForMxc(
	        baseUrl, rawUrl, width, height, resizeMethod, allowDirectLinks
	    );
	    if (httpUrl) {
	        return httpUrl;
	    }
	    else if (allowDefault) {
	        return ContentRepo.getIdenticonUri(
	            baseUrl, this.userId, width, height
	        );
	    }
	    return null;
	};
	
	function calculateDisplayName(member, event, roomState) {
	    var displayName = event.getDirectionalContent().displayname;
	    var selfUserId = member.userId;
	
	    /*
	    // FIXME: this would be great but still needs to use the
	    // full userId to disambiguate if needed...
	
	    if (!displayName) {
	        var matches = selfUserId.match(/^@(.*?):/);
	        if (matches) {
	            return matches[1];
	        }
	        else {
	            return selfUserId;
	        }
	    }
	    */
	
	    if (!displayName) {
	        return selfUserId;
	    }
	
	    if (!roomState) {
	        return displayName;
	    }
	
	    var userIds = roomState.getUserIdsWithDisplayName(displayName);
	    var otherUsers = userIds.filter(function(u) {
	        return u !== selfUserId;
	    });
	    if (otherUsers.length > 0) {
	        return displayName + " (" + selfUserId + ")";
	    }
	    return displayName;
	}
	
	/**
	 * The RoomMember class.
	 */
	module.exports = RoomMember;
	
	/**
	 * Fires whenever any room member's name changes.
	 * @event module:client~MatrixClient#"RoomMember.name"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.name changed.
	 * @example
	 * matrixClient.on("RoomMember.name", function(event, member){
	 *   var newName = member.name;
	 * });
	 */
	
	/**
	 * Fires whenever any room member's membership state changes.
	 * @event module:client~MatrixClient#"RoomMember.membership"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.membership changed.
	 * @example
	 * matrixClient.on("RoomMember.membership", function(event, member){
	 *   var newState = member.membership;
	 * });
	 */
	
	/**
	 * Fires whenever any room member's typing state changes.
	 * @event module:client~MatrixClient#"RoomMember.typing"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.typing changed.
	 * @example
	 * matrixClient.on("RoomMember.typing", function(event, member){
	 *   var isTyping = member.typing;
	 * });
	 */
	
	/**
	 * Fires whenever any room member's power level changes.
	 * @event module:client~MatrixClient#"RoomMember.powerLevel"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomMember} member The member whose RoomMember.powerLevel changed.
	 * @example
	 * matrixClient.on("RoomMember.powerLevel", function(event, member){
	 *   var newPowerLevel = member.powerLevel;
	 *   var newNormPowerLevel = member.powerLevelNorm;
	 * });
	 */


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room-state
	 */
	var EventEmitter = __webpack_require__(27).EventEmitter;
	
	var utils = __webpack_require__(5);
	var RoomMember = __webpack_require__(93);
	
	/**
	 * Construct room state.
	 * @constructor
	 * @param {string} roomId Required. The ID of the room which has this state.
	 * @prop {Object.<string, RoomMember>} members The room member dictionary, keyed
	 * on the user's ID.
	 * @prop {Object.<string, Object.<string, MatrixEvent>>} events The state
	 * events dictionary, keyed on the event type and then the state_key value.
	 * @prop {string} paginationToken The pagination token for this state.
	 */
	function RoomState(roomId) {
	    this.roomId = roomId;
	    this.members = {
	        // userId: RoomMember
	    };
	    this.events = {
	        // eventType: { stateKey: MatrixEvent }
	    };
	    this.paginationToken = null;
	
	    this._sentinels = {
	        // userId: RoomMember
	    };
	    this._updateModifiedTime();
	    this._displayNameToUserIds = {};
	    this._userIdsToDisplayNames = {};
	    this._tokenToInvite = {}; // 3pid invite state_key to m.room.member invite
	}
	utils.inherits(RoomState, EventEmitter);
	
	/**
	 * Get all RoomMembers in this room.
	 * @return {Array<RoomMember>} A list of RoomMembers.
	 */
	RoomState.prototype.getMembers = function() {
	    return utils.values(this.members);
	};
	
	/**
	 * Get a room member by their user ID.
	 * @param {string} userId The room member's user ID.
	 * @return {RoomMember} The member or null if they do not exist.
	 */
	RoomState.prototype.getMember = function(userId) {
	    return this.members[userId] || null;
	};
	
	/**
	 * Get a room member whose properties will not change with this room state. You
	 * typically want this if you want to attach a RoomMember to a MatrixEvent which
	 * may no longer be represented correctly by Room.currentState or Room.oldState.
	 * The term 'sentinel' refers to the fact that this RoomMember is an unchanging
	 * guardian for state at this particular point in time.
	 * @param {string} userId The room member's user ID.
	 * @return {RoomMember} The member or null if they do not exist.
	 */
	RoomState.prototype.getSentinelMember = function(userId) {
	    return this._sentinels[userId] || null;
	};
	
	/**
	 * Get state events from the state of the room.
	 * @param {string} eventType The event type of the state event.
	 * @param {string} stateKey Optional. The state_key of the state event. If
	 * this is <code>undefined</code> then all matching state events will be
	 * returned.
	 * @return {MatrixEvent[]|MatrixEvent} A list of events if state_key was
	 * <code>undefined</code>, else a single event (or null if no match found).
	 */
	RoomState.prototype.getStateEvents = function(eventType, stateKey) {
	    if (!this.events[eventType]) {
	        // no match
	        return stateKey === undefined ? [] : null;
	    }
	    if (stateKey === undefined) { // return all values
	        return utils.values(this.events[eventType]);
	    }
	    var event = this.events[eventType][stateKey];
	    return event ? event : null;
	};
	
	/**
	 * Add an array of one or more state MatrixEvents, overwriting
	 * any existing state with the same {type, stateKey} tuple. Will fire
	 * "RoomState.events" for every event added. May fire "RoomState.members"
	 * if there are <code>m.room.member</code> events.
	 * @param {MatrixEvent[]} stateEvents a list of state events for this room.
	 * @fires module:client~MatrixClient#event:"RoomState.members"
	 * @fires module:client~MatrixClient#event:"RoomState.newMember"
	 * @fires module:client~MatrixClient#event:"RoomState.events"
	 */
	RoomState.prototype.setStateEvents = function(stateEvents) {
	    var self = this;
	    this._updateModifiedTime();
	
	    // update the core event dict
	    utils.forEach(stateEvents, function(event) {
	        if (event.getRoomId() !== self.roomId) { return; }
	        if (!event.isState()) { return; }
	
	        if (self.events[event.getType()] === undefined) {
	            self.events[event.getType()] = {};
	        }
	        self.events[event.getType()][event.getStateKey()] = event;
	        if (event.getType() === "m.room.member") {
	            _updateDisplayNameCache(
	                self, event.getStateKey(), event.getContent().displayname
	            );
	            _updateThirdPartyTokenCache(self, event);
	        }
	        self.emit("RoomState.events", event, self);
	    });
	
	    // update higher level data structures. This needs to be done AFTER the
	    // core event dict as these structures may depend on other state events in
	    // the given array (e.g. disambiguating display names in one go to do both
	    // clashing names rather than progressively which only catches 1 of them).
	    utils.forEach(stateEvents, function(event) {
	        if (event.getRoomId() !== self.roomId) { return; }
	        if (!event.isState()) { return; }
	
	        if (event.getType() === "m.room.member") {
	            var userId = event.getStateKey();
	            var member = self.members[userId];
	            if (!member) {
	                member = new RoomMember(event.getRoomId(), userId);
	                self.emit("RoomState.newMember", event, self, member);
	            }
	            // Add a new sentinel for this change. We apply the same
	            // operations to both sentinel and member rather than deep copying
	            // so we don't make assumptions about the properties of RoomMember
	            // (e.g. and manage to break it because deep copying doesn't do
	            // everything).
	            var sentinel = new RoomMember(event.getRoomId(), userId);
	            utils.forEach([member, sentinel], function(roomMember) {
	                roomMember.setMembershipEvent(event, self);
	                // this member may have a power level already, so set it.
	                var pwrLvlEvent = self.getStateEvents("m.room.power_levels", "");
	                if (pwrLvlEvent) {
	                    roomMember.setPowerLevelEvent(pwrLvlEvent);
	                }
	            });
	
	            self._sentinels[userId] = sentinel;
	            self.members[userId] = member;
	            self.emit("RoomState.members", event, self, member);
	        }
	        else if (event.getType() === "m.room.power_levels") {
	            var members = utils.values(self.members);
	            utils.forEach(members, function(member) {
	                member.setPowerLevelEvent(event);
	                self.emit("RoomState.members", event, self, member);
	            });
	        }
	    });
	};
	
	/**
	 * Set the current typing event for this room.
	 * @param {MatrixEvent} event The typing event
	 */
	RoomState.prototype.setTypingEvent = function(event) {
	    utils.forEach(utils.values(this.members), function(member) {
	        member.setTypingEvent(event);
	    });
	};
	
	/**
	 * Get the m.room.member event which has the given third party invite token.
	 *
	 * @param {string} token The token
	 * @return {?MatrixEvent} The m.room.member event or null
	 */
	RoomState.prototype.getInviteForThreePidToken = function(token) {
	    return this._tokenToInvite[token] || null;
	};
	
	/**
	 * Update the last modified time to the current time.
	 */
	RoomState.prototype._updateModifiedTime = function() {
	    this._modified = Date.now();
	};
	
	/**
	 * Get the timestamp when this room state was last updated. This timestamp is
	 * updated when this object has received new state events.
	 * @return {number} The timestamp
	 */
	RoomState.prototype.getLastModifiedTime = function() {
	    return this._modified;
	};
	
	/**
	 * Get user IDs with the specified display name.
	 * @param {string} displayName The display name to get user IDs from.
	 * @return {string[]} An array of user IDs or an empty array.
	 */
	RoomState.prototype.getUserIdsWithDisplayName = function(displayName) {
	    return this._displayNameToUserIds[displayName] || [];
	};
	
	/**
	 * The RoomState class.
	 */
	module.exports = RoomState;
	
	
	function _updateThirdPartyTokenCache(roomState, memberEvent) {
	    if (!memberEvent.getContent().third_party_invite) {
	        return;
	    }
	    var token = (memberEvent.getContent().third_party_invite.signed || {}).token;
	    if (!token) {
	        return;
	    }
	    var threePidInvite = roomState.getStateEvents(
	        "m.room.third_party_invite", token
	    );
	    if (!threePidInvite) {
	        return;
	    }
	    roomState._tokenToInvite[token] = memberEvent;
	}
	
	function _updateDisplayNameCache(roomState, userId, displayName) {
	    var oldName = roomState._userIdsToDisplayNames[userId];
	    delete roomState._userIdsToDisplayNames[userId];
	    if (oldName) {
	        // Remove the old name from the cache.
	        // We clobber the user_id > name lookup but the name -> [user_id] lookup
	        // means we need to remove that user ID from that array rather than nuking
	        // the lot.
	        var existingUserIds = roomState._displayNameToUserIds[oldName] || [];
	        for (var i = 0; i < existingUserIds.length; i++) {
	            if (existingUserIds[i] === userId) {
	                // remove this user ID from this array
	                existingUserIds.splice(i, 1);
	                i--;
	            }
	        }
	        roomState._displayNameToUserIds[oldName] = existingUserIds;
	    }
	
	    roomState._userIdsToDisplayNames[userId] = displayName;
	    if (!roomState._displayNameToUserIds[displayName]) {
	        roomState._displayNameToUserIds[displayName] = [];
	    }
	    roomState._displayNameToUserIds[displayName].push(userId);
	}
	
	/**
	 * Fires whenever the event dictionary in room state is updated.
	 * @event module:client~MatrixClient#"RoomState.events"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomState} state The room state whose RoomState.events dictionary
	 * was updated.
	 * @example
	 * matrixClient.on("RoomState.events", function(event, state){
	 *   var newStateEvent = event;
	 * });
	 */
	
	/**
	 * Fires whenever a member in the members dictionary is updated in any way.
	 * @event module:client~MatrixClient#"RoomState.members"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomState} state The room state whose RoomState.members dictionary
	 * was updated.
	 * @param {RoomMember} member The room member that was updated.
	 * @example
	 * matrixClient.on("RoomState.members", function(event, state, member){
	 *   var newMembershipState = member.membership;
	 * });
	 */
	
	 /**
	 * Fires whenever a member is added to the members dictionary. The RoomMember
	 * will not be fully populated yet (e.g. no membership state).
	 * @event module:client~MatrixClient#"RoomState.newMember"
	 * @param {MatrixEvent} event The matrix event which caused this event to fire.
	 * @param {RoomState} state The room state whose RoomState.members dictionary
	 * was updated with a new entry.
	 * @param {RoomMember} member The room member that was added.
	 * @example
	 * matrixClient.on("RoomState.newMember", function(event, state, member){
	 *   // add event listeners on 'member'
	 * });
	 */


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module. See {@link createNewMatrixCall} for the public API.
	 * @module webrtc/call
	 */
	var utils = __webpack_require__(5);
	var EventEmitter = __webpack_require__(27).EventEmitter;
	var DEBUG = true;  // set true to enable console logging.
	
	// events: hangup, error(err), replaced(call), state(state, oldState)
	
	/**
	 * Construct a new Matrix Call.
	 * @constructor
	 * @param {Object} opts Config options.
	 * @param {string} opts.roomId The room ID for this call.
	 * @param {Object} opts.webRtc The WebRTC globals from the browser.
	 * @param {Object} opts.URL The URL global.
	 * @param {Array<Object>} opts.turnServers Optional. A list of TURN servers.
	 * @param {MatrixClient} opts.client The Matrix Client instance to send events to.
	 */
	function MatrixCall(opts) {
	    this.roomId = opts.roomId;
	    this.client = opts.client;
	    this.webRtc = opts.webRtc;
	    this.URL = opts.URL;
	    // Array of Objects with urls, username, credential keys
	    this.turnServers = opts.turnServers || [];
	    if (this.turnServers.length === 0) {
	        this.turnServers.push({
	            urls: [MatrixCall.FALLBACK_STUN_SERVER]
	        });
	    }
	    utils.forEach(this.turnServers, function(server) {
	        utils.checkObjectHasKeys(server, ["urls"]);
	    });
	
	    this.callId = "c" + new Date().getTime();
	    this.state = 'fledgling';
	    this.didConnect = false;
	
	    // A queue for candidates waiting to go out.
	    // We try to amalgamate candidates into a single candidate message where
	    // possible
	    this.candidateSendQueue = [];
	    this.candidateSendTries = 0;
	
	    this.screenSharingStream = null;
	}
	/** The length of time a call can be ringing for. */
	MatrixCall.CALL_TIMEOUT_MS = 60000;
	/** The fallback server to use for STUN. */
	MatrixCall.FALLBACK_STUN_SERVER = 'stun:stun.l.google.com:19302';
	/** An error code when the local client failed to create an offer. */
	MatrixCall.ERR_LOCAL_OFFER_FAILED = "local_offer_failed";
	/**
	 * An error code when there is no local mic/camera to use. This may be because
	 * the hardware isn't plugged in, or the user has explicitly denied access.
	 */
	MatrixCall.ERR_NO_USER_MEDIA = "no_user_media";
	
	utils.inherits(MatrixCall, EventEmitter);
	
	/**
	 * Place a voice call to this room.
	 * @throws If you have not specified a listener for 'error' events.
	 */
	MatrixCall.prototype.placeVoiceCall = function() {
	    debuglog("placeVoiceCall");
	    checkForErrorListener(this);
	    _placeCallWithConstraints(this, _getUserMediaVideoContraints('voice'));
	    this.type = 'voice';
	};
	
	/**
	 * Place a video call to this room.
	 * @param {Element} remoteVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render video to.
	 * @param {Element} localVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render the local camera preview.
	 * @throws If you have not specified a listener for 'error' events.
	 */
	MatrixCall.prototype.placeVideoCall = function(remoteVideoElement, localVideoElement) {
	    debuglog("placeVideoCall");
	    checkForErrorListener(this);
	    this.localVideoElement = localVideoElement;
	    this.remoteVideoElement = remoteVideoElement;
	    _placeCallWithConstraints(this, _getUserMediaVideoContraints('video'));
	    this.type = 'video';
	    _tryPlayRemoteStream(this);
	};
	
	/**
	 * Place a screen-sharing call to this room. This includes audio.
	 * <b>This method is EXPERIMENTAL and subject to change without warning. It
	 * only works in Google Chrome.</b>
	 * @param {Element} remoteVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render video to.
	 * @param {Element} localVideoElement a <code>&lt;video&gt;</code> DOM element
	 * to render the local camera preview.
	 * @throws If you have not specified a listener for 'error' events.
	 */
	MatrixCall.prototype.placeScreenSharingCall =
	    function(remoteVideoElement, localVideoElement)
	{
	    debuglog("placeScreenSharingCall");
	    checkForErrorListener(this);
	    var screenConstraints = _getChromeScreenSharingConstraints(this);
	    if (!screenConstraints) {
	        return;
	    }
	    this.localVideoElement = localVideoElement;
	    this.remoteVideoElement = remoteVideoElement;
	    var self = this;
	    this.webRtc.getUserMedia(screenConstraints, function(stream) {
	        self.screenSharingStream = stream;
	        debuglog("Got screen stream, requesting audio stream...");
	        var audioConstraints = _getUserMediaVideoContraints('voice');
	        _placeCallWithConstraints(self, audioConstraints);
	    }, function(err) {
	        self.emit("error",
	            callError(
	                MatrixCall.ERR_NO_USER_MEDIA,
	                "Failed to get screen-sharing stream: " + err
	            )
	        );
	    });
	    this.type = 'video';
	    _tryPlayRemoteStream(this);
	};
	
	/**
	 * Retrieve the local <code>&lt;video&gt;</code> DOM element.
	 * @return {Element} The dom element
	 */
	MatrixCall.prototype.getLocalVideoElement = function() {
	    return this.localVideoElement;
	};
	
	/**
	 * Retrieve the remote <code>&lt;video&gt;</code> DOM element
	 * used for playing back video capable streams.
	 * @return {Element} The dom element
	 */
	MatrixCall.prototype.getRemoteVideoElement = function() {
	    return this.remoteVideoElement;
	};
	
	/**
	 * Retrieve the remote <code>&lt;audio&gt;</code> DOM element
	 * used for playing back audio only streams.
	 * @return {Element} The dom element
	 */
	MatrixCall.prototype.getRemoteAudioElement = function() {
	    return this.remoteAudioElement;
	};
	
	/**
	 * Set the local <code>&lt;video&gt;</code> DOM element. If this call is active,
	 * video will be rendered to it immediately.
	 * @param {Element} element The <code>&lt;video&gt;</code> DOM element.
	 */
	MatrixCall.prototype.setLocalVideoElement = function(element) {
	    this.localVideoElement = element;
	
	    if (element && this.localAVStream && this.type === 'video') {
	        element.autoplay = true;
	        element.src = this.URL.createObjectURL(this.localAVStream);
	        element.muted = true;
	        var self = this;
	        setTimeout(function() {
	            var vel = self.getLocalVideoElement();
	            if (vel.play) {
	                vel.play();
	            }
	        }, 0);
	    }
	};
	
	/**
	 * Set the remote <code>&lt;video&gt;</code> DOM element. If this call is active,
	 * the first received video-capable stream will be rendered to it immediately.
	 * @param {Element} element The <code>&lt;video&gt;</code> DOM element.
	 */
	MatrixCall.prototype.setRemoteVideoElement = function(element) {
	    this.remoteVideoElement = element;
	    _tryPlayRemoteStream(this);
	};
	
	/**
	 * Set the remote <code>&lt;audio&gt;</code> DOM element. If this call is active,
	 * the first received audio-only stream will be rendered to it immediately.
	 * @param {Element} element The <code>&lt;video&gt;</code> DOM element.
	 */
	MatrixCall.prototype.setRemoteAudioElement = function(element) {
	    this.remoteAudioElement = element;
	    _tryPlayRemoteAudioStream(this);
	};
	
	/**
	 * Configure this call from an invite event. Used by MatrixClient.
	 * @protected
	 * @param {MatrixEvent} event The m.call.invite event
	 */
	MatrixCall.prototype._initWithInvite = function(event) {
	    this.msg = event.getContent();
	    this.peerConn = _createPeerConnection(this);
	    var self = this;
	    if (this.peerConn) {
	        this.peerConn.setRemoteDescription(
	            new this.webRtc.RtcSessionDescription(this.msg.offer),
	            hookCallback(self, self._onSetRemoteDescriptionSuccess),
	            hookCallback(self, self._onSetRemoteDescriptionError)
	        );
	    }
	    setState(this, 'ringing');
	    this.direction = 'inbound';
	
	    // firefox and OpenWebRTC's RTCPeerConnection doesn't add streams until it
	    // starts getting media on them so we need to figure out whether a video
	    // channel has been offered by ourselves.
	    if (
	        this.msg.offer &&
	        this.msg.offer.sdp &&
	        this.msg.offer.sdp.indexOf('m=video') > -1
	    ) {
	        this.type = 'video';
	    }
	    else {
	        this.type = 'voice';
	    }
	
	    if (event.getAge()) {
	        setTimeout(function() {
	            if (self.state == 'ringing') {
	                debuglog("Call invite has expired. Hanging up.");
	                self.hangupParty = 'remote'; // effectively
	                setState(self, 'ended');
	                stopAllMedia(self);
	                if (self.peerConn.signalingState != 'closed') {
	                    self.peerConn.close();
	                }
	                self.emit("hangup", self);
	            }
	        }, this.msg.lifetime - event.getAge());
	    }
	};
	
	/**
	 * Configure this call from a hangup event. Used by MatrixClient.
	 * @protected
	 * @param {MatrixEvent} event The m.call.hangup event
	 */
	MatrixCall.prototype._initWithHangup = function(event) {
	    // perverse as it may seem, sometimes we want to instantiate a call with a
	    // hangup message (because when getting the state of the room on load, events
	    // come in reverse order and we want to remember that a call has been hung up)
	    this.msg = event.getContent();
	    setState(this, 'ended');
	};
	
	/**
	 * Answer a call.
	 */
	MatrixCall.prototype.answer = function() {
	    debuglog("Answering call %s of type %s", this.callId, this.type);
	    var self = this;
	
	    if (!this.localAVStream && !this.waitForLocalAVStream) {
	        this.webRtc.getUserMedia(
	            _getUserMediaVideoContraints(this.type),
	            hookCallback(self, self._gotUserMediaForAnswer),
	            hookCallback(self, self._getUserMediaFailed)
	        );
	        setState(this, 'wait_local_media');
	    } else if (this.localAVStream) {
	        this._gotUserMediaForAnswer(this.localAVStream);
	    } else if (this.waitForLocalAVStream) {
	        setState(this, 'wait_local_media');
	    }
	};
	
	/**
	 * Replace this call with a new call, e.g. for glare resolution. Used by
	 * MatrixClient.
	 * @protected
	 * @param {MatrixCall} newCall The new call.
	 */
	MatrixCall.prototype._replacedBy = function(newCall) {
	    debuglog(this.callId + " being replaced by " + newCall.callId);
	    if (this.state == 'wait_local_media') {
	        debuglog("Telling new call to wait for local media");
	        newCall.waitForLocalAVStream = true;
	    } else if (this.state == 'create_offer') {
	        debuglog("Handing local stream to new call");
	        newCall._gotUserMediaForAnswer(this.localAVStream);
	        delete(this.localAVStream);
	    } else if (this.state == 'invite_sent') {
	        debuglog("Handing local stream to new call");
	        newCall._gotUserMediaForAnswer(this.localAVStream);
	        delete(this.localAVStream);
	    }
	    newCall.localVideoElement = this.localVideoElement;
	    newCall.remoteVideoElement = this.remoteVideoElement;
	    newCall.remoteAudioElement = this.remoteAudioElement;
	    this.successor = newCall;
	    this.emit("replaced", newCall);
	    this.hangup(true);
	};
	
	/**
	 * Hangup a call.
	 * @param {string} reason The reason why the call is being hung up.
	 * @param {boolean} suppressEvent True to suppress emitting an event.
	 */
	MatrixCall.prototype.hangup = function(reason, suppressEvent) {
	    debuglog("Ending call " + this.callId);
	    terminate(this, "local", reason, !suppressEvent);
	    var content = {
	        version: 0,
	        call_id: this.callId,
	        reason: reason
	    };
	    sendEvent(this, 'm.call.hangup', content);
	};
	
	/**
	 * Set whether the local video preview should be muted or not.
	 * @param {boolean} muted True to mute the local video.
	 */
	MatrixCall.prototype.setLocalVideoMuted = function(muted) {
	    if (!this.localAVStream) {
	        return;
	    }
	    setTracksEnabled(this.localAVStream.getVideoTracks(), !muted);
	};
	
	/**
	 * Check if local video is muted.
	 *
	 * If there are multiple video tracks, <i>all</i> of the tracks need to be muted
	 * for this to return true. This means if there are no video tracks, this will
	 * return true.
	 * @return {Boolean} True if the local preview video is muted, else false
	 * (including if the call is not set up yet).
	 */
	MatrixCall.prototype.isLocalVideoMuted = function() {
	    if (!this.localAVStream) {
	        return false;
	    }
	    return !isTracksEnabled(this.localAVStream.getVideoTracks());
	};
	
	/**
	 * Set whether the microphone should be muted or not.
	 * @param {boolean} muted True to mute the mic.
	 */
	MatrixCall.prototype.setMicrophoneMuted = function(muted) {
	    if (!this.localAVStream) {
	        return;
	    }
	    setTracksEnabled(this.localAVStream.getAudioTracks(), !muted);
	};
	
	/**
	 * Check if the microphone is muted.
	 *
	 * If there are multiple audio tracks, <i>all</i> of the tracks need to be muted
	 * for this to return true. This means if there are no audio tracks, this will
	 * return true.
	 * @return {Boolean} True if the mic is muted, else false (including if the call
	 * is not set up yet).
	 */
	MatrixCall.prototype.isMicrophoneMuted = function() {
	    if (!this.localAVStream) {
	        return false;
	    }
	    return !isTracksEnabled(this.localAVStream.getAudioTracks());
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} stream
	 */
	MatrixCall.prototype._gotUserMediaForInvite = function(stream) {
	    if (this.successor) {
	        this.successor._gotUserMediaForAnswer(stream);
	        return;
	    }
	    if (this.state == 'ended') {
	        return;
	    }
	    debuglog("_gotUserMediaForInvite -> " + this.type);
	    var self = this;
	    var videoEl = this.getLocalVideoElement();
	
	    if (videoEl && this.type == 'video') {
	        videoEl.autoplay = true;
	        if (this.screenSharingStream) {
	            debuglog("Setting screen sharing stream to the local video element");
	            videoEl.src = this.URL.createObjectURL(this.screenSharingStream);
	        }
	        else {
	            videoEl.src = this.URL.createObjectURL(stream);
	        }
	        videoEl.muted = true;
	        setTimeout(function() {
	            var vel = self.getLocalVideoElement();
	            if (vel.play) {
	                vel.play();
	            }
	        }, 0);
	    }
	
	    this.localAVStream = stream;
	    // why do we enable audio (and only audio) tracks here? -- matthew
	    setTracksEnabled(stream.getAudioTracks(), true);
	    this.peerConn = _createPeerConnection(this);
	    this.peerConn.addStream(stream);
	    if (this.screenSharingStream) {
	        console.log("Adding screen-sharing stream to peer connection");
	        this.peerConn.addStream(this.screenSharingStream);
	        // let's use this for the local preview...
	        this.localAVStream = this.screenSharingStream;
	    }
	    this.peerConn.createOffer(
	        hookCallback(self, self._gotLocalOffer),
	        hookCallback(self, self._getLocalOfferFailed)
	    );
	    setState(self, 'create_offer');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} stream
	 */
	MatrixCall.prototype._gotUserMediaForAnswer = function(stream) {
	    var self = this;
	    if (self.state == 'ended') {
	        return;
	    }
	    var localVidEl = self.getLocalVideoElement();
	
	    if (localVidEl && self.type == 'video') {
	        localVidEl.autoplay = true;
	        localVidEl.src = self.URL.createObjectURL(stream);
	        localVidEl.muted = true;
	        setTimeout(function() {
	            var vel = self.getLocalVideoElement();
	            if (vel.play) {
	                vel.play();
	            }
	        }, 0);
	    }
	
	    self.localAVStream = stream;
	    setTracksEnabled(stream.getAudioTracks(), true);
	    self.peerConn.addStream(stream);
	
	    var constraints = {
	        'mandatory': {
	            'OfferToReceiveAudio': true,
	            'OfferToReceiveVideo': self.type == 'video'
	        }
	    };
	    self.peerConn.createAnswer(function(description) {
	        debuglog("Created answer: " + description);
	        self.peerConn.setLocalDescription(description, function() {
	            var content = {
	                version: 0,
	                call_id: self.callId,
	                answer: {
	                    sdp: self.peerConn.localDescription.sdp,
	                    type: self.peerConn.localDescription.type
	                }
	            };
	            sendEvent(self, 'm.call.answer', content);
	            setState(self, 'connecting');
	        }, function() {
	            debuglog("Error setting local description!");
	        }, constraints);
	    }, function(err) {
	        debuglog("Failed to create answer: " + err);
	    });
	    setState(self, 'create_answer');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._gotLocalIceCandidate = function(event) {
	    if (event.candidate) {
	        debuglog(
	            "Got local ICE " + event.candidate.sdpMid + " candidate: " +
	            event.candidate.candidate
	        );
	        // As with the offer, note we need to make a copy of this object, not
	        // pass the original: that broke in Chrome ~m43.
	        var c = {
	            candidate: event.candidate.candidate,
	            sdpMid: event.candidate.sdpMid,
	            sdpMLineIndex: event.candidate.sdpMLineIndex
	        };
	        sendCandidate(this, c);
	    }
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} cand
	 */
	MatrixCall.prototype._gotRemoteIceCandidate = function(cand) {
	    if (this.state == 'ended') {
	        //debuglog("Ignoring remote ICE candidate because call has ended");
	        return;
	    }
	    debuglog("Got remote ICE " + cand.sdpMid + " candidate: " + cand.candidate);
	    this.peerConn.addIceCandidate(
	        new this.webRtc.RtcIceCandidate(cand),
	        function() {},
	        function(e) {}
	    );
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} msg
	 */
	MatrixCall.prototype._receivedAnswer = function(msg) {
	    if (this.state == 'ended') {
	        return;
	    }
	
	    var self = this;
	    this.peerConn.setRemoteDescription(
	        new this.webRtc.RtcSessionDescription(msg.answer),
	        hookCallback(self, self._onSetRemoteDescriptionSuccess),
	        hookCallback(self, self._onSetRemoteDescriptionError)
	    );
	    setState(self, 'connecting');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} description
	 */
	MatrixCall.prototype._gotLocalOffer = function(description) {
	    var self = this;
	    debuglog("Created offer: " + description);
	
	    if (self.state == 'ended') {
	        debuglog("Ignoring newly created offer on call ID " + self.callId +
	            " because the call has ended");
	        return;
	    }
	
	    self.peerConn.setLocalDescription(description, function() {
	        var content = {
	            version: 0,
	            call_id: self.callId,
	            // OpenWebRTC appears to add extra stuff (like the DTLS fingerprint)
	            // to the description when setting it on the peerconnection.
	            // According to the spec it should only add ICE
	            // candidates. Any ICE candidates that have already been generated
	            // at this point will probably be sent both in the offer and separately.
	            // Also, note that we have to make a new object here, copying the
	            // type and sdp properties.
	            // Passing the RTCSessionDescription object as-is doesn't work in
	            // Chrome (as of about m43).
	            offer: {
	                sdp: self.peerConn.localDescription.sdp,
	                type: self.peerConn.localDescription.type
	            },
	            lifetime: MatrixCall.CALL_TIMEOUT_MS
	        };
	        sendEvent(self, 'm.call.invite', content);
	
	        setTimeout(function() {
	            if (self.state == 'invite_sent') {
	                self.hangup('invite_timeout');
	            }
	        }, MatrixCall.CALL_TIMEOUT_MS);
	        setState(self, 'invite_sent');
	    }, function() {
	        debuglog("Error setting local description!");
	    });
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} error
	 */
	MatrixCall.prototype._getLocalOfferFailed = function(error) {
	    this.emit(
	        "error",
	        callError(MatrixCall.ERR_LOCAL_OFFER_FAILED, "Failed to start audio for call!")
	    );
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} error
	 */
	MatrixCall.prototype._getUserMediaFailed = function(error) {
	    this.emit(
	        "error",
	        callError(
	            MatrixCall.ERR_NO_USER_MEDIA,
	            "Couldn't start capturing media! Is your microphone set up and " +
	            "does this app have permission?"
	        )
	    );
	    this.hangup("user_media_failed");
	};
	
	/**
	 * Internal
	 * @private
	 */
	MatrixCall.prototype._onIceConnectionStateChanged = function() {
	    if (this.state == 'ended') {
	        return; // because ICE can still complete as we're ending the call
	    }
	    debuglog(
	        "Ice connection state changed to: " + this.peerConn.iceConnectionState
	    );
	    // ideally we'd consider the call to be connected when we get media but
	    // chrome doesn't implement any of the 'onstarted' events yet
	    if (this.peerConn.iceConnectionState == 'completed' ||
	            this.peerConn.iceConnectionState == 'connected') {
	        setState(this, 'connected');
	        this.didConnect = true;
	    } else if (this.peerConn.iceConnectionState == 'failed') {
	        this.hangup('ice_failed');
	    }
	};
	
	/**
	 * Internal
	 * @private
	 */
	MatrixCall.prototype._onSignallingStateChanged = function() {
	    debuglog(
	        "call " + this.callId + ": Signalling state changed to: " +
	        this.peerConn.signalingState
	    );
	};
	
	/**
	 * Internal
	 * @private
	 */
	MatrixCall.prototype._onSetRemoteDescriptionSuccess = function() {
	    debuglog("Set remote description");
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} e
	 */
	MatrixCall.prototype._onSetRemoteDescriptionError = function(e) {
	    debuglog("Failed to set remote description" + e);
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onAddStream = function(event) {
	    debuglog("Stream id " + event.stream.id + " added");
	
	    var s = event.stream;
	
	    if (s.getVideoTracks().length > 0) {
	        this.type = 'video';
	        this.remoteAVStream = s;
	    } else {
	        this.type = 'voice';
	        this.remoteAStream = s;
	    }
	
	    var self = this;
	    forAllTracksOnStream(s, function(t) {
	        debuglog("Track id " + t.id + " added");
	        // not currently implemented in chrome
	        t.onstarted = hookCallback(self, self._onRemoteStreamTrackStarted);
	    });
	
	    event.stream.onended = hookCallback(self, self._onRemoteStreamEnded);
	    // not currently implemented in chrome
	    event.stream.onstarted = hookCallback(self, self._onRemoteStreamStarted);
	
	    if (this.type === 'video') {
	        _tryPlayRemoteStream(this);
	    }
	    else {
	        _tryPlayRemoteAudioStream(this);
	    }
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onRemoteStreamStarted = function(event) {
	    setState(this, 'connected');
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onRemoteStreamEnded = function(event) {
	    debuglog("Remote stream ended");
	    this.hangupParty = 'remote';
	    setState(this, 'ended');
	    stopAllMedia(this);
	    if (this.peerConn.signalingState != 'closed') {
	        this.peerConn.close();
	    }
	    this.emit("hangup", this);
	};
	
	/**
	 * Internal
	 * @private
	 * @param {Object} event
	 */
	MatrixCall.prototype._onRemoteStreamTrackStarted = function(event) {
	    setState(this, 'connected');
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} msg
	 */
	MatrixCall.prototype._onHangupReceived = function(msg) {
	    debuglog("Hangup received");
	    terminate(this, "remote", msg.reason, true);
	};
	
	/**
	 * Used by MatrixClient.
	 * @protected
	 * @param {Object} msg
	 */
	MatrixCall.prototype._onAnsweredElsewhere = function(msg) {
	    debuglog("Answered elsewhere");
	    terminate(this, "remote", "answered_elsewhere", true);
	};
	
	var setTracksEnabled = function(tracks, enabled) {
	    for (var i = 0; i < tracks.length; i++) {
	        tracks[i].enabled = enabled;
	    }
	};
	
	var isTracksEnabled = function(tracks) {
	    for (var i = 0; i < tracks.length; i++) {
	        if (tracks[i].enabled) {
	            return true; // at least one track is enabled
	        }
	    }
	    return false;
	};
	
	var setState = function(self, state) {
	    var oldState = self.state;
	    self.state = state;
	    self.emit("state", state, oldState);
	};
	
	/**
	 * Internal
	 * @param {MatrixCall} self
	 * @param {string} eventType
	 * @param {Object} content
	 * @return {Promise}
	 */
	var sendEvent = function(self, eventType, content) {
	    return self.client.sendEvent(self.roomId, eventType, content);
	};
	
	var sendCandidate = function(self, content) {
	    // Sends candidates with are sent in a special way because we try to amalgamate
	    // them into one message
	    self.candidateSendQueue.push(content);
	    if (self.candidateSendTries === 0) {
	        setTimeout(function() {
	            _sendCandidateQueue(self);
	        }, 100);
	    }
	};
	
	var terminate = function(self, hangupParty, hangupReason, shouldEmit) {
	    if (self.getRemoteVideoElement()) {
	        if (self.getRemoteVideoElement().pause) {
	            self.getRemoteVideoElement().pause();
	        }
	        self.getRemoteVideoElement().src = "";
	    }
	    if (self.getRemoteAudioElement()) {
	        if (self.getRemoteAudioElement().pause) {
	            self.getRemoteAudioElement().pause();
	        }
	        self.getRemoteAudioElement().src = "";
	    }
	    if (self.getLocalVideoElement()) {
	        if (self.getLocalVideoElement().pause) {
	            self.getLocalVideoElement().pause();
	        }
	        self.getLocalVideoElement().src = "";
	    }
	    self.hangupParty = hangupParty;
	    self.hangupReason = hangupReason;
	    setState(self, 'ended');
	    stopAllMedia(self);
	    if (self.peerConn && self.peerConn.signalingState !== 'closed') {
	        self.peerConn.close();
	    }
	    if (shouldEmit) {
	        self.emit("hangup", self);
	    }
	};
	
	var stopAllMedia = function(self) {
	    debuglog("stopAllMedia (stream=%s)", self.localAVStream);
	    if (self.localAVStream) {
	        forAllTracksOnStream(self.localAVStream, function(t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	        // also call stop on the main stream so firefox will stop sharing
	        // the mic
	        if (self.localAVStream.stop) {
	            self.localAVStream.stop();
	        }
	    }
	    if (self.screenSharingStream) {
	        forAllTracksOnStream(self.screenSharingStream, function(t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	        if (self.screenSharingStream.stop) {
	            self.screenSharingStream.stop();
	        }
	    }
	    if (self.remoteAVStream) {
	        forAllTracksOnStream(self.remoteAVStream, function(t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	    }
	    if (self.remoteAStream) {
	        forAllTracksOnStream(self.remoteAStream, function(t) {
	            if (t.stop) {
	                t.stop();
	            }
	        });
	    }
	};
	
	var _tryPlayRemoteStream = function(self) {
	    if (self.getRemoteVideoElement() && self.remoteAVStream) {
	        var player = self.getRemoteVideoElement();
	        player.autoplay = true;
	        player.src = self.URL.createObjectURL(self.remoteAVStream);
	        setTimeout(function() {
	            var vel = self.getRemoteVideoElement();
	            if (vel.play) {
	                vel.play();
	            }
	            // OpenWebRTC does not support oniceconnectionstatechange yet
	            if (self.webRtc.isOpenWebRTC()) {
	                setState(self, 'connected');
	            }
	        }, 0);
	    }
	};
	
	var _tryPlayRemoteAudioStream = function(self) {
	    if (self.getRemoteAudioElement() && self.remoteAStream) {
	        var player = self.getRemoteAudioElement();
	        player.autoplay = true;
	        player.src = self.URL.createObjectURL(self.remoteAStream);
	        setTimeout(function() {
	            var ael = self.getRemoteAudioElement();
	            if (ael.play) {
	                ael.play();
	            }
	            // OpenWebRTC does not support oniceconnectionstatechange yet
	            if (self.webRtc.isOpenWebRTC()) {
	                setState(self, 'connected');
	            }
	        }, 0);
	    }
	};
	
	var checkForErrorListener = function(self) {
	    if (self.listeners("error").length === 0) {
	        throw new Error(
	            "You MUST attach an error listener using call.on('error', function() {})"
	        );
	    }
	};
	
	var callError = function(code, msg) {
	    var e = new Error(msg);
	    e.code = code;
	    return e;
	};
	
	var debuglog = function() {
	    if (DEBUG) {
	        console.log.apply(console, arguments);
	    }
	};
	
	var _sendCandidateQueue = function(self) {
	    if (self.candidateSendQueue.length === 0) {
	        return;
	    }
	
	    var cands = self.candidateSendQueue;
	    self.candidateSendQueue = [];
	    ++self.candidateSendTries;
	    var content = {
	        version: 0,
	        call_id: self.callId,
	        candidates: cands
	    };
	    debuglog("Attempting to send " + cands.length + " candidates");
	    sendEvent(self, 'm.call.candidates', content).then(function() {
	        self.candidateSendTries = 0;
	        _sendCandidateQueue(self);
	    }, function(error) {
	        for (var i = 0; i < cands.length; i++) {
	            self.candidateSendQueue.push(cands[i]);
	        }
	
	        if (self.candidateSendTries > 5) {
	            debuglog(
	                "Failed to send candidates on attempt %s. Giving up for now.",
	                self.candidateSendTries
	            );
	            self.candidateSendTries = 0;
	            return;
	        }
	
	        var delayMs = 500 * Math.pow(2, self.candidateSendTries);
	        ++self.candidateSendTries;
	        debuglog("Failed to send candidates. Retrying in " + delayMs + "ms");
	        setTimeout(function() {
	            _sendCandidateQueue(self);
	        }, delayMs);
	    });
	};
	
	var _placeCallWithConstraints = function(self, constraints) {
	    self.client.callList[self.callId] = self;
	    self.webRtc.getUserMedia(
	        constraints,
	        hookCallback(self, self._gotUserMediaForInvite),
	        hookCallback(self, self._getUserMediaFailed)
	    );
	    setState(self, 'wait_local_media');
	    self.direction = 'outbound';
	    self.config = constraints;
	};
	
	var _createPeerConnection = function(self) {
	    var servers = self.turnServers;
	    if (self.webRtc.vendor === "mozilla") {
	        // modify turnServers struct to match what mozilla expects.
	        servers = [];
	        for (var i = 0; i < self.turnServers.length; i++) {
	            for (var j = 0; j < self.turnServers[i].urls.length; j++) {
	                servers.push({
	                    url: self.turnServers[i].urls[j],
	                    username: self.turnServers[i].username,
	                    credential: self.turnServers[i].credential
	                });
	            }
	        }
	    }
	
	    var pc = new self.webRtc.RtcPeerConnection({
	        iceServers: servers
	    });
	    pc.oniceconnectionstatechange = hookCallback(self, self._onIceConnectionStateChanged);
	    pc.onsignalingstatechange = hookCallback(self, self._onSignallingStateChanged);
	    pc.onicecandidate = hookCallback(self, self._gotLocalIceCandidate);
	    pc.onaddstream = hookCallback(self, self._onAddStream);
	    return pc;
	};
	
	var _getChromeScreenSharingConstraints = function(call) {
	    var screen = global.screen;
	    if (!screen) {
	        call.emit("error", callError(
	            MatrixCall.ERR_NO_USER_MEDIA,
	            "Couldn't determine screen sharing constaints."
	        ));
	        return;
	    }
	    // it won't work at all if you're not on HTTPS so whine whine whine
	    if (!global.window || global.window.location.protocol !== "https:") {
	        call.emit("error", callError(
	            MatrixCall.ERR_NO_USER_MEDIA,
	            "You need to be using HTTPS to place a screen-sharing call."
	        ));
	        return;
	    }
	
	    return {
	        video: {
	            mandatory: {
	                chromeMediaSource: "screen",
	                chromeMediaSourceId: "" + Date.now(),
	                maxWidth: screen.width,
	                maxHeight: screen.height,
	                minFrameRate: 1,
	                maxFrameRate: 10
	            }
	        }
	    };
	};
	
	var _getUserMediaVideoContraints = function(callType) {
	    switch (callType) {
	        case 'voice':
	            return ({audio: true, video: false});
	        case 'video':
	            return ({audio: true, video: {
	                mandatory: {
	                    minWidth: 640,
	                    maxWidth: 640,
	                    minHeight: 360,
	                    maxHeight: 360
	                }
	            }});
	    }
	};
	
	var hookCallback = function(call, fn) {
	    return function() {
	        return fn.apply(call, arguments);
	    };
	};
	
	var forAllVideoTracksOnStream = function(s, f) {
	    var tracks = s.getVideoTracks();
	    for (var i = 0; i < tracks.length; i++) {
	        f(tracks[i]);
	    }
	};
	
	var forAllAudioTracksOnStream = function(s, f) {
	    var tracks = s.getAudioTracks();
	    for (var i = 0; i < tracks.length; i++) {
	        f(tracks[i]);
	    }
	};
	
	var forAllTracksOnStream = function(s, f) {
	    forAllVideoTracksOnStream(s, f);
	    forAllAudioTracksOnStream(s, f);
	};
	
	/** The MatrixCall class. */
	module.exports.MatrixCall = MatrixCall;
	
	/**
	 * Create a new Matrix call for the browser.
	 * @param {MatrixClient} client The client instance to use.
	 * @param {string} roomId The room the call is in.
	 * @return {MatrixCall} the call or null if the browser doesn't support calling.
	 */
	module.exports.createNewMatrixCall = function(client, roomId) {
	    var w = global.window;
	    var doc = global.document;
	    if (!w || !doc) {
	        return null;
	    }
	    var webRtc = {};
	    webRtc.isOpenWebRTC = function() {
	        var scripts = doc.getElementById("script");
	        if (!scripts || !scripts.length) {
	            return false;
	        }
	        for (var i = 0; i < scripts.length; i++) {
	            if (scripts[i].src.indexOf("owr.js") > -1) {
	                return true;
	            }
	        }
	        return false;
	    };
	    var getUserMedia = (
	        w.navigator.getUserMedia || w.navigator.webkitGetUserMedia ||
	        w.navigator.mozGetUserMedia
	    );
	    if (getUserMedia) {
	        webRtc.getUserMedia = function() {
	            return getUserMedia.apply(w.navigator, arguments);
	        };
	    }
	    webRtc.RtcPeerConnection = (
	        w.RTCPeerConnection || w.webkitRTCPeerConnection || w.mozRTCPeerConnection
	    );
	    webRtc.RtcSessionDescription = (
	        w.RTCSessionDescription || w.webkitRTCSessionDescription ||
	        w.mozRTCSessionDescription
	    );
	    webRtc.RtcIceCandidate = (
	        w.RTCIceCandidate || w.webkitRTCIceCandidate || w.mozRTCIceCandidate
	    );
	    webRtc.vendor = null;
	    if (w.mozRTCPeerConnection) {
	        webRtc.vendor = "mozilla";
	    }
	    else if (w.webkitRTCPeerConnection) {
	        webRtc.vendor = "webkit";
	    }
	    else if (w.RTCPeerConnection) {
	        webRtc.vendor = "generic";
	    }
	    if (!webRtc.RtcIceCandidate || !webRtc.RtcSessionDescription ||
	            !webRtc.RtcPeerConnection || !webRtc.getUserMedia) {
	        return null; // WebRTC is not supported.
	    }
	    var opts = {
	        webRtc: webRtc,
	        client: client,
	        URL: w.URL,
	        roomId: roomId,
	        turnServers: client.getTurnServers()
	    };
	    return new MatrixCall(opts);
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashFunctionMemoize = __webpack_require__(207);
	
	var _lodashFunctionMemoize2 = _interopRequireDefault(_lodashFunctionMemoize);
	
	var isFirefox = _lodashFunctionMemoize2['default'](function () {
	  return (/firefox/i.test(navigator.userAgent)
	  );
	});
	
	exports.isFirefox = isFirefox;
	var isSafari = _lodashFunctionMemoize2['default'](function () {
	  return Boolean(window.safari);
	});
	exports.isSafari = isSafari;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(224);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(209),
	    getNative = __webpack_require__(39);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39),
	    isArrayLike = __webpack_require__(28),
	    isObject = __webpack_require__(21),
	    shimKeys = __webpack_require__(230);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = decorateHandler;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _disposables = __webpack_require__(64);
	
	var _utilsShallowEqual = __webpack_require__(63);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsShallowEqualScalar = __webpack_require__(103);
	
	var _utilsShallowEqualScalar2 = _interopRequireDefault(_utilsShallowEqualScalar);
	
	var _lodashLangIsPlainObject = __webpack_require__(24);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _bindConnector2 = __webpack_require__(241);
	
	var _bindConnector3 = _interopRequireDefault(_bindConnector2);
	
	function decorateHandler(_ref) {
	  var DecoratedComponent = _ref.DecoratedComponent;
	  var createHandler = _ref.createHandler;
	  var createMonitor = _ref.createMonitor;
	  var createConnector = _ref.createConnector;
	  var registerHandler = _ref.registerHandler;
	  var containerDisplayName = _ref.containerDisplayName;
	  var getType = _ref.getType;
	  var collect = _ref.collect;
	  var options = _ref.options;
	  var _options$arePropsEqual = options.arePropsEqual;
	  var arePropsEqual = _options$arePropsEqual === undefined ? _utilsShallowEqualScalar2['default'] : _options$arePropsEqual;
	
	  var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	  return (function (_Component) {
	    _inherits(DragDropContainer, _Component);
	
	    DragDropContainer.prototype.getHandlerId = function getHandlerId() {
	      return this.handlerId;
	    };
	
	    DragDropContainer.prototype.getDecoratedComponentInstance = function getDecoratedComponentInstance() {
	      return this.decoratedComponentInstance;
	    };
	
	    DragDropContainer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return !arePropsEqual(nextProps, this.props) || !_utilsShallowEqual2['default'](nextState, this.state);
	    };
	
	    _createClass(DragDropContainer, null, [{
	      key: 'DecoratedComponent',
	      value: DecoratedComponent,
	      enumerable: true
	    }, {
	      key: 'displayName',
	      value: containerDisplayName + '(' + displayName + ')',
	      enumerable: true
	    }, {
	      key: 'contextTypes',
	      value: {
	        dragDropManager: _react.PropTypes.object.isRequired
	      },
	      enumerable: true
	    }]);
	
	    function DragDropContainer(props, context) {
	      _classCallCheck(this, DragDropContainer);
	
	      _Component.call(this, props, context);
	      this.handleChange = this.handleChange.bind(this);
	      this.handleChildRef = this.handleChildRef.bind(this);
	
	      _invariant2['default'](typeof this.context.dragDropManager === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	      this.manager = this.context.dragDropManager;
	      this.handlerMonitor = createMonitor(this.manager);
	      this.handler = createHandler(this.handlerMonitor);
	      this.disposable = new _disposables.SerialDisposable();
	
	      this.receiveProps(props);
	      this.state = this.getCurrentState();
	    }
	
	    DragDropContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (!arePropsEqual(nextProps, this.props)) {
	        this.receiveProps(nextProps);
	        this.handleChange();
	      }
	    };
	
	    DragDropContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	      this.disposable.dispose();
	    };
	
	    DragDropContainer.prototype.receiveProps = function receiveProps(props) {
	      this.handler.receiveProps(props);
	      this.receiveType(getType(props));
	    };
	
	    DragDropContainer.prototype.receiveType = function receiveType(type) {
	      if (type === this.currentType) {
	        return;
	      }
	
	      this.currentType = type;
	
	      var _registerHandler = registerHandler(type, this.handler, this.manager);
	
	      var handlerId = _registerHandler.handlerId;
	      var unregister = _registerHandler.unregister;
	
	      var connector = createConnector(this.manager.getBackend());
	
	      var _bindConnector = _bindConnector3['default'](connector, handlerId);
	
	      var handlerConnector = _bindConnector.handlerConnector;
	      var connectorDisposable = _bindConnector.disposable;
	
	      this.handlerId = handlerId;
	      this.handlerConnector = handlerConnector;
	      this.handlerMonitor.receiveHandlerId(handlerId);
	
	      var globalMonitor = this.manager.getMonitor();
	      var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });
	
	      this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister), connectorDisposable));
	    };
	
	    DragDropContainer.prototype.handleChange = function handleChange() {
	      var nextState = this.getCurrentState();
	      if (!_utilsShallowEqual2['default'](nextState, this.state)) {
	        this.setState(nextState);
	      }
	    };
	
	    DragDropContainer.prototype.handleChildRef = function handleChildRef(component) {
	      this.decoratedComponentInstance = component;
	      this.handler.receiveComponent(component);
	    };
	
	    DragDropContainer.prototype.getCurrentState = function getCurrentState() {
	      var nextState = collect(this.handlerConnector, this.handlerMonitor);
	      if (false) {
	        _invariant2['default'](_lodashLangIsPlainObject2['default'](nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
	      }
	      return nextState;
	    };
	
	    DragDropContainer.prototype.render = function render() {
	      return _react2['default'].createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	        ref: this.handleChildRef }));
	    };
	
	    return DragDropContainer;
	  })(_react.Component);
	}
	
	module.exports = exports['default'];

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = isValidType;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashLangIsArray = __webpack_require__(22);
	
	var _lodashLangIsArray2 = _interopRequireDefault(_lodashLangIsArray);
	
	function isValidType(type, allowArray) {
	       return typeof type === 'string' || typeof type === 'symbol' || allowArray && _lodashLangIsArray2['default'](type) && type.every(function (t) {
	              return isValidType(t, false);
	       });
	}
	
	module.exports = exports['default'];

/***/ },
/* 103 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shallowEqualScalar;
	
	function shallowEqualScalar(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i])) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB || typeof valA === 'object' || typeof valB === 'object') {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _typeof(obj) { return obj && obj.constructor === Symbol ? 'symbol' : typeof obj; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsArray = __webpack_require__(22);
	
	var _lodashLangIsArray2 = _interopRequireDefault(_lodashLangIsArray);
	
	var _utilsGetNextUniqueId = __webpack_require__(264);
	
	var _utilsGetNextUniqueId2 = _interopRequireDefault(_utilsGetNextUniqueId);
	
	var _actionsRegistry = __webpack_require__(45);
	
	var HandlerRoles = {
	  SOURCE: 'SOURCE',
	  TARGET: 'TARGET'
	};
	
	function validateSourceContract(source) {
	  _invariant2['default'](typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	  _invariant2['default'](typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	  _invariant2['default'](typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
	}
	
	function validateTargetContract(target) {
	  _invariant2['default'](typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	  _invariant2['default'](typeof target.hover === 'function', 'Expected hover to be a function.');
	  _invariant2['default'](typeof target.drop === 'function', 'Expected beginDrag to be a function.');
	}
	
	function validateType(type, allowArray) {
	  if (allowArray && _lodashLangIsArray2['default'](type)) {
	    type.forEach(function (t) {
	      return validateType(t, false);
	    });
	    return;
	  }
	
	  _invariant2['default'](typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
	}
	
	function getNextHandlerId(role) {
	  var id = _utilsGetNextUniqueId2['default']().toString();
	  switch (role) {
	    case HandlerRoles.SOURCE:
	      return 'S' + id;
	    case HandlerRoles.TARGET:
	      return 'T' + id;
	    default:
	      _invariant2['default'](false, 'Unknown role: ' + role);
	  }
	}
	
	function parseRoleFromHandlerId(handlerId) {
	  switch (handlerId[0]) {
	    case 'S':
	      return HandlerRoles.SOURCE;
	    case 'T':
	      return HandlerRoles.TARGET;
	    default:
	      _invariant2['default'](false, 'Cannot parse handler ID: ' + handlerId);
	  }
	}
	
	var HandlerRegistry = (function () {
	  function HandlerRegistry(store) {
	    _classCallCheck(this, HandlerRegistry);
	
	    this.store = store;
	
	    this.types = {};
	    this.handlers = {};
	
	    this.pinnedSourceId = null;
	    this.pinnedSource = null;
	  }
	
	  HandlerRegistry.prototype.addSource = function addSource(type, source) {
	    validateType(type);
	    validateSourceContract(source);
	
	    var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
	    this.store.dispatch(_actionsRegistry.addSource(sourceId));
	    return sourceId;
	  };
	
	  HandlerRegistry.prototype.addTarget = function addTarget(type, target) {
	    validateType(type, true);
	    validateTargetContract(target);
	
	    var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
	    this.store.dispatch(_actionsRegistry.addTarget(targetId));
	    return targetId;
	  };
	
	  HandlerRegistry.prototype.addHandler = function addHandler(role, type, handler) {
	    var id = getNextHandlerId(role);
	    this.types[id] = type;
	    this.handlers[id] = handler;
	
	    return id;
	  };
	
	  HandlerRegistry.prototype.containsHandler = function containsHandler(handler) {
	    var _this = this;
	
	    return Object.keys(this.handlers).some(function (key) {
	      return _this.handlers[key] === handler;
	    });
	  };
	
	  HandlerRegistry.prototype.getSource = function getSource(sourceId, includePinned) {
	    _invariant2['default'](this.isSourceId(sourceId), 'Expected a valid source ID.');
	
	    var isPinned = includePinned && sourceId === this.pinnedSourceId;
	    var source = isPinned ? this.pinnedSource : this.handlers[sourceId];
	
	    return source;
	  };
	
	  HandlerRegistry.prototype.getTarget = function getTarget(targetId) {
	    _invariant2['default'](this.isTargetId(targetId), 'Expected a valid target ID.');
	    return this.handlers[targetId];
	  };
	
	  HandlerRegistry.prototype.getSourceType = function getSourceType(sourceId) {
	    _invariant2['default'](this.isSourceId(sourceId), 'Expected a valid source ID.');
	    return this.types[sourceId];
	  };
	
	  HandlerRegistry.prototype.getTargetType = function getTargetType(targetId) {
	    _invariant2['default'](this.isTargetId(targetId), 'Expected a valid target ID.');
	    return this.types[targetId];
	  };
	
	  HandlerRegistry.prototype.isSourceId = function isSourceId(handlerId) {
	    var role = parseRoleFromHandlerId(handlerId);
	    return role === HandlerRoles.SOURCE;
	  };
	
	  HandlerRegistry.prototype.isTargetId = function isTargetId(handlerId) {
	    var role = parseRoleFromHandlerId(handlerId);
	    return role === HandlerRoles.TARGET;
	  };
	
	  HandlerRegistry.prototype.removeSource = function removeSource(sourceId) {
	    _invariant2['default'](this.getSource(sourceId), 'Expected an existing source.');
	    this.store.dispatch(_actionsRegistry.removeSource(sourceId));
	    delete this.handlers[sourceId];
	    delete this.types[sourceId];
	  };
	
	  HandlerRegistry.prototype.removeTarget = function removeTarget(targetId) {
	    _invariant2['default'](this.getTarget(targetId), 'Expected an existing target.');
	    this.store.dispatch(_actionsRegistry.removeTarget(targetId));
	    delete this.handlers[targetId];
	    delete this.types[targetId];
	  };
	
	  HandlerRegistry.prototype.pinSource = function pinSource(sourceId) {
	    var source = this.getSource(sourceId);
	    _invariant2['default'](source, 'Expected an existing source.');
	
	    this.pinnedSourceId = sourceId;
	    this.pinnedSource = source;
	  };
	
	  HandlerRegistry.prototype.unpinSource = function unpinSource() {
	    _invariant2['default'](this.pinnedSource, 'No source is pinned at the time.');
	
	    this.pinnedSourceId = null;
	    this.pinnedSource = null;
	  };
	
	  return HandlerRegistry;
	})();
	
	exports['default'] = HandlerRegistry;
	module.exports = exports['default'];

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = dirtyHandlerIds;
	exports.areDirty = areDirty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashArrayXor = __webpack_require__(271);
	
	var _lodashArrayXor2 = _interopRequireDefault(_lodashArrayXor);
	
	var _lodashArrayIntersection = __webpack_require__(269);
	
	var _lodashArrayIntersection2 = _interopRequireDefault(_lodashArrayIntersection);
	
	var _actionsDragDrop = __webpack_require__(44);
	
	var _actionsRegistry = __webpack_require__(45);
	
	var NONE = [];
	var ALL = [];
	
	function dirtyHandlerIds(state, action, dragOperation) {
	  if (state === undefined) state = NONE;
	
	  switch (action.type) {
	    case _actionsDragDrop.HOVER:
	      break;
	    case _actionsRegistry.ADD_SOURCE:
	    case _actionsRegistry.ADD_TARGET:
	    case _actionsRegistry.REMOVE_TARGET:
	    case _actionsRegistry.REMOVE_SOURCE:
	      return NONE;
	    case _actionsDragDrop.BEGIN_DRAG:
	    case _actionsDragDrop.PUBLISH_DRAG_SOURCE:
	    case _actionsDragDrop.END_DRAG:
	    case _actionsDragDrop.DROP:
	    default:
	      return ALL;
	  }
	
	  var targetIds = action.targetIds;
	  var prevTargetIds = dragOperation.targetIds;
	
	  var dirtyHandlerIds = _lodashArrayXor2['default'](targetIds, prevTargetIds);
	
	  var didChange = false;
	  if (dirtyHandlerIds.length === 0) {
	    for (var i = 0; i < targetIds.length; i++) {
	      if (targetIds[i] !== prevTargetIds[i]) {
	        didChange = true;
	        break;
	      }
	    }
	  } else {
	    didChange = true;
	  }
	
	  if (!didChange) {
	    return NONE;
	  }
	
	  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	  var innermostTargetId = targetIds[targetIds.length - 1];
	
	  if (prevInnermostTargetId !== innermostTargetId) {
	    if (prevInnermostTargetId) {
	      dirtyHandlerIds.push(prevInnermostTargetId);
	    }
	    if (innermostTargetId) {
	      dirtyHandlerIds.push(innermostTargetId);
	    }
	  }
	
	  return dirtyHandlerIds;
	}
	
	function areDirty(state, handlerIds) {
	  if (state === NONE) {
	    return false;
	  }
	
	  if (state === ALL || typeof handlerIds === 'undefined') {
	    return true;
	  }
	
	  return _lodashArrayIntersection2['default'](handlerIds, state).length > 0;
	}

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = dragOffset;
	exports.getSourceClientOffset = getSourceClientOffset;
	exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;
	
	var _actionsDragDrop = __webpack_require__(44);
	
	var initialState = {
	  initialSourceClientOffset: null,
	  initialClientOffset: null,
	  clientOffset: null
	};
	
	function areOffsetsEqual(offsetA, offsetB) {
	  if (offsetA === offsetB) {
	    return true;
	  }
	  return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
	}
	
	function dragOffset(state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case _actionsDragDrop.BEGIN_DRAG:
	      return {
	        initialSourceClientOffset: action.sourceClientOffset,
	        initialClientOffset: action.clientOffset,
	        clientOffset: action.clientOffset
	      };
	    case _actionsDragDrop.HOVER:
	      if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
	        return state;
	      }
	      return _extends({}, state, {
	        clientOffset: action.clientOffset
	      });
	    case _actionsDragDrop.END_DRAG:
	    case _actionsDragDrop.DROP:
	      return initialState;
	    default:
	      return state;
	  }
	}
	
	function getSourceClientOffset(state) {
	  var clientOffset = state.clientOffset;
	  var initialClientOffset = state.initialClientOffset;
	  var initialSourceClientOffset = state.initialSourceClientOffset;
	
	  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
	    return null;
	  }
	  return {
	    x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
	    y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	  };
	}
	
	function getDifferenceFromInitialOffset(state) {
	  var clientOffset = state.clientOffset;
	  var initialClientOffset = state.initialClientOffset;
	
	  if (!clientOffset || !initialClientOffset) {
	    return null;
	  }
	  return {
	    x: clientOffset.x - initialClientOffset.x,
	    y: clientOffset.y - initialClientOffset.y
	  };
	}

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = matchesType;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashLangIsArray = __webpack_require__(22);
	
	var _lodashLangIsArray2 = _interopRequireDefault(_lodashLangIsArray);
	
	function matchesType(targetType, draggedItemType) {
	  if (_lodashLangIsArray2['default'](targetType)) {
	    return targetType.some(function (t) {
	      return t === draggedItemType;
	    });
	  } else {
	    return targetType === draggedItemType;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 108 */
/***/ function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(66),
	    cacheIndexOf = __webpack_require__(67),
	    createCache = __webpack_require__(68);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(46),
	    isObjectLike = __webpack_require__(47);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(118);


/***/ },
/* 112 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(293);
	var ReactMultiChildUpdateTypes = __webpack_require__(130);
	var ReactPerf = __webpack_require__(10);
	
	var setInnerHTML = __webpack_require__(55);
	var setTextContent = __webpack_require__(86);
	var invariant = __webpack_require__(1);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(16);
	var ReactElement = __webpack_require__(9);
	
	var emptyFunction = __webpack_require__(12);
	var traverseAllChildren = __webpack_require__(88);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(117);
	var ReactElement = __webpack_require__(9);
	var ReactPropTypeLocations = __webpack_require__(50);
	var ReactPropTypeLocationNames = __webpack_require__(49);
	var ReactNoopUpdateQueue = __webpack_require__(132);
	
	var assign = __webpack_require__(3);
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var keyMirror = __webpack_require__(56);
	var keyOf = __webpack_require__(17);
	var warning = __webpack_require__(4);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(132);
	
	var canDefineProperty = __webpack_require__(53);
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactDOMTextComponent = __webpack_require__(121);
	var ReactDefaultInjection = __webpack_require__(123);
	var ReactInstanceHandles = __webpack_require__(26);
	var ReactMount = __webpack_require__(7);
	var ReactPerf = __webpack_require__(10);
	var ReactReconciler = __webpack_require__(19);
	var ReactUpdates = __webpack_require__(11);
	var ReactVersion = __webpack_require__(78);
	
	var findDOMNode = __webpack_require__(79);
	var renderSubtreeIntoContainer = __webpack_require__(342);
	var warning = __webpack_require__(4);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(73);
	var ReactMount = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(11);
	
	var assign = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(113);
	var DOMPropertyOperations = __webpack_require__(72);
	var ReactComponentBrowserEnvironment = __webpack_require__(74);
	var ReactMount = __webpack_require__(7);
	
	var assign = __webpack_require__(3);
	var escapeTextContentForBrowser = __webpack_require__(54);
	var setTextContent = __webpack_require__(86);
	var validateDOMNesting = __webpack_require__(89);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(11);
	var Transaction = __webpack_require__(52);
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(12);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(289);
	var ChangeEventPlugin = __webpack_require__(291);
	var ClientReactRootIndex = __webpack_require__(292);
	var DefaultEventPluginOrder = __webpack_require__(294);
	var EnterLeaveEventPlugin = __webpack_require__(295);
	var ExecutionEnvironment = __webpack_require__(6);
	var HTMLDOMPropertyConfig = __webpack_require__(298);
	var ReactBrowserComponentMixin = __webpack_require__(300);
	var ReactComponentBrowserEnvironment = __webpack_require__(74);
	var ReactDefaultBatchingStrategy = __webpack_require__(122);
	var ReactDOMComponent = __webpack_require__(304);
	var ReactDOMTextComponent = __webpack_require__(121);
	var ReactEventListener = __webpack_require__(312);
	var ReactInjection = __webpack_require__(313);
	var ReactInstanceHandles = __webpack_require__(26);
	var ReactMount = __webpack_require__(7);
	var ReactReconcileTransaction = __webpack_require__(317);
	var SelectEventPlugin = __webpack_require__(323);
	var ServerReactRootIndex = __webpack_require__(324);
	var SimpleEventPlugin = __webpack_require__(325);
	var SVGDOMPropertyConfig = __webpack_require__(322);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(9);
	var ReactPropTypeLocations = __webpack_require__(50);
	var ReactPropTypeLocationNames = __webpack_require__(49);
	var ReactCurrentOwner = __webpack_require__(14);
	
	var canDefineProperty = __webpack_require__(53);
	var getIteratorFn = __webpack_require__(83);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(9);
	var ReactEmptyComponentRegistry = __webpack_require__(126);
	var ReactReconciler = __webpack_require__(19);
	
	var assign = __webpack_require__(3);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(308);
	
	var containsNode = __webpack_require__(141);
	var focusNode = __webpack_require__(142);
	var getActiveElement = __webpack_require__(143);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(334);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(56);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(4);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(9);
	var ReactPropTypeLocationNames = __webpack_require__(49);
	
	var emptyFunction = __webpack_require__(12);
	var getIteratorFn = __webpack_require__(83);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ },
/* 135 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 137 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 139 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(12);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(351);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 143 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 145 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(355)
	var ieee754 = __webpack_require__(356)
	var isArray = __webpack_require__(357)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	Buffer.poolSize = 8192 // not used by this implementation
	
	var rootParent = {}
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Safari 5-7 lacks support for changing the `Object.prototype.constructor` property
	 *     on objects.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	function typedArraySupport () {
	  function Bar () {}
	  try {
	    var arr = new Uint8Array(1)
	    arr.foo = function () { return 42 }
	    arr.constructor = Bar
	    return arr.foo() === 42 && // typed array instances can be augmented
	        arr.constructor === Bar && // constructor can be set
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	/**
	 * Class: Buffer
	 * =============
	 *
	 * The Buffer constructor returns instances of `Uint8Array` that are augmented
	 * with function properties for all the node `Buffer` API functions. We use
	 * `Uint8Array` so that square bracket notation works as expected -- it returns
	 * a single octet.
	 *
	 * By augmenting the instances, we can avoid modifying the `Uint8Array`
	 * prototype.
	 */
	function Buffer (arg) {
	  if (!(this instanceof Buffer)) {
	    // Avoid going through an ArgumentsAdaptorTrampoline in the common case.
	    if (arguments.length > 1) return new Buffer(arg, arguments[1])
	    return new Buffer(arg)
	  }
	
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    this.length = 0
	    this.parent = undefined
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    return fromNumber(this, arg)
	  }
	
	  // Slightly less common case.
	  if (typeof arg === 'string') {
	    return fromString(this, arg, arguments.length > 1 ? arguments[1] : 'utf8')
	  }
	
	  // Unusual.
	  return fromObject(this, arg)
	}
	
	function fromNumber (that, length) {
	  that = allocate(that, length < 0 ? 0 : checked(length) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < length; i++) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8'
	
	  // Assumption: byteLength() return value is always < kMaxLength.
	  var length = byteLength(string, encoding) | 0
	  that = allocate(that, length)
	
	  that.write(string, encoding)
	  return that
	}
	
	function fromObject (that, object) {
	  if (Buffer.isBuffer(object)) return fromBuffer(that, object)
	
	  if (isArray(object)) return fromArray(that, object)
	
	  if (object == null) {
	    throw new TypeError('must start with number, buffer, array or string')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined') {
	    if (object.buffer instanceof ArrayBuffer) {
	      return fromTypedArray(that, object)
	    }
	    if (object instanceof ArrayBuffer) {
	      return fromArrayBuffer(that, object)
	    }
	  }
	
	  if (object.length) return fromArrayLike(that, object)
	
	  return fromJsonObject(that, object)
	}
	
	function fromBuffer (that, buffer) {
	  var length = checked(buffer.length) | 0
	  that = allocate(that, length)
	  buffer.copy(that, 0, 0, length)
	  return that
	}
	
	function fromArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Duplicate of fromArray() to keep fromArray() monomorphic.
	function fromTypedArray (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  // Truncating the elements is probably not what people expect from typed
	  // arrays with BYTES_PER_ELEMENT > 1 but it's compatible with the behavior
	  // of the old Buffer constructor.
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    array.byteLength
	    that = Buffer._augment(new Uint8Array(array))
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromTypedArray(that, new Uint8Array(array))
	  }
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = checked(array.length) | 0
	  that = allocate(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	// Deserialize { type: 'Buffer', data: [1,2,3,...] } into a Buffer object.
	// Returns a zero-length buffer for inputs that don't conform to the spec.
	function fromJsonObject (that, object) {
	  var array
	  var length = 0
	
	  if (object.type === 'Buffer' && isArray(object.data)) {
	    array = object.data
	    length = checked(array.length) | 0
	  }
	  that = allocate(that, length)
	
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	} else {
	  // pre-set for values that may exist in the future
	  Buffer.prototype.length = undefined
	  Buffer.prototype.parent = undefined
	}
	
	function allocate (that, length) {
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = Buffer._augment(new Uint8Array(length))
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that.length = length
	    that._isBuffer = true
	  }
	
	  var fromPool = length !== 0 && length <= Buffer.poolSize >>> 1
	  if (fromPool) that.parent = rootParent
	
	  return that
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (subject, encoding) {
	  if (!(this instanceof SlowBuffer)) return new SlowBuffer(subject, encoding)
	
	  var buf = new Buffer(subject, encoding)
	  delete buf.parent
	  return buf
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  var i = 0
	  var len = Math.min(x, y)
	  while (i < len) {
	    if (a[i] !== b[i]) break
	
	    ++i
	  }
	
	  if (i !== len) {
	    x = a[i]
	    y = b[i]
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'binary':
	    case 'base64':
	    case 'raw':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) throw new TypeError('list argument must be an Array of Buffers.')
	
	  if (list.length === 0) {
	    return new Buffer(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; i++) {
	      length += list[i].length
	    }
	  }
	
	  var buf = new Buffer(length)
	  var pos = 0
	  for (i = 0; i < list.length; i++) {
	    var item = list[i]
	    item.copy(buf, pos)
	    pos += item.length
	  }
	  return buf
	}
	
	function byteLength (string, encoding) {
	  if (typeof string !== 'string') string = '' + string
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'binary':
	      // Deprecated
	      case 'raw':
	      case 'raws':
	        return len
	      case 'utf8':
	      case 'utf-8':
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  start = start | 0
	  end = end === undefined || end === Infinity ? this.length : end | 0
	
	  if (!encoding) encoding = 'utf8'
	  if (start < 0) start = 0
	  if (end > this.length) end = this.length
	  if (end <= start) return ''
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'binary':
	        return binarySlice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return 0
	  return Buffer.compare(this, b)
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset) {
	  if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff
	  else if (byteOffset < -0x80000000) byteOffset = -0x80000000
	  byteOffset >>= 0
	
	  if (this.length === 0) return -1
	  if (byteOffset >= this.length) return -1
	
	  // Negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = Math.max(this.length + byteOffset, 0)
	
	  if (typeof val === 'string') {
	    if (val.length === 0) return -1 // special case: looking for empty string always fails
	    return String.prototype.indexOf.call(this, val, byteOffset)
	  }
	  if (Buffer.isBuffer(val)) {
	    return arrayIndexOf(this, val, byteOffset)
	  }
	  if (typeof val === 'number') {
	    if (Buffer.TYPED_ARRAY_SUPPORT && Uint8Array.prototype.indexOf === 'function') {
	      return Uint8Array.prototype.indexOf.call(this, val, byteOffset)
	    }
	    return arrayIndexOf(this, [ val ], byteOffset)
	  }
	
	  function arrayIndexOf (arr, val, byteOffset) {
	    var foundIndex = -1
	    for (var i = 0; byteOffset + i < arr.length; i++) {
	      if (arr[byteOffset + i] === val[foundIndex === -1 ? 0 : i - foundIndex]) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === val.length) return byteOffset + foundIndex
	      } else {
	        foundIndex = -1
	      }
	    }
	    return -1
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	// `get` is deprecated
	Buffer.prototype.get = function get (offset) {
	  console.log('.get() is deprecated. Access using array indexes instead.')
	  return this.readUInt8(offset)
	}
	
	// `set` is deprecated
	Buffer.prototype.set = function set (v, offset) {
	  console.log('.set() is deprecated. Access using array indexes instead.')
	  return this.writeUInt8(v, offset)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new Error('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; i++) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) throw new Error('Invalid hex string')
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function binaryWrite (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    var swap = encoding
	    encoding = offset
	    offset = length | 0
	    length = swap
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'binary':
	        return binaryWrite(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function binarySlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; i++) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; i++) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = Buffer._augment(this.subarray(start, end))
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; i++) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  if (newBuf.length) newBuf.parent = this.parent || this
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('buffer must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkInt(this, value, offset, byteLength, Math.pow(2, 8 * byteLength), 0)
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; i++) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; i++) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = value < 0 ? 1 : 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (value > max || value < min) throw new RangeError('value is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('index out of range')
	  if (offset < 0) throw new RangeError('index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; i--) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; i++) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    target._set(this.subarray(start, start + len), targetStart)
	  }
	
	  return len
	}
	
	// fill(value, start=0, end=buffer.length)
	Buffer.prototype.fill = function fill (value, start, end) {
	  if (!value) value = 0
	  if (!start) start = 0
	  if (!end) end = this.length
	
	  if (end < start) throw new RangeError('end < start')
	
	  // Fill 0 bytes; we're done
	  if (end === start) return
	  if (this.length === 0) return
	
	  if (start < 0 || start >= this.length) throw new RangeError('start out of bounds')
	  if (end < 0 || end > this.length) throw new RangeError('end out of bounds')
	
	  var i
	  if (typeof value === 'number') {
	    for (i = start; i < end; i++) {
	      this[i] = value
	    }
	  } else {
	    var bytes = utf8ToBytes(value.toString())
	    var len = bytes.length
	    for (i = start; i < end; i++) {
	      this[i] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	/**
	 * Creates a new `ArrayBuffer` with the *copied* memory of the buffer instance.
	 * Added in Node 0.12. Only available in browsers that support ArrayBuffer.
	 */
	Buffer.prototype.toArrayBuffer = function toArrayBuffer () {
	  if (typeof Uint8Array !== 'undefined') {
	    if (Buffer.TYPED_ARRAY_SUPPORT) {
	      return (new Buffer(this)).buffer
	    } else {
	      var buf = new Uint8Array(this.length)
	      for (var i = 0, len = buf.length; i < len; i += 1) {
	        buf[i] = this[i]
	      }
	      return buf.buffer
	    }
	  } else {
	    throw new TypeError('Buffer.toArrayBuffer not supported in this browser')
	  }
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var BP = Buffer.prototype
	
	/**
	 * Augment a Uint8Array *instance* (not the Uint8Array class!) with Buffer methods
	 */
	Buffer._augment = function _augment (arr) {
	  arr.constructor = Buffer
	  arr._isBuffer = true
	
	  // save reference to original Uint8Array set method before overwriting
	  arr._set = arr.set
	
	  // deprecated
	  arr.get = BP.get
	  arr.set = BP.set
	
	  arr.write = BP.write
	  arr.toString = BP.toString
	  arr.toLocaleString = BP.toString
	  arr.toJSON = BP.toJSON
	  arr.equals = BP.equals
	  arr.compare = BP.compare
	  arr.indexOf = BP.indexOf
	  arr.copy = BP.copy
	  arr.slice = BP.slice
	  arr.readUIntLE = BP.readUIntLE
	  arr.readUIntBE = BP.readUIntBE
	  arr.readUInt8 = BP.readUInt8
	  arr.readUInt16LE = BP.readUInt16LE
	  arr.readUInt16BE = BP.readUInt16BE
	  arr.readUInt32LE = BP.readUInt32LE
	  arr.readUInt32BE = BP.readUInt32BE
	  arr.readIntLE = BP.readIntLE
	  arr.readIntBE = BP.readIntBE
	  arr.readInt8 = BP.readInt8
	  arr.readInt16LE = BP.readInt16LE
	  arr.readInt16BE = BP.readInt16BE
	  arr.readInt32LE = BP.readInt32LE
	  arr.readInt32BE = BP.readInt32BE
	  arr.readFloatLE = BP.readFloatLE
	  arr.readFloatBE = BP.readFloatBE
	  arr.readDoubleLE = BP.readDoubleLE
	  arr.readDoubleBE = BP.readDoubleBE
	  arr.writeUInt8 = BP.writeUInt8
	  arr.writeUIntLE = BP.writeUIntLE
	  arr.writeUIntBE = BP.writeUIntBE
	  arr.writeUInt16LE = BP.writeUInt16LE
	  arr.writeUInt16BE = BP.writeUInt16BE
	  arr.writeUInt32LE = BP.writeUInt32LE
	  arr.writeUInt32BE = BP.writeUInt32BE
	  arr.writeIntLE = BP.writeIntLE
	  arr.writeIntBE = BP.writeIntBE
	  arr.writeInt8 = BP.writeInt8
	  arr.writeInt16LE = BP.writeInt16LE
	  arr.writeInt16BE = BP.writeInt16BE
	  arr.writeInt32LE = BP.writeInt32LE
	  arr.writeInt32BE = BP.writeInt32BE
	  arr.writeFloatLE = BP.writeFloatLE
	  arr.writeFloatBE = BP.writeFloatBE
	  arr.writeDoubleLE = BP.writeDoubleLE
	  arr.writeDoubleBE = BP.writeDoubleBE
	  arr.fill = BP.fill
	  arr.inspect = BP.inspect
	  arr.toArrayBuffer = BP.toArrayBuffer
	
	  return arr
	}
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; i++) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; i++) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; i++) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(146).Buffer, (function() { return this; }())))

/***/ },
/* 147 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = setTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    clearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        setTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 148 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 149 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 150 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 151 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports = {
		"default_hs_url": "https://webrtc-hub.fccn.pt:8448",
		"default_is_url": "https://webrtc-hub.fccn.pt:8448"
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	/*
	 * THIS FILE IS AUTO-GENERATED
	 * You can edit it you like, but your changes will be overwritten,
	 * so you'd just be trying to swim upstream like a salmon.
	 * You are not a salmon.
	 */
	
	'use strict';
	
	module.exports.components = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/component-index\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())).components;
	
	module.exports.components['structures.BottomLeftMenu'] = __webpack_require__(154);
	module.exports.components['structures.CompatibilityPage'] = __webpack_require__(155);
	module.exports.components['structures.LeftPanel'] = __webpack_require__(156);
	module.exports.components['structures.RightPanel'] = __webpack_require__(157);
	module.exports.components['structures.RoomDirectory'] = __webpack_require__(158);
	module.exports.components['structures.RoomSubList'] = __webpack_require__(159);
	module.exports.components['structures.ViewSource'] = __webpack_require__(160);
	module.exports.components['views.elements.ImageView'] = __webpack_require__(161);
	module.exports.components['views.elements.Spinner'] = __webpack_require__(162);
	module.exports.components['views.globals.GuestWarningBar'] = __webpack_require__(163);
	module.exports.components['views.globals.MatrixToolbar'] = __webpack_require__(164);
	module.exports.components['views.globals.NewVersionBar'] = __webpack_require__(165);
	module.exports.components['views.login.VectorCustomServerDialog'] = __webpack_require__(166);
	module.exports.components['views.login.VectorLoginFooter'] = __webpack_require__(167);
	module.exports.components['views.login.VectorLoginHeader'] = __webpack_require__(168);
	module.exports.components['views.messages.DateSeparator'] = __webpack_require__(169);
	module.exports.components['views.messages.MessageTimestamp'] = __webpack_require__(170);
	module.exports.components['views.messages.SenderProfile'] = __webpack_require__(171);
	module.exports.components['views.rooms.BottomLeftMenuTile'] = __webpack_require__(172);
	module.exports.components['views.rooms.MessageContextMenu'] = __webpack_require__(173);
	module.exports.components['views.rooms.RoomDNDView'] = __webpack_require__(174);
	module.exports.components['views.rooms.RoomDropTarget'] = __webpack_require__(175);
	module.exports.components['views.rooms.RoomTooltip'] = __webpack_require__(176);
	module.exports.components['views.rooms.SearchBar'] = __webpack_require__(177);
	module.exports.components['views.settings.Notifications'] = __webpack_require__(178);


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'BottomLeftMenu',
	
	    onSettingsClick: function onSettingsClick() {
	        dis.dispatch({ action: 'view_user_settings' });
	    },
	
	    onRoomDirectoryClick: function onRoomDirectoryClick() {
	        dis.dispatch({ action: 'view_room_directory' });
	    },
	
	    onCreateRoomClick: function onCreateRoomClick() {
	        dis.dispatch({ action: 'view_create_room' });
	    },
	
	    getLabel: function getLabel(name) {
	        if (!this.props.collapsed) {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomTile_name' },
	                name
	            );
	        } else if (this.state.hover) {
	            var RoomTooltip = sdk.getComponent("rooms.RoomTooltip");
	            return React.createElement(RoomTooltip, { name: name });
	        }
	    },
	
	    render: function render() {
	        var BottomLeftMenuTile = sdk.getComponent('rooms.BottomLeftMenuTile');
	        return React.createElement(
	            'div',
	            { className: 'mx_BottomLeftMenu' },
	            React.createElement(
	                'div',
	                { className: 'mx_BottomLeftMenu_options' },
	                React.createElement(BottomLeftMenuTile, { collapsed: this.props.collapsed, img: 'img/create-big.svg', label: 'Start chat', onClick: this.onCreateRoomClick }),
	                React.createElement(BottomLeftMenuTile, { collapsed: this.props.collapsed, img: 'img/directory-big.svg', label: 'Directory', onClick: this.onRoomDirectoryClick }),
	                React.createElement(BottomLeftMenuTile, { collapsed: this.props.collapsed, img: 'img/settings-big.svg', label: 'Settings', onClick: this.onSettingsClick })
	            )
	        );
	    }
	});


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'CompatibilityPage',
	    propTypes: {
	        onAccept: React.PropTypes.func
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onAccept: function onAccept() {} // NOP
	        };
	    },
	
	    onAccept: function onAccept() {
	        this.props.onAccept();
	    },
	
	    render: function render() {
	
	        return React.createElement(
	            'div',
	            { className: 'mx_CompatibilityPage' },
	            React.createElement(
	                'div',
	                { className: 'mx_CompatibilityPage_box' },
	                React.createElement(
	                    'p',
	                    null,
	                    'Sorry, your browser is ',
	                    React.createElement(
	                        'b',
	                        null,
	                        'not'
	                    ),
	                    ' able to run Vector.'
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    'Buttons and images may appear out of place, communication may not be possible and all manner of chaos may be unleashed.'
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    'Please install ',
	                    React.createElement(
	                        'a',
	                        { href: "https://www.google.com/chrome" },
	                        'Chrome'
	                    ),
	                    ' for the best experience.'
	                ),
	                React.createElement(
	                    'p',
	                    null,
	                    'Though if you like taking risks with your life, you can still try it out by clicking that you understand the risks involved.'
	                ),
	                React.createElement(
	                    'button',
	                    { onClick: this.onAccept },
	                    'I understand the risks and wish to continue'
	                )
	            )
	        );
	    }
	});


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var DragDropContext = __webpack_require__(42).DragDropContext;
	var HTML5Backend = __webpack_require__(203);
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	var VectorConferenceHandler = __webpack_require__(91);
	var CallHandler = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/CallHandler\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	var LeftPanel = React.createClass({
	    displayName: 'LeftPanel',
	
	    getInitialState: function getInitialState() {
	        return {
	            showCallElement: null
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        this._recheckCallElement(newProps.selectedRoom);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	    },
	
	    onAction: function onAction(payload) {
	        switch (payload.action) {
	            // listen for call state changes to prod the render method, which
	            // may hide the global CallView if the call it is tracking is dead
	            case 'call_state':
	                this._recheckCallElement(this.props.selectedRoom);
	                break;
	        }
	    },
	
	    _recheckCallElement: function _recheckCallElement(selectedRoomId) {
	        // if we aren't viewing a room with an ongoing call, but there is an
	        // active call, show the call element - we need to do this to make
	        // audio/video not crap out
	        var activeCall = CallHandler.getAnyActiveCall();
	        var callForRoom = CallHandler.getCallForRoom(selectedRoomId);
	        var showCall = activeCall && activeCall.call_state === 'connected' && !callForRoom;
	        this.setState({
	            showCallElement: showCall
	        });
	    },
	
	    onHideClick: function onHideClick() {
	        dis.dispatch({
	            action: 'hide_left_panel'
	        });
	    },
	
	    onCallViewClick: function onCallViewClick() {
	        var call = CallHandler.getAnyActiveCall();
	        if (call) {
	            dis.dispatch({
	                action: 'view_room',
	                room_id: call.roomId
	            });
	        }
	    },
	
	    render: function render() {
	        var RoomList = sdk.getComponent('rooms.RoomList');
	        var BottomLeftMenu = sdk.getComponent('structures.BottomLeftMenu');
	
	        var collapseButton;
	        var classes = "mx_LeftPanel";
	        if (this.props.collapsed) {
	            classes += " collapsed";
	        } else {
	            // Hide the collapse button until we work out how to display it in the new skin
	            // collapseButton = <img className="mx_LeftPanel_hideButton" onClick={ this.onHideClick } src="img/hide.png" width="12" height="20" alt="<"/>  
	        }
	
	        var callPreview;
	        if (this.state.showCallElement && !this.props.collapsed) {
	            var CallView = sdk.getComponent('voip.CallView');
	            callPreview = React.createElement(CallView, {
	                className: 'mx_LeftPanel_callView', onClick: this.onCallViewClick,
	                ConferenceHandler: VectorConferenceHandler });
	        }
	
	        return React.createElement(
	            'aside',
	            { className: classes },
	            collapseButton,
	            callPreview,
	            React.createElement(RoomList, {
	                selectedRoom: this.props.selectedRoom,
	                collapsed: this.props.collapsed,
	                ConferenceHandler: VectorConferenceHandler }),
	            React.createElement(BottomLeftMenu, { collapsed: this.props.collapsed })
	        );
	    }
	});
	
	module.exports = DragDropContext(HTML5Backend)(LeftPanel);


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var MatrixClientPeg = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/MatrixClientPeg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'RightPanel',
	
	    Phase: {
	        MemberList: 'MemberList',
	        FileList: 'FileList',
	        MemberInfo: 'MemberInfo'
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.dispatcherRef = dis.register(this.onAction);
	        var cli = MatrixClientPeg.get();
	        cli.on("RoomState.members", this.onRoomStateMember);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        dis.unregister(this.dispatcherRef);
	        if (MatrixClientPeg.get()) {
	            MatrixClientPeg.get().removeListener("RoomState.members", this.onRoomStateMember);
	        }
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            phase: this.Phase.MemberList
	        };
	    },
	
	    onMemberListButtonClick: function onMemberListButtonClick() {
	        if (this.props.collapsed) {
	            this.setState({ phase: this.Phase.MemberList });
	            dis.dispatch({
	                action: 'show_right_panel'
	            });
	        } else {
	            dis.dispatch({
	                action: 'hide_right_panel'
	            });
	        }
	    },
	
	    onRoomStateMember: function onRoomStateMember(ev, state, member) {
	        // redraw the badge on the membership list
	        if (this.state.phase == this.Phase.MemberList && member.roomId === this.props.roomId) {
	            this.forceUpdate();
	        } else if (this.state.phase === this.Phase.MemberInfo && member.roomId === this.props.roomId && member.userId === this.state.member.userId) {
	            // refresh the member info (e.g. new power level)
	            this.forceUpdate();
	        }
	    },
	
	    onAction: function onAction(payload) {
	        if (payload.action === "view_user") {
	            if (payload.member) {
	                this.setState({
	                    phase: this.Phase.MemberInfo,
	                    member: payload.member
	                });
	            } else {
	                this.setState({
	                    phase: this.Phase.MemberList
	                });
	            }
	        }
	        if (payload.action === "view_room") {
	            if (this.state.phase === this.Phase.MemberInfo) {
	                this.setState({
	                    phase: this.Phase.MemberList
	                });
	            }
	        }
	    },
	
	    render: function render() {
	        var MemberList = sdk.getComponent('rooms.MemberList');
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	        var buttonGroup;
	        var panel;
	
	        var filesHighlight;
	        var membersHighlight;
	        if (!this.props.collapsed) {
	            if (this.state.phase == this.Phase.MemberList || this.state.phase === this.Phase.MemberInfo) {
	                membersHighlight = React.createElement('div', { className: 'mx_RightPanel_headerButton_highlight' });
	            } else if (this.state.phase == this.Phase.FileList) {
	                filesHighlight = React.createElement('div', { className: 'mx_RightPanel_headerButton_highlight' });
	            }
	        }
	
	        var membersBadge;
	        if ((this.state.phase == this.Phase.MemberList || this.state.phase === this.Phase.MemberInfo) && this.props.roomId) {
	            var cli = MatrixClientPeg.get();
	            var room = cli.getRoom(this.props.roomId);
	            if (room) {
	                membersBadge = React.createElement(
	                    'div',
	                    { className: 'mx_RightPanel_headerButton_badge' },
	                    room.getJoinedMembers().length
	                );
	            }
	        }
	
	        if (this.props.roomId) {
	            buttonGroup = React.createElement(
	                'div',
	                { className: 'mx_RightPanel_headerButtonGroup' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_RightPanel_headerButton', title: 'Members', onClick: this.onMemberListButtonClick },
	                    React.createElement(TintableSvg, { src: 'img/members.svg', width: '17', height: '22' }),
	                    membersBadge,
	                    membersHighlight
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RightPanel_headerButton mx_RightPanel_filebutton', title: 'Files' },
	                    React.createElement(TintableSvg, { src: 'img/files.svg', width: '17', height: '22' }),
	                    filesHighlight
	                )
	            );
	
	            if (!this.props.collapsed) {
	                if (this.state.phase == this.Phase.MemberList) {
	                    panel = React.createElement(MemberList, { roomId: this.props.roomId, key: this.props.roomId });
	                } else if (this.state.phase == this.Phase.MemberInfo) {
	                    var MemberInfo = sdk.getComponent('rooms.MemberInfo');
	                    panel = React.createElement(MemberInfo, { roomId: this.props.roomId, member: this.state.member, key: this.props.roomId });
	                }
	            }
	        }
	
	        var classes = "mx_RightPanel";
	        if (this.props.collapsed) {
	            classes += " collapsed";
	        }
	
	        return React.createElement(
	            'aside',
	            { className: classes },
	            React.createElement(
	                'div',
	                { className: 'mx_RightPanel_header' },
	                buttonGroup
	            ),
	            panel
	        );
	    }
	});


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	var MatrixClientPeg = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/MatrixClientPeg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var Modal = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/Modal\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'RoomDirectory',
	
	    getInitialState: function getInitialState() {
	        return {
	            publicRooms: [],
	            roomAlias: '',
	            loading: true
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        var self = this;
	        MatrixClientPeg.get().publicRooms(function (err, data) {
	            if (err) {
	                self.setState({ loading: false });
	                console.error("Failed to get publicRooms: %s", JSON.stringify(err));
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Failed to get public room list",
	                    description: err.message
	                });
	            } else {
	                self.setState({
	                    publicRooms: data.chunk,
	                    loading: false
	                });
	                self.forceUpdate();
	            }
	        });
	    },
	
	    showRoom: function showRoom(roomId) {
	        dis.dispatch({
	            action: 'view_room',
	            room_id: roomId
	        });
	    },
	
	    getRows: function getRows(filter) {
	        if (!this.state.publicRooms) return [];
	
	        var rooms = this.state.publicRooms.filter(function (a) {
	            // FIXME: if incrementally typing, keep narrowing down the search set
	            // incrementally rather than starting over each time.
	            return a.aliases[0].search(filter) >= 0 && a.num_joined_members > 0;
	        }).sort(function (a, b) {
	            return a.num_joined_members - b.num_joined_members;
	        });
	        var rows = [];
	        var self = this;
	        var guestRead, guestJoin, perms;
	        for (var i = 0; i < rooms.length; i++) {
	            var name = rooms[i].name || rooms[i].aliases[0];
	            guestRead = null;
	            guestJoin = null;
	
	            if (rooms[i].world_readable) {
	                guestRead = React.createElement(
	                    'span',
	                    null,
	                    '[world readable]'
	                );
	                // <img src="img/members.svg"
	                //     alt="World Readable" title="World Readable" width="12" height="12" />
	            }
	            if (rooms[i].guest_can_join) {
	                guestJoin = React.createElement(
	                    'span',
	                    null,
	                    '[guests allowed]'
	                );
	                // <img src="img/leave.svg"
	                //     alt="Guests can join" title="Guests can join" width="12" height="12" />
	            }
	
	            perms = null;
	            if (guestRead || guestJoin) {
	                perms = React.createElement(
	                    'div',
	                    null,
	                    guestRead,
	                    ' ',
	                    guestJoin
	                );
	            }
	
	            // <img src={ MatrixClientPeg.get().getAvatarUrlForRoom(rooms[i].room_id, 40, 40, "crop") } width="40" height="40" alt=""/>
	            rows.unshift(React.createElement(
	                'tbody',
	                { key: rooms[i].room_id },
	                React.createElement(
	                    'tr',
	                    { onClick: self.showRoom.bind(null, rooms[i].room_id) },
	                    React.createElement(
	                        'td',
	                        { className: 'mx_RoomDirectory_name' },
	                        name
	                    ),
	                    React.createElement(
	                        'td',
	                        null,
	                        rooms[i].aliases[0]
	                    ),
	                    React.createElement(
	                        'td',
	                        null,
	                        rooms[i].num_joined_members
	                    )
	                ),
	                React.createElement(
	                    'tr',
	                    { onClick: self.showRoom.bind(null, rooms[i].room_id) },
	                    React.createElement(
	                        'td',
	                        { className: 'mx_RoomDirectory_topic', colSpan: '3' },
	                        perms,
	                        ' ',
	                        rooms[i].topic
	                    )
	                )
	            ));
	        }
	        return rows;
	    },
	
	    onKeyUp: function onKeyUp(ev) {
	        this.forceUpdate();
	        this.setState({ roomAlias: this.refs.roomAlias.value });
	        if (ev.key == "Enter") {
	            this.showRoom(this.refs.roomAlias.value);
	        }
	    },
	
	    render: function render() {
	        if (this.state.loading) {
	            var Loader = sdk.getComponent("elements.Spinner");
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomDirectory' },
	                React.createElement(Loader, null)
	            );
	        }
	
	        var RoomHeader = sdk.getComponent('rooms.RoomHeader');
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomDirectory' },
	            React.createElement(RoomHeader, { simpleHeader: 'Public Rooms' }),
	            React.createElement(
	                'div',
	                { className: 'mx_RoomDirectory_list' },
	                React.createElement('input', { ref: 'roomAlias', placeholder: 'Join a room (e.g. #foo:domain.com)', className: 'mx_RoomDirectory_input', size: '64', onKeyUp: this.onKeyUp }),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomDirectory_tableWrapper' },
	                    React.createElement(
	                        'table',
	                        { className: 'mx_RoomDirectory_table' },
	                        React.createElement(
	                            'thead',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement(
	                                    'th',
	                                    { width: '45%' },
	                                    'Room'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { width: '45%' },
	                                    'Alias'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { width: '10%' },
	                                    'Members'
	                                )
	                            )
	                        ),
	                        this.getRows(this.state.roomAlias)
	                    )
	                )
	            )
	        );
	    }
	});


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var DropTarget = __webpack_require__(42).DropTarget;
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var Unread = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/Unread\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	// turn this on for drop & drag console debugging galore
	var debug = false;
	
	var roomListTarget = {
	    canDrop: function canDrop() {
	        return true;
	    },
	
	    drop: function drop(props, monitor, component) {
	        if (debug) console.log("dropped on sublist");
	    },
	
	    hover: function hover(props, monitor, component) {
	        var item = monitor.getItem();
	
	        if (component.state.sortedList.length == 0 && props.editable) {
	            if (debug) console.log("hovering on sublist " + props.label + ", isOver=" + monitor.isOver());
	
	            if (item.targetList !== component) {
	                item.targetList.removeRoomTile(item.room);
	                item.targetList = component;
	            }
	
	            component.moveRoomTile(item.room, 0);
	        }
	    }
	};
	
	var RoomSubList = React.createClass({
	    displayName: 'RoomSubList',
	
	    debug: debug,
	
	    propTypes: {
	        list: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
	        label: React.PropTypes.string.isRequired,
	        tagName: React.PropTypes.string,
	        editable: React.PropTypes.bool,
	        order: React.PropTypes.string.isRequired,
	        selectedRoom: React.PropTypes.string.isRequired,
	        startAsHidden: React.PropTypes.bool,
	        showSpinner: React.PropTypes.bool, // true to show a spinner if 0 elements when expanded
	
	        // TODO: Fix the name of this. This is too easily confused with the
	        // "hidden" state which is the expanded (or not) view of the list of rooms.
	        // What this prop *really* does is control whether the room name is displayed
	        // so it should be named as such.
	        collapsed: React.PropTypes.bool.isRequired,
	        onHeaderClick: React.PropTypes.func,
	        alwaysShowHeader: React.PropTypes.bool,
	        incomingCall: React.PropTypes.object,
	        onShowMoreRooms: React.PropTypes.func
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            hidden: this.props.startAsHidden || false,
	            truncateAt: 20,
	            sortedList: []
	        };
	    },
	
	    getDefaultProps: function getDefaultProps() {
	        return {
	            onHeaderClick: function onHeaderClick() {}, // NOP
	            onShowMoreRooms: function onShowMoreRooms() {} // NOP
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        this.sortList(this.props.list, this.props.order);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        // order the room list appropriately before we re-render
	        //if (debug) console.log("received new props, list = " + newProps.list);
	        this.sortList(newProps.list, newProps.order);
	    },
	
	    onClick: function onClick(ev) {
	        var isHidden = !this.state.hidden;
	        this.setState({ hidden: isHidden });
	
	        if (isHidden) {
	            // as good a way as any to reset the truncate state
	            this.setState({ truncateAt: 20 });
	            this.props.onShowMoreRooms();
	        }
	
	        this.props.onHeaderClick(isHidden);
	    },
	
	    tsOfNewestEvent: function tsOfNewestEvent(room) {
	        for (var i = room.timeline.length - 1; i >= 0; --i) {
	            var ev = room.timeline[i];
	            if (Unread.eventTriggersUnreadCount(ev)) {
	                return ev.getTs();
	            }
	        }
	
	        // we might only have events that don't trigger the unread indicator,
	        // in which case use the oldest event even if normally it wouldn't count.
	        // This is better than just assuming the last event was forever ago.
	        if (room.timeline.length) {
	            return room.timeline[0].getTs();
	        } else {
	            return Number.MAX_SAFE_INTEGER;
	        }
	    },
	
	    // TODO: factor the comparators back out into a generic comparator
	    // so that view_prev_room and view_next_room can do the right thing
	
	    recentsComparator: function recentsComparator(roomA, roomB) {
	        return this.tsOfNewestEvent(roomB) - this.tsOfNewestEvent(roomA);
	    },
	
	    manualComparator: function manualComparator(roomA, roomB) {
	        if (!roomA.tags[this.props.tagName] || !roomB.tags[this.props.tagName]) return 0;
	        var a = roomA.tags[this.props.tagName].order;
	        var b = roomB.tags[this.props.tagName].order;
	        return a == b ? this.recentsComparator(roomA, roomB) : a > b ? 1 : -1;
	    },
	
	    sortList: function sortList(list, order) {
	        if (list === undefined) list = this.state.sortedList;
	        if (order === undefined) order = this.props.order;
	        var comparator;
	        list = list || [];
	        if (order === "manual") comparator = this.manualComparator;
	        if (order === "recent") comparator = this.recentsComparator;
	
	        //if (debug) console.log("sorting list for sublist " + this.props.label + " with length " + list.length + ", this.props.list = " + this.props.list);
	        this.setState({ sortedList: list.sort(comparator) });
	    },
	
	    moveRoomTile: function moveRoomTile(room, atIndex) {
	        if (debug) console.log("moveRoomTile: id " + room.roomId + ", atIndex " + atIndex);
	        //console.log("moveRoomTile before: " + JSON.stringify(this.state.rooms));
	        var found = this.findRoomTile(room);
	        var rooms = this.state.sortedList;
	        if (found.room) {
	            if (debug) console.log("removing at index " + found.index + " and adding at index " + atIndex);
	            rooms.splice(found.index, 1);
	            rooms.splice(atIndex, 0, found.room);
	        } else {
	            if (debug) console.log("Adding at index " + atIndex);
	            rooms.splice(atIndex, 0, room);
	        }
	        this.setState({ sortedList: rooms });
	        // console.log("moveRoomTile after: " + JSON.stringify(this.state.rooms));
	    },
	
	    // XXX: this isn't invoked via a property method but indirectly via
	    // the roomList property method.  Unsure how evil this is.
	    removeRoomTile: function removeRoomTile(room) {
	        if (debug) console.log("remove room " + room.roomId);
	        var found = this.findRoomTile(room);
	        var rooms = this.state.sortedList;
	        if (found.room) {
	            rooms.splice(found.index, 1);
	        } else {
	            console.warn("Can't remove room " + room.roomId + " - can't find it");
	        }
	        this.setState({ sortedList: rooms });
	    },
	
	    findRoomTile: function findRoomTile(room) {
	        var index = this.state.sortedList.indexOf(room);
	        if (index >= 0) {
	            // console.log("found: room: " + room.roomId + " with index " + index);
	        } else {
	                if (debug) console.log("didn't find room");
	                room = null;
	            }
	        return {
	            room: room,
	            index: index
	        };
	    },
	
	    calcManualOrderTagData: function calcManualOrderTagData(room) {
	        var index = this.state.sortedList.indexOf(room);
	
	        // we sort rooms by the lexicographic ordering of the 'order' metadata on their tags.
	        // for convenience, we calculate this for now a floating point number between 0.0 and 1.0.
	
	        var orderA = 0.0; // by default we're next to the beginning of the list
	        if (index > 0) {
	            var prevTag = this.state.sortedList[index - 1].tags[this.props.tagName];
	            if (!prevTag) {
	                console.error("Previous room in sublist is not tagged to be in this list. This should never happen.");
	            } else if (prevTag.order === undefined) {
	                console.error("Previous room in sublist has no ordering metadata. This should never happen.");
	            } else {
	                orderA = prevTag.order;
	            }
	        }
	
	        var orderB = 1.0; // by default we're next to the end of the list too
	        if (index < this.state.sortedList.length - 1) {
	            var nextTag = this.state.sortedList[index + 1].tags[this.props.tagName];
	            if (!nextTag) {
	                console.error("Next room in sublist is not tagged to be in this list. This should never happen.");
	            } else if (nextTag.order === undefined) {
	                console.error("Next room in sublist has no ordering metadata. This should never happen.");
	            } else {
	                orderB = nextTag.order;
	            }
	        }
	
	        var order = (orderA + orderB) / 2.0;
	        if (order === orderA || order === orderB) {
	            console.error("Cannot describe new list position.  This should be incredibly unlikely.");
	            // TODO: renumber the list
	        }
	
	        return order;
	    },
	
	    makeRoomTiles: function makeRoomTiles() {
	        var self = this;
	        var RoomTile = sdk.getComponent("rooms.RoomTile");
	        return this.state.sortedList.map(function (room) {
	            var selected = room.roomId == self.props.selectedRoom;
	            // XXX: is it evil to pass in self as a prop to RoomTile?
	            return React.createElement(RoomTile, {
	                room: room,
	                roomSubList: self,
	                key: room.roomId,
	                collapsed: self.props.collapsed || false,
	                selected: selected,
	                unread: Unread.doesRoomHaveUnreadMessages(room),
	                highlight: room.getUnreadNotificationCount('highlight') > 0 || self.props.label === 'Invites',
	                isInvite: self.props.label === 'Invites',
	                incomingCall: self.props.incomingCall && self.props.incomingCall.roomId === room.roomId ? self.props.incomingCall : null });
	        });
	    },
	
	    _getHeaderJsx: function _getHeaderJsx() {
	        var TintableSvg = sdk.getComponent("elements.TintableSvg");
	        return React.createElement(
	            'h2',
	            { onClick: this.onClick, className: 'mx_RoomSubList_label' },
	            this.props.collapsed ? '' : this.props.label,
	            React.createElement(TintableSvg, { className: 'mx_RoomSubList_chevron',
	                src: this.state.hidden ? "img/list-close.svg" : "img/list-open.svg",
	                width: '10', height: '10' })
	        );
	    },
	
	    _createOverflowTile: function _createOverflowTile(overflowCount, totalCount) {
	        var BaseAvatar = sdk.getComponent('avatars.BaseAvatar');
	        // XXX: this is duplicated from RoomTile - factor it out
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomTile mx_RoomTile_ellipsis', onClick: this._showFullMemberList },
	            React.createElement(
	                'div',
	                { className: 'mx_RoomTile_avatar' },
	                React.createElement(BaseAvatar, { url: 'img/ellipsis.svg', name: '...', width: 24, height: 24 })
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_RoomTile_name' },
	                'and ',
	                overflowCount,
	                ' others...'
	            )
	        );
	    },
	
	    _showFullMemberList: function _showFullMemberList() {
	        this.setState({
	            truncateAt: -1
	        });
	        this.props.onShowMoreRooms();
	    },
	
	    render: function render() {
	        var connectDropTarget = this.props.connectDropTarget;
	        var RoomDropTarget = sdk.getComponent('rooms.RoomDropTarget');
	        var TruncatedList = sdk.getComponent('elements.TruncatedList');
	
	        var label = this.props.collapsed ? null : this.props.label;
	
	        //console.log("render: " + JSON.stringify(this.state.sortedList));
	
	        var target;
	        if (this.state.sortedList.length == 0 && this.props.editable) {
	            target = React.createElement(RoomDropTarget, { label: 'Drop here to ' + this.props.verb });
	        }
	
	        if (this.state.sortedList.length > 0 || this.props.editable) {
	            var subList;
	            var classes = "mx_RoomSubList";
	
	            if (!this.state.hidden) {
	                subList = React.createElement(
	                    TruncatedList,
	                    { className: classes, truncateAt: this.state.truncateAt,
	                        createOverflowElement: this._createOverflowTile },
	                    target,
	                    this.makeRoomTiles()
	                );
	            } else {
	                subList = React.createElement(TruncatedList, { className: classes });
	            }
	
	            return connectDropTarget(React.createElement(
	                'div',
	                null,
	                this._getHeaderJsx(),
	                subList
	            ));
	        } else {
	            var Loader = sdk.getComponent("elements.Spinner");
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomSubList' },
	                this.props.alwaysShowHeader ? this._getHeaderJsx() : undefined,
	                this.props.showSpinner && !this.state.hidden ? React.createElement(Loader, null) : undefined
	            );
	        }
	    }
	});
	
	// Export the wrapped version, inlining the 'collect' functions
	// to more closely resemble the ES7
	module.exports = DropTarget('RoomTile', roomListTarget, function (connect) {
	    return {
	        connectDropTarget: connect.dropTarget()
	    };
	})(RoomSubList);


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'ViewSource',
	
	    propTypes: {
	        onFinished: React.PropTypes.func.isRequired
	    },
	
	    componentDidMount: function componentDidMount() {
	        document.addEventListener("keydown", this.onKeyDown);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener("keydown", this.onKeyDown);
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        if (ev.keyCode == 27) {
	            // escape
	            ev.stopPropagation();
	            ev.preventDefault();
	            this.props.onFinished();
	        }
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_ViewSource' },
	            React.createElement(
	                'pre',
	                null,
	                JSON.stringify(this.props.mxEvent.event, null, 2)
	            )
	        );
	    }
	});


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	var MatrixClientPeg = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/MatrixClientPeg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	var DateUtils = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/DateUtils\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var filesize = __webpack_require__(182);
	
	module.exports = React.createClass({
	    displayName: 'ImageView',
	
	    propTypes: {
	        onFinished: React.PropTypes.func.isRequired
	    },
	
	    // XXX: keyboard shortcuts for managing dialogs should be done by the modal
	    // dialog base class somehow, surely...
	    componentDidMount: function componentDidMount() {
	        document.addEventListener("keydown", this.onKeyDown);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener("keydown", this.onKeyDown);
	    },
	
	    onKeyDown: function onKeyDown(ev) {
	        if (ev.keyCode == 27) {
	            // escape
	            ev.stopPropagation();
	            ev.preventDefault();
	            this.props.onFinished();
	        }
	    },
	
	    onRedactClick: function onRedactClick() {
	        var self = this;
	        MatrixClientPeg.get().redactEvent(this.props.mxEvent.getRoomId(), this.props.mxEvent.getId()).done(function () {
	            if (self.props.onFinished) self.props.onFinished();
	        }, function (e) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            // display error message stating you couldn't delete this.
	            var code = e.errcode || e.statusCode;
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "You cannot delete this image. (" + code + ")"
	            });
	        });
	    },
	
	    render: function render() {
	
	        /*
	                // In theory max-width: 80%, max-height: 80% on the CSS should work
	                // but in practice, it doesn't, so do it manually:
	        
	                var width = this.props.width || 500;
	                var height = this.props.height || 500;
	        
	                var maxWidth = document.documentElement.clientWidth * 0.8;
	                var maxHeight = document.documentElement.clientHeight * 0.8;
	        
	                var widthFrac = width / maxWidth;
	                var heightFrac = height / maxHeight;
	        
	                var displayWidth;
	                var displayHeight;
	                if (widthFrac > heightFrac) {
	                    displayWidth = Math.min(width, maxWidth);
	                    displayHeight = (displayWidth / width) * height;
	                } else {
	                    displayHeight = Math.min(height, maxHeight);
	                    displayWidth = (displayHeight / height) * width;
	                }
	        
	                var style = {
	                    width: displayWidth,
	                    height: displayHeight
	                };
	        */
	        var style, res;
	
	        if (this.props.width && this.props.height) {
	            style = {
	                width: this.props.width,
	                height: this.props.height
	            };
	            res = ", " + style.width + "x" + style.height + "px";
	        }
	
	        var size;
	        if (this.props.mxEvent.getContent().info && this.props.mxEvent.getContent().info.size) {
	            size = filesize(this.props.mxEvent.getContent().info.size);
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_ImageView' },
	            React.createElement('div', { className: 'mx_ImageView_lhs' }),
	            React.createElement(
	                'div',
	                { className: 'mx_ImageView_content' },
	                React.createElement('img', { src: this.props.src, style: style }),
	                React.createElement(
	                    'div',
	                    { className: 'mx_ImageView_labelWrapper' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_ImageView_label' },
	                        React.createElement('img', { className: 'mx_ImageView_cancel', src: 'img/cancel-white.svg', width: '18', height: '18', alt: 'Close', onClick: this.props.onFinished }),
	                        React.createElement('div', { className: 'mx_ImageView_shim' }),
	                        React.createElement(
	                            'div',
	                            { className: 'mx_ImageView_name' },
	                            this.props.mxEvent.getContent().body
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'mx_ImageView_metadata' },
	                            'Uploaded on ',
	                            DateUtils.formatDate(new Date(this.props.mxEvent.getTs())),
	                            ' by ',
	                            this.props.mxEvent.getSender()
	                        ),
	                        React.createElement(
	                            'a',
	                            { className: 'mx_ImageView_link', href: this.props.src, target: '_blank' },
	                            React.createElement(
	                                'div',
	                                { className: 'mx_ImageView_download' },
	                                'Download this file',
	                                React.createElement('br', null),
	                                React.createElement(
	                                    'span',
	                                    { className: 'mx_ImageView_size' },
	                                    size,
	                                    ' ',
	                                    res
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'mx_ImageView_button' },
	                            React.createElement(
	                                'a',
	                                { className: 'mx_ImageView_link', href: this.props.src, target: '_blank' },
	                                'View full screen'
	                            )
	                        ),
	                        React.createElement(
	                            'div',
	                            { className: 'mx_ImageView_button', onClick: this.onRedactClick },
	                            'Redact'
	                        ),
	                        React.createElement('div', { className: 'mx_ImageView_shim' })
	                    )
	                )
	            ),
	            React.createElement('div', { className: 'mx_ImageView_rhs' })
	        );
	    }
	});


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'Spinner',
	
	    render: function render() {
	        var w = this.props.w || 32;
	        var h = this.props.h || 32;
	        var imgClass = this.props.imgClassName || "";
	        return React.createElement(
	            'div',
	            { className: 'mx_Spinner' },
	            React.createElement('img', { src: 'img/spinner.gif', width: w, height: h, className: imgClass })
	        );
	    }
	});


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'GuestWarningBar',
	
	    onRegisterClicked: function onRegisterClicked() {
	        dis.dispatch({ 'action': 'logout' });
	        dis.dispatch({ 'action': 'start_registration' });
	    },
	
	    onLoginClicked: function onLoginClicked() {
	        dis.dispatch({ 'action': 'logout' });
	        dis.dispatch({ 'action': 'start_login' });
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_GuestWarningBar' },
	            React.createElement('img', { className: 'mx_GuestWarningBar_warning', src: 'img/warning.svg', width: '24', height: '23', alt: '/!\\' }),
	            React.createElement(
	                'div',
	                null,
	                'You are using Vector as a guest. ',
	                React.createElement(
	                    'a',
	                    { onClick: this.onRegisterClicked },
	                    'Register'
	                ),
	                ' or ',
	                React.createElement(
	                    'a',
	                    { onClick: this.onLoginClicked },
	                    'log in'
	                ),
	                ' to access more rooms and features.'
	            )
	        );
	    }
	});


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var Notifier = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/Notifier\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'MatrixToolbar',
	
	    hideToolbar: function hideToolbar() {
	        Notifier.setToolbarHidden(true);
	    },
	
	    onClick: function onClick() {
	        Notifier.setEnabled(true);
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_MatrixToolbar' },
	            React.createElement('img', { className: 'mx_MatrixToolbar_warning', src: 'img/warning.svg', width: '24', height: '23', alt: '/!\\' }),
	            React.createElement(
	                'div',
	                null,
	                'You are not receiving desktop notifications. ',
	                React.createElement(
	                    'a',
	                    { className: 'mx_MatrixToolbar_link', onClick: this.onClick },
	                    'Enable them now'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_MatrixToolbar_close' },
	                React.createElement('img', { src: 'img/cancel.svg', width: '18', height: '18', onClick: this.hideToolbar })
	            )
	        );
	    }
	});


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'NewVersionBar',
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_MatrixToolbar' },
	            React.createElement('img', { className: 'mx_MatrixToolbar_warning', src: 'img/warning.svg', width: '24', height: '23', alt: '/!\\' }),
	            React.createElement(
	                'div',
	                null,
	                'A new version of Vector is available. Refresh your browser.'
	            )
	        );
	    }
	});


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'VectorCustomServerDialog',
	    statics: {
	        replaces: 'CustomServerDialog'
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_ErrorDialog' },
	            React.createElement(
	                'div',
	                { className: 'mx_Dialog_title' },
	                'Custom Server Options'
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_Dialog_content' },
	                React.createElement(
	                    'span',
	                    null,
	                    'You can use the custom server options to log into other Matrix servers by specifying a different Home server URL.',
	                    React.createElement('br', null),
	                    'This allows you to use Vector with an existing Matrix account on a different Home server.',
	                    React.createElement('br', null),
	                    React.createElement('br', null),
	                    'You can also set a custom Identity server but this will affect people\'s ability to find you if you use a server in a group other than the main Matrix.org group.'
	                )
	            ),
	            React.createElement(
	                'div',
	                { className: 'mx_Dialog_buttons' },
	                React.createElement(
	                    'button',
	                    { onClick: this.props.onFinished, autoFocus: true },
	                    'Dismiss'
	                )
	            )
	        );
	    }
	});


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'VectorLoginFooter',
	    statics: {
	        replaces: 'LoginFooter'
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_Login_links' },
	            React.createElement(
	                'a',
	                { href: 'https://medium.com/@Vector' },
	                'blog'
	            ),
	            '  ·  ',
	            React.createElement(
	                'a',
	                { href: 'https://twitter.com/@VectorCo' },
	                'twitter'
	            ),
	            '  ·  ',
	            React.createElement(
	                'a',
	                { href: 'https://github.com/vector-im/vector-web' },
	                'github'
	            ),
	            '  ·  ',
	            React.createElement(
	                'a',
	                { href: 'https://matrix.org' },
	                'powered by Matrix'
	            )
	        );
	    }
	});


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'VectorLoginHeader',
	    statics: {
	        replaces: 'LoginHeader'
	    },
	
	    render: function render() {
	        return React.createElement(
	            'div',
	            { className: 'mx_Login_logo' },
	            React.createElement('img', { src: 'img/logo.png', width: '249', height: '78', alt: 'vector' })
	        );
	    }
	});


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
	
	module.exports = React.createClass({
	    displayName: 'DateSeparator',
	    render: function render() {
	        var date = new Date(this.props.ts);
	        var today = new Date();
	        var yesterday = new Date();
	        yesterday.setDate(today.getDate() - 1);
	        var label;
	        if (date.toDateString() === today.toDateString()) {
	            label = "Today";
	        } else if (date.toDateString() === yesterday.toDateString()) {
	            label = "Yesterday";
	        } else if (today.getTime() - date.getTime() < 6 * 24 * 60 * 60 * 1000) {
	            label = days[date.getDay()];
	        } else {
	            label = date.toDateString();
	        }
	
	        return React.createElement(
	            'h2',
	            null,
	            label
	        );
	    }
	});


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var DateUtils = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/DateUtils\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'MessageTimestamp',
	
	    render: function render() {
	        var date = new Date(this.props.ts);
	        return React.createElement(
	            'span',
	            { className: 'mx_MessageTimestamp' },
	            DateUtils.formatDate(date)
	        );
	    }
	});


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'SenderProfile',
	
	    render: function render() {
	        var mxEvent = this.props.mxEvent;
	        var name = mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender();
	
	        var msgtype = mxEvent.getContent().msgtype;
	        if (msgtype && msgtype == 'm.emote') {
	            name = ''; // emote message must include the name so don't duplicate it
	        }
	        return React.createElement(
	            'span',
	            { className: 'mx_SenderProfile' },
	            name,
	            ' ',
	            this.props.aux
	        );
	    }
	});


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'BottomLeftMenuTile',
	
	    getInitialState: function getInitialState() {
	        return { hover: false };
	    },
	
	    onMouseEnter: function onMouseEnter() {
	        this.setState({ hover: true });
	    },
	
	    onMouseLeave: function onMouseLeave() {
	        this.setState({ hover: false });
	    },
	
	    render: function render() {
	        var label;
	        if (!this.props.collapsed) {
	            label = React.createElement(
	                'div',
	                { className: 'mx_RoomTile_name' },
	                this.props.label
	            );
	        } else if (this.state.hover) {
	            var RoomTooltip = sdk.getComponent("rooms.RoomTooltip");
	            label = React.createElement(RoomTooltip, { bottom: true, label: this.props.label });
	        }
	
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomTile', onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, onClick: this.props.onClick },
	            React.createElement(
	                'div',
	                { className: 'mx_RoomTile_avatar' },
	                React.createElement('img', { src: this.props.img, width: '26', height: '26' })
	            ),
	            label
	        );
	    }
	});


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	var MatrixClientPeg = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/MatrixClientPeg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var Modal = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/Modal\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var Resend = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/Resend\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'MessageContextMenu',
	
	    onResendClick: function onResendClick() {
	        Resend.resend(this.props.mxEvent);
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onViewSourceClick: function onViewSourceClick() {
	        var ViewSource = sdk.getComponent('structures.ViewSource');
	        Modal.createDialog(ViewSource, {
	            mxEvent: this.props.mxEvent
	        });
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onRedactClick: function onRedactClick() {
	        MatrixClientPeg.get().redactEvent(this.props.mxEvent.getRoomId(), this.props.mxEvent.getId()).done(function () {
	            // message should disappear by itself
	        }, function (e) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            // display error message stating you couldn't delete this.
	            var code = e.errcode || e.statusCode;
	            Modal.createDialog(ErrorDialog, {
	                title: "Error",
	                description: "You cannot delete this message. (" + code + ")"
	            });
	        });
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    onCancelSendClick: function onCancelSendClick() {
	        Resend.removeFromQueue(this.props.mxEvent);
	        if (this.props.onFinished) this.props.onFinished();
	    },
	
	    render: function render() {
	        var eventStatus = this.props.mxEvent.status;
	        var resendButton;
	        var viewSourceButton;
	        var redactButton;
	        var cancelButton;
	
	        if (eventStatus === 'not_sent') {
	            resendButton = React.createElement(
	                'div',
	                { className: 'mx_ContextualMenu_field', onClick: this.onResendClick },
	                'Resend'
	            );
	        }
	
	        if (!eventStatus) {
	            // sent
	            redactButton = React.createElement(
	                'div',
	                { className: 'mx_ContextualMenu_field', onClick: this.onRedactClick },
	                'Redact'
	            );
	        }
	
	        if (eventStatus === "queued" || eventStatus === "not_sent") {
	            cancelButton = React.createElement(
	                'div',
	                { className: 'mx_ContextualMenu_field', onClick: this.onCancelSendClick },
	                'Cancel Sending'
	            );
	        }
	
	        viewSourceButton = React.createElement(
	            'div',
	            { className: 'mx_ContextualMenu_field', onClick: this.onViewSourceClick },
	            'View Source'
	        );
	
	        return React.createElement(
	            'div',
	            null,
	            resendButton,
	            redactButton,
	            cancelButton,
	            viewSourceButton
	        );
	    }
	});


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var DragSource = __webpack_require__(42).DragSource;
	var DropTarget = __webpack_require__(42).DropTarget;
	
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var MatrixClientPeg = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/MatrixClientPeg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var RoomTile = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/components/views/rooms/RoomTile\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	/**
	 * Specifies the drag source contract.
	 * Only `beginDrag` function is required.
	 */
	var roomTileSource = {
	    canDrag: function canDrag(props, monitor) {
	        return props.roomSubList.props.editable;
	    },
	
	    beginDrag: function beginDrag(props) {
	        // Return the data describing the dragged item
	        var item = {
	            room: props.room,
	            originalList: props.roomSubList,
	            originalIndex: props.roomSubList.findRoomTile(props.room).index,
	            targetList: props.roomSubList };
	
	        // at first target is same as original
	        // lastTargetRoom: null,
	        // lastYOffset: null,
	        // lastYDelta: null,
	        if (props.roomSubList.debug) console.log("roomTile beginDrag for " + item.room.roomId);
	
	        // doing this 'correctly' with state causes react-dnd to break seemingly due to the state transitions
	        props.room._dragging = true;
	
	        return item;
	    },
	
	    endDrag: function endDrag(props, monitor, component) {
	        var item = monitor.getItem();
	
	        if (props.roomSubList.debug) console.log("roomTile endDrag for " + item.room.roomId + " with didDrop=" + monitor.didDrop());
	
	        props.room._dragging = false;
	        if (monitor.didDrop()) {
	            if (props.roomSubList.debug) console.log("force updating component " + item.targetList.props.label);
	            item.targetList.forceUpdate(); // as we're not using state
	        }
	
	        if (monitor.didDrop() && item.targetList.props.editable) {
	            // if we moved lists, remove the old tag
	            if (item.targetList !== item.originalList && item.originalList.props.tagName) {
	                // commented out attempts to set a spinner on our target component as component is actually
	                // the original source component being dragged, not our target.  To fix we just need to
	                // move all of this to endDrop in the target instead.  FIXME later.
	
	                //component.state.set({ spinner: component.state.spinner ? component.state.spinner++ : 1 });
	                MatrixClientPeg.get().deleteRoomTag(item.room.roomId, item.originalList.props.tagName)['finally'](function () {
	                    //component.state.set({ spinner: component.state.spinner-- });
	                }).fail(function (err) {
	                    var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                    Modal.createDialog(ErrorDialog, {
	                        title: "Failed to remove tag " + item.originalList.props.tagName + " from room",
	                        description: err.toString()
	                    });
	                });
	            }
	
	            var newOrder = {};
	            if (item.targetList.props.order === 'manual') {
	                newOrder['order'] = item.targetList.calcManualOrderTagData(item.room);
	            }
	
	            // if we moved lists or the ordering changed, add the new tag
	            if (item.targetList.props.tagName && (item.targetList !== item.originalList || newOrder)) {
	                //component.state.set({ spinner: component.state.spinner ? component.state.spinner++ : 1 });
	                MatrixClientPeg.get().setRoomTag(item.room.roomId, item.targetList.props.tagName, newOrder)['finally'](function () {
	                    //component.state.set({ spinner: component.state.spinner-- });
	                }).fail(function (err) {
	                    var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                    Modal.createDialog(ErrorDialog, {
	                        title: "Failed to add tag " + item.targetList.props.tagName + " to room",
	                        description: err.toString()
	                    });
	                });
	            }
	        } else {
	            // cancel the drop and reset our original position
	            if (props.roomSubList.debug) console.log("cancelling drop & drag");
	            props.roomSubList.moveRoomTile(item.room, item.originalIndex);
	            if (item.targetList && item.targetList !== item.originalList) {
	                item.targetList.removeRoomTile(item.room);
	            }
	        }
	    }
	};
	
	var roomTileTarget = {
	    canDrop: function canDrop() {
	        return false;
	    },
	
	    hover: function hover(props, monitor) {
	        var item = monitor.getItem();
	        //var off = monitor.getClientOffset();
	        // console.log("hovering on room " + props.room.roomId + ", isOver=" + monitor.isOver());
	
	        //console.log("item.targetList=" + item.targetList + ", roomSubList=" + props.roomSubList);
	
	        var switchedTarget = false;
	        if (item.targetList !== props.roomSubList) {
	            // we've switched target, so remove the tile from the previous target.
	            // n.b. the previous target might actually be the source list.
	            if (props.roomSubList.debug) console.log("switched target sublist");
	            switchedTarget = true;
	            item.targetList.removeRoomTile(item.room);
	            item.targetList = props.roomSubList;
	        }
	
	        if (!item.targetList.props.editable) return;
	
	        if (item.targetList.props.order === 'manual') {
	            if (item.room.roomId !== props.room.roomId && props.room !== item.lastTargetRoom) {
	                // find the offset of the target tile in the list.
	                var roomTile = props.roomSubList.findRoomTile(props.room);
	                // shuffle the list to add our tile to that position.
	                props.roomSubList.moveRoomTile(item.room, roomTile.index);
	            }
	
	            // stop us from flickering between our droptarget and the previous room.
	            // whenever the cursor changes direction we have to reset the flicker-damping.
	            /*            
	                        var yDelta = off.y - item.lastYOffset;
	            
	                        if ((yDelta > 0 && item.lastYDelta < 0) ||
	                            (yDelta < 0 && item.lastYDelta > 0))
	                        {
	                            // the cursor changed direction - forget our previous room
	                            item.lastTargetRoom = null;
	                        }
	                        else {
	                            // track the last room we were hovering over so we can stop
	                            // bouncing back and forth if the droptarget is narrower than
	                            // the other list items.  The other way to do this would be
	                            // to reduce the size of the hittarget on the list items, but
	                            // can't see an easy way to do that.
	                            item.lastTargetRoom = props.room;
	                        }
	            
	                        if (yDelta) item.lastYDelta = yDelta;
	                        item.lastYOffset = off.y;
	            */
	        } else if (switchedTarget) {
	                if (!props.roomSubList.findRoomTile(item.room).room) {
	                    // add to the list in the right place
	                    props.roomSubList.moveRoomTile(item.room, 0);
	                }
	                // we have to sort the list whatever to recalculate it
	                props.roomSubList.sortList();
	            }
	    }
	};
	
	// Export the wrapped version, inlining the 'collect' functions
	// to more closely resemble the ES7
	module.exports = DropTarget('RoomTile', roomTileTarget, function (connect, monitor) {
	    return {
	        // Call this function inside render()
	        // to let React DnD handle the drag events:
	        connectDropTarget: connect.dropTarget(),
	        isOver: monitor.isOver()
	    };
	})(DragSource('RoomTile', roomTileSource, function (connect, monitor) {
	    return {
	        // Call this function inside render()
	        // to let React DnD handle the drag events:
	        connectDragSource: connect.dragSource(),
	        // You can ask the monitor about the current drag state:
	        isDragging: monitor.isDragging()
	    };
	})(RoomTile));
	
	module.exports.replaces = 'RoomTile';


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	
	module.exports = React.createClass({
	    displayName: 'RoomDropTarget',
	
	    render: function render() {
	        if (this.props.placeholder) {
	            return React.createElement('div', { className: 'mx_RoomDropTarget mx_RoomDropTarget_placeholder' });
	        } else {
	            return React.createElement(
	                'div',
	                { className: 'mx_RoomDropTarget' },
	                React.createElement('div', { className: 'mx_RoomDropTarget_avatar' }),
	                React.createElement(
	                    'div',
	                    { className: 'mx_RoomDropTarget_label' },
	                    this.props.label
	                )
	            );
	        }
	    }
	});


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var ReactDOM = __webpack_require__(111);
	
	var dis = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/dispatcher\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	module.exports = React.createClass({
	    displayName: 'RoomTooltip',
	
	    componentDidMount: function componentDidMount() {
	        var tooltip = ReactDOM.findDOMNode(this);
	        if (!this.props.bottom) {
	            // tell the roomlist about us so it can position us
	            dis.dispatch({
	                action: 'view_tooltip',
	                tooltip: tooltip
	            });
	        } else {
	            tooltip.style.top = tooltip.parentElement.getBoundingClientRect().top + "px";
	            tooltip.style.display = "block";
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (!this.props.bottom) {
	            dis.dispatch({
	                action: 'view_tooltip',
	                tooltip: null
	            });
	        }
	    },
	
	    render: function render() {
	        var label = this.props.room ? this.props.room.name : this.props.label;
	        return React.createElement(
	            'div',
	            { className: 'mx_RoomTooltip' },
	            React.createElement('img', { className: 'mx_RoomTooltip_chevron', src: 'img/chevron-left.png', width: '9', height: '16' }),
	            label
	        );
	    }
	});


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	
	var React = __webpack_require__(2);
	var MatrixClientPeg = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/MatrixClientPeg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var classNames = __webpack_require__(181);
	
	module.exports = React.createClass({
	    displayName: 'SearchBar',
	
	    getInitialState: function getInitialState() {
	        return {
	            scope: 'Room'
	        };
	    },
	
	    onThisRoomClick: function onThisRoomClick() {
	        this.setState({ scope: 'Room' });
	    },
	
	    onAllRoomsClick: function onAllRoomsClick() {
	        this.setState({ scope: 'All' });
	    },
	
	    onSearchChange: function onSearchChange(e) {
	        if (e.keyCode === 13) {
	            // on enter...
	            this.onSearch();
	        }
	        if (e.keyCode === 27) {
	            // escape...
	            this.props.onCancelClick();
	        }
	    },
	
	    onSearch: function onSearch() {
	        this.props.onSearch(this.refs.search_term.value, this.state.scope);
	    },
	
	    render: function render() {
	        var searchButtonClasses = classNames({ mx_SearchBar_searchButton: true, mx_SearchBar_searching: this.props.searchInProgress });
	        var thisRoomClasses = classNames({ mx_SearchBar_button: true, mx_SearchBar_unselected: this.state.scope !== 'Room' });
	        var allRoomsClasses = classNames({ mx_SearchBar_button: true, mx_SearchBar_unselected: this.state.scope !== 'All' });
	
	        return React.createElement(
	            'div',
	            { className: 'mx_SearchBar' },
	            React.createElement('input', { ref: 'search_term', className: 'mx_SearchBar_input', type: 'text', autoFocus: true, placeholder: 'Search...', onKeyDown: this.onSearchChange }),
	            React.createElement(
	                'div',
	                { className: searchButtonClasses, onClick: this.onSearch },
	                React.createElement('img', { src: 'img/search-button.svg', width: '37', height: '37', alt: 'Search' })
	            ),
	            React.createElement(
	                'div',
	                { className: thisRoomClasses, onClick: this.onThisRoomClick },
	                'This Room'
	            ),
	            React.createElement(
	                'div',
	                { className: allRoomsClasses, onClick: this.onAllRoomsClick },
	                'All Rooms'
	            ),
	            React.createElement('img', { className: 'mx_SearchBar_cancel', src: 'img/cancel.svg', width: '18', height: '18', onClick: this.props.onCancelClick })
	        );
	    }
	});


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	
	'use strict';
	var React = __webpack_require__(2);
	var q = __webpack_require__(18);
	var sdk = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var MatrixClientPeg = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/MatrixClientPeg\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var UserSettingsStore = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/UserSettingsStore\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	var Modal = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"matrix-react-sdk/lib/Modal\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
	
	/**
	 * Enum for state of a push rule as defined by the Vector UI.
	 * @readonly
	 * @enum {string}
	 */
	var PushRuleVectorState = {
	    /** The user will receive push notification for this rule */
	    ON: "on",
	    /** The user will receive push notification for this rule with sound and
	        highlight if this is legitimate */
	    LOUD: "loud",
	    /** The push rule is disabled */
	    OFF: "off"
	};
	
	/**
	 * The descriptions of rules managed by the Vector UI.
	 * Each rule is described so that if the server does not have it in its default 
	 * rules or if the user wants to use actions ('PushRuleVectorState') that are 
	 * different from the hs one, the code will create a new rule that will override
	 * the hs one.
	 */
	var VectorPushRulesDefinitions = {
	
	    // Messages containing user's display name
	    // (skip contains_user_name which is too geeky)
	    "im.vector.rule.contains_display_name": {
	        kind: "underride",
	        hsDefaultRuleId: ".m.rule.contains_display_name",
	        description: "Messages containing my name",
	        conditions: [{
	            "kind": "contains_display_name"
	        }],
	        vectorStateToActions: { // The actions for each vector state
	            on: ["notify"],
	            loud: ["notify", {
	                "set_tweak": "sound",
	                "value": "default"
	            }, {
	                "set_tweak": "highlight"
	            }]
	        },
	        vectorStateToHsDefaultRuleEnabled: { // If it exists, the hs default push rule enabled expected value for each vector state
	            on: undefined, // ON (and its actions) does not corresponds to the default hs push rule, so NA
	            loud: true, // LOUD corresponds to the default rule when its enabled value is true
	            off: false // OFF corresponds to the default rule  when its enabled value is false
	        }
	    },
	
	    // Messages just sent to the user in a 1:1 room
	    "im.vector.rule.room_one_to_one": {
	        kind: "underride",
	        hsDefaultRuleId: ".m.rule.room_one_to_one",
	        description: "Messages in one-to-one chats",
	        conditions: [{
	            "is": "2",
	            "kind": "room_member_count"
	        }],
	        vectorStateToActions: {
	            on: ["notify"],
	            loud: ["notify", {
	                "set_tweak": "sound",
	                "value": "default"
	            }],
	            off: ["dont_notify"]
	        },
	        vectorStateToHsDefaultRuleEnabled: {
	            on: undefined,
	            loud: true,
	            off: undefined
	        }
	    },
	
	    // Messages just sent to a group chat room
	    // 1:1 room messages are catched by the .m.rule.room_one_to_one rule if any defined
	    // By opposition, all other room messages are from group chat rooms.
	    "im.vector.rule.room_message": {
	        kind: "underride",
	        description: "Messages in group chats",
	        conditions: [{
	            "pattern": "m.room.message",
	            "kind": "event_match",
	            "key": "type"
	        }],
	        hsDefaultRuleId: ".m.rule.message",
	        vectorStateToActions: {
	            on: ["notify"],
	            loud: ["notify", {
	                "set_tweak": "sound",
	                "value": "default"
	            }],
	            off: ["dont_notify"]
	        },
	        vectorStateToHsDefaultRuleEnabled: {
	            on: true,
	            loud: undefined,
	            off: undefined
	        }
	    },
	
	    // Invitation for the user
	    "im.vector.rule.invite_for_me": {
	        kind: "underride",
	        hsDefaultRuleId: ".m.rule.invite_for_me",
	        description: "When I'm invited to a room",
	        conditions: [{
	            "key": "type",
	            "kind": "event_match",
	            "pattern": "m.room.member"
	        }, {
	            "key": "content.membership",
	            "kind": "event_match",
	            "pattern": "invite"
	        }, {
	            "key": "state_key",
	            "kind": "event_match",
	            "pattern": "" // It is updated at runtime the user id
	        }],
	        vectorStateToActions: {
	            on: ["notify"],
	            loud: ["notify", {
	                "set_tweak": "sound",
	                "value": "default"
	            }]
	        },
	        vectorStateToHsDefaultRuleEnabled: {
	            on: undefined,
	            loud: true,
	            off: false
	        }
	    },
	
	    // When people join or leave a room
	    /*"im.vector.rule.member_event": {
	        hsDefaultRuleId: ".m.rule.member_event",
	        description: "When people join or leave a room",
	        conditions: [{
	            "pattern": "m.room.member",
	            "kind": "event_match",
	            "key": "type"
	        }],
	        vectorStateToActions: {
	            on: [
	                "notify"
	            ],
	            loud: [
	                "notify",
	                {
	                    "set_tweak": "sound",
	                    "value": "default"
	                }
	            ]
	        },
	        vectorStateToHsDefaultRuleEnabled: {
	            on: true,
	            loud: undefined,
	            off: false
	        }
	    },*/
	
	    // Incoming call
	    "im.vector.rule.call": {
	        kind: "underride",
	        hsDefaultRuleId: ".m.rule.call",
	        description: "Call invitation",
	        conditions: [{
	            "pattern": "m.room.member",
	            "kind": "event_match",
	            "key": "type"
	        }],
	        vectorStateToActions: {
	            on: ["notify"],
	            loud: ["notify", {
	                "set_tweak": "sound",
	                "value": "ring"
	            }]
	        },
	        vectorStateToHsDefaultRuleEnabled: {
	            on: undefined,
	            loud: true,
	            off: false
	        }
	    },
	
	    // Notifications from bots
	    "im.vector.rule.notices": {
	        kind: "override",
	        hsDefaultRuleId: ".m.rule.suppress_notices",
	        description: "Messages sent by bot",
	        conditions: [{
	            "kind": "event_match",
	            "key": "content.msgtype",
	            "pattern": "m.notice"
	        }],
	        vectorStateToActions: {
	            on: undefined, // ON for vector UI means that the .m.rule.suppress_notices rule is disabled.
	            loud: ["notify", {
	                "set_tweak": "sound",
	                "value": "ring"
	            }],
	            off: ["dont_notify"]
	        },
	        vectorStateToHsDefaultRuleEnabled: {
	            on: false, // .m.rule.suppress_notices is a "negative" rule, we have to invert its enabled value for vector UI
	            loud: undefined,
	            off: true
	        }
	    }
	};
	
	module.exports = React.createClass({
	    displayName: 'Notififications',
	
	    phases: {
	        LOADING: "LOADING", // The component is loading or sending data to the hs
	        DISPLAY: "DISPLAY", // The component is ready and display data
	        ERROR: "ERROR" // There was an error
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            phase: this.phases.LOADING,
	            masterPushRule: undefined, // The master rule ('.m.rule.master')
	            vectorPushRules: [], // HS default push rules displayed in Vector UI
	            vectorContentRules: { // Keyword push rules displayed in Vector UI
	                vectorState: PushRuleVectorState.ON,
	                rules: []
	            },
	            externalPushRules: [], // Push rules (except content rule) that have been defined outside Vector UI
	            externalContentRules: [] // Keyword push rules that have been defined outside Vector UI
	        };
	    },
	
	    componentWillMount: function componentWillMount() {
	        // Finalise the vector definitions
	        VectorPushRulesDefinitions["im.vector.rule.invite_for_me"].conditions[2].pattern = MatrixClientPeg.get().credentials.userId;
	
	        this._refreshFromServer();
	    },
	
	    onEnableNotificationsChange: function onEnableNotificationsChange(event) {
	        var self = this;
	        this.setState({
	            phase: this.phases.LOADING
	        });
	
	        MatrixClientPeg.get().setPushRuleEnabled('global', self.state.masterPushRule.kind, self.state.masterPushRule.rule_id, !event.target.checked).done(function () {
	            self._refreshFromServer();
	        });
	    },
	
	    onEnableDesktopNotificationsChange: function onEnableDesktopNotificationsChange(event) {
	        UserSettingsStore.setEnableNotifications(event.target.checked);
	    },
	
	    onNotifStateButtonClicked: function onNotifStateButtonClicked(event) {
	        var vectorRuleId = event.target.className.split("-")[0];
	        var newPushRuleVectorState = event.target.className.split("-")[1];
	
	        if ("_keywords" === vectorRuleId) {
	            this._setKeywordsPushRuleVectorState(newPushRuleVectorState);
	        } else {
	            var rule = this.getRule(vectorRuleId);
	            if (rule) {
	                this._setPushRuleVectorState(rule, newPushRuleVectorState);
	            }
	        }
	    },
	
	    onKeywordsClicked: function onKeywordsClicked(event) {
	        var self = this;
	
	        // Compute the keywords list to display
	        var keywords = [];
	        for (var i in this.state.vectorContentRules.rules) {
	            var rule = this.state.vectorContentRules.rules[i];
	            keywords.push(rule.pattern);
	        }
	        if (keywords.length) {
	            // As keeping the order of per-word push rules hs side is a bit tricky to code,
	            // display the keywords in alphabetical order to the user
	            keywords.sort();
	
	            keywords = keywords.join(", ");
	        } else {
	            keywords = "";
	        }
	
	        var TextInputDialog = sdk.getComponent("dialogs.TextInputDialog");
	        Modal.createDialog(TextInputDialog, {
	            title: "Keywords",
	            description: "Enter keywords separated by a comma:",
	            value: keywords,
	            onFinished: function onFinished(should_leave, newValue) {
	
	                if (should_leave && newValue !== keywords) {
	                    var newKeywords = newValue.split(',');
	                    for (var i in newKeywords) {
	                        newKeywords[i] = newKeywords[i].trim();
	                    }
	
	                    // Remove duplicates and empty
	                    newKeywords = newKeywords.reduce(function (array, keyword) {
	                        if (keyword !== "" && array.indexOf(keyword) < 0) {
	                            array.push(keyword);
	                        }
	                        return array;
	                    }, []);
	
	                    self._setKeywords(newKeywords);
	                }
	            }
	        });
	    },
	
	    getRule: function getRule(vectorRuleId) {
	        for (var i in this.state.vectorPushRules) {
	            var rule = this.state.vectorPushRules[i];
	            if (rule.vectorRuleId === vectorRuleId) {
	                return rule;
	            }
	        }
	    },
	
	    _actionsFor: function _actionsFor(pushRuleVectorState) {
	        if (pushRuleVectorState === PushRuleVectorState.ON) {
	            return ['notify'];
	        } else if (pushRuleVectorState === PushRuleVectorState.LOUD) {
	            return ['notify', { 'set_tweak': 'sound', 'value': 'default' }, { 'set_tweak': 'highlight', 'value': 'true' }];;
	        }
	    },
	
	    // Determine whether a content rule is in the PushRuleVectorState.ON category or in PushRuleVectorState.LOUD
	    // regardless of its enabled state. Returns undefined if it does not match these categories.
	    _contentRuleVectorStateKind: function _contentRuleVectorStateKind(rule) {
	        var stateKind;
	
	        // Count tweaks to determine if it is a ON or LOUD rule
	        var tweaks = 0;
	        for (var j in rule.actions) {
	            var action = rule.actions[j];
	            if (action.set_tweak === 'sound' || action.set_tweak === 'highlight' && action.value) {
	                tweaks++;
	            }
	        }
	        switch (tweaks) {
	            case 0:
	                stateKind = PushRuleVectorState.ON;
	                break;
	            case 2:
	                stateKind = PushRuleVectorState.LOUD;
	                break;
	        }
	        return stateKind;
	    },
	
	    _setPushRuleVectorState: function _setPushRuleVectorState(rule, newPushRuleVectorState) {
	        if (rule && rule.vectorState !== newPushRuleVectorState) {
	
	            this.setState({
	                phase: this.phases.LOADING
	            });
	
	            var self = this;
	            var cli = MatrixClientPeg.get();
	            var deferreds = [];
	            var ruleDefinition = VectorPushRulesDefinitions[rule.vectorRuleId];
	
	            if (rule.rule) {
	                if (undefined !== ruleDefinition.vectorStateToHsDefaultRuleEnabled[newPushRuleVectorState] && rule.hsDefaultRule) {
	                    // The new state corresponds to the default hs rule
	                    // Enable or disable it according to the rule definition
	                    deferreds.push(cli.setPushRuleEnabled('global', rule.hsDefaultRule.kind, ruleDefinition.hsDefaultRuleId, ruleDefinition.vectorStateToHsDefaultRuleEnabled[newPushRuleVectorState]));
	
	                    // Remove the vector rule if any
	                    if (!rule.isHSDefaultRule) {
	                        deferreds.push(cli.deletePushRule('global', rule.rule.kind, rule.rule.rule_id));
	                    }
	                } else {
	                    // The new state (and its implied actions) does not correspond to a default hs rule
	                    // or the HS does not expose this default rule.
	                    if (rule.isHSDefaultRule) {
	                        // Create a new rule that will override the default one
	                        deferreds.push(this._addOverridingVectorPushRule(rule.vectorRuleId, newPushRuleVectorState));
	                    } else {
	                        // Change the actions of the existing overriding Vector rule
	                        deferreds.push(this._updatePushRuleActions(rule.rule, ruleDefinition.vectorStateToActions[newPushRuleVectorState]));
	                    }
	                }
	            } else {
	                // This is a Vector rule which does not exist yet server side
	                // Create it
	                deferreds.push(this._addOverridingVectorPushRule(rule.vectorRuleId, newPushRuleVectorState));
	            }
	
	            q.all(deferreds).done(function () {
	                self._refreshFromServer();
	            }, function (error) {
	                var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	                Modal.createDialog(ErrorDialog, {
	                    title: "Can't change settings",
	                    description: error.toString(),
	                    onFinished: self._refreshFromServer
	                });
	            });
	        }
	    },
	
	    _setKeywordsPushRuleVectorState: function _setKeywordsPushRuleVectorState(newPushRuleVectorState) {
	        // Is there really a change?
	        if (this.state.vectorContentRules.vectorState === newPushRuleVectorState || this.state.vectorContentRules.rules.length === 0) {
	            return;
	        }
	
	        var self = this;
	        var cli = MatrixClientPeg.get();
	
	        this.setState({
	            phase: this.phases.LOADING
	        });
	
	        // Update all rules in self.state.vectorContentRules
	        var deferreds = [];
	        for (var i in this.state.vectorContentRules.rules) {
	            var rule = this.state.vectorContentRules.rules[i];
	
	            var enabled, actions;
	            switch (newPushRuleVectorState) {
	                case PushRuleVectorState.ON:
	                    if (rule.actions.length !== 1) {
	                        actions = this._actionsFor(PushRuleVectorState.ON);
	                    }
	
	                    if (this.state.vectorContentRules.vectorState === PushRuleVectorState.OFF) {
	                        enabled = true;
	                    }
	                    break;
	
	                case PushRuleVectorState.LOUD:
	                    if (rule.actions.length !== 3) {
	                        actions = this._actionsFor(PushRuleVectorState.LOUD);
	                    }
	
	                    if (this.state.vectorContentRules.vectorState === PushRuleVectorState.OFF) {
	                        enabled = true;
	                    }
	                    break;
	
	                case PushRuleVectorState.OFF:
	                    enabled = false;
	                    break;
	            }
	
	            if (actions) {
	                // Note that the workaround in _updatePushRuleActions will automatically
	                // enable the rule
	                deferreds.push(this._updatePushRuleActions(rule, actions, enabled));
	            } else if (enabled != undefined) {
	                deferreds.push(cli.setPushRuleEnabled('global', rule.kind, rule.rule_id, enabled));
	            }
	        }
	
	        q.all(deferreds).done(function (resps) {
	            self._refreshFromServer();
	        }, function (error) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Can't update user notification settings",
	                description: error.toString(),
	                onFinished: self._refreshFromServer
	            });
	        });
	    },
	
	    _setKeywords: function _setKeywords(newKeywords) {
	        this.setState({
	            phase: this.phases.LOADING
	        });
	
	        var self = this;
	        var cli = MatrixClientPeg.get();
	        var removeDeferreds = [];
	
	        // Remove per-word push rules of keywords that are no more in the list
	        var vectorContentRulesPatterns = [];
	        for (var i in self.state.vectorContentRules.rules) {
	            var rule = self.state.vectorContentRules.rules[i];
	
	            vectorContentRulesPatterns.push(rule.pattern);
	
	            if (newKeywords.indexOf(rule.pattern) < 0) {
	                removeDeferreds.push(cli.deletePushRule('global', rule.kind, rule.rule_id));
	            }
	        }
	
	        // If the keyword is part of `externalContentRules`, remove the rule
	        // before recreating it in the right Vector path
	        for (var i in self.state.externalContentRules) {
	            var rule = self.state.externalContentRules[i];
	
	            if (newKeywords.indexOf(rule.pattern) >= 0) {
	                removeDeferreds.push(cli.deletePushRule('global', rule.kind, rule.rule_id));
	            }
	        }
	
	        var onError = function onError(error) {
	            var ErrorDialog = sdk.getComponent("dialogs.ErrorDialog");
	            Modal.createDialog(ErrorDialog, {
	                title: "Can't update keywords",
	                description: error.toString(),
	                onFinished: self._refreshFromServer
	            });
	        };
	
	        // Then, add the new ones
	        q.all(removeDeferreds).done(function (resps) {
	            var deferreds = [];
	
	            var pushRuleVectorStateKind = self.state.vectorContentRules.vectorState;
	            if (pushRuleVectorStateKind === PushRuleVectorState.OFF) {
	                // When the current global keywords rule is OFF, we need to look at
	                // the flavor of rules in 'vectorContentRules' to apply the same actions
	                // when creating the new rule.
	                // Thus, this new rule will join the 'vectorContentRules' set.
	                if (self.state.vectorContentRules.rules.length) {
	                    pushRuleVectorStateKind = self._contentRuleVectorStateKind(self.state.vectorContentRules.rules[0]);
	                } else {
	                    // ON is default
	                    pushRuleVectorStateKind = PushRuleVectorState.ON;
	                }
	            }
	
	            for (var i in newKeywords) {
	                var keyword = newKeywords[i];
	
	                if (vectorContentRulesPatterns.indexOf(keyword) < 0) {
	                    if (self.state.vectorContentRules.vectorState !== PushRuleVectorState.OFF) {
	                        deferreds.push(cli.addPushRule('global', 'content', keyword, {
	                            actions: self._actionsFor(pushRuleVectorStateKind),
	                            pattern: keyword
	                        }));
	                    } else {
	                        deferreds.push(self._addDisabledPushRule('global', 'content', keyword, {
	                            actions: self._actionsFor(pushRuleVectorStateKind),
	                            pattern: keyword
	                        }));
	                    }
	                }
	            }
	
	            q.all(deferreds).done(function (resps) {
	                self._refreshFromServer();
	            }, onError);
	        }, onError);
	    },
	
	    // Create a push rule but disabled
	    _addDisabledPushRule: function _addDisabledPushRule(scope, kind, ruleId, body) {
	        var cli = MatrixClientPeg.get();
	        var deferred = q.defer();
	
	        cli.addPushRule(scope, kind, ruleId, body).done(function () {
	            cli.setPushRuleEnabled(scope, kind, ruleId, false).done(function () {
	                deferred.resolve();
	            }, function (err) {
	                deferred.reject(err);
	            });
	        }, function (err) {
	            deferred.reject(err);
	        });
	
	        return deferred.promise;
	    },
	
	    // Add a push rule server side according to the 'VectorPushRulesDefinitions' spec
	    _addOverridingVectorPushRule: function _addOverridingVectorPushRule(vectorRuleId, vectorState) {
	        var self = this;
	
	        // Create the rule as predefined
	        var ruleDefinition = VectorPushRulesDefinitions[vectorRuleId];
	        var body = {
	            conditions: ruleDefinition.conditions,
	            actions: ruleDefinition.vectorStateToActions[vectorState]
	        };
	
	        return MatrixClientPeg.get().addPushRule('global', ruleDefinition.kind, vectorRuleId, body);
	    },
	
	    _refreshFromServer: function _refreshFromServer() {
	        var self = this;
	        MatrixClientPeg.get().getPushRules().done(function (rulesets) {
	            MatrixClientPeg.get().pushRules = rulesets;
	
	            // Get homeserver default rules and triage them by categories
	            var rule_categories = {
	                // The master rule (all notifications disabling)
	                '.m.rule.master': 'master',
	
	                // The default push rules displayed by Vector UI
	                // XXX: .m.rule.contains_user_name is not managed (not a fancy rule for Vector?)
	                '.m.rule.contains_display_name': 'vector',
	                '.m.rule.room_one_to_one': 'vector',
	                '.m.rule.message': 'vector',
	                '.m.rule.invite_for_me': 'vector',
	                //'.m.rule.member_event': 'vector',
	                '.m.rule.call': 'vector',
	                '.m.rule.suppress_notices': 'vector'
	
	                // Others go to others
	            };
	
	            // HS default rules
	            var defaultRules = { master: [], vector: {}, others: [] };
	            // Push rules defined py Vector to override hs default rules
	            var vectorOverridingRules = {};
	            //  Content/keyword rules
	            var contentRules = { on: [], on_but_disabled: [], loud: [], loud_but_disabled: [], other: [] };
	
	            for (var kind in rulesets.global) {
	                for (var i = 0; i < Object.keys(rulesets.global[kind]).length; ++i) {
	                    var r = rulesets.global[kind][i];
	                    var cat = rule_categories[r.rule_id];
	                    r.kind = kind;
	                    if (r.rule_id[0] === '.') {
	                        if (cat) {
	                            if (cat === 'vector') {
	                                // Remove disabled, useless actions
	                                r.actions = r.actions.reduce(function (array, action) {
	                                    if (action.value !== false) {
	                                        array.push(action);
	                                    }
	                                    return array;
	                                }, []);
	
	                                defaultRules.vector[r.rule_id] = r;
	                            } else {
	                                defaultRules[cat].push(r);
	                            }
	                        } else {
	                            defaultRules['others'].push(r);
	                        }
	                    } else if (r.rule_id.startsWith('im.vector')) {
	                        vectorOverridingRules[r.rule_id] = r;
	                    } else if (kind === 'content') {
	                        switch (self._contentRuleVectorStateKind(r)) {
	                            case PushRuleVectorState.ON:
	                                if (r.enabled) {
	                                    contentRules.on.push(r);
	                                } else {
	                                    contentRules.on_but_disabled.push(r);
	                                }
	                                break;
	                            case PushRuleVectorState.LOUD:
	                                if (r.enabled) {
	                                    contentRules.loud.push(r);
	                                } else {
	                                    contentRules.loud_but_disabled.push(r);
	                                }
	                                break;
	                            default:
	                                contentRules.other.push(r);
	                                break;
	                        }
	                    }
	                }
	            }
	
	            // Decide which content rules to display in Vector UI.
	            // Vector displays a single global rule for a list of keywords
	            // whereas Matrix has a push rule per keyword.
	            // Vector can set the unique rule in ON, LOUD or OFF state.
	            // Matrix has enabled/disabled plus a combination of (highlight, sound) tweaks.
	
	            // The code below determines which set of user's content push rules can be
	            // displayed by the vector UI.
	            // Push rules that does not fit, ie defined by another Matrix client, ends
	            // in self.state.externalContentRules.
	            // There is priority in the determination of which set will be the displayed one.
	            // The set with rules that have LOUD tweaks is the first choice. Then, the ones
	            // with ON tweaks (no tweaks).
	            if (contentRules.loud.length) {
	                self.state.vectorContentRules = {
	                    vectorState: PushRuleVectorState.LOUD,
	                    rules: contentRules.loud
	                };
	                self.state.externalContentRules = [].concat(contentRules.loud_but_disabled, contentRules.on, contentRules.on_but_disabled, contentRules.other);
	            } else if (contentRules.loud_but_disabled.length) {
	                self.state.vectorContentRules = {
	                    vectorState: PushRuleVectorState.OFF,
	                    rules: contentRules.loud_but_disabled
	                };
	                self.state.externalContentRules = [].concat(contentRules.on, contentRules.on_but_disabled, contentRules.other);
	            } else if (contentRules.on.length) {
	                self.state.vectorContentRules = {
	                    vectorState: PushRuleVectorState.ON,
	                    rules: contentRules.on
	                };
	                self.state.externalContentRules = [].concat(contentRules.on_but_disabled, contentRules.other);
	            } else if (contentRules.on_but_disabled.length) {
	                self.state.vectorContentRules = {
	                    vectorState: PushRuleVectorState.OFF,
	                    rules: contentRules.on_but_disabled
	                };
	                self.state.externalContentRules = contentRules.other;
	            } else {
	                self.state.externalContentRules = contentRules.other;
	            }
	
	            // Get the master rule if any defined by the hs
	            if (defaultRules.master.length > 0) {
	                self.state.masterPushRule = defaultRules.master[0];
	            }
	
	            // Build the rules displayed in the Vector UI matrix table
	            self.state.vectorPushRules = [];
	
	            var vectorRuleIds = ['im.vector.rule.contains_display_name', '_keywords', 'im.vector.rule.room_one_to_one', 'im.vector.rule.room_message', 'im.vector.rule.invite_for_me',
	            //'im.vector.rule.member_event',
	            'im.vector.rule.call', 'im.vector.rule.notices'];
	            for (var i in vectorRuleIds) {
	                var vectorRuleId = vectorRuleIds[i];
	                var ruleDefinition = VectorPushRulesDefinitions[vectorRuleId];
	
	                if (vectorRuleId === '_keywords') {
	                    // keywords needs a special handling
	                    // For Vector UI, this is a single global push rule but translated in Matrix,
	                    // it corresponds to all content push rules (stored in self.state.vectorContentRule)
	                    self.state.vectorPushRules.push({
	                        "vectorRuleId": "_keywords",
	                        "description": React.createElement(
	                            'span',
	                            null,
	                            'Messages containing ',
	                            React.createElement(
	                                'span',
	                                { className: 'mx_UserNotifSettings_keywords', onClick: self.onKeywordsClicked },
	                                'keywords'
	                            )
	                        ),
	                        "vectorState": self.state.vectorContentRules.vectorState
	                    });
	                } else {
	                    var rule = vectorOverridingRules[vectorRuleId];
	                    var isHSDefaultRule = false;
	                    if (!rule) {
	                        // If the rule is not defined, look at the hs default one
	                        rule = defaultRules.vector[ruleDefinition.hsDefaultRuleId];
	                        isHSDefaultRule = true;
	                    }
	
	                    // Translate the rule actions and its enabled value into vector state
	                    var vectorState;
	                    if (rule) {
	                        for (var stateKey in PushRuleVectorState) {
	                            var state = PushRuleVectorState[stateKey];
	                            var vectorStateToActions = ruleDefinition.vectorStateToActions[state];
	
	                            if (!vectorStateToActions) {
	                                // No defined actions means that this vector state expects a disabled default hs rule
	                                if (isHSDefaultRule && rule.enabled === ruleDefinition.vectorStateToHsDefaultRuleEnabled[state]) {
	                                    vectorState = state;
	                                    break;
	                                }
	                            } else {
	                                // The actions must match to the ones expected by vector state
	                                if (JSON.stringify(rule.actions) === JSON.stringify(vectorStateToActions)) {
	                                    if (isHSDefaultRule) {
	                                        // In the case of a default hs push rule, the enabled value must also match
	                                        if (rule.enabled === ruleDefinition.vectorStateToHsDefaultRuleEnabled[state]) {
	                                            vectorState = state;
	                                            break;
	                                        }
	                                    } else {
	                                        vectorState = state;
	                                        break;
	                                    }
	                                }
	                            }
	                        }
	
	                        if (!vectorState) {
	                            console.error("Cannot translate rule actions into Vector rule state. Rule: " + rule);
	                            vectorState = PushRuleVectorState.OFF;
	                        }
	                    } else {
	                        vectorState = PushRuleVectorState.OFF;
	                    }
	
	                    self.state.vectorPushRules.push({
	                        "vectorRuleId": vectorRuleId,
	                        "description": ruleDefinition.description,
	                        "rule": rule,
	                        "vectorState": vectorState,
	                        "isHSDefaultRule": isHSDefaultRule,
	                        "hsDefaultRule": defaultRules.vector[ruleDefinition.hsDefaultRuleId]
	                    });
	                }
	            }
	
	            // Build the rules not managed by Vector UI
	            var otherRulesDescriptions = {
	                '.m.rule.message': "Notify for all other messages/rooms",
	                '.m.rule.fallback': "Notify me for anything else"
	            };
	
	            self.state.externalPushRules = [];
	            for (var i in defaultRules.others) {
	                var rule = defaultRules.others[i];
	                var ruleDescription = otherRulesDescriptions[rule.rule_id];
	
	                // Show enabled default rules that was modified by the user
	                if (ruleDescription && rule.enabled && !rule['default']) {
	                    rule.description = ruleDescription;
	                    self.state.externalPushRules.push(rule);
	                }
	            }
	
	            self.setState({
	                phase: self.phases.DISPLAY
	            });
	        });
	    },
	
	    _updatePushRuleActions: function _updatePushRuleActions(rule, actions, enabled) {
	        // Workaround for SYN-590 : Push rule update fails
	        // Remove the rule and recreate it with the new actions
	        var cli = MatrixClientPeg.get();
	        var deferred = q.defer();
	
	        cli.deletePushRule('global', rule.kind, rule.rule_id).done(function () {
	            cli.addPushRule('global', rule.kind, rule.rule_id, {
	                conditions: rule.conditions,
	                actions: actions,
	                pattern: rule.pattern
	            }).done(function () {
	
	                // Then, if requested, enabled or disabled the rule
	                if (undefined != enabled) {
	                    cli.setPushRuleEnabled('global', rule.kind, rule.rule_id, enabled).done(function () {
	                        deferred.resolve();
	                    }, function (err) {
	                        deferred.reject(err);
	                    });
	                } else {
	                    deferred.resolve();
	                }
	            }, function (err) {
	                deferred.reject(err);
	            });
	        }, function (err) {
	            deferred.reject(err);
	        });
	
	        return deferred.promise;
	    },
	
	    renderNotifRulesTableRow: function renderNotifRulesTableRow(title, className, pushRuleVectorState) {
	        return React.createElement(
	            'tr',
	            { key: className },
	            React.createElement(
	                'th',
	                null,
	                title
	            ),
	            React.createElement(
	                'th',
	                null,
	                React.createElement('input', { className: className + "-" + PushRuleVectorState.ON,
	                    type: 'radio',
	                    checked: pushRuleVectorState === PushRuleVectorState.ON,
	                    onChange: this.onNotifStateButtonClicked })
	            ),
	            React.createElement(
	                'th',
	                null,
	                React.createElement('input', { className: className + "-" + PushRuleVectorState.LOUD,
	                    type: 'radio',
	                    checked: pushRuleVectorState === PushRuleVectorState.LOUD,
	                    onChange: this.onNotifStateButtonClicked })
	            ),
	            React.createElement(
	                'th',
	                null,
	                React.createElement('input', { className: className + "-" + PushRuleVectorState.OFF,
	                    type: 'radio',
	                    checked: pushRuleVectorState === PushRuleVectorState.OFF,
	                    onChange: this.onNotifStateButtonClicked })
	            )
	        );
	    },
	
	    renderNotifRulesTableRows: function renderNotifRulesTableRows() {
	        var rows = [];
	        for (var i in this.state.vectorPushRules) {
	            var rule = this.state.vectorPushRules[i];
	            rows.push(this.renderNotifRulesTableRow(rule.description, rule.vectorRuleId, rule.vectorState));
	        }
	        return rows;
	    },
	
	    render: function render() {
	        var self = this;
	
	        if (this.state.phase === this.phases.LOADING) {
	            var Loader = sdk.getComponent("elements.Spinner");
	            return React.createElement(
	                'div',
	                { className: 'mx_UserSettings_notifTable' },
	                React.createElement(Loader, null)
	            );
	        }
	
	        if (this.state.masterPushRule) {
	            var masterPushRuleDiv = React.createElement(
	                'div',
	                { className: 'mx_UserNotifSettings_tableRow' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_inputCell' },
	                    React.createElement('input', { id: 'enableNotifications',
	                        ref: 'enableNotifications',
	                        type: 'checkbox',
	                        checked: !this.state.masterPushRule.enabled,
	                        onChange: this.onEnableNotificationsChange })
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_labelCell' },
	                    React.createElement(
	                        'label',
	                        { htmlFor: 'enableNotifications' },
	                        'Enable notifications'
	                    )
	                )
	            );
	        }
	
	        // When enabled, the master rule inhibits all existing rules
	        // So do not show all notification settings
	        if (this.state.masterPushRule.enabled) {
	            return React.createElement(
	                'div',
	                null,
	                masterPushRuleDiv,
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserSettings_notifTable' },
	                    'All notifications are currently disabled for all devices.'
	                )
	            );
	        }
	
	        // Build external push rules
	        var externalRules = [];
	        for (var i in this.state.externalPushRules) {
	            var rule = this.state.externalPushRules[i];
	            externalRules.push(React.createElement(
	                'li',
	                null,
	                rule.description
	            ));
	        }
	
	        // Show keywords not displayed by the vector UI as a single external push rule
	        var externalKeyWords = [];
	        for (var i in this.state.externalContentRules) {
	            var rule = this.state.externalContentRules[i];
	            externalKeyWords.push(rule.pattern);
	        }
	        if (externalKeyWords.length) {
	            externalKeyWords = externalKeyWords.join(", ");
	            externalRules.push(React.createElement(
	                'li',
	                null,
	                'Notifications on the following keywords follow rules which can’t be displayed here: ',
	                externalKeyWords
	            ));
	        }
	
	        var advancedSettings;
	        if (externalRules.length) {
	            advancedSettings = React.createElement(
	                'div',
	                null,
	                React.createElement(
	                    'h3',
	                    null,
	                    'Advanced notifications settings'
	                ),
	                'There are advanced notifications which are not shown here.',
	                React.createElement('br', null),
	                'You might have configured them in another client than Vector. You cannot tune them in Vector but they still apply.',
	                React.createElement(
	                    'ul',
	                    null,
	                    externalRules
	                )
	            );
	        }
	
	        return React.createElement(
	            'div',
	            null,
	            masterPushRuleDiv,
	            React.createElement(
	                'div',
	                { className: 'mx_UserSettings_notifTable' },
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_tableRow' },
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserNotifSettings_inputCell' },
	                        React.createElement('input', { id: 'enableDesktopNotifications',
	                            ref: 'enableDesktopNotifications',
	                            type: 'checkbox',
	                            checked: UserSettingsStore.getEnableNotifications(),
	                            onChange: this.onEnableDesktopNotificationsChange })
	                    ),
	                    React.createElement(
	                        'div',
	                        { className: 'mx_UserNotifSettings_labelCell' },
	                        React.createElement(
	                            'label',
	                            { htmlFor: 'enableDesktopNotifications' },
	                            'Enable desktop notifications'
	                        )
	                    )
	                ),
	                React.createElement(
	                    'h3',
	                    null,
	                    'General use'
	                ),
	                React.createElement(
	                    'div',
	                    { className: 'mx_UserNotifSettings_pushRulesTableWrapper' },
	                    React.createElement(
	                        'table',
	                        { className: 'mx_UserNotifSettings_pushRulesTable' },
	                        React.createElement(
	                            'thead',
	                            null,
	                            React.createElement(
	                                'tr',
	                                null,
	                                React.createElement('th', { width: '55%' }),
	                                React.createElement(
	                                    'th',
	                                    { width: '15%' },
	                                    'On'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { width: '15%' },
	                                    'Loud'
	                                ),
	                                React.createElement(
	                                    'th',
	                                    { width: '15%' },
	                                    'Off'
	                                )
	                            )
	                        ),
	                        React.createElement(
	                            'tbody',
	                            null,
	                            this.renderNotifRulesTableRows()
	                        )
	                    )
	                ),
	                advancedSettings
	            )
	        );
	    }
	});


/***/ },
/* 179 */
/***/ function(module, exports) {

	/*! modernizr 3.1.0 (Custom Build) | MIT *
	 * http://modernizr.com/download/?-displaytable-es5-flexbox-localstorage-objectfit-cssclassprefix:modernizr_ !*/
	"use strict";
	
	!(function (window, document, undefined) {
	  function is(e, t) {
	    return typeof e === t;
	  }function testRunner() {
	    var e, t, r, n, o, s, i;for (var d in tests) {
	      if ((e = [], t = tests[d], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length))) for (r = 0; r < t.options.aliases.length; r++) e.push(t.options.aliases[r].toLowerCase());for (n = is(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) s = e[o], i = s.split("."), 1 === i.length ? Modernizr[i[0]] = n : (!Modernizr[i[0]] || Modernizr[i[0]] instanceof Boolean || (Modernizr[i[0]] = new Boolean(Modernizr[i[0]])), Modernizr[i[0]][i[1]] = n), classes.push((n ? "" : "no-") + i.join("-"));
	    }
	  }function setClasses(e) {
	    var t = docElement.className,
	        r = Modernizr._config.classPrefix || "";if ((isSVG && (t = t.baseVal), Modernizr._config.enableJSClass)) {
	      var n = new RegExp("(^|\\s)" + r + "no-js(\\s|$)");t = t.replace(n, "$1" + r + "js$2");
	    }Modernizr._config.enableClasses && (t += " " + r + e.join(" " + r), isSVG ? docElement.className.baseVal = t : docElement.className = t);
	  }function createElement() {
	    return "function" != typeof document.createElement ? document.createElement(arguments[0]) : isSVG ? document.createElementNS.call(document, "http://www.w3.org/2000/svg", arguments[0]) : document.createElement.apply(document, arguments);
	  }function getBody() {
	    var e = document.body;return e || (e = createElement(isSVG ? "svg" : "body"), e.fake = !0), e;
	  }function injectElementWithStyles(e, t, r, n) {
	    var o,
	        s,
	        i,
	        d,
	        a = "modernizr",
	        l = createElement("div"),
	        c = getBody();if (parseInt(r, 10)) for (; r--;) i = createElement("div"), i.id = n ? n[r] : a + (r + 1), l.appendChild(i);return o = createElement("style"), o.type = "text/css", o.id = "s" + a, (c.fake ? c : l).appendChild(o), c.appendChild(l), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e)), l.id = a, c.fake && (c.style.background = "", c.style.overflow = "hidden", d = docElement.style.overflow, docElement.style.overflow = "hidden", docElement.appendChild(c)), s = t(l, e), c.fake ? (c.parentNode.removeChild(c), docElement.style.overflow = d, docElement.offsetHeight) : l.parentNode.removeChild(l), !!s;
	  }function contains(e, t) {
	    return !! ~("" + e).indexOf(t);
	  }function domToCSS(e) {
	    return e.replace(/([A-Z])/g, function (e, t) {
	      return "-" + t.toLowerCase();
	    }).replace(/^ms-/, "-ms-");
	  }function nativeTestProps(e, t) {
	    var r = e.length;if ("CSS" in window && "supports" in window.CSS) {
	      for (; r--;) if (window.CSS.supports(domToCSS(e[r]), t)) return !0;return !1;
	    }if ("CSSSupportsRule" in window) {
	      for (var n = []; r--;) n.push("(" + domToCSS(e[r]) + ":" + t + ")");return n = n.join(" or "), injectElementWithStyles("@supports (" + n + ") { #modernizr { position: absolute; } }", function (e) {
	        return "absolute" == getComputedStyle(e, null).position;
	      });
	    }return undefined;
	  }function cssToDOM(e) {
	    return e.replace(/([a-z])-([a-z])/g, function (e, t, r) {
	      return t + r.toUpperCase();
	    }).replace(/^-/, "");
	  }function testProps(e, t, r, n) {
	    function o() {
	      i && (delete mStyle.style, delete mStyle.modElem);
	    }if ((n = is(n, "undefined") ? !1 : n, !is(r, "undefined"))) {
	      var s = nativeTestProps(e, r);if (!is(s, "undefined")) return s;
	    }for (var i, d, a, l, c, f = ["modernizr", "tspan"]; !mStyle.style;) i = !0, mStyle.modElem = createElement(f.shift()), mStyle.style = mStyle.modElem.style;for (a = e.length, d = 0; a > d; d++) if ((l = e[d], c = mStyle.style[l], contains(l, "-") && (l = cssToDOM(l)), mStyle.style[l] !== undefined)) {
	      if (n || is(r, "undefined")) return o(), "pfx" == t ? l : !0;try {
	        mStyle.style[l] = r;
	      } catch (u) {}if (mStyle.style[l] != c) return o(), "pfx" == t ? l : !0;
	    }return o(), !1;
	  }function fnBind(e, t) {
	    return function () {
	      return e.apply(t, arguments);
	    };
	  }function testDOMProps(e, t, r) {
	    var n;for (var o in e) if (e[o] in t) return r === !1 ? e[o] : (n = t[e[o]], is(n, "function") ? fnBind(n, r || t) : n);return !1;
	  }function testPropsAll(e, t, r, n, o) {
	    var s = e.charAt(0).toUpperCase() + e.slice(1),
	        i = (e + " " + cssomPrefixes.join(s + " ") + s).split(" ");return is(t, "string") || is(t, "undefined") ? testProps(i, t, n, o) : (i = (e + " " + domPrefixes.join(s + " ") + s).split(" "), testDOMProps(i, t, r));
	  }function testAllProps(e, t, r) {
	    return testPropsAll(e, undefined, undefined, t, r);
	  }var tests = [],
	      ModernizrProto = { _version: "3.1.0", _config: { classPrefix: "modernizr_", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {
	      var r = this;setTimeout(function () {
	        t(r[e]);
	      }, 0);
	    }, addTest: function addTest(e, t, r) {
	      tests.push({ name: e, fn: t, options: r });
	    }, addAsyncTest: function addAsyncTest(e) {
	      tests.push({ name: null, fn: e });
	    } },
	      Modernizr = function Modernizr() {};Modernizr.prototype = ModernizrProto, Modernizr = new Modernizr();var classes = [],
	      docElement = document.documentElement,
	      isSVG = "svg" === docElement.nodeName.toLowerCase(),
	      testStyles = ModernizrProto.testStyles = injectElementWithStyles;testStyles("#modernizr{display: table; direction: ltr}#modernizr div{display: table-cell; padding: 10px}", function (e) {
	    var t,
	        r = e.childNodes;t = r[0].offsetLeft < r[1].offsetLeft, Modernizr.addTest("displaytable", t, { aliases: ["display-table"] });
	  }, 2);var omPrefixes = "Moz O ms Webkit",
	      cssomPrefixes = ModernizrProto._config.usePrefixes ? omPrefixes.split(" ") : [];ModernizrProto._cssomPrefixes = cssomPrefixes;var modElem = { elem: createElement("modernizr") };Modernizr._q.push(function () {
	    delete modElem.elem;
	  });var mStyle = { style: modElem.elem.style };Modernizr._q.unshift(function () {
	    delete mStyle.style;
	  });var domPrefixes = ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(" ") : [];ModernizrProto._domPrefixes = domPrefixes, ModernizrProto.testAllProps = testPropsAll, ModernizrProto.testAllProps = testAllProps, Modernizr.addTest("flexbox", testAllProps("flexBasis", "1px", !0)), Modernizr.addTest("es5array", function () {
	    return !!(Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray);
	  }), Modernizr.addTest("es5date", function () {
	    var e = "2013-04-12T06:06:37.307Z",
	        t = !1;try {
	      t = !!Date.parse(e);
	    } catch (r) {}return !!(Date.now && Date.prototype && Date.prototype.toISOString && Date.prototype.toJSON && t);
	  }), Modernizr.addTest("es5function", function () {
	    return !(!Function.prototype || !Function.prototype.bind);
	  }), Modernizr.addTest("es5object", function () {
	    return !!(Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions);
	  }), Modernizr.addTest("strictmode", (function () {
	    "use strict";return !this;
	  })()), Modernizr.addTest("es5string", function () {
	    return !(!String.prototype || !String.prototype.trim);
	  }), Modernizr.addTest("json", "JSON" in window && "parse" in JSON && "stringify" in JSON), Modernizr.addTest("es5syntax", function () {
	    var value, obj, stringAccess, getter, setter, reservedWords, zeroWidthChars;try {
	      return stringAccess = eval('"foobar"[3] === "b"'), getter = eval("({ get x(){ return 1 } }).x === 1"), eval("({ set x(v){ value = v; } }).x = 1"), setter = 1 === value, eval("obj = ({ if: 1 })"), reservedWords = 1 === obj["if"], zeroWidthChars = eval("_‌‍ = true"), stringAccess && getter && setter && reservedWords && zeroWidthChars;
	    } catch (ignore) {
	      return !1;
	    }
	  }), Modernizr.addTest("es5undefined", function () {
	    var e, t;try {
	      t = window.undefined, window.undefined = 12345, e = "undefined" == typeof window.undefined, window.undefined = t;
	    } catch (r) {
	      return !1;
	    }return e;
	  }), Modernizr.addTest("es5", function () {
	    return !!(Modernizr.es5array && Modernizr.es5date && Modernizr.es5function && Modernizr.es5object && Modernizr.strictmode && Modernizr.es5string && Modernizr.json && Modernizr.es5syntax && Modernizr.es5undefined);
	  });var atRule = function atRule(e) {
	    var t,
	        r = prefixes.length,
	        n = window.CSSRule;if ("undefined" == typeof n) return undefined;if (!e) return !1;if ((e = e.replace(/^@/, ""), t = e.replace(/-/g, "_").toUpperCase() + "_RULE", t in n)) return "@" + e;for (var o = 0; r > o; o++) {
	      var s = prefixes[o],
	          i = s.toUpperCase() + "_" + t;if (i in n) return "@-" + s.toLowerCase() + "-" + e;
	    }return !1;
	  };ModernizrProto.atRule = atRule;var prefixed = ModernizrProto.prefixed = function (e, t, r) {
	    return 0 === e.indexOf("@") ? atRule(e) : (-1 != e.indexOf("-") && (e = cssToDOM(e)), t ? testPropsAll(e, t, r) : testPropsAll(e, "pfx"));
	  };Modernizr.addTest("objectfit", !!prefixed("objectFit"), { aliases: ["object-fit"] }), Modernizr.addTest("localstorage", function () {
	    var e = "modernizr";try {
	      return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
	    } catch (t) {
	      return !1;
	    }
	  }), testRunner(), setClasses(classes), delete ModernizrProto.addTest, delete ModernizrProto.addAsyncTest;for (var i = 0; i < Modernizr._q.length; i++) Modernizr._q[i]();window.Modernizr = Modernizr;
	})(window, document);


/***/ },
/* 180 */
/***/ function(module, exports) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	var POKE_RATE_MS = 10 * 60 * 1000; // 10 min
	var currentVersion = null;
	var latestVersion = null;
	var listener = function listener() {}; // NOP
	
	module.exports = {
	    setVersionListener: function setVersionListener(fn) {
	        // invoked with fn(currentVer, newVer)
	        listener = fn;
	    },
	
	    run: function run() {
	        var req = new XMLHttpRequest();
	        req.addEventListener("load", function () {
	            if (!req.responseText) {
	                return;
	            }
	            var ver = req.responseText.trim();
	            if (!currentVersion) {
	                currentVersion = ver;
	                listener(currentVersion, currentVersion);
	            }
	
	            if (ver !== latestVersion) {
	                latestVersion = ver;
	                if (module.exports.hasNewVersion()) {
	                    console.log("Current=%s Latest=%s", currentVersion, latestVersion);
	                    listener(currentVersion, latestVersion);
	                }
	            }
	        });
	        req.open("GET", "version");
	        req.send(); // can't suppress 404s from being logged.
	
	        setTimeout(module.exports.run, POKE_RATE_MS);
	    },
	
	    getCurrentVersion: function getCurrentVersion() {
	        return currentVersion;
	    },
	
	    hasNewVersion: function hasNewVersion() {
	        return currentVersion && latestVersion && currentVersion !== latestVersion;
	    }
	};


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	/**
	 * filesize
	 *
	 * @copyright 2016 Jason Mulligan <jason.mulligan@avoidwork.com>
	 * @license BSD-3-Clause
	 * @version 3.2.1
	 */
	(function (global) {
		var b = /^(b|B)$/;
		var symbol = {
			bits: ["b", "Kb", "Mb", "Gb", "Tb", "Pb", "Eb", "Zb", "Yb"],
			bytes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
		};
	
		/**
	  * filesize
	  *
	  * @method filesize
	  * @param  {Mixed}   arg        String, Int or Float to transform
	  * @param  {Object}  descriptor [Optional] Flags
	  * @return {String}             Readable file size String
	  */
		function filesize(arg) {
			var descriptor = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
			var result = [],
			    val = 0,
			    e = undefined,
			    base = undefined,
			    bits = undefined,
			    ceil = undefined,
			    neg = undefined,
			    num = undefined,
			    output = undefined,
			    round = undefined,
			    unix = undefined,
			    spacer = undefined,
			    symbols = undefined;
	
			if (isNaN(arg)) {
				throw new Error("Invalid arguments");
			}
	
			bits = descriptor.bits === true;
			unix = descriptor.unix === true;
			base = descriptor.base || 2;
			round = descriptor.round !== undefined ? descriptor.round : unix ? 1 : 2;
			spacer = descriptor.spacer !== undefined ? descriptor.spacer : unix ? "" : " ";
			symbols = descriptor.symbols || descriptor.suffixes || {};
			output = descriptor.output || "string";
			e = descriptor.exponent !== undefined ? descriptor.exponent : -1;
			num = Number(arg);
			neg = num < 0;
			ceil = base > 2 ? 1000 : 1024;
	
			// Flipping a negative number to determine the size
			if (neg) {
				num = -num;
			}
	
			// Zero is now a special case because bytes divide by 1
			if (num === 0) {
				result[0] = 0;
				result[1] = unix ? "" : !bits ? "B" : "b";
			} else {
				// Determining the exponent
				if (e === -1 || isNaN(e)) {
					e = Math.floor(Math.log(num) / Math.log(ceil));
	
					if (e < 0) {
						e = 0;
					}
				}
	
				// Exceeding supported length, time to reduce & multiply
				if (e > 8) {
					e = 8;
				}
	
				val = base === 2 ? num / Math.pow(2, e * 10) : num / Math.pow(1000, e);
	
				if (bits) {
					val = val * 8;
	
					if (val > ceil && e < 8) {
						val = val / ceil;
						e++;
					}
				}
	
				result[0] = Number(val.toFixed(e > 0 ? round : 0));
				result[1] = base === 10 && e === 1 ? bits ? "kb" : "kB" : symbol[bits ? "bits" : "bytes"][e];
	
				if (unix) {
					result[1] = result[1].charAt(0);
	
					if (b.test(result[1])) {
						result[0] = Math.floor(result[0]);
						result[1] = "";
					}
				}
			}
	
			// Decorating a 'diff'
			if (neg) {
				result[0] = -result[0];
			}
	
			// Applying custom suffix
			result[1] = symbols[result[1]] || result[1];
	
			// Returning Array, Object, or String (default)
			if (output === "array") {
				return result;
			}
	
			if (output === "exponent") {
				return e;
			}
	
			if (output === "object") {
				return { value: result[0], suffix: result[1], symbol: result[1] };
			}
	
			return result.join(spacer);
		}
	
		// CommonJS, AMD, script tag
		if (true) {
			module.exports = filesize;
		} else if (typeof define === "function" && define.amd) {
			define(function () {
				return filesize;
			});
		} else {
			global.filesize = filesize;
		}
	})(typeof window !== "undefined" ? window : global);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var matrixcs = __webpack_require__(184);
	matrixcs.request(__webpack_require__(196));
	module.exports = matrixcs; // keep export for browserify package deps
	global.matrixcs = matrixcs;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/** The {@link module:models/event.MatrixEvent|MatrixEvent} class. */
	module.exports.MatrixEvent = __webpack_require__(15).MatrixEvent;
	/** The {@link module:models/event.EventStatus|EventStatus} enum. */
	module.exports.EventStatus = __webpack_require__(15).EventStatus;
	/** The {@link module:store/memory.MatrixInMemoryStore|MatrixInMemoryStore} class. */
	module.exports.MatrixInMemoryStore = __webpack_require__(190).MatrixInMemoryStore;
	/** The {@link module:store/webstorage~WebStorageStore|WebStorageStore} class.
	 * <strong>Work in progress; unstable.</strong> */
	module.exports.WebStorageStore = __webpack_require__(193);
	/** The {@link module:http-api.MatrixHttpApi|MatrixHttpApi} class. */
	module.exports.MatrixHttpApi = __webpack_require__(35).MatrixHttpApi;
	/** The {@link module:http-api.MatrixError|MatrixError} class. */
	module.exports.MatrixError = __webpack_require__(35).MatrixError;
	/** The {@link module:client.MatrixClient|MatrixClient} class. */
	module.exports.MatrixClient = __webpack_require__(92).MatrixClient;
	/** The {@link module:models/room~Room|Room} class. */
	module.exports.Room = __webpack_require__(58);
	/** The {@link module:models/event-timeline~EventTimeline} class. */
	module.exports.EventTimeline = __webpack_require__(36);
	/** The {@link module:models/room-member~RoomMember|RoomMember} class. */
	module.exports.RoomMember = __webpack_require__(93);
	/** The {@link module:models/room-state~RoomState|RoomState} class. */
	module.exports.RoomState = __webpack_require__(94);
	/** The {@link module:models/user~User|User} class. */
	module.exports.User = __webpack_require__(37);
	/** The {@link module:scheduler~MatrixScheduler|MatrixScheduler} class. */
	module.exports.MatrixScheduler = __webpack_require__(189);
	/** The {@link module:store/session/webstorage~WebStorageSessionStore|
	 * WebStorageSessionStore} class. <strong>Work in progress; unstable.</strong> */
	module.exports.WebStorageSessionStore = __webpack_require__(191);
	/** True if crypto libraries are being used on this client. */
	module.exports.CRYPTO_ENABLED = __webpack_require__(92).CRYPTO_ENABLED;
	/** {@link module:content-repo|ContentRepo} utility functions. */
	module.exports.ContentRepo = __webpack_require__(34);
	/** The {@link module:filter~Filter|Filter} class. */
	module.exports.Filter = __webpack_require__(57);
	/** The {@link module:timeline-window~TimelineWindow} class. */
	module.exports.TimelineWindow = __webpack_require__(195).TimelineWindow;
	
	/**
	 * Create a new Matrix Call.
	 * @function
	 * @param {module:client.MatrixClient} client The MatrixClient instance to use.
	 * @param {string} roomId The room the call is in.
	 * @return {module:webrtc/call~MatrixCall} The Matrix call or null if the browser
	 * does not support WebRTC.
	 */
	module.exports.createNewMatrixCall = __webpack_require__(95).createNewMatrixCall;
	
	// expose the underlying request object so different environments can use
	// different request libs (e.g. request or browser-request)
	var request;
	/**
	 * The function used to perform HTTP requests. Only use this if you want to
	 * use a different HTTP library, e.g. Angular's <code>$http</code>. This should
	 * be set prior to calling {@link createClient}.
	 * @param {requestFunction} r The request function to use.
	 */
	module.exports.request = function(r) {
	    request = r;
	};
	
	/**
	 * Construct a Matrix Client. Similar to {@link module:client~MatrixClient}
	 * except that the 'request', 'store' and 'scheduler' dependencies are satisfied.
	 * @param {(Object|string)} opts The configuration options for this client. If
	 * this is a string, it is assumed to be the base URL. These configuration
	 * options will be passed directly to {@link module:client~MatrixClient}.
	 * @param {Object} opts.store If not set, defaults to
	 * {@link module:store/memory.MatrixInMemoryStore}.
	 * @param {Object} opts.scheduler If not set, defaults to
	 * {@link module:scheduler~MatrixScheduler}.
	 * @param {requestFunction} opts.request If not set, defaults to the function
	 * supplied to {@link request} which defaults to the request module from NPM.
	 * @return {MatrixClient} A new matrix client.
	 * @see {@link module:client~MatrixClient} for the full list of options for
	 * <code>opts</code>.
	 */
	module.exports.createClient = function(opts) {
	    if (typeof opts === "string") {
	        opts = {
	            "baseUrl": opts
	        };
	    }
	    opts.request = opts.request || request;
	    opts.store = opts.store || new module.exports.MatrixInMemoryStore({
	      localStorage: global.localStorage
	    });
	    opts.scheduler = opts.scheduler || new module.exports.MatrixScheduler();
	    return new module.exports.MatrixClient(opts);
	};
	
	/**
	 * The request function interface for performing HTTP requests. This matches the
	 * API for the {@link https://github.com/request/request#requestoptions-callback|
	 * request NPM module}. The SDK will attempt to call this function in order to
	 * perform an HTTP request.
	 * @callback requestFunction
	 * @param {Object} opts The options for this HTTP request.
	 * @param {string} opts.uri The complete URI.
	 * @param {string} opts.method The HTTP method.
	 * @param {Object} opts.qs The query parameters to append to the URI.
	 * @param {Object} opts.body The JSON-serializable object.
	 * @param {boolean} opts.json True if this is a JSON request.
	 * @param {Object} opts._matrix_opts The underlying options set for
	 * {@link MatrixHttpApi}.
	 * @param {requestCallback} callback The request callback.
	 */
	
	 /**
	  * The request callback interface for performing HTTP requests. This matches the
	  * API for the {@link https://github.com/request/request#requestoptions-callback|
	  * request NPM module}. The SDK will implement a callback which meets this
	  * interface in order to handle the HTTP response.
	  * @callback requestCallback
	  * @param {Error} err The error if one occurred, else falsey.
	  * @param {Object} response The HTTP response which consists of
	  * <code>{statusCode: {Number}, headers: {Object}}</code>
	  * @param {Object} body The parsed HTTP response body.
	  */
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 185 */
/***/ function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module models/event-context
	 */
	
	/**
	 * Construct a new EventContext
	 *
	 * An eventcontext is used for circumstances such as search results, when we
	 * have a particular event of interest, and a bunch of events before and after
	 * it.
	 *
	 * It also stores pagination tokens for going backwards and forwards in the
	 * timeline.
	 *
	 * @param {MatrixEvent} ourEvent  the event at the centre of this context
	 *
	 * @constructor
	 */
	function EventContext(ourEvent) {
	    this._timeline = [ourEvent];
	    this._ourEventIndex = 0;
	    this._paginateTokens = {b: null, f: null};
	
	    // this is used by MatrixClient to keep track of active requests
	    this._paginateRequests = {b: null, f: null};
	}
	
	/**
	 * Get the main event of interest
	 *
	 * This is a convenience function for getTimeline()[getOurEventIndex()].
	 *
	 * @return {MatrixEvent} The event at the centre of this context.
	 */
	EventContext.prototype.getEvent = function() {
	    return this._timeline[this._ourEventIndex];
	};
	
	/**
	 * Get the list of events in this context
	 *
	 * @return {Array} An array of MatrixEvents
	 */
	EventContext.prototype.getTimeline = function() {
	    return this._timeline;
	};
	
	/**
	 * Get the index in the timeline of our event
	 *
	 * @return {Number}
	 */
	EventContext.prototype.getOurEventIndex = function() {
	    return this._ourEventIndex;
	};
	
	/**
	 * Get a pagination token.
	 *
	 * @param {boolean} backwards   true to get the pagination token for going
	 *                                  backwards in time
	 * @return {string}
	 */
	EventContext.prototype.getPaginateToken = function(backwards) {
	    return this._paginateTokens[backwards ? 'b' : 'f'];
	};
	
	/**
	 * Set a pagination token.
	 *
	 * Generally this will be used only by the matrix js sdk.
	 *
	 * @param {string} token        pagination token
	 * @param {boolean} backwards   true to set the pagination token for going
	 *                                   backwards in time
	 */
	EventContext.prototype.setPaginateToken = function(token, backwards) {
	    this._paginateTokens[backwards ? 'b' : 'f'] = token;
	};
	
	/**
	 * Add more events to the timeline
	 *
	 * @param {Array} events      new events, in timeline order
	 * @param {boolean} atStart   true to insert new events at the start
	 */
	EventContext.prototype.addEvents = function(events, atStart) {
	    // TODO: should we share logic with Room.addEventsToTimeline?
	    // Should Room even use EventContext?
	
	    if (atStart) {
	        this._timeline = events.concat(this._timeline);
	        this._ourEventIndex += events.length;
	    } else {
	        this._timeline = this._timeline.concat(events);
	    }
	};
	
	/**
	 * The EventContext class
	 */
	module.exports = EventContext;


/***/ },
/* 186 */
/***/ function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * @module models/room-summary
	 */
	
	/**
	 * Construct a new Room Summary. A summary can be used for display on a recent
	 * list, without having to load the entire room list into memory.
	 * @constructor
	 * @param {string} roomId Required. The ID of this room.
	 * @param {Object} info Optional. The summary info. Additional keys are supported.
	 * @param {string} info.title The title of the room (e.g. <code>m.room.name</code>)
	 * @param {string} info.desc The description of the room (e.g.
	 * <code>m.room.topic</code>)
	 * @param {Number} info.numMembers The number of joined users.
	 * @param {string[]} info.aliases The list of aliases for this room.
	 * @param {Number} info.timestamp The timestamp for this room.
	 */
	function RoomSummary(roomId, info) {
	    this.roomId = roomId;
	    this.info = info;
	}
	
	/**
	 * The RoomSummary class.
	 */
	module.exports = RoomSummary;


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module models/search-result
	 */
	
	var EventContext = __webpack_require__(185);
	var utils = __webpack_require__(5);
	
	/**
	 * Construct a new SearchResult
	 *
	 * @param {number} rank   where this SearchResult ranks in the results
	 * @param {event-context.EventContext} eventContext  the matching event and its
	 *    context
	 *
	 * @constructor
	 */
	function SearchResult(rank, eventContext) {
	    this.rank = rank;
	    this.context = eventContext;
	}
	
	/**
	 * Create a SearchResponse from the response to /search
	 * @static
	 * @param {Object} jsonObj
	 * @param {function} eventMapper
	 * @return {SearchResult}
	 */
	
	SearchResult.fromJson = function(jsonObj, eventMapper) {
	    var jsonContext = jsonObj.context || {};
	    var events_before = jsonContext.events_before || [];
	    var events_after = jsonContext.events_after || [];
	
	    var context = new EventContext(eventMapper(jsonObj.result));
	
	    context.setPaginateToken(jsonContext.start, true);
	    context.addEvents(utils.map(events_before, eventMapper), true);
	    context.addEvents(utils.map(events_after, eventMapper), false);
	    context.setPaginateToken(jsonContext.end, false);
	
	    return new SearchResult(jsonObj.rank, context);
	};
	
	
	/**
	 * The SearchResult class
	 */
	module.exports = SearchResult;


/***/ },
/* 188 */
/***/ function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	/**
	 * @module pushprocessor
	 */
	
	/**
	 * Construct a Push Processor.
	 * @constructor
	 * @param {Object} client The Matrix client object to use
	 */
	function PushProcessor(client) {
	    var escapeRegExp = function(string) {
	        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	    };
	
	    var matchingRuleFromKindSet = function(ev, kindset, device) {
	        var rulekinds_in_order = ['override', 'content', 'room', 'sender', 'underride'];
	        for (var ruleKindIndex = 0;
	                ruleKindIndex < rulekinds_in_order.length;
	                ++ruleKindIndex) {
	            var kind = rulekinds_in_order[ruleKindIndex];
	            var ruleset = kindset[kind];
	
	            for (var ruleIndex = 0; ruleIndex < ruleset.length; ++ruleIndex) {
	                var rule = ruleset[ruleIndex];
	                if (!rule.enabled) { continue; }
	
	                var rawrule = templateRuleToRaw(kind, rule, device);
	                if (!rawrule) { continue; }
	
	                if (ruleMatchesEvent(rawrule, ev)) {
	                    rule.kind = kind;
	                    return rule;
	                }
	            }
	        }
	        return null;
	    };
	
	    var templateRuleToRaw = function(kind, tprule, device) {
	        var rawrule = {
	            'rule_id': tprule.rule_id,
	            'actions': tprule.actions,
	            'conditions': []
	        };
	        switch (kind) {
	            case 'underride':
	            case 'override':
	                rawrule.conditions = tprule.conditions;
	                break;
	            case 'room':
	                if (!tprule.rule_id) { return null; }
	                rawrule.conditions.push({
	                    'kind': 'event_match',
	                    'key': 'room_id',
	                    'pattern': tprule.rule_id
	                });
	                break;
	            case 'sender':
	                if (!tprule.rule_id) { return null; }
	                rawrule.conditions.push({
	                    'kind': 'event_match',
	                    'key': 'user_id',
	                    'pattern': tprule.rule_id
	                });
	                break;
	            case 'content':
	                if (!tprule.pattern) { return null; }
	                rawrule.conditions.push({
	                    'kind': 'event_match',
	                    'key': 'content.body',
	                    'pattern': tprule.pattern
	                });
	                break;
	        }
	        if (device) {
	            rawrule.conditions.push({
	                'kind': 'device',
	                'profile_tag': device
	            });
	        }
	        return rawrule;
	    };
	
	    var ruleMatchesEvent = function(rule, ev) {
	        var ret = true;
	        for (var i = 0; i < rule.conditions.length; ++i) {
	            var cond = rule.conditions[i];
	            ret &= eventFulfillsCondition(cond, ev);
	        }
	        //console.log("Rule "+rule.rule_id+(ret ? " matches" : " doesn't match"));
	        return ret;
	    };
	
	    var eventFulfillsCondition = function(cond, ev) {
	        var condition_functions = {
	            "event_match": eventFulfillsEventMatchCondition,
	            "device": eventFulfillsDeviceCondition,
	            "contains_display_name": eventFulfillsDisplayNameCondition,
	            "room_member_count": eventFulfillsRoomMemberCountCondition
	        };
	        if (condition_functions[cond.kind]) {
	            return condition_functions[cond.kind](cond, ev);
	        }
	        return true;
	    };
	
	    var eventFulfillsRoomMemberCountCondition = function(cond, ev) {
	        if (!cond.is) { return false; }
	
	        var room = client.getRoom(ev.room_id);
	        if (!room || !room.currentState || !room.currentState.members) { return false; }
	
	        var memberCount = Object.keys(room.currentState.members).length;
	
	        var m = cond.is.match(/^([=<>]*)([0-9]*)$/);
	        if (!m) { return false; }
	        var ineq = m[1];
	        var rhs = parseInt(m[2]);
	        if (isNaN(rhs)) { return false; }
	        switch (ineq) {
	            case '':
	            case '==':
	                return memberCount == rhs;
	            case '<':
	                return memberCount < rhs;
	            case '>':
	                return memberCount > rhs;
	            case '<=':
	                return memberCount <= rhs;
	            case '>=':
	                return memberCount >= rhs;
	            default:
	                return false;
	        }
	    };
	
	    var eventFulfillsDisplayNameCondition = function(cond, ev) {
	        if (!ev.content || ! ev.content.body || typeof ev.content.body != 'string') {
	            return false;
	        }
	
	        var room = client.getRoom(ev.room_id);
	        if (!room || !room.currentState || !room.currentState.members ||
	            !room.currentState.getMember(client.credentials.userId)) { return false; }
	
	        var displayName = room.currentState.getMember(client.credentials.userId).name;
	
	        var pat = new RegExp("\\b" + escapeRegExp(displayName) + "\\b", 'i');
	        return ev.content.body.search(pat) > -1;
	    };
	
	    var eventFulfillsDeviceCondition = function(cond, ev) {
	        return false; // XXX: Allow a profile tag to be set for the web client instance
	    };
	
	    var eventFulfillsEventMatchCondition = function(cond, ev) {
	        var val = valueForDottedKey(cond.key, ev);
	        if (!val || typeof val != 'string') { return false; }
	
	        var pat;
	        if (cond.key == 'content.body') {
	            pat = '\\b' + globToRegexp(cond.pattern) + '\\b';
	        } else {
	            pat = '^' + globToRegexp(cond.pattern) + '$';
	        }
	        var regex = new RegExp(pat, 'i');
	        return !!val.match(regex);
	    };
	
	    var globToRegexp = function(glob) {
	        // From
	        // https://github.com/matrix-org/synapse/blob/abbee6b29be80a77e05730707602f3bbfc3f38cb/synapse/push/__init__.py#L132
	        // Because micromatch is about 130KB with dependencies,
	        // and minimatch is not much better.
	        var pat = escapeRegExp(glob);
	        pat = pat.replace(/\\\*/, '.*');
	        pat = pat.replace(/\?/, '.');
	        pat = pat.replace(/\\\[(!|)(.*)\\]/, function(match, p1, p2, offset, string) {
	            var first = p1 && '^' || '';
	            var second = p2.replace(/\\\-/, '-');
	            return '[' + first + second + ']';
	        });
	        return pat;
	    };
	
	    var valueForDottedKey = function(key, ev) {
	        var parts = key.split('.');
	        var val = ev;
	        while (parts.length > 0) {
	            var thispart = parts.shift();
	            if (!val[thispart]) { return null; }
	            val = val[thispart];
	        }
	        return val;
	    };
	
	    var matchingRuleForEventWithRulesets = function(ev, rulesets) {
	        if (!rulesets || !rulesets.device) { return null; }
	        if (ev.user_id == client.credentials.userId) { return null; }
	
	        var allDevNames = Object.keys(rulesets.device);
	        for (var i = 0; i < allDevNames.length; ++i) {
	            var devname = allDevNames[i];
	            var devrules = rulesets.device[devname];
	
	            var matchingRule = matchingRuleFromKindSet(devrules, devname);
	            if (matchingRule) { return matchingRule; }
	        }
	        return matchingRuleFromKindSet(ev, rulesets.global);
	    };
	
	    var actionListToActionsObject = function(actionlist) {
	        var actionobj = { 'notify': false, 'tweaks': {} };
	        for (var i = 0; i < actionlist.length; ++i) {
	            var action = actionlist[i];
	            if (action === 'notify') {
	                actionobj.notify = true;
	            } else if (typeof action === 'object') {
	                if (action.value === undefined) { action.value = true; }
	                actionobj.tweaks[action.set_tweak] = action.value;
	            }
	        }
	        return actionobj;
	    };
	
	    var pushActionsForEventAndRulesets = function(ev, rulesets) {
	        var rule = matchingRuleForEventWithRulesets(ev, rulesets);
	        if (!rule) { return {}; }
	
	        var actionObj = actionListToActionsObject(rule.actions);
	
	        // Some actions are implicit in some situations: we add those here
	        if (actionObj.tweaks.highlight === undefined) {
	            // if it isn't specified, highlight if it's a content
	            // rule but otherwise not
	            actionObj.tweaks.highlight = (rule.kind == 'content');
	        }
	
	        return actionObj;
	    };
	
	    this.actionsForEvent = function(ev) {
	        return pushActionsForEventAndRulesets(ev, client.pushRules);
	    };
	}
	
	/**
	 * @typedef {Object} PushAction
	 * @type {Object}
	 * @property {boolean} notify Whether this event should notify the user or not.
	 * @property {Object} tweaks How this event should be notified.
	 * @property {boolean} tweaks.highlight Whether this event should be highlighted
	 * on the UI.
	 * @property {boolean} tweaks.sound Whether this notification should produce a
	 * noise.
	 */
	
	/** The PushProcessor class. */
	module.exports = PushProcessor;


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module which manages queuing, scheduling and retrying
	 * of requests.
	 * @module scheduler
	 */
	var utils = __webpack_require__(5);
	var q = __webpack_require__(18);
	
	var DEBUG = false;  // set true to enable console logging.
	
	/**
	 * Construct a scheduler for Matrix. Requires
	 * {@link module:scheduler~MatrixScheduler#setProcessFunction} to be provided
	 * with a way of processing events.
	 * @constructor
	 * @param {module:scheduler~retryAlgorithm} retryAlgorithm Optional. The retry
	 * algorithm to apply when determining when to try to send an event again.
	 * Defaults to {@link module:scheduler~MatrixScheduler.RETRY_BACKOFF_RATELIMIT}.
	 * @param {module:scheduler~queueAlgorithm} queueAlgorithm Optional. The queuing
	 * algorithm to apply when determining which events should be sent before the
	 * given event. Defaults to {@link module:scheduler~MatrixScheduler.QUEUE_MESSAGES}.
	 */
	function MatrixScheduler(retryAlgorithm, queueAlgorithm) {
	    this.retryAlgorithm = retryAlgorithm || MatrixScheduler.RETRY_BACKOFF_RATELIMIT;
	    this.queueAlgorithm = queueAlgorithm || MatrixScheduler.QUEUE_MESSAGES;
	    this._queues = {
	        // queueName: [{
	        //  event: MatrixEvent,  // event to send
	        //  defer: Deferred,  // defer to resolve/reject at the END of the retries
	        //  attempts: Number  // number of times we've called processFn
	        // }, ...]
	    };
	    this._activeQueues = [];
	    this._procFn = null;
	}
	
	/**
	 * Retrieve a queue based on an event. The event provided does not need to be in
	 * the queue.
	 * @param {MatrixEvent} event An event to get the queue for.
	 * @return {?Array<MatrixEvent>} A shallow copy of events in the queue or null.
	 * Modifying this array will not modify the list itself. Modifying events in
	 * this array <i>will</i> modify the underlying event in the queue.
	 * @see MatrixScheduler.removeEventFromQueue To remove an event from the queue.
	 */
	MatrixScheduler.prototype.getQueueForEvent = function(event) {
	    var name = this.queueAlgorithm(event);
	    if (!name || !this._queues[name]) {
	        return null;
	    }
	    return utils.map(this._queues[name], function(obj) {
	        return obj.event;
	    });
	};
	
	/**
	 * Remove this event from the queue. The event is equal to another event if they
	 * have the same ID returned from event.getId().
	 * @param {MatrixEvent} event The event to remove.
	 * @return {boolean} True if this event was removed.
	 */
	MatrixScheduler.prototype.removeEventFromQueue = function(event) {
	    var name = this.queueAlgorithm(event);
	    if (!name || !this._queues[name]) {
	        return false;
	    }
	    var removed = false;
	    utils.removeElement(this._queues[name], function(element) {
	        if (element.event.getId() === event.getId()) {
	            removed = true;
	            return true;
	        }
	    });
	    return removed;
	};
	
	
	/**
	 * Set the process function. Required for events in the queue to be processed.
	 * If set after events have been added to the queue, this will immediately start
	 * processing them.
	 * @param {module:scheduler~processFn} fn The function that can process events
	 * in the queue.
	 */
	MatrixScheduler.prototype.setProcessFunction = function(fn) {
	    this._procFn = fn;
	    _startProcessingQueues(this);
	};
	
	/**
	 * Queue an event if it is required and start processing queues.
	 * @param {MatrixEvent} event The event that may be queued.
	 * @return {?Promise} A promise if the event was queued, which will be
	 * resolved or rejected in due time, else null.
	 */
	MatrixScheduler.prototype.queueEvent = function(event) {
	    var queueName = this.queueAlgorithm(event);
	    if (!queueName) {
	        return null;
	    }
	    // add the event to the queue and make a deferred for it.
	    if (!this._queues[queueName]) {
	        this._queues[queueName] = [];
	    }
	    var defer = q.defer();
	    this._queues[queueName].push({
	        event: event,
	        defer: defer,
	        attempts: 0
	    });
	    debuglog(
	        "Queue algorithm dumped event %s into queue '%s'",
	        event.getId(), queueName
	    );
	    _startProcessingQueues(this);
	    return defer.promise;
	};
	
	/**
	 * Retries events up to 4 times using exponential backoff. This produces wait
	 * times of 2, 4, 8, and 16 seconds (30s total) after which we give up. If the
	 * failure was due to a rate limited request, the time specified in the error is
	 * waited before being retried.
	 * @param {MatrixEvent} event
	 * @param {Number} attempts
	 * @param {MatrixError} err
	 * @return {Number}
	 * @see module:scheduler~retryAlgorithm
	 */
	MatrixScheduler.RETRY_BACKOFF_RATELIMIT = function(event, attempts, err) {
	    if (err.httpStatus === 400 || err.httpStatus === 403 || err.httpStatus === 401) {
	        // client error; no amount of retrying with save you now.
	        return -1;
	    }
	    // we ship with browser-request which returns { cors: rejected } when trying
	    // with no connection, so if we match that, give up since they have no conn.
	    if (err.cors === "rejected") {
	        return -1;
	    }
	
	    if (err.name === "M_LIMIT_EXCEEDED") {
	        var waitTime = err.data.retry_after_ms;
	        if (waitTime) {
	            return waitTime;
	        }
	    }
	    if (attempts > 4) {
	        return -1; // give up
	    }
	    return (1000 * Math.pow(2, attempts));
	};
	
	/**
	 * Queues <code>m.room.message</code> events and lets other events continue
	 * concurrently.
	 * @param {MatrixEvent} event
	 * @return {string}
	 * @see module:scheduler~queueAlgorithm
	 */
	MatrixScheduler.QUEUE_MESSAGES = function(event) {
	    if (event.getType() === "m.room.message") {
	        // put these events in the 'message' queue.
	        return "message";
	    }
	    // allow all other events continue concurrently.
	    return null;
	};
	
	function _startProcessingQueues(scheduler) {
	    if (!scheduler._procFn) {
	        return;
	    }
	    // for each inactive queue with events in them
	    utils.forEach(utils.filter(utils.keys(scheduler._queues), function(queueName) {
	        return scheduler._activeQueues.indexOf(queueName) === -1 &&
	                scheduler._queues[queueName].length > 0;
	    }), function(queueName) {
	        // mark the queue as active
	        scheduler._activeQueues.push(queueName);
	        // begin processing the head of the queue
	        debuglog("Spinning up queue: '%s'", queueName);
	        _processQueue(scheduler, queueName);
	    });
	}
	
	function _processQueue(scheduler, queueName) {
	    // get head of queue
	    var obj = _peekNextEvent(scheduler, queueName);
	    if (!obj) {
	        // queue is empty. Mark as inactive and stop recursing.
	        var index = scheduler._activeQueues.indexOf(queueName);
	        if (index >= 0) {
	            scheduler._activeQueues.splice(index, 1);
	        }
	        debuglog("Stopping queue '%s' as it is now empty", queueName);
	        return;
	    }
	    debuglog(
	        "Queue '%s' has %s pending events",
	        queueName, scheduler._queues[queueName].length
	    );
	    // fire the process function and if it resolves, resolve the deferred. Else
	    // invoke the retry algorithm.
	    scheduler._procFn(obj.event).done(function(res) {
	        // remove this from the queue
	        _removeNextEvent(scheduler, queueName);
	        debuglog("Queue '%s' sent event %s", queueName, obj.event.getId());
	        obj.defer.resolve(res);
	        // keep processing
	        _processQueue(scheduler, queueName);
	    }, function(err) {
	        obj.attempts += 1;
	        // ask the retry algorithm when/if we should try again
	        var waitTimeMs = scheduler.retryAlgorithm(obj.event, obj.attempts, err);
	        debuglog(
	            "retry(%s) err=%s event_id=%s waitTime=%s",
	            obj.attempts, err, obj.event.getId(), waitTimeMs
	        );
	        if (waitTimeMs === -1) {  // give up (you quitter!)
	            debuglog(
	                "Queue '%s' giving up on event %s", queueName, obj.event.getId()
	            );
	            // remove this from the queue
	            _removeNextEvent(scheduler, queueName);
	            obj.defer.reject(err);
	            // process next event
	            _processQueue(scheduler, queueName);
	        }
	        else {
	            setTimeout(function() {
	                _processQueue(scheduler, queueName);
	            }, waitTimeMs);
	        }
	    });
	}
	
	function _peekNextEvent(scheduler, queueName) {
	    var queue = scheduler._queues[queueName];
	    if (!utils.isArray(queue)) {
	        return null;
	    }
	    return queue[0];
	}
	
	function _removeNextEvent(scheduler, queueName) {
	    var queue = scheduler._queues[queueName];
	    if (!utils.isArray(queue)) {
	        return null;
	    }
	    return queue.shift();
	}
	
	function debuglog() {
	    if (DEBUG) {
	        console.log.apply(console, arguments);
	    }
	}
	
	/**
	 * The retry algorithm to apply when retrying events. To stop retrying, return
	 * <code>-1</code>. If this event was part of a queue, it will be removed from
	 * the queue.
	 * @callback retryAlgorithm
	 * @param {MatrixEvent} event The event being retried.
	 * @param {Number} attempts The number of failed attempts. This will always be
	 * >= 1.
	 * @param {MatrixError} err The most recent error message received when trying
	 * to send this event.
	 * @return {Number} The number of milliseconds to wait before trying again. If
	 * this is 0, the request will be immediately retried. If this is
	 * <code>-1</code>, the event will be marked as
	 * {@link module:models/event.EventStatus.NOT_SENT} and will not be retried.
	 */
	
	/**
	 * The queuing algorithm to apply to events. This function must be idempotent as
	 * it may be called multiple times with the same event. All queues created are
	 * serviced in a FIFO manner. To send the event ASAP, return <code>null</code>
	 * which will not put this event in a queue. Events that fail to send that form
	 * part of a queue will be removed from the queue and the next event in the
	 * queue will be sent.
	 * @callback queueAlgorithm
	 * @param {MatrixEvent} event The event to be sent.
	 * @return {string} The name of the queue to put the event into. If a queue with
	 * this name does not exist, it will be created. If this is <code>null</code>,
	 * the event is not put into a queue and will be sent concurrently.
	 */
	
	 /**
	 * The function to invoke to process (send) events in the queue.
	 * @callback processFn
	 * @param {MatrixEvent} event The event to send.
	 * @return {Promise} Resolved/rejected depending on the outcome of the request.
	 */
	
	/**
	 * The MatrixScheduler class.
	 */
	module.exports = MatrixScheduler;


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module. See {@link MatrixInMemoryStore} for the public class.
	 * @module store/memory
	 */
	 var utils = __webpack_require__(5);
	 var User = __webpack_require__(37);
	
	/**
	 * Construct a new in-memory data store for the Matrix Client.
	 * @constructor
	 * @param {Object=} opts Config options
	 * @param {LocalStorage} opts.localStorage The local storage instance to persist
	 * some forms of data such as tokens. Rooms will NOT be stored. See
	 * {@link WebStorageStore} to persist rooms.
	 */
	module.exports.MatrixInMemoryStore = function MatrixInMemoryStore(opts) {
	    opts = opts || {};
	    this.rooms = {
	        // roomId: Room
	    };
	    this.users = {
	        // userId: User
	    };
	    this.syncToken = null;
	    this.filters = {
	        // userId: {
	        //    filterId: Filter
	        // }
	    };
	    this.localStorage = opts.localStorage;
	};
	
	module.exports.MatrixInMemoryStore.prototype = {
	
	    /**
	     * Retrieve the token to stream from.
	     * @return {string} The token or null.
	     */
	    getSyncToken: function() {
	        return this.syncToken;
	    },
	
	
	    /**
	     * Set the token to stream from.
	     * @param {string} token The token to stream from.
	     */
	    setSyncToken: function(token) {
	        this.syncToken = token;
	    },
	
	    /**
	     * Store the given room.
	     * @param {Room} room The room to be stored. All properties must be stored.
	     */
	    storeRoom: function(room) {
	        this.rooms[room.roomId] = room;
	        // add listeners for room member changes so we can keep the room member
	        // map up-to-date.
	        room.currentState.on("RoomState.members", this._onRoomMember.bind(this));
	        // add existing members
	        var self = this;
	        room.currentState.getMembers().forEach(function(m) {
	            self._onRoomMember(null, room.currentState, m);
	        });
	    },
	
	    /**
	     * Called when a room member in a room being tracked by this store has been
	     * updated.
	     * @param {MatrixEvent} event
	     * @param {RoomState} state
	     * @param {RoomMember} member
	     */
	    _onRoomMember: function(event, state, member) {
	        if (member.membership === "invite") {
	            // We do NOT add invited members because people love to typo user IDs
	            // which would then show up in these lists (!)
	            return;
	        }
	        // We don't clobber any existing entry in the user map which has presence
	        // so user entries with presence info are preferred. This does mean we will
	        // clobber room member entries constantly, which is desirable to keep things
	        // like display names and avatar URLs up-to-date.
	        if (this.users[member.userId] && this.users[member.userId].events.presence) {
	            return;
	        }
	
	        var user = new User(member.userId);
	        user.setDisplayName(member.name);
	        var rawUrl = (
	            member.events.member ? member.events.member.getContent().avatar_url : null
	        );
	        user.setAvatarUrl(rawUrl);
	        this.users[user.userId] = user;
	    },
	
	    /**
	     * Retrieve a room by its' room ID.
	     * @param {string} roomId The room ID.
	     * @return {Room} The room or null.
	     */
	    getRoom: function(roomId) {
	        return this.rooms[roomId] || null;
	    },
	
	    /**
	     * Retrieve all known rooms.
	     * @return {Room[]} A list of rooms, which may be empty.
	     */
	    getRooms: function() {
	        return utils.values(this.rooms);
	    },
	
	    /**
	     * Permanently delete a room.
	     * @param {string} roomId
	     */
	    removeRoom: function(roomId) {
	        if (this.rooms[roomId]) {
	            this.rooms[roomId].removeListener("RoomState.members", this._onRoomMember);
	        }
	        delete this.rooms[roomId];
	    },
	
	    /**
	     * Retrieve a summary of all the rooms.
	     * @return {RoomSummary[]} A summary of each room.
	     */
	    getRoomSummaries: function() {
	        return utils.map(utils.values(this.rooms), function(room) {
	            return room.summary;
	        });
	    },
	
	    /**
	     * Store a User.
	     * @param {User} user The user to store.
	     */
	    storeUser: function(user) {
	        this.users[user.userId] = user;
	    },
	
	    /**
	     * Retrieve a User by its' user ID.
	     * @param {string} userId The user ID.
	     * @return {User} The user or null.
	     */
	    getUser: function(userId) {
	        return this.users[userId] || null;
	    },
	
	    /**
	     * Retrieve all known users.
	     * @return {User[]} A list of users, which may be empty.
	     */
	    getUsers: function() {
	        return utils.values(this.users);
	    },
	
	    /**
	     * Retrieve scrollback for this room.
	     * @param {Room} room The matrix room
	     * @param {integer} limit The max number of old events to retrieve.
	     * @return {Array<Object>} An array of objects which will be at most 'limit'
	     * length and at least 0. The objects are the raw event JSON.
	     */
	    scrollback: function(room, limit) {
	        return [];
	    },
	
	    /**
	     * Store events for a room. The events have already been added to the timeline
	     * @param {Room} room The room to store events for.
	     * @param {Array<MatrixEvent>} events The events to store.
	     * @param {string} token The token associated with these events.
	     * @param {boolean} toStart True if these are paginated results.
	     */
	    storeEvents: function(room, events, token, toStart) {
	        // no-op because they've already been added to the room instance.
	    },
	
	    /**
	     * Store a filter.
	     * @param {Filter} filter
	     */
	    storeFilter: function(filter) {
	        if (!filter) { return; }
	        if (!this.filters[filter.userId]) {
	            this.filters[filter.userId] = {};
	        }
	        this.filters[filter.userId][filter.filterId] = filter;
	    },
	
	    /**
	     * Retrieve a filter.
	     * @param {string} userId
	     * @param {string} filterId
	     * @return {?Filter} A filter or null.
	     */
	    getFilter: function(userId, filterId) {
	        if (!this.filters[userId] || !this.filters[userId][filterId]) {
	            return null;
	        }
	        return this.filters[userId][filterId];
	    },
	
	    /**
	     * Retrieve a filter ID with the given name.
	     * @param {string} filterName The filter name.
	     * @return {?string} The filter ID or null.
	     */
	    getFilterIdByName: function(filterName) {
	        if (!this.localStorage) {
	            return null;
	        }
	        try {
	            return this.localStorage.getItem("mxjssdk_memory_filter_" + filterName);
	        }
	        catch (e) {}
	        return null;
	    },
	
	    /**
	     * Set a filter name to ID mapping.
	     * @param {string} filterName
	     * @param {string} filterId
	     */
	    setFilterIdByName: function(filterName, filterId) {
	        if (!this.localStorage) {
	            return;
	        }
	        try {
	            this.localStorage.setItem("mxjssdk_memory_filter_" + filterName, filterId);
	        }
	        catch (e) {}
	    }
	
	    // TODO
	    //setMaxHistoryPerRoom: function(maxHistory) {},
	
	    // TODO
	    //reapOldMessages: function() {},
	};


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/**
	 * @module store/session/webstorage
	 */
	
	var utils = __webpack_require__(5);
	
	var DEBUG = false;  // set true to enable console logging.
	var E2E_PREFIX = "session.e2e.";
	
	/**
	 * Construct a web storage session store, capable of storing account keys,
	 * session keys and access tokens.
	 * @constructor
	 * @param {WebStorage} webStore A web storage implementation, e.g.
	 * 'window.localStorage' or 'window.sessionStorage' or a custom implementation.
	 * @throws if the supplied 'store' does not meet the Storage interface of the
	 * WebStorage API.
	 */
	function WebStorageSessionStore(webStore) {
	    this.store = webStore;
	    if (!utils.isFunction(webStore.getItem) ||
	        !utils.isFunction(webStore.setItem) ||
	        !utils.isFunction(webStore.removeItem)) {
	        throw new Error(
	            "Supplied webStore does not meet the WebStorage API interface"
	        );
	    }
	}
	
	WebStorageSessionStore.prototype = {
	
	    /**
	     * Store the end to end account for the logged-in user.
	     * @param {string} account Base64 encoded account.
	     */
	    storeEndToEndAccount: function(account) {
	        this.store.setItem(KEY_END_TO_END_ACCOUNT, account);
	    },
	
	    /**
	     * Load the end to end account for the logged-in user.
	     * @return {?string} Base64 encoded account.
	     */
	    getEndToEndAccount: function() {
	        return this.store.getItem(KEY_END_TO_END_ACCOUNT);
	    },
	
	    /**
	     * Stores the known devices for a user.
	     * @param {string} userId The user's ID.
	     * @param {object} devices A map from device ID to keys for the device.
	     */
	    storeEndToEndDevicesForUser: function(userId, devices) {
	        setJsonItem(this.store, keyEndToEndDevicesForUser(userId), devices);
	    },
	
	    /**
	     * Retrieves the known devices for a user.
	     * @param {string} userId The user's ID.
	     * @return {object} A map from device ID to keys for the device.
	     */
	    getEndToEndDevicesForUser: function(userId)  {
	        return getJsonItem(this.store, keyEndToEndDevicesForUser(userId));
	    },
	
	    /**
	     * Store a session between the logged-in user and another device
	     * @param {string} deviceKey The public key of the other device.
	     * @param {string} sessionId The ID for this end-to-end session.
	     * @param {string} session Base64 encoded end-to-end session.
	     */
	    storeEndToEndSession: function(deviceKey, sessionId, session) {
	        var sessions = this.getEndToEndSessions(deviceKey) || {};
	        sessions[sessionId] = session;
	        setJsonItem(
	            this.store, keyEndToEndSessions(deviceKey), sessions
	        );
	    },
	
	    /**
	     * Retrieve the end-to-end sessions between the logged-in user and another
	     * device.
	     * @param {string} deviceKey The public key of the other device.
	     * @return {object} A map from sessionId to Base64 end-to-end session.
	     */
	    getEndToEndSessions: function(deviceKey) {
	        return getJsonItem(this.store, keyEndToEndSessions(deviceKey));
	    },
	
	    /**
	     * Store the end-to-end state for a room.
	     * @param {string} roomId The room's ID.
	     * @param {object} roomInfo The end-to-end info for the room.
	     */
	    storeEndToEndRoom: function(roomId, roomInfo) {
	        setJsonItem(this.store, keyEndToEndRoom(roomId), roomInfo);
	    },
	
	    /**
	     * Get the end-to-end state for a room
	     * @param {string} roomId The room's ID.
	     * @return {object} The end-to-end info for the room.
	     */
	    getEndToEndRoom: function(roomId) {
	        return getJsonItem(this.store, keyEndToEndRoom(roomId));
	    }
	};
	
	var KEY_END_TO_END_ACCOUNT = E2E_PREFIX + "account";
	
	function keyEndToEndDevicesForUser(userId) {
	    return E2E_PREFIX + "devices/" + userId;
	}
	
	function keyEndToEndSessions(deviceKey) {
	    return E2E_PREFIX + "sessions/" + deviceKey;
	}
	
	function keyEndToEndRoom(roomId) {
	    return E2E_PREFIX + "rooms/" + roomId;
	}
	
	function getJsonItem(store, key) {
	    try {
	        return JSON.parse(store.getItem(key));
	    }
	    catch (e) {
	        debuglog("Failed to get key %s: %s", key, e);
	        debuglog(e.stack);
	    }
	    return null;
	}
	
	function setJsonItem(store, key, val) {
	    store.setItem(key, JSON.stringify(val));
	}
	
	function debuglog() {
	    if (DEBUG) {
	        console.log.apply(console, arguments);
	    }
	}
	
	/** */
	module.exports = WebStorageSessionStore;


/***/ },
/* 192 */
/***/ function(module, exports) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module.
	 * @module store/stub
	 */
	
	/**
	 * Construct a stub store. This does no-ops on most store methods.
	 * @constructor
	 */
	function StubStore() {
	    this.fromToken = null;
	}
	
	StubStore.prototype = {
	
	    /**
	     * Get the sync token.
	     * @return {string}
	     */
	    getSyncToken: function() {
	        return this.fromToken;
	    },
	
	    /**
	     * Set the sync token.
	     * @param {string} token
	     */
	    setSyncToken: function(token) {
	        this.fromToken = token;
	    },
	
	    /**
	     * No-op.
	     * @param {Room} room
	     */
	    storeRoom: function(room) {
	    },
	
	    /**
	     * No-op.
	     * @param {string} roomId
	     * @return {null}
	     */
	    getRoom: function(roomId) {
	        return null;
	    },
	
	    /**
	     * No-op.
	     * @return {Array} An empty array.
	     */
	    getRooms: function() {
	        return [];
	    },
	
	    /**
	     * Permanently delete a room.
	     * @param {string} roomId
	     */
	    removeRoom: function(roomId) {
	        return;
	    },
	
	    /**
	     * No-op.
	     * @return {Array} An empty array.
	     */
	    getRoomSummaries: function() {
	        return [];
	    },
	
	    /**
	     * No-op.
	     * @param {User} user
	     */
	    storeUser: function(user) {
	    },
	
	    /**
	     * No-op.
	     * @param {string} userId
	     * @return {null}
	     */
	    getUser: function(userId) {
	        return null;
	    },
	
	    /**
	     * No-op.
	     * @return {User[]}
	     */
	    getUsers: function() {
	        return [];
	    },
	
	    /**
	     * No-op.
	     * @param {Room} room
	     * @param {integer} limit
	     * @return {Array}
	     */
	    scrollback: function(room, limit) {
	        return [];
	    },
	
	    /**
	     * Store events for a room.
	     * @param {Room} room The room to store events for.
	     * @param {Array<MatrixEvent>} events The events to store.
	     * @param {string} token The token associated with these events.
	     * @param {boolean} toStart True if these are paginated results.
	     */
	    storeEvents: function(room, events, token, toStart) {
	    },
	
	    /**
	     * Store a filter.
	     * @param {Filter} filter
	     */
	    storeFilter: function(filter) {
	    },
	
	    /**
	     * Retrieve a filter.
	     * @param {string} userId
	     * @param {string} filterId
	     * @return {?Filter} A filter or null.
	     */
	    getFilter: function(userId, filterId) {
	        return null;
	    },
	
	    /**
	     * Retrieve a filter ID with the given name.
	     * @param {string} filterName The filter name.
	     * @return {?string} The filter ID or null.
	     */
	    getFilterIdByName: function(filterName) {
	        return null;
	    },
	
	    /**
	     * Set a filter name to ID mapping.
	     * @param {string} filterName
	     * @param {string} filterId
	     */
	    setFilterIdByName: function(filterName, filterId) {
	
	    }
	
	    // TODO
	    //setMaxHistoryPerRoom: function(maxHistory) {},
	
	    // TODO
	    //reapOldMessages: function() {},
	};
	
	/** Stub Store class. */
	module.exports = StubStore;


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	/**
	 * This is an internal module. Implementation details:
	 * <pre>
	 * Room data is stored as follows:
	 *   room_$ROOMID_timeline_$INDEX : [ Event, Event, Event ]
	 *   room_$ROOMID_state : {
	 *                          pagination_token: <oldState.paginationToken>,
	 *                          events: {
	 *                            <event_type>: { <state_key> : {JSON} }
	 *                          }
	 *                        }
	 * User data is stored as follows:
	 *   user_$USERID : User
	 * Sync token:
	 *   sync_token : $TOKEN
	 *
	 * Room Retrieval
	 * --------------
	 * Retrieving a room requires the $ROOMID which then pulls out the current state
	 * from room_$ROOMID_state. A defined starting batch of timeline events are then
	 * extracted from the highest numbered $INDEX for room_$ROOMID_timeline_$INDEX
	 * (more indices as required). The $INDEX may be negative. These are
	 * added to the timeline in the same way as /initialSync (old state will diverge).
	 * If there exists a room_$ROOMID_timeline_live key, then a timeline sync should
	 * be performed before retrieving.
	 *
	 * Retrieval of earlier messages
	 * -----------------------------
	 * The earliest event the Room instance knows about is E. Retrieving earlier
	 * messages requires a Room which has a storageToken defined.
	 * This token maps to the index I where the Room is at. Events are then retrieved from
	 * room_$ROOMID_timeline_{I} and elements before E are extracted. If the limit
	 * demands more events, I-1 is retrieved, up until I=min $INDEX where it gives
	 * less than the limit. Index may go negative if you have paginated in the past.
	 *
	 * Full Insertion
	 * --------------
	 * Storing a room requires the timeline and state keys for $ROOMID to
	 * be blown away and completely replaced, which is computationally expensive.
	 * Room.timeline is batched according to the given batch size B. These batches
	 * are then inserted into storage as room_$ROOMID_timeline_$INDEX. Finally,
	 * the current room state is persisted to room_$ROOMID_state.
	 *
	 * Incremental Insertion
	 * ---------------------
	 * As events arrive, the store can quickly persist these new events. This
	 * involves pushing the events to room_$ROOMID_timeline_live. If the
	 * current room state has been modified by the new event, then
	 * room_$ROOMID_state should be updated in addition to the timeline.
	 *
	 * Timeline sync
	 * -------------
	 * Retrieval of events from the timeline depends on the proper batching of
	 * events. This is computationally expensive to perform on every new event, so
	 * is deferred by inserting live events to room_$ROOMID_timeline_live. A
	 * timeline sync reconciles timeline_live and timeline_$INDEX. This involves
	 * retrieving _live and the highest numbered $INDEX batch. If the batch is < B,
	 * the earliest entries from _live are inserted into the $INDEX until the
	 * batch == B. Then, the remaining entries in _live are batched to $INDEX+1,
	 * $INDEX+2, and so on. The easiest way to visualise this is that the timeline
	 * goes from old to new, left to right:
	 *          -2         -1         0         1
	 * <--OLD---------------------------------------NEW-->
	 *        [a,b,c]    [d,e,f]   [g,h,i]   [j,k,l]
	 *
	 * Purging
	 * -------
	 * Events from the timeline can be purged by removing the lowest
	 * timeline_$INDEX in the store.
	 *
	 * Example
	 * -------
	 * A room with room_id !foo:bar has 9 messages (M1->9 where 9=newest) with a
	 * batch size of 4. The very first time, there is no entry for !foo:bar until
	 * storeRoom() is called, which results in the keys: [Full Insert]
	 *   room_!foo:bar_timeline_0 : [M1, M2, M3, M4]
	 *   room_!foo:bar_timeline_1 : [M5, M6, M7, M8]
	 *   room_!foo:bar_timeline_2 : [M9]
	 *   room_!foo:bar_state: { ... }
	 *
	 * 5 new messages (N1-5, 5=newest) arrive and are then added: [Incremental Insert]
	 *   room_!foo:bar_timeline_live: [N1]
	 *   room_!foo:bar_timeline_live: [N1, N2]
	 *   room_!foo:bar_timeline_live: [N1, N2, N3]
	 *   room_!foo:bar_timeline_live: [N1, N2, N3, N4]
	 *   room_!foo:bar_timeline_live: [N1, N2, N3, N4, N5]
	 *
	 * App is shutdown. Restarts. The timeline is synced [Timeline Sync]
	 *   room_!foo:bar_timeline_2 : [M9, N1, N2, N3]
	 *   room_!foo:bar_timeline_3 : [N4, N5]
	 *   room_!foo:bar_timeline_live: []
	 *
	 * And the room is retrieved with 8 messages: [Room Retrieval]
	 *   Room.timeline: [M7, M8, M9, N1, N2, N3, N4, N5]
	 *   Room.storageToken: => early_index = 1 because that's where M7 is.
	 *
	 * 3 earlier messages are requested: [Earlier retrieval]
	 *   Use storageToken to find batch index 1. Scan batch for earliest event ID.
	 *   earliest event = M7
	 *   events = room_!foo:bar_timeline_1 where event < M7 = [M5, M6]
	 * Too few events, use next index (0) and get 1 more:
	 *   events = room_!foo:bar_timeline_0 = [M1, M2, M3, M4] => [M4]
	 * Return concatentation:
	 *   [M4, M5, M6]
	 *
	 * Purge oldest events: [Purge]
	 *   del room_!foo:bar_timeline_0
	 * </pre>
	 * @module store/webstorage
	 */
	var DEBUG = false;  // set true to enable console logging.
	var utils = __webpack_require__(5);
	var Room = __webpack_require__(58);
	var User = __webpack_require__(37);
	var MatrixEvent = __webpack_require__(15).MatrixEvent;
	
	/**
	 * Construct a web storage store, capable of storing rooms and users.
	 * @constructor
	 * @param {WebStorage} webStore A web storage implementation, e.g.
	 * 'window.localStorage' or 'window.sessionStorage' or a custom implementation.
	 * @param {integer} batchSize The number of events to store per key/value (room
	 * scoped). Use -1 to store all events for a room under one key/value.
	 * @throws if the supplied 'store' does not meet the Storage interface of the
	 * WebStorage API.
	 */
	function WebStorageStore(webStore, batchSize) {
	    this.store = webStore;
	    this.batchSize = batchSize;
	    if (!utils.isFunction(webStore.getItem) || !utils.isFunction(webStore.setItem) ||
	            !utils.isFunction(webStore.removeItem) || !utils.isFunction(webStore.key)) {
	        throw new Error(
	            "Supplied webStore does not meet the WebStorage API interface"
	        );
	    }
	    if (!parseInt(webStore.length) && webStore.length !== 0) {
	        throw new Error(
	            "Supplied webStore does not meet the WebStorage API interface (length)"
	        );
	    }
	    // cached list of room_ids this is storing.
	    this._roomIds = [];
	    this._syncedWithStore = false;
	    // tokens used to remember which index the room instance is at.
	    this._tokens = [
	        // { earliestIndex: -4 }
	    ];
	}
	
	
	/**
	 * Retrieve the token to stream from.
	 * @return {string} The token or null.
	 */
	WebStorageStore.prototype.getSyncToken = function() {
	    return this.store.getItem("sync_token");
	};
	
	/**
	 * Set the token to stream from.
	 * @param {string} token The token to stream from.
	 */
	WebStorageStore.prototype.setSyncToken = function(token) {
	    this.store.setItem("sync_token", token);
	};
	
	/**
	 * Store a room in web storage.
	 * @param {Room} room
	 */
	WebStorageStore.prototype.storeRoom = function(room) {
	    var serRoom = SerialisedRoom.fromRoom(room, this.batchSize);
	    persist(this.store, serRoom);
	    if (this._roomIds.indexOf(room.roomId) === -1) {
	        this._roomIds.push(room.roomId);
	    }
	};
	
	/**
	 * Retrieve a room from web storage.
	 * @param {string} roomId
	 * @return {?Room}
	 */
	WebStorageStore.prototype.getRoom = function(roomId) {
	    // probe if room exists; break early if not. Every room should have state.
	    if (!getItem(this.store, keyName(roomId, "state"))) {
	        debuglog("getRoom: No room with id %s found.", roomId);
	        return null;
	    }
	    var timelineKeys = getTimelineIndices(this.store, roomId);
	    if (timelineKeys.indexOf("live") !== -1) {
	        debuglog("getRoom: Live events found. Syncing timeline for %s", roomId);
	        this._syncTimeline(roomId, timelineKeys);
	    }
	    return loadRoom(this.store, roomId, this.batchSize, this._tokens);
	};
	
	/**
	 * Get a list of all rooms from web storage.
	 * @return {Array} An empty array.
	 */
	WebStorageStore.prototype.getRooms = function() {
	    var rooms = [];
	    var i;
	    if (!this._syncedWithStore) {
	        // sync with the store to set this._roomIds correctly. We know there is
	        // exactly one 'state' key for each room, so we grab them.
	        this._roomIds = [];
	        for (i = 0; i < this.store.length; i++) {
	            if (this.store.key(i).indexOf("room_") === 0 &&
	                    this.store.key(i).indexOf("_state") !== -1) {
	                // grab the middle bit which is the room ID
	                var k = this.store.key(i);
	                this._roomIds.push(
	                    k.substring("room_".length, k.length - "_state".length)
	                );
	            }
	        }
	        this._syncedWithStore = true;
	    }
	    // call getRoom on each room_id
	    for (i = 0; i < this._roomIds.length; i++) {
	        var rm = this.getRoom(this._roomIds[i]);
	        if (rm) {
	            rooms.push(rm);
	        }
	    }
	    return rooms;
	};
	
	/**
	 * Get a list of summaries from web storage.
	 * @return {Array} An empty array.
	 */
	WebStorageStore.prototype.getRoomSummaries = function() {
	    return [];
	};
	
	/**
	 * Store a user in web storage.
	 * @param {User} user
	 */
	WebStorageStore.prototype.storeUser = function(user) {
	    // persist the events used to make the user, we can reconstruct on demand.
	    setItem(this.store, "user_" + user.userId, {
	        presence: user.events.presence ? user.events.presence.event : null
	    });
	};
	
	/**
	 * Get a user from web storage.
	 * @param {string} userId
	 * @return {User}
	 */
	WebStorageStore.prototype.getUser = function(userId) {
	    var userData = getItem(this.store, "user_" + userId);
	    if (!userData) {
	        return null;
	    }
	    var user = new User(userId);
	    if (userData.presence) {
	        user.setPresenceEvent(new MatrixEvent(userData.presence));
	    }
	    return user;
	};
	
	/**
	 * Retrieve scrollback for this room. Automatically adds events to the timeline.
	 * @param {Room} room The matrix room to add the events to the start of the timeline.
	 * @param {integer} limit The max number of old events to retrieve.
	 * @return {Array<Object>} An array of objects which will be at most 'limit'
	 * length and at least 0. The objects are the raw event JSON. The last element
	 * is the 'oldest' (for parity with homeserver scrollback APIs).
	 */
	WebStorageStore.prototype.scrollback = function(room, limit) {
	    if (room.storageToken === undefined || room.storageToken >= this._tokens.length) {
	        return [];
	    }
	    // find the index of the earliest event in this room's timeline
	    var storeData = this._tokens[room.storageToken] || {};
	    var i;
	    var earliestIndex = storeData.earliestIndex;
	    var earliestEventId = room.timeline[0] ? room.timeline[0].getId() : null;
	    debuglog(
	        "scrollback in %s (timeline=%s msgs) i=%s, timeline[0].id=%s - req %s events",
	        room.roomId, room.timeline.length, earliestIndex, earliestEventId, limit
	    );
	    var batch = getItem(
	        this.store, keyName(room.roomId, "timeline", earliestIndex)
	    );
	    if (!batch) {
	        // bad room or already at start, either way we have nothing to give.
	        debuglog("No batch with index %s found.", earliestIndex);
	        return [];
	    }
	    // populate from this batch first
	    var scrollback = [];
	    var foundEventId = false;
	    for (i = batch.length - 1; i >= 0; i--) {
	        // go back and find the earliest event ID, THEN start adding entries.
	        // Make a MatrixEvent so we don't assume .event_id exists
	        // (e.g v2/v3 JSON may be different)
	        var matrixEvent = new MatrixEvent(batch[i]);
	        if (matrixEvent.getId() === earliestEventId) {
	            foundEventId = true;
	            debuglog(
	                "Found timeline[0] event at position %s in batch %s",
	                i, earliestIndex
	            );
	            continue;
	        }
	        if (!foundEventId) {
	            continue;
	        }
	        // add entry
	        debuglog("Add event at position %s in batch %s", i, earliestIndex);
	        scrollback.push(batch[i]);
	        if (scrollback.length === limit) {
	            break;
	        }
	    }
	    if (scrollback.length === limit) {
	        debuglog("Batch has enough events to satisfy request.");
	        return scrollback;
	    }
	    if (!foundEventId) {
	        // the earliest index batch didn't contain the event. In other words,
	        // this timeline is at a state we don't know, so bail.
	        debuglog(
	            "Failed to find event ID %s in batch %s", earliestEventId, earliestIndex
	        );
	        return [];
	    }
	
	    // get the requested earlier events from earlier batches
	    while (scrollback.length < limit) {
	        earliestIndex--;
	        batch = getItem(
	            this.store, keyName(room.roomId, "timeline", earliestIndex)
	        );
	        if (!batch) {
	            // no more events
	            debuglog("No batch found at index %s", earliestIndex);
	            break;
	        }
	        for (i = batch.length - 1; i >= 0; i--) {
	            debuglog("Add event at position %s in batch %s", i, earliestIndex);
	            scrollback.push(batch[i]);
	            if (scrollback.length === limit) {
	                break;
	            }
	        }
	    }
	    debuglog(
	        "Out of %s requested events, returning %s. New index=%s",
	        limit, scrollback.length, earliestIndex
	    );
	    room.addEventsToTimeline(utils.map(scrollback, function(e) {
	            return new MatrixEvent(e);
	    }), true);
	
	    this._tokens[room.storageToken] = {
	        earliestIndex: earliestIndex
	    };
	    return scrollback;
	};
	
	/**
	 * Store events for a room. The events have already been added to the timeline.
	 * @param {Room} room The room to store events for.
	 * @param {Array<MatrixEvent>} events The events to store.
	 * @param {string} token The token associated with these events.
	 * @param {boolean} toStart True if these are paginated results. The last element
	 * is the 'oldest' (for parity with homeserver scrollback APIs).
	 */
	WebStorageStore.prototype.storeEvents = function(room, events, token, toStart) {
	    if (toStart) {
	        // add paginated events to lowest batch indexes (can go -ve)
	        var lowIndex = getIndexExtremity(
	            getTimelineIndices(this.store, room.roomId), true
	        );
	        var i, key, batch;
	        for (i = 0; i < events.length; i++) { // loop events to be stored
	            key = keyName(room.roomId, "timeline", lowIndex);
	            batch = getItem(this.store, key) || [];
	            while (batch.length < this.batchSize && i < events.length) {
	                batch.unshift(events[i].event);
	                i++; // increment to insert next event into this batch
	            }
	            i--; // decrement to avoid skipping one (for loop ++s)
	            setItem(this.store, key, batch);
	            lowIndex--; // decrement index to get a new batch.
	        }
	    }
	    else {
	        // dump as live events
	        var liveEvents = getItem(
	            this.store, keyName(room.roomId, "timeline", "live")
	        ) || [];
	        debuglog(
	            "Adding %s events to %s live list (which has %s already)",
	            events.length, room.roomId, liveEvents.length
	        );
	        var updateState = false;
	        liveEvents = liveEvents.concat(utils.map(events, function(me) {
	            // cheeky check to avoid looping twice
	            if (me.isState()) {
	                updateState = true;
	            }
	            return me.event;
	        }));
	        setItem(
	            this.store, keyName(room.roomId, "timeline", "live"), liveEvents
	        );
	        if (updateState) {
	            debuglog("Storing state for %s as new events updated state", room.roomId);
	            // use 0 batch size; we don't care about batching right now.
	            var serRoom = SerialisedRoom.fromRoom(room, 0);
	            setItem(this.store, keyName(serRoom.roomId, "state"), serRoom.state);
	        }
	    }
	};
	
	/**
	 * Sync the 'live' timeline, batching live events according to 'batchSize'.
	 * @param {string} roomId The room to sync the timeline.
	 * @param {Array<String>} timelineIndices Optional. The indices in the timeline
	 * if known already.
	 */
	WebStorageStore.prototype._syncTimeline = function(roomId, timelineIndices) {
	    timelineIndices = timelineIndices || getTimelineIndices(this.store, roomId);
	    var liveEvents = getItem(this.store, keyName(roomId, "timeline", "live")) || [];
	
	    // get the highest numbered $INDEX batch
	    var highestIndex = getIndexExtremity(timelineIndices);
	    var hiKey = keyName(roomId, "timeline", highestIndex);
	    var hiBatch = getItem(this.store, hiKey) || [];
	    // fill up the existing batch first.
	    while (hiBatch.length < this.batchSize && liveEvents.length > 0) {
	        hiBatch.push(liveEvents.shift());
	    }
	    setItem(this.store, hiKey, hiBatch);
	
	    // start adding new batches as required
	    var batch = [];
	    while (liveEvents.length > 0) {
	        batch.push(liveEvents.shift());
	        if (batch.length === this.batchSize || liveEvents.length === 0) {
	            // persist the full batch and make another
	            highestIndex++;
	            hiKey = keyName(roomId, "timeline", highestIndex);
	            setItem(this.store, hiKey, batch);
	            batch = [];
	        }
	    }
	    // reset live array
	    setItem(this.store, keyName(roomId, "timeline", "live"), []);
	};
	
	
	/**
	 * Store a filter.
	 * @param {Filter} filter
	 */
	WebStorageStore.prototype.storeFilter = function(filter) {
	};
	
	/**
	 * Retrieve a filter.
	 * @param {string} userId
	 * @param {string} filterId
	 * @return {?Filter} A filter or null.
	 */
	WebStorageStore.prototype.getFilter = function(userId, filterId) {
	    return null;
	};
	
	function SerialisedRoom(roomId) {
	    this.state = {
	        events: {}
	    };
	    this.timeline = {
	        // $INDEX: []
	    };
	    this.roomId = roomId;
	}
	
	/**
	 * Convert a Room instance into a SerialisedRoom instance which can be stored
	 * in the key value store.
	 * @param {Room} room The matrix room to convert
	 * @param {integer} batchSize The number of events per timeline batch
	 * @return {SerialisedRoom} A serialised room representation of 'room'.
	 */
	SerialisedRoom.fromRoom = function(room, batchSize) {
	    var self = new SerialisedRoom(room.roomId);
	    var index;
	    self.state.pagination_token = room.oldState.paginationToken;
	    // [room_$ROOMID_state] downcast to POJO from MatrixEvent
	    utils.forEach(utils.keys(room.currentState.events), function(eventType) {
	        utils.forEach(utils.keys(room.currentState.events[eventType]), function(skey) {
	            if (!self.state.events[eventType]) {
	                self.state.events[eventType] = {};
	            }
	            self.state.events[eventType][skey] = (
	                room.currentState.events[eventType][skey].event
	            );
	        });
	    });
	
	    // [room_$ROOMID_timeline_$INDEX]
	    if (batchSize > 0) {
	        index = 0;
	        while (index * batchSize < room.timeline.length) {
	            self.timeline[index] = room.timeline.slice(
	                index * batchSize, (index + 1) * batchSize
	            );
	            self.timeline[index] = utils.map(self.timeline[index], function(me) {
	                // use POJO not MatrixEvent
	                return me.event;
	            });
	            index++;
	        }
	    }
	    else { // don't batch
	        self.timeline[0] = utils.map(room.timeline, function(matrixEvent) {
	            return matrixEvent.event;
	        });
	    }
	    return self;
	};
	
	function loadRoom(store, roomId, numEvents, tokenArray) {
	    var room = new Room(roomId, {
	        storageToken: tokenArray.length
	    });
	
	    // populate state (flatten nested struct to event array)
	    var currentStateMap = getItem(store, keyName(roomId, "state"));
	    var stateEvents = [];
	    utils.forEach(utils.keys(currentStateMap.events), function(eventType) {
	        utils.forEach(utils.keys(currentStateMap.events[eventType]), function(skey) {
	            stateEvents.push(currentStateMap.events[eventType][skey]);
	        });
	    });
	    // TODO: Fix logic dupe with MatrixClient._processRoomEvents
	    var oldStateEvents = utils.map(
	        utils.deepCopy(stateEvents), function(e) {
	            return new MatrixEvent(e);
	        }
	    );
	    var currentStateEvents = utils.map(stateEvents, function(e) {
	            return new MatrixEvent(e);
	        }
	    );
	    room.oldState.setStateEvents(oldStateEvents);
	    room.currentState.setStateEvents(currentStateEvents);
	
	    // add most recent numEvents
	    var recentEvents = [];
	    var index = getIndexExtremity(getTimelineIndices(store, roomId));
	    var eventIndex = index;
	    var i, key, batch;
	    while (recentEvents.length < numEvents) {
	        key = keyName(roomId, "timeline", index);
	        batch = getItem(store, key) || [];
	        if (batch.length === 0) {
	            // nothing left in the store.
	            break;
	        }
	        for (i = batch.length - 1; i >= 0; i--) {
	            recentEvents.unshift(new MatrixEvent(batch[i]));
	            if (recentEvents.length === numEvents) {
	                eventIndex = index;
	                break;
	            }
	        }
	        index--;
	    }
	    // add events backwards to diverge old state correctly.
	    room.addEventsToTimeline(recentEvents.reverse(), true);
	    room.oldState.paginationToken = currentStateMap.pagination_token;
	    // set the token data to let us know which index this room instance is at
	    // for scrollback.
	    tokenArray.push({
	        earliestIndex: eventIndex
	    });
	    return room;
	}
	
	function persist(store, serRoom) {
	    setItem(store, keyName(serRoom.roomId, "state"), serRoom.state);
	    utils.forEach(utils.keys(serRoom.timeline), function(index) {
	        setItem(store,
	            keyName(serRoom.roomId, "timeline", index),
	            serRoom.timeline[index]
	        );
	    });
	}
	
	function getTimelineIndices(store, roomId) {
	    var keys = [];
	    for (var i = 0; i < store.length; i++) {
	        if (store.key(i).indexOf(keyName(roomId, "timeline_")) !== -1) {
	            // e.g. room_$ROOMID_timeline_0  =>  0
	            keys.push(
	                store.key(i).replace(keyName(roomId, "timeline_"), "")
	            );
	        }
	    }
	    return keys;
	}
	
	function getIndexExtremity(timelineIndices, getLowest) {
	    var extremity, index;
	    for (var i = 0; i < timelineIndices.length; i++) {
	        index = parseInt(timelineIndices[i]);
	        if (!isNaN(index) && (
	                extremity === undefined ||
	                !getLowest && index > extremity ||
	                getLowest && index < extremity)) {
	            extremity = index;
	        }
	    }
	    return extremity;
	}
	
	function keyName(roomId, key, index) {
	    return "room_" + roomId + "_" + key + (
	        index === undefined ? "" : ("_" + index)
	    );
	}
	
	function getItem(store, key) {
	    try {
	        return JSON.parse(store.getItem(key));
	    }
	    catch (e) {
	        debuglog("Failed to get key %s: %s", key, e);
	        debuglog(e.stack);
	    }
	    return null;
	}
	
	function setItem(store, key, val) {
	    store.setItem(key, JSON.stringify(val));
	}
	
	function debuglog() {
	    if (DEBUG) {
	        console.log.apply(console, arguments);
	    }
	}
	
	/*
	function delRoomStruct(store, roomId) {
	    var prefix = "room_" + roomId;
	    var keysToRemove = [];
	    for (var i = 0; i < store.length; i++) {
	        if (store.key(i).indexOf(prefix) !== -1) {
	            keysToRemove.push(store.key(i));
	        }
	    }
	    utils.forEach(keysToRemove, function(key) {
	        store.removeItem(key);
	    });
	} */
	
	/** Web Storage Store class. */
	module.exports = WebStorageStore;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2015, 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/*
	 * TODO:
	 * This class mainly serves to take all the syncing logic out of client.js and
	 * into a separate file. It's all very fluid, and this class gut wrenches a lot
	 * of MatrixClient props (e.g. _http). Given we want to support WebSockets as
	 * an alternative syncing API, we may want to have a proper syncing interface
	 * for HTTP and WS at some point.
	 */
	var q = __webpack_require__(18);
	var User = __webpack_require__(37);
	var Room = __webpack_require__(58);
	var utils = __webpack_require__(5);
	var httpApi = __webpack_require__(35);
	var Filter = __webpack_require__(57);
	
	var DEBUG = true;
	
	// /sync requests allow you to set a timeout= but the request may continue
	// beyond that and wedge forever, so we need to track how long we are willing
	// to keep open the connection. This constant is *ADDED* to the timeout= value
	// to determine the max time we're willing to wait.
	var BUFFER_PERIOD_MS = 80 * 1000;
	
	function getFilterName(userId, suffix) {
	    // scope this on the user ID because people may login on many accounts
	    // and they all need to be stored!
	    return "FILTER_SYNC_" + userId + (suffix ? "_" + suffix : "");
	}
	
	function debuglog() {
	    if (!DEBUG) { return; }
	    console.log.apply(console, arguments);
	}
	
	
	/**
	 * <b>Internal class - unstable.</b>
	 * Construct an entity which is able to sync with a homeserver.
	 * @constructor
	 * @param {MatrixClient} client The matrix client instance to use.
	 * @param {Object} opts Config options
	 */
	function SyncApi(client, opts) {
	    this.client = client;
	    opts = opts || {};
	    opts.initialSyncLimit = opts.initialSyncLimit || 8;
	    opts.resolveInvitesToProfiles = opts.resolveInvitesToProfiles || false;
	    opts.pollTimeout = opts.pollTimeout || (30 * 1000);
	    opts.pendingEventOrdering = opts.pendingEventOrdering || "chronological";
	    this.opts = opts;
	    this._peekRoomId = null;
	    this._syncConnectionLost = false;
	    this._currentSyncRequest = null;
	}
	
	/**
	 * @param {string} roomId
	 * @return {Room}
	 */
	SyncApi.prototype.createRoom = function(roomId) {
	    var client = this.client;
	    var room = new Room(roomId, {
	        pendingEventOrdering: this.opts.pendingEventOrdering,
	        timelineSupport: client.timelineSupport,
	    });
	    reEmit(client, room, ["Room.name", "Room.timeline", "Room.receipt", "Room.tags"]);
	    this._registerStateListeners(room);
	    return room;
	};
	
	/**
	 * @param {Room} room
	 * @private
	 */
	SyncApi.prototype._registerStateListeners = function(room) {
	    var client = this.client;
	    // we need to also re-emit room state and room member events, so hook it up
	    // to the client now. We need to add a listener for RoomState.members in
	    // order to hook them correctly. (TODO: find a better way?)
	    reEmit(client, room.currentState, [
	        "RoomState.events", "RoomState.members", "RoomState.newMember"
	    ]);
	    room.currentState.on("RoomState.newMember", function(event, state, member) {
	        member.user = client.getUser(member.userId);
	        reEmit(
	            client, member,
	            [
	                "RoomMember.name", "RoomMember.typing", "RoomMember.powerLevel",
	                "RoomMember.membership"
	            ]
	        );
	    });
	};
	
	/**
	 * @param {Room} room
	 * @private
	 */
	SyncApi.prototype._deregisterStateListeners = function(room) {
	    // could do with a better way of achieving this.
	    room.currentState.removeAllListeners("RoomState.events");
	    room.currentState.removeAllListeners("RoomState.members");
	    room.currentState.removeAllListeners("RoomState.newMember");
	};
	
	
	/**
	 * Sync rooms the user has left.
	 * @return {Promise} Resolved when they've been added to the store.
	 */
	SyncApi.prototype.syncLeftRooms = function() {
	    var client = this.client;
	    var self = this;
	
	    // grab a filter with limit=1 and include_leave=true
	    var filter = new Filter(this.client.credentials.userId);
	    filter.setTimelineLimit(1);
	    filter.setIncludeLeaveRooms(true);
	
	    var localTimeoutMs = this.opts.pollTimeout + BUFFER_PERIOD_MS;
	    var qps = {
	        timeout: 0 // don't want to block since this is a single isolated req
	    };
	
	    return this._getOrCreateFilter(
	        getFilterName(client.credentials.userId, "LEFT_ROOMS"), filter
	    ).then(function(filterId) {
	        qps.filter = filterId;
	        return client._http.authedRequestWithPrefix(
	            undefined, "GET", "/sync", qps, undefined, httpApi.PREFIX_V2_ALPHA,
	            localTimeoutMs
	        );
	    }).then(function(data) {
	        var leaveRooms = [];
	        if (data.rooms && data.rooms.leave) {
	            leaveRooms = self._mapSyncResponseToRoomArray(data.rooms.leave);
	        }
	        var rooms = [];
	        leaveRooms.forEach(function(leaveObj) {
	            var room = leaveObj.room;
	            rooms.push(room);
	            if (!leaveObj.isBrandNewRoom) {
	                // the intention behind syncLeftRooms is to add in rooms which were
	                // *omitted* from the initial /sync. Rooms the user were joined to
	                // but then left whilst the app is running will appear in this list
	                // and we do not want to bother with them since they will have the
	                // current state already (and may get dupe messages if we add
	                // yet more timeline events!), so skip them.
	                // NB: When we persist rooms to localStorage this will be more
	                //     complicated...
	                return;
	            }
	            leaveObj.timeline = leaveObj.timeline || {};
	            var timelineEvents =
	                self._mapSyncEventsFormat(leaveObj.timeline, room);
	            var stateEvents = self._mapSyncEventsFormat(leaveObj.state, room);
	            var paginationToken = (
	                leaveObj.timeline.limited ? leaveObj.timeline.prev_batch : null
	            );
	            self._processRoomEvents(
	                room, stateEvents, timelineEvents, paginationToken
	            );
	            room.recalculate(client.credentials.userId);
	            client.store.storeRoom(room);
	            client.emit("Room", room);
	        });
	        return rooms;
	    });
	};
	
	/**
	 * Peek into a room. This will result in the room in question being synced so it
	 * is accessible via getRooms(). Live updates for the room will be provided.
	 * @param {string} roomId The room ID to peek into.
	 * @return {Promise} A promise which resolves once the room has been added to the
	 * store.
	 */
	SyncApi.prototype.peek = function(roomId) {
	    var self = this;
	    var client = this.client;
	    this._peekRoomId = roomId;
	    return this.client.roomInitialSync(roomId, 20).then(function(response) {
	        // make sure things are init'd
	        response.messages = response.messages || {};
	        response.messages.chunk = response.messages.chunk || [];
	        response.state = response.state || [];
	
	        var peekRoom = self.createRoom(roomId);
	
	        // FIXME: Mostly duplicated from _processRoomEvents but not entirely
	        // because "state" in this API is at the BEGINNING of the chunk
	        var oldStateEvents = utils.map(
	            utils.deepCopy(response.state), client.getEventMapper()
	        );
	        var stateEvents = utils.map(
	            response.state, client.getEventMapper()
	        );
	        var messages = utils.map(
	            response.messages.chunk, client.getEventMapper()
	        );
	
	        // set the pagination token before adding the events in case people
	        // fire off pagination requests in response to the Room.timeline
	        // events.
	        if (response.messages.start) {
	            peekRoom.oldState.paginationToken = response.messages.start;
	        }
	
	        // set the state of the room to as it was after the timeline executes
	        peekRoom.oldState.setStateEvents(oldStateEvents);
	        peekRoom.currentState.setStateEvents(stateEvents);
	
	        self._resolveInvites(peekRoom);
	        peekRoom.recalculate(self.client.credentials.userId);
	
	        // roll backwards to diverge old state. addEventsToTimeline
	        // will overwrite the pagination token, so make sure it overwrites
	        // it with the right thing.
	        peekRoom.addEventsToTimeline(messages.reverse(), true,
	                                     undefined, response.messages.start);
	
	        client.store.storeRoom(peekRoom);
	        client.emit("Room", peekRoom);
	
	        self._peekPoll(roomId);
	        return peekRoom;
	    });
	};
	
	/**
	 * Stop polling for updates in the peeked room. NOPs if there is no room being
	 * peeked.
	 */
	SyncApi.prototype.stopPeeking = function() {
	    this._peekRoomId = null;
	};
	
	/**
	 * Do a peek room poll.
	 * @param {string} roomId
	 * @param {string} token from= token
	 */
	SyncApi.prototype._peekPoll = function(roomId, token) {
	    if (this._peekRoomId !== roomId) {
	        debuglog("Stopped peeking in room %s", roomId);
	        return;
	    }
	
	    var self = this;
	    // FIXME: gut wrenching; hard-coded timeout values
	    this.client._http.authedRequestWithPrefix(undefined, "GET", "/events", {
	        room_id: roomId,
	        timeout: 30 * 1000,
	        from: token
	    }, undefined, httpApi.PREFIX_V1, 50 * 1000).done(function(res) {
	        // strip out events which aren't for the given room_id (e.g presence)
	        var events = res.chunk.filter(function(e) {
	            return e.room_id === roomId;
	        }).map(self.client.getEventMapper());
	        var room = self.client.getRoom(roomId);
	        room.addEvents(events);
	        self._peekPoll(roomId, res.end);
	    }, function(err) {
	        console.error("[%s] Peek poll failed: %s", roomId, err);
	        setTimeout(function() {
	            self._peekPoll(roomId, token);
	        }, 30 * 1000);
	    });
	};
	
	/**
	 * Main entry point
	 */
	SyncApi.prototype.sync = function() {
	    debuglog("SyncApi.sync");
	    var client = this.client;
	    var self = this;
	
	    // We need to do one-off checks before we can begin the /sync loop.
	    // These are:
	    //   1) We need to get push rules so we can check if events should bing as we get
	    //      them from /sync.
	    //   2) We need to get/create a filter which we can use for /sync.
	
	    function getPushRules(attempt) {
	        attempt = attempt || 0;
	        attempt += 1;
	
	        client.getPushRules().done(function(result) {
	            debuglog("Got push rules");
	            client.pushRules = result;
	            getFilter(); // Now get the filter
	        }, retryHandler(attempt, getPushRules));
	    }
	
	    function getFilter(attempt) {
	        attempt = attempt || 0;
	        attempt += 1;
	
	        var filter = new Filter(client.credentials.userId);
	        filter.setTimelineLimit(self.opts.initialSyncLimit);
	
	        self._getOrCreateFilter(
	            getFilterName(client.credentials.userId), filter
	        ).done(function(filterId) {
	            debuglog("Using existing filter ID %s", filterId);
	            self._sync({ filterId: filterId });
	        }, retryHandler(attempt, getFilter));
	    }
	
	    // sets the sync state to error and waits a bit before re-invoking the function.
	    function retryHandler(attempt, fnToRun) {
	        return function(err) {
	            startSyncingRetryTimer(client, attempt, function(newAttempt) {
	                fnToRun(newAttempt);
	            });
	            updateSyncState(client, "ERROR", { error: err });
	        };
	    }
	
	    if (client.isGuest()) {
	        // no push rules for guests, no access to POST filter for guests.
	        self._sync({});
	    }
	    else {
	        getPushRules();
	    }
	};
	
	/**
	 * Invoke me to do /sync calls
	 * @param {Object} syncOptions
	 * @param {string} syncOptions.filterId
	 * @param {boolean} syncOptions.hasSyncedBefore
	 * @param {Number=} attempt
	 */
	SyncApi.prototype._sync = function(syncOptions, attempt) {
	    var client = this.client;
	    var self = this;
	    attempt = attempt || 1;
	
	    var filterId = syncOptions.filterId;
	    if (client.isGuest() && !filterId) {
	        filterId = this._getGuestFilter();
	    }
	
	    var syncToken = client.store.getSyncToken();
	
	    var qps = {
	        filter: filterId,
	        timeout: this.opts.pollTimeout,
	        since: syncToken || undefined // do not send 'null'
	    };
	
	    if (attempt > 1) {
	        // we think the connection is dead. If it comes back up, we won't know
	        // about it till /sync returns. If the timeout= is high, this could
	        // be a long time. Set it to 0 when doing retries.
	        qps.timeout = 0;
	    }
	
	    // normal timeout= plus buffer time
	    var clientSideTimeoutMs = this.opts.pollTimeout + BUFFER_PERIOD_MS;
	
	    this._currentSyncRequest = client._http.authedRequestWithPrefix(
	        undefined, "GET", "/sync", qps, undefined, httpApi.PREFIX_V2_ALPHA,
	        clientSideTimeoutMs
	    );
	
	    this._currentSyncRequest.done(function(data) {
	        self._syncConnectionLost = false;
	        // data looks like:
	        // {
	        //    next_batch: $token,
	        //    presence: { events: [] },
	        //    rooms: {
	        //      invite: {
	        //        $roomid: {
	        //          invite_state: { events: [] }
	        //        }
	        //      },
	        //      join: {
	        //        $roomid: {
	        //          state: { events: [] },
	        //          timeline: { events: [], prev_batch: $token, limited: true },
	        //          ephemeral: { events: [] },
	        //          account_data: { events: [] },
	        //          unread_notifications: {
	        //              highlight_count: 0,
	        //              notification_count: 0,
	        //          }
	        //        }
	        //      },
	        //      leave: {
	        //        $roomid: {
	        //          state: { events: [] },
	        //          timeline: { events: [], prev_batch: $token }
	        //        }
	        //      }
	        //    }
	        // }
	
	        // set the sync token NOW *before* processing the events. We do this so
	        // if something barfs on an event we can skip it rather than constantly
	        // polling with the same token.
	        client.store.setSyncToken(data.next_batch);
	
	        // TODO-arch:
	        // - Each event we pass through needs to be emitted via 'event', can we
	        //   do this in one place?
	        // - The isBrandNewRoom boilerplate is boilerplatey.
	
	        try {
	            self._processSyncResponse(syncToken, data);
	        }
	        catch (e) {
	            console.error("Caught /sync error:");
	            console.error(e);
	        }
	
	        // emit synced events
	        if (!syncOptions.hasSyncedBefore) {
	            updateSyncState(client, "PREPARED");
	            syncOptions.hasSyncedBefore = true;
	        }
	
	        // keep emitting SYNCING -> SYNCING for clients who want to do bulk updates
	        updateSyncState(client, "SYNCING");
	
	        self._sync(syncOptions);
	    }, function(err) {
	        if (!self._syncConnectionLost) {
	            debuglog("Starting keep-alive");
	            self._syncConnectionLost = true;
	            retryPromise(self._pokeKeepAlive.bind(self), 2000).done(function() {
	                debuglog("Keep-alive successful.");
	                // blow away the current /sync request if the connection is still
	                // dead. It may be black-holed.
	                if (!self._syncConnectionLost) {
	                    return;
	                }
	                if (self._currentSyncRequest.abort) {
	                    // kill the current sync request
	                    debuglog("Aborting current /sync.");
	                    self._currentSyncRequest.abort();
	                }
	                // immediately retry if we were waiting
	                debuglog(
	                    "Interrupted /sync backoff: %s", self.client.retryImmediately()
	                );
	            });
	        }
	        console.error("/sync error (%s attempts): %s", attempt, err);
	        console.error(err);
	        attempt += 1;
	        startSyncingRetryTimer(client, attempt, function(newAttempt) {
	            self._sync(syncOptions, newAttempt);
	        });
	        updateSyncState(client, "ERROR", { error: err });
	    });
	};
	
	/**
	 * Process data returned from a sync response and propagate it
	 * into the model objects
	 *
	 * @param {string} syncToken the old next_batch token sent to this
	 *    sync request.
	 * @param {Object} data The response from /sync
	 */
	SyncApi.prototype._processSyncResponse = function(syncToken, data) {
	    var client = this.client;
	    var self = this;
	
	    // handle presence events (User objects)
	    if (data.presence && utils.isArray(data.presence.events)) {
	        data.presence.events.map(client.getEventMapper()).forEach(
	        function(presenceEvent) {
	            var user = client.store.getUser(presenceEvent.getSender());
	            if (user) {
	                user.setPresenceEvent(presenceEvent);
	            }
	            else {
	                user = createNewUser(client, presenceEvent.getSender());
	                user.setPresenceEvent(presenceEvent);
	                client.store.storeUser(user);
	            }
	            client.emit("event", presenceEvent);
	        });
	    }
	
	    // the returned json structure is abit crap, so make it into a
	    // nicer form (array) after applying sanity to make sure we don't fail
	    // on missing keys (on the off chance)
	    var inviteRooms = [];
	    var joinRooms = [];
	    var leaveRooms = [];
	
	    if (data.rooms) {
	        if (data.rooms.invite) {
	            inviteRooms = this._mapSyncResponseToRoomArray(data.rooms.invite);
	        }
	        if (data.rooms.join) {
	            joinRooms = this._mapSyncResponseToRoomArray(data.rooms.join);
	        }
	        if (data.rooms.leave) {
	            leaveRooms = this._mapSyncResponseToRoomArray(data.rooms.leave);
	        }
	    }
	
	    // Handle invites
	    inviteRooms.forEach(function(inviteObj) {
	        var room = inviteObj.room;
	        var stateEvents =
	            self._mapSyncEventsFormat(inviteObj.invite_state, room);
	        self._processRoomEvents(room, stateEvents);
	        if (inviteObj.isBrandNewRoom) {
	            room.recalculate(client.credentials.userId);
	            client.store.storeRoom(room);
	            client.emit("Room", room);
	        }
	        stateEvents.forEach(function(e) { client.emit("event", e); });
	    });
	
	    // Handle joins
	    joinRooms.forEach(function(joinObj) {
	        var room = joinObj.room;
	        var stateEvents = self._mapSyncEventsFormat(joinObj.state, room);
	        var timelineEvents = self._mapSyncEventsFormat(joinObj.timeline, room);
	        var ephemeralEvents = self._mapSyncEventsFormat(joinObj.ephemeral);
	        var accountDataEvents = self._mapSyncEventsFormat(joinObj.account_data);
	
	        // we do this first so it's correct when any of the events fire
	        if (joinObj.unread_notifications) {
	            room.setUnreadNotificationCount(
	                'total', joinObj.unread_notifications.notification_count
	            );
	            room.setUnreadNotificationCount(
	                'highlight', joinObj.unread_notifications.highlight_count
	            );
	        }
	
	        joinObj.timeline = joinObj.timeline || {};
	
	        if (joinObj.timeline.limited) {
	            // nuke the timeline so we don't get holes
	            //
	            // save the old 'next_batch' token as the
	            // forward-pagination token for the previously-active
	            // timeline.
	            room.currentState.paginationToken = syncToken;
	            self._deregisterStateListeners(room);
	            room.resetLiveTimeline();
	            self._registerStateListeners(room);
	        }
	
	        // we want to set a new pagination token if this is the first time
	        // we've made this room or if we're nuking the timeline
	        var paginationToken = null;
	        if (joinObj.isBrandNewRoom || joinObj.timeline.limited) {
	            paginationToken = joinObj.timeline.prev_batch;
	        }
	
	        self._processRoomEvents(
	            room, stateEvents, timelineEvents, paginationToken
	        );
	
	        // XXX: should we be adding ephemeralEvents to the timeline?
	        // It feels like that for symmetry with room.addAccountData()
	        // there should be a room.addEphemeralEvents() or similar.
	        room.addEvents(ephemeralEvents);
	
	        // we deliberately don't add accountData to the timeline
	        room.addAccountData(accountDataEvents);
	
	        room.recalculate(client.credentials.userId);
	        if (joinObj.isBrandNewRoom) {
	            client.store.storeRoom(room);
	            client.emit("Room", room);
	        }
	        stateEvents.forEach(function(e) { client.emit("event", e); });
	        timelineEvents.forEach(function(e) { client.emit("event", e); });
	        ephemeralEvents.forEach(function(e) { client.emit("event", e); });
	        accountDataEvents.forEach(function(e) { client.emit("event", e); });
	    });
	
	    // Handle leaves
	    leaveRooms.forEach(function(leaveObj) {
	        // Do the bear minimum to register rejected invites / you leaving rooms
	        var room = leaveObj.room;
	        var timelineEvents =
	            self._mapSyncEventsFormat(leaveObj.timeline, room);
	        room.addEvents(timelineEvents);
	        timelineEvents.forEach(function(e) { client.emit("event", e); });
	    });
	};
	
	/**
	 * @return {Promise}
	 */
	SyncApi.prototype._pokeKeepAlive = function() {
	    return this.client._http.requestWithPrefix(
	        undefined, "GET", "/_matrix/client/versions", undefined,
	        undefined, "", 5 * 1000
	    );
	};
	
	/**
	 * @param {string} filterName
	 * @param {Filter} filter
	 * @return {Promise<String>} Filter ID
	 */
	SyncApi.prototype._getOrCreateFilter = function(filterName, filter) {
	    var client = this.client;
	    var filterId = client.store.getFilterIdByName(filterName);
	    if (filterId) {
	        // super, just use that.
	        return q(filterId);
	    }
	
	    // create a filter
	    return client.createFilter(filter.getDefinition()).then(function(createdFilter) {
	        client.store.setFilterIdByName(filterName, createdFilter.filterId);
	        return createdFilter.filterId;
	    });
	};
	
	/**
	 * @param {Object} obj
	 * @return {Object[]}
	 */
	SyncApi.prototype._mapSyncResponseToRoomArray = function(obj) {
	    // Maps { roomid: {stuff}, roomid: {stuff} }
	    // to
	    // [{stuff+Room+isBrandNewRoom}, {stuff+Room+isBrandNewRoom}]
	    var client = this.client;
	    var self = this;
	    return utils.keys(obj).map(function(roomId) {
	        var arrObj = obj[roomId];
	        var room = client.store.getRoom(roomId);
	        var isBrandNewRoom = false;
	        if (!room) {
	            room = self.createRoom(roomId);
	            isBrandNewRoom = true;
	        }
	        arrObj.room = room;
	        arrObj.isBrandNewRoom = isBrandNewRoom;
	        return arrObj;
	    });
	};
	
	/**
	 * @param {Object} obj
	 * @param {Room} room
	 * @return {MatrixEvent[]}
	 */
	SyncApi.prototype._mapSyncEventsFormat = function(obj, room) {
	    if (!obj || !utils.isArray(obj.events)) {
	        return [];
	    }
	    var mapper = this.client.getEventMapper();
	    return obj.events.map(function(e) {
	        if (room) {
	            e.room_id = room.roomId;
	        }
	        return mapper(e);
	    });
	};
	
	/**
	 * @param {Room} room
	 */
	SyncApi.prototype._resolveInvites = function(room) {
	    if (!room || !this.opts.resolveInvitesToProfiles) {
	        return;
	    }
	    var client = this.client;
	    // For each invited room member we want to give them a displayname/avatar url
	    // if they have one (the m.room.member invites don't contain this).
	    room.getMembersWithMembership("invite").forEach(function(member) {
	        if (member._requestedProfileInfo) {
	            return;
	        }
	        member._requestedProfileInfo = true;
	        // try to get a cached copy first.
	        var user = client.getUser(member.userId);
	        var promise;
	        if (user) {
	            promise = q({
	                avatar_url: user.avatarUrl,
	                displayname: user.displayName
	            });
	        }
	        else {
	            promise = client.getProfileInfo(member.userId);
	        }
	        promise.done(function(info) {
	            // slightly naughty by doctoring the invite event but this means all
	            // the code paths remain the same between invite/join display name stuff
	            // which is a worthy trade-off for some minor pollution.
	            var inviteEvent = member.events.member;
	            if (inviteEvent.getContent().membership !== "invite") {
	                // between resolving and now they have since joined, so don't clobber
	                return;
	            }
	            inviteEvent.getContent().avatar_url = info.avatar_url;
	            inviteEvent.getContent().displayname = info.displayname;
	            // fire listeners
	            member.setMembershipEvent(inviteEvent, room.currentState);
	        }, function(err) {
	            // OH WELL.
	        });
	    });
	};
	
	/**
	 * @param {Room} room
	 * @param {MatrixEvent[]} stateEventList A list of state events. This is the state
	 * at the *START* of the timeline list if it is supplied.
	 * @param {?MatrixEvent[]} timelineEventList A list of timeline events. Lower index
	 * is earlier in time. Higher index is later.
	 * @param {string=} paginationToken  pagination token for going backwards in time.
	 * This should only be set if this is a new room/timeline.
	 */
	SyncApi.prototype._processRoomEvents = function(room, stateEventList,
	                                                timelineEventList, paginationToken) {
	    timelineEventList = timelineEventList || [];
	    var client = this.client;
	    // "old" and "current" state are the same initially; they
	    // start diverging if the user paginates.
	    // We must deep copy otherwise membership changes in old state
	    // will leak through to current state!
	    var oldStateEvents = utils.map(
	        utils.deepCopy(
	            stateEventList.map(function(mxEvent) { return mxEvent.event; })
	        ), client.getEventMapper()
	    );
	    var stateEvents = stateEventList;
	
	    // Set the pagination token BEFORE adding events to the timeline: it's not
	    // unreasonable for clients to call scrollback() in response to Room.timeline
	    // events which addEventsToTimeline will emit-- we want to make sure they use
	    // the right token if and when they do.
	    if (paginationToken) {
	        room.oldState.paginationToken = paginationToken;
	    }
	
	    // set the state of the room to as it was before the timeline executes
	    room.oldState.setStateEvents(oldStateEvents);
	    room.currentState.setStateEvents(stateEvents);
	
	    this._resolveInvites(room);
	
	    // recalculate the room name at this point as adding events to the timeline
	    // may make notifications appear which should have the right name.
	    room.recalculate(this.client.credentials.userId);
	
	    // execute the timeline events, this will begin to diverge the current state
	    // if the timeline has any state events in it.
	    room.addEventsToTimeline(timelineEventList);
	};
	
	/**
	 * @return {string}
	 */
	SyncApi.prototype._getGuestFilter = function() {
	    var guestRooms = this.client._guestRooms; // FIXME: horrible gut-wrenching
	    if (!guestRooms) {
	        return "{}";
	    }
	    // we just need to specify the filter inline if we're a guest because guests
	    // can't create filters.
	    return JSON.stringify({
	        room: {
	            timeline: {
	                limit: 20
	            }
	        }
	    });
	};
	
	function retryTimeMsForAttempt(attempt) {
	    // 2,4,8,16,32,32,32,32,... seconds
	    // max 2^5 secs = 32 secs
	    return Math.pow(2, Math.min(attempt, 5)) * 1000;
	}
	
	function retryPromise(promiseFn, delay) {
	    delay = delay || 0;
	    return promiseFn().catch(function(reason) { // if it fails
	        // retry after waiting the delay time
	        return q.delay(delay).then(retryPromise.bind(null, promiseFn, delay));
	    });
	}
	
	function startSyncingRetryTimer(client, attempt, fn) {
	    client._syncingRetry = {};
	    client._syncingRetry.fn = fn;
	    var newAttempt = attempt;
	    var timeBeforeWaitingMs = Date.now();
	    var timeToWaitMs = retryTimeMsForAttempt(attempt);
	    client._syncingRetry.timeoutId = setTimeout(function() {
	        var timeAfterWaitingMs = Date.now();
	        var timeDeltaMs = timeAfterWaitingMs - timeBeforeWaitingMs;
	        if (timeDeltaMs > (2 * timeToWaitMs)) {
	            // we've waited more than twice what we were supposed to. Reset the
	            // attempt number back to 1. This can happen when the comp goes to
	            // sleep whilst the timer is running.
	            newAttempt = 1;
	            console.warn(
	                "Sync retry timer: Tried to wait %s ms but actually waited %s ms",
	                timeToWaitMs, timeDeltaMs
	            );
	        }
	        fn(newAttempt);
	    }, timeToWaitMs);
	}
	
	function updateSyncState(client, newState, data) {
	    var old = client._syncState;
	    client._syncState = newState;
	    client.emit("sync", client._syncState, old, data);
	}
	
	function createNewUser(client, userId) {
	    var user = new User(userId);
	    reEmit(client, user, ["User.avatarUrl", "User.displayName", "User.presence"]);
	    return user;
	}
	
	function reEmit(reEmitEntity, emittableEntity, eventNames) {
	    utils.forEach(eventNames, function(eventName) {
	        // setup a listener on the entity (the Room, User, etc) for this event
	        emittableEntity.on(eventName, function() {
	            // take the args from the listener and reuse them, adding the
	            // event name to the arg list so it works with .emit()
	            // Transformation Example:
	            // listener on "foo" => function(a,b) { ... }
	            // Re-emit on "thing" => thing.emit("foo", a, b)
	            var newArgs = [eventName];
	            for (var i = 0; i < arguments.length; i++) {
	                newArgs.push(arguments[i]);
	            }
	            reEmitEntity.emit.apply(reEmitEntity, newArgs);
	        });
	    });
	}
	
	/** */
	module.exports = SyncApi;


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	/*
	Copyright 2016 OpenMarket Ltd
	
	Licensed under the Apache License, Version 2.0 (the "License");
	you may not use this file except in compliance with the License.
	You may obtain a copy of the License at
	
	    http://www.apache.org/licenses/LICENSE-2.0
	
	Unless required by applicable law or agreed to in writing, software
	distributed under the License is distributed on an "AS IS" BASIS,
	WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	See the License for the specific language governing permissions and
	limitations under the License.
	*/
	"use strict";
	
	/** @module timeline-window */
	
	var q = __webpack_require__(18);
	var EventTimeline = __webpack_require__(36);
	
	/**
	 * @private
	 */
	var DEBUG = false;
	
	/**
	 * @private
	 */
	var debuglog = DEBUG ? console.log.bind(console) : function() {};
	
	/**
	 * Construct a TimelineWindow.
	 *
	 * <p>This abstracts the separate timelines in a Matrix {@link
	 * module:models/room~Room|Room} into a single iterable thing. It keeps track of
	 * the start and endpoints of the window, which can be advanced with the help
	 * of pagination requests.
	 *
	 * <p>Before the window is useful, it must be initialised by calling {@link
	 * module:timeline-window~TimelineWindow#load|load}.
	 *
	 * <p>Note that the window will not automatically extend itself when new events
	 * are received from /sync; you should arrange to call {@link
	 * module:timeline-window~TimelineWindow#paginate|paginate} on {@link
	 * module:client~MatrixClient.event:"Room.timeline"|Room.timeline} events.
	 *
	 * @param {MatrixClient} client   MatrixClient to be used for context/pagination
	 *   requests.
	 *
	 * @param {Room} room  The room to track
	 *
	 * @param {Object} [opts] Configuration options for this window
	 *
	 * @param {number} [opts.windowLimit = 1000] maximum number of events to keep
	 *    in the window. If more events are retrieved via pagination requests,
	 *    excess events will be dropped from the other end of the window.
	 *
	 * @constructor
	 */
	function TimelineWindow(client, room, opts) {
	    opts = opts || {};
	    this._client = client;
	    this._room = room;
	
	    // these will be TimelineIndex objects; they delineate the 'start' and
	    // 'end' of the window.
	    //
	    // _start.index is inclusive; _end.index is exclusive.
	    this._start = null;
	    this._end = null;
	
	    this._eventCount = 0;
	    this._windowLimit = opts.windowLimit || 1000;
	}
	
	/**
	 * Initialise the window to point at a given event, or the live timeline
	 *
	 * @param {string} [initialEventId]   If given, the window will contain the
	 *    given event
	 * @param {number} [initialWindowSize = 20]   Size of the initial window
	 *
	 * @return {module:client.Promise}
	 */
	TimelineWindow.prototype.load = function(initialEventId, initialWindowSize) {
	    var self = this;
	    initialWindowSize = initialWindowSize || 20;
	
	    var prom;
	    if (initialEventId) {
	        debuglog("TimelineWindow: initialising for event " + initialEventId);
	        prom = this._client.getEventTimeline(this._room, initialEventId)
	            .then(function(tl) {
	                // make sure that our window includes the event
	                for (var i = 0; i < tl.getEvents().length; i++) {
	                    if (tl.getEvents()[i].getId() == initialEventId) {
	                        return {timeline: tl, index: i};
	                    }
	                }
	                throw new Error("getEventTimeline result didn't include requested event");
	            });
	    } else {
	        debuglog("TimelineWindow: initialising with live timeline");
	
	        // start with the most recent events
	        var tl = this._room.getLiveTimeline();
	        prom = q({timeline: tl, index: tl.getEvents().length});
	    }
	
	    prom = prom.then(function(v) {
	        var tl = v.timeline, eventIndex = v.index;
	
	        var endIndex = Math.min(tl.getEvents().length,
	                                eventIndex + Math.ceil(initialWindowSize / 2));
	        var startIndex = Math.max(0, endIndex - initialWindowSize);
	        self._start = new TimelineIndex(tl, startIndex - tl.getBaseIndex());
	        self._end = new TimelineIndex(tl, endIndex - tl.getBaseIndex());
	        self._eventCount = endIndex - startIndex;
	    });
	
	    return prom;
	};
	
	/**
	 * Check if this window can be extended
	 *
	 * <p>This returns true if we either have more events, or if we have a
	 * pagination token which means we can paginate in that direction. It does not
	 * necessarily mean that there are more events available in that direction at
	 * this time.
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to check if we can
	 *   paginate backwards; EventTimeline.FORWARDS to check if we can go forwards
	 *
	 * @return {boolean} true if we can paginate in the given direction
	 */
	TimelineWindow.prototype.canPaginate = function(direction) {
	    var tl;
	    if (direction == EventTimeline.BACKWARDS) {
	        tl = this._start;
	    } else if (direction == EventTimeline.FORWARDS) {
	        tl = this._end;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	
	    if (!tl) {
	        debuglog("TimelineWindow: no timeline yet");
	        return false;
	    }
	
	    if (direction == EventTimeline.BACKWARDS) {
	        if (tl.index > tl.minIndex()) { return true; }
	    } else {
	        if (tl.index < tl.maxIndex()) { return true; }
	    }
	
	    return Boolean(tl.timeline.getNeighbouringTimeline(direction) ||
	                   tl.timeline.getPaginationToken(direction));
	};
	
	/**
	 * Attempt to extend the window
	 *
	 * @param {string} direction   EventTimeline.BACKWARDS to extend the window
	 *    backwards (towards older events); EventTimeline.FORWARDS to go forwards.
	 *
	 * @param {number} size   number of events to try to extend by. If fewer than this
	 *    number are immediately available, then we return immediately rather than
	 *    making an API call.
	 *
	 * @param {boolean} [makeRequest = true] whether we should make API calls to
	 *    fetch further events if we don't have any at all. (This has no effect if
	 *    the room already knows about additional events in the relevant direction,
	 *    even if there are fewer than 'size' of them, as we will just return those
	 *    we already know about.)
	 *
	 * @return {module:client.Promise} Resolves to a boolean which is true if more events
	 *    were successfully retrieved.
	 */
	TimelineWindow.prototype.paginate = function(direction, size, makeRequest) {
	    // Either wind back the message cap (if there are enough events in the
	    // timeline to do so), or fire off a pagination request.
	
	    if (makeRequest === undefined) {
	        makeRequest = true;
	    }
	
	    var tl;
	    if (direction == EventTimeline.BACKWARDS) {
	        tl = this._start;
	    } else if (direction == EventTimeline.FORWARDS) {
	        tl = this._end;
	    } else {
	        throw new Error("Invalid direction '" + direction + "'");
	    }
	
	    if (!tl) {
	        debuglog("TimelineWindow: no timeline yet");
	        return q(false);
	    }
	
	    if (tl.pendingPaginate) {
	        return tl.pendingPaginate;
	    }
	
	    // try moving the cap
	    var count = (direction == EventTimeline.BACKWARDS) ?
	        tl.retreat(size) : tl.advance(size);
	
	    if (count) {
	        this._eventCount += count;
	        debuglog("TimelineWindow: increased cap by " + count +
	                 " (now " + this._eventCount + ")");
	        // remove some events from the other end, if necessary
	        var excess = this._eventCount - this._windowLimit;
	        if (excess > 0) {
	            this._unpaginate(excess, direction != EventTimeline.BACKWARDS);
	        }
	        return q(true);
	    }
	
	    if (!makeRequest) {
	        return q(false);
	    }
	
	    // try making a pagination request
	    var token = tl.timeline.getPaginationToken(direction);
	    if (!token) {
	        debuglog("TimelineWindow: no token");
	        return q(false);
	    }
	
	    debuglog("TimelineWindow: starting request");
	    var self = this;
	    var prom = this._client.paginateEventTimeline(tl.timeline, {
	        backwards: direction == EventTimeline.BACKWARDS,
	        limit: size
	    }).finally(function() {
	        tl.pendingPaginate = null;
	    }).then(function(r) {
	        debuglog("TimelineWindow: request completed with result " + r);
	        if (!r) {
	            // end of timeline
	            return false;
	        }
	        // recurse to advance the index into the results, but before we do, set
	        // makeRequest=false. It's not an absolute given that the paginate
	        // request returned events which we can now use, but we certainly don't
	        // want to get stuck in a tight loop here if things start going wrong.
	        return self.paginate(direction, size, false);
	    });
	    tl.pendingPaginate = prom;
	    return prom;
	};
	
	
	/**
	 * Trim the window to the windowlimit
	 *
	 * @param {number}  delta           number of events to remove from the timeline
	 * @param {boolean} startOfTimeline if events should be removed from the start
	 *     of the timeline.
	 *
	 * @private
	 */
	TimelineWindow.prototype._unpaginate = function(delta, startOfTimeline) {
	    var tl = startOfTimeline ? this._start : this._end;
	
	    // sanity-check the delta
	    if (delta > this._eventCount || delta < 0) {
	        throw new Error("Attemting to unpaginate " + delta + " events, but " +
	                        "only have " + this._eventCount + " in the timeline");
	    }
	
	    while (delta > 0) {
	        var count = startOfTimeline ? tl.advance(delta) : tl.retreat(delta);
	        if (count <= 0) {
	            // sadness. This shouldn't be possible.
	            throw new Error(
	                "Unable to unpaginate any further, but still have " +
	                    this._eventCount + " events");
	        }
	
	        delta -= count;
	        this._eventCount -= count;
	        debuglog("TimelineWindow.unpaginate: dropped " + count +
	                 " (now " + this._eventCount + ")");
	    }
	};
	
	
	/**
	 * Get a list of the events currently in the window
	 *
	 * @return {MatrixEvent[]} the events in the window
	 */
	TimelineWindow.prototype.getEvents = function() {
	    if (!this._start) {
	        // not yet loaded
	        return [];
	    }
	
	    var result = [];
	
	    // iterate through each timeline between this._start and this._end
	    // (inclusive).
	    var timeline = this._start.timeline;
	    while (true) {
	        var events = timeline.getEvents();
	
	        // For the first timeline in the chain, we want to start at
	        // this._start.index. For the last timeline in the chain, we want to
	        // stop before this._end.index. Otherwise, we want to copy all of the
	        // events in the timeline.
	        //
	        // (Note that both this._start.index and this._end.index are relative
	        // to their respective timelines' BaseIndex).
	        //
	        var startIndex = 0, endIndex = events.length;
	        if (timeline === this._start.timeline) {
	            startIndex = this._start.index + timeline.getBaseIndex();
	        }
	        if (timeline === this._end.timeline) {
	            endIndex = this._end.index + timeline.getBaseIndex();
	        }
	
	        for (var i = startIndex; i < endIndex; i++) {
	            result.push(events[i]);
	        }
	
	        // if we're not done, iterate to the next timeline.
	        if (timeline === this._end.timeline) {
	            break;
	        } else {
	            timeline = timeline.getNeighbouringTimeline(EventTimeline.FORWARDS);
	        }
	    }
	
	    return result;
	};
	
	
	/**
	 * a thing which contains a timeline reference, and an index into it.
	 *
	 * @constructor
	 * @param {EventTimeline} timeline
	 * @param {number} index
	 * @private
	 */
	function TimelineIndex(timeline, index) {
	    this.timeline = timeline;
	
	    // the indexes are relative to BaseIndex, so could well be negative.
	    this.index = index;
	}
	
	/**
	 * @return {number} the minimum possible value for the index in the current
	 *    timeline
	 */
	TimelineIndex.prototype.minIndex = function() {
	    return this.timeline.getBaseIndex() * -1;
	};
	
	/**
	 * @return {number} the maximum possible value for the index in the current
	 *    timeline (exclusive - ie, it actually returns one more than the index
	 *    of the last element).
	 */
	TimelineIndex.prototype.maxIndex = function() {
	    return this.timeline.getEvents().length - this.timeline.getBaseIndex();
	};
	
	/**
	 * Try move the index forward, or into the neighbouring timeline
	 *
	 * @param {number} delta  number of events to advance by
	 * @return {number} number of events successfully advanced by
	 */
	TimelineIndex.prototype.advance = function(delta) {
	    if (!delta) {
	        return 0;
	    }
	
	    // first try moving the index in the current timeline. See if there is room
	    // to do so.
	    var cappedDelta;
	    if (delta < 0) {
	        // we want to wind the index backwards.
	        //
	        // (this.minIndex() - this.index) is a negative number whose magnitude
	        // is the amount of room we have to wind back the index in the current
	        // timeline. We cap delta to this quantity.
	        cappedDelta = Math.max(delta, this.minIndex() - this.index);
	        if (cappedDelta < 0) {
	            this.index += cappedDelta;
	            return cappedDelta;
	        }
	    } else {
	        // we want to wind the index forwards.
	        //
	        // (this.maxIndex() - this.index) is a (positive) number whose magnitude
	        // is the amount of room we have to wind forward the index in the current
	        // timeline. We cap delta to this quantity.
	        cappedDelta = Math.min(delta, this.maxIndex() - this.index);
	        if (cappedDelta > 0) {
	            this.index += cappedDelta;
	            return cappedDelta;
	        }
	    }
	
	    // the index is already at the start/end of the current timeline.
	    //
	    // next see if there is a neighbouring timeline to switch to.
	    var neighbour = this.timeline.getNeighbouringTimeline(
	        delta < 0 ? EventTimeline.BACKWARDS : EventTimeline.FORWARDS);
	    if (neighbour) {
	        this.timeline = neighbour;
	        if (delta < 0) {
	            this.index = this.maxIndex();
	        } else {
	            this.index = this.minIndex();
	        }
	
	        debuglog("paginate: switched to new neighbour");
	
	        // recurse, using the next timeline
	        return this.advance(delta);
	    }
	
	    return 0;
	};
	
	/**
	 * Try move the index backwards, or into the neighbouring timeline
	 *
	 * @param {number} delta  number of events to retreat by
	 * @return {number} number of events successfully retreated by
	 */
	TimelineIndex.prototype.retreat = function(delta) {
	    return this.advance(delta * -1) * -1;
	};
	
	/**
	 * The TimelineWindow class.
	 */
	module.exports.TimelineWindow = TimelineWindow;
	
	/**
	 * The TimelineIndex class. exported here for unit testing.
	 */
	module.exports.TimelineIndex = TimelineIndex;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Browser Request
	//
	// Licensed under the Apache License, Version 2.0 (the "License");
	// you may not use this file except in compliance with the License.
	// You may obtain a copy of the License at
	//
	//     http://www.apache.org/licenses/LICENSE-2.0
	//
	// Unless required by applicable law or agreed to in writing, software
	// distributed under the License is distributed on an "AS IS" BASIS,
	// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	// See the License for the specific language governing permissions and
	// limitations under the License.
	
	// UMD HEADER START 
	(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like enviroments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.returnExports = factory();
	  }
	}(this, function () {
	// UMD HEADER END
	
	var XHR = XMLHttpRequest
	if (!XHR) throw new Error('missing XMLHttpRequest')
	request.log = {
	  'trace': noop, 'debug': noop, 'info': noop, 'warn': noop, 'error': noop
	}
	
	var DEFAULT_TIMEOUT = 3 * 60 * 1000 // 3 minutes
	
	//
	// request
	//
	
	function request(options, callback) {
	  // The entry-point to the API: prep the options object and pass the real work to run_xhr.
	  if(typeof callback !== 'function')
	    throw new Error('Bad callback given: ' + callback)
	
	  if(!options)
	    throw new Error('No options given')
	
	  var options_onResponse = options.onResponse; // Save this for later.
	
	  if(typeof options === 'string')
	    options = {'uri':options};
	  else
	    options = JSON.parse(JSON.stringify(options)); // Use a duplicate for mutating.
	
	  options.onResponse = options_onResponse // And put it back.
	
	  if (options.verbose) request.log = getLogger();
	
	  if(options.url) {
	    options.uri = options.url;
	    delete options.url;
	  }
	
	  if(!options.uri && options.uri !== "")
	    throw new Error("options.uri is a required argument");
	
	  if(typeof options.uri != "string")
	    throw new Error("options.uri must be a string");
	
	  var unsupported_options = ['proxy', '_redirectsFollowed', 'maxRedirects', 'followRedirect']
	  for (var i = 0; i < unsupported_options.length; i++)
	    if(options[ unsupported_options[i] ])
	      throw new Error("options." + unsupported_options[i] + " is not supported")
	
	  options.callback = callback
	  options.method = options.method || 'GET';
	  options.headers = options.headers || {};
	  options.body    = options.body || null
	  options.timeout = options.timeout || request.DEFAULT_TIMEOUT
	
	  if(options.headers.host)
	    throw new Error("Options.headers.host is not supported");
	
	  if(options.json) {
	    options.headers.accept = options.headers.accept || 'application/json'
	    if(options.method !== 'GET')
	      options.headers['content-type'] = 'application/json'
	
	    if(typeof options.json !== 'boolean')
	      options.body = JSON.stringify(options.json)
	    else if(typeof options.body !== 'string')
	      options.body = JSON.stringify(options.body)
	  }
	  
	  //BEGIN QS Hack
	  var serialize = function(obj) {
	    var str = [];
	    for(var p in obj)
	      if (obj.hasOwnProperty(p)) {
	        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
	      }
	    return str.join("&");
	  }
	  
	  if(options.qs){
	    var qs = (typeof options.qs == 'string')? options.qs : serialize(options.qs);
	    if(options.uri.indexOf('?') !== -1){ //no get params
	        options.uri = options.uri+'&'+qs;
	    }else{ //existing get params
	        options.uri = options.uri+'?'+qs;
	    }
	  }
	  //END QS Hack
	  
	  //BEGIN FORM Hack
	  var multipart = function(obj) {
	    //todo: support file type (useful?)
	    var result = {};
	    result.boundry = '-------------------------------'+Math.floor(Math.random()*1000000000);
	    var lines = [];
	    for(var p in obj){
	        if (obj.hasOwnProperty(p)) {
	            lines.push(
	                '--'+result.boundry+"\n"+
	                'Content-Disposition: form-data; name="'+p+'"'+"\n"+
	                "\n"+
	                obj[p]+"\n"
	            );
	        }
	    }
	    lines.push( '--'+result.boundry+'--' );
	    result.body = lines.join('');
	    result.length = result.body.length;
	    result.type = 'multipart/form-data; boundary='+result.boundry;
	    return result;
	  }
	  
	  if(options.form){
	    if(typeof options.form == 'string') throw('form name unsupported');
	    if(options.method === 'POST'){
	        var encoding = (options.encoding || 'application/x-www-form-urlencoded').toLowerCase();
	        options.headers['content-type'] = encoding;
	        switch(encoding){
	            case 'application/x-www-form-urlencoded':
	                options.body = serialize(options.form).replace(/%20/g, "+");
	                break;
	            case 'multipart/form-data':
	                var multi = multipart(options.form);
	                //options.headers['content-length'] = multi.length;
	                options.body = multi.body;
	                options.headers['content-type'] = multi.type;
	                break;
	            default : throw new Error('unsupported encoding:'+encoding);
	        }
	    }
	  }
	  //END FORM Hack
	
	  // If onResponse is boolean true, call back immediately when the response is known,
	  // not when the full request is complete.
	  options.onResponse = options.onResponse || noop
	  if(options.onResponse === true) {
	    options.onResponse = callback
	    options.callback = noop
	  }
	
	  // XXX Browsers do not like this.
	  //if(options.body)
	  //  options.headers['content-length'] = options.body.length;
	
	  // HTTP basic authentication
	  if(!options.headers.authorization && options.auth)
	    options.headers.authorization = 'Basic ' + b64_enc(options.auth.username + ':' + options.auth.password);
	
	  return run_xhr(options)
	}
	
	var req_seq = 0
	function run_xhr(options) {
	  var xhr = new XHR
	    , timed_out = false
	    , is_cors = is_crossDomain(options.uri)
	    , supports_cors = ('withCredentials' in xhr)
	
	  req_seq += 1
	  xhr.seq_id = req_seq
	  xhr.id = req_seq + ': ' + options.method + ' ' + options.uri
	  xhr._id = xhr.id // I know I will type "_id" from habit all the time.
	
	  if(is_cors && !supports_cors) {
	    var cors_err = new Error('Browser does not support cross-origin request: ' + options.uri)
	    cors_err.cors = 'unsupported'
	    return options.callback(cors_err, xhr)
	  }
	
	  xhr.timeoutTimer = setTimeout(too_late, options.timeout)
	  function too_late() {
	    timed_out = true
	    var er = new Error('ETIMEDOUT')
	    er.code = 'ETIMEDOUT'
	    er.duration = options.timeout
	
	    request.log.error('Timeout', { 'id':xhr._id, 'milliseconds':options.timeout })
	    return options.callback(er, xhr)
	  }
	
	  // Some states can be skipped over, so remember what is still incomplete.
	  var did = {'response':false, 'loading':false, 'end':false}
	
	  xhr.onreadystatechange = on_state_change
	  xhr.open(options.method, options.uri, true) // asynchronous
	  if(is_cors)
	    xhr.withCredentials = !! options.withCredentials
	  xhr.send(options.body)
	  return xhr
	
	  function on_state_change(event) {
	    if(timed_out)
	      return request.log.debug('Ignoring timed out state change', {'state':xhr.readyState, 'id':xhr.id})
	
	    request.log.debug('State change', {'state':xhr.readyState, 'id':xhr.id, 'timed_out':timed_out})
	
	    if(xhr.readyState === XHR.OPENED) {
	      request.log.debug('Request started', {'id':xhr.id})
	      for (var key in options.headers)
	        xhr.setRequestHeader(key, options.headers[key])
	    }
	
	    else if(xhr.readyState === XHR.HEADERS_RECEIVED)
	      on_response()
	
	    else if(xhr.readyState === XHR.LOADING) {
	      on_response()
	      on_loading()
	    }
	
	    else if(xhr.readyState === XHR.DONE) {
	      on_response()
	      on_loading()
	      on_end()
	    }
	  }
	
	  function on_response() {
	    if(did.response)
	      return
	
	    did.response = true
	    request.log.debug('Got response', {'id':xhr.id, 'status':xhr.status})
	    clearTimeout(xhr.timeoutTimer)
	    xhr.statusCode = xhr.status // Node request compatibility
	
	    // Detect failed CORS requests.
	    if(is_cors && xhr.statusCode == 0) {
	      var cors_err = new Error('CORS request rejected: ' + options.uri)
	      cors_err.cors = 'rejected'
	
	      // Do not process this request further.
	      did.loading = true
	      did.end = true
	
	      return options.callback(cors_err, xhr)
	    }
	
	    options.onResponse(null, xhr)
	  }
	
	  function on_loading() {
	    if(did.loading)
	      return
	
	    did.loading = true
	    request.log.debug('Response body loading', {'id':xhr.id})
	    // TODO: Maybe simulate "data" events by watching xhr.responseText
	  }
	
	  function on_end() {
	    if(did.end)
	      return
	
	    did.end = true
	    request.log.debug('Request done', {'id':xhr.id})
	
	    xhr.body = xhr.responseText
	    if(options.json) {
	      try        { xhr.body = JSON.parse(xhr.responseText) }
	      catch (er) { return options.callback(er, xhr)        }
	    }
	
	    options.callback(null, xhr, xhr.body)
	  }
	
	} // request
	
	request.withCredentials = false;
	request.DEFAULT_TIMEOUT = DEFAULT_TIMEOUT;
	
	//
	// defaults
	//
	
	request.defaults = function(options, requester) {
	  var def = function (method) {
	    var d = function (params, callback) {
	      if(typeof params === 'string')
	        params = {'uri': params};
	      else {
	        params = JSON.parse(JSON.stringify(params));
	      }
	      for (var i in options) {
	        if (params[i] === undefined) params[i] = options[i]
	      }
	      return method(params, callback)
	    }
	    return d
	  }
	  var de = def(request)
	  de.get = def(request.get)
	  de.post = def(request.post)
	  de.put = def(request.put)
	  de.head = def(request.head)
	  return de
	}
	
	//
	// HTTP method shortcuts
	//
	
	var shortcuts = [ 'get', 'put', 'post', 'head' ];
	shortcuts.forEach(function(shortcut) {
	  var method = shortcut.toUpperCase();
	  var func   = shortcut.toLowerCase();
	
	  request[func] = function(opts) {
	    if(typeof opts === 'string')
	      opts = {'method':method, 'uri':opts};
	    else {
	      opts = JSON.parse(JSON.stringify(opts));
	      opts.method = method;
	    }
	
	    var args = [opts].concat(Array.prototype.slice.apply(arguments, [1]));
	    return request.apply(this, args);
	  }
	})
	
	//
	// CouchDB shortcut
	//
	
	request.couch = function(options, callback) {
	  if(typeof options === 'string')
	    options = {'uri':options}
	
	  // Just use the request API to do JSON.
	  options.json = true
	  if(options.body)
	    options.json = options.body
	  delete options.body
	
	  callback = callback || noop
	
	  var xhr = request(options, couch_handler)
	  return xhr
	
	  function couch_handler(er, resp, body) {
	    if(er)
	      return callback(er, resp, body)
	
	    if((resp.statusCode < 200 || resp.statusCode > 299) && body.error) {
	      // The body is a Couch JSON object indicating the error.
	      er = new Error('CouchDB error: ' + (body.error.reason || body.error.error))
	      for (var key in body)
	        er[key] = body[key]
	      return callback(er, resp, body);
	    }
	
	    return callback(er, resp, body);
	  }
	}
	
	//
	// Utility
	//
	
	function noop() {}
	
	function getLogger() {
	  var logger = {}
	    , levels = ['trace', 'debug', 'info', 'warn', 'error']
	    , level, i
	
	  for(i = 0; i < levels.length; i++) {
	    level = levels[i]
	
	    logger[level] = noop
	    if(typeof console !== 'undefined' && console && console[level])
	      logger[level] = formatted(console, level)
	  }
	
	  return logger
	}
	
	function formatted(obj, method) {
	  return formatted_logger
	
	  function formatted_logger(str, context) {
	    if(typeof context === 'object')
	      str += ' ' + JSON.stringify(context)
	
	    return obj[method].call(obj, str)
	  }
	}
	
	// Return whether a URL is a cross-domain request.
	function is_crossDomain(url) {
	  var rurl = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+))?)?/
	
	  // jQuery #8138, IE may throw an exception when accessing
	  // a field from window.location if document.domain has been set
	  var ajaxLocation
	  try { ajaxLocation = location.href }
	  catch (e) {
	    // Use the href attribute of an A element since IE will modify it given document.location
	    ajaxLocation = document.createElement( "a" );
	    ajaxLocation.href = "";
	    ajaxLocation = ajaxLocation.href;
	  }
	
	  var ajaxLocParts = rurl.exec(ajaxLocation.toLowerCase()) || []
	    , parts = rurl.exec(url.toLowerCase() )
	
	  var result = !!(
	    parts &&
	    (  parts[1] != ajaxLocParts[1]
	    || parts[2] != ajaxLocParts[2]
	    || (parts[3] || (parts[1] === "http:" ? 80 : 443)) != (ajaxLocParts[3] || (ajaxLocParts[1] === "http:" ? 80 : 443))
	    )
	  )
	
	  //console.debug('is_crossDomain('+url+') -> ' + result)
	  return result
	}
	
	// MIT License from http://phpjs.org/functions/base64_encode:358
	function b64_enc (data) {
	    // Encodes string using MIME base64 algorithm
	    var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc="", tmp_arr = [];
	
	    if (!data) {
	        return data;
	    }
	
	    // assume utf8 data
	    // data = this.utf8_encode(data+'');
	
	    do { // pack three octets into four hexets
	        o1 = data.charCodeAt(i++);
	        o2 = data.charCodeAt(i++);
	        o3 = data.charCodeAt(i++);
	
	        bits = o1<<16 | o2<<8 | o3;
	
	        h1 = bits>>18 & 0x3f;
	        h2 = bits>>12 & 0x3f;
	        h3 = bits>>6 & 0x3f;
	        h4 = bits & 0x3f;
	
	        // use hexets to index into b64, and append result to encoded string
	        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
	    } while (i < data.length);
	
	    enc = tmp_arr.join('');
	
	    switch (data.length % 3) {
	        case 1:
	            enc = enc.slice(0, -2) + '==';
	        break;
	        case 2:
	            enc = enc.slice(0, -1) + '=';
	        break;
	    }
	
	    return enc;
	}
	    return request;
	//UMD FOOTER START
	}));
	//UMD FOOTER END


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodashArrayUnion = __webpack_require__(205);
	
	var _lodashArrayUnion2 = _interopRequireDefault(_lodashArrayUnion);
	
	var _lodashArrayWithout = __webpack_require__(206);
	
	var _lodashArrayWithout2 = _interopRequireDefault(_lodashArrayWithout);
	
	var EnterLeaveCounter = (function () {
	  function EnterLeaveCounter() {
	    _classCallCheck(this, EnterLeaveCounter);
	
	    this.entered = [];
	  }
	
	  EnterLeaveCounter.prototype.enter = function enter(enteringNode) {
	    var previousLength = this.entered.length;
	
	    this.entered = _lodashArrayUnion2['default'](this.entered.filter(function (node) {
	      return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
	    }), [enteringNode]);
	
	    return previousLength === 0 && this.entered.length > 0;
	  };
	
	  EnterLeaveCounter.prototype.leave = function leave(leavingNode) {
	    var previousLength = this.entered.length;
	
	    this.entered = _lodashArrayWithout2['default'](this.entered.filter(function (node) {
	      return document.documentElement.contains(node);
	    }), leavingNode);
	
	    return previousLength > 0 && this.entered.length === 0;
	  };
	
	  EnterLeaveCounter.prototype.reset = function reset() {
	    this.entered = [];
	  };
	
	  return EnterLeaveCounter;
	})();
	
	exports['default'] = EnterLeaveCounter;
	module.exports = exports['default'];

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodashObjectDefaults = __webpack_require__(234);
	
	var _lodashObjectDefaults2 = _interopRequireDefault(_lodashObjectDefaults);
	
	var _shallowEqual = __webpack_require__(204);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _EnterLeaveCounter = __webpack_require__(197);
	
	var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);
	
	var _BrowserDetector = __webpack_require__(96);
	
	var _OffsetUtils = __webpack_require__(201);
	
	var _NativeDragSources = __webpack_require__(200);
	
	var _NativeTypes = __webpack_require__(59);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	var HTML5Backend = (function () {
	  function HTML5Backend(manager) {
	    _classCallCheck(this, HTML5Backend);
	
	    this.actions = manager.getActions();
	    this.monitor = manager.getMonitor();
	    this.registry = manager.getRegistry();
	
	    this.sourcePreviewNodes = {};
	    this.sourcePreviewNodeOptions = {};
	    this.sourceNodes = {};
	    this.sourceNodeOptions = {};
	    this.enterLeaveCounter = new _EnterLeaveCounter2['default']();
	
	    this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
	    this.handleTopDragStart = this.handleTopDragStart.bind(this);
	    this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
	    this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
	    this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
	    this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
	    this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
	    this.handleTopDragOver = this.handleTopDragOver.bind(this);
	    this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
	    this.handleTopDrop = this.handleTopDrop.bind(this);
	    this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
	    this.handleSelectStart = this.handleSelectStart.bind(this);
	    this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
	    this.endDragNativeItem = this.endDragNativeItem.bind(this);
	  }
	
	  HTML5Backend.prototype.setup = function setup() {
	    if (typeof window === 'undefined') {
	      return;
	    }
	
	    if (this.constructor.isSetUp) {
	      throw new Error('Cannot have two HTML5 backends at the same time.');
	    }
	    this.constructor.isSetUp = true;
	    this.addEventListeners(window);
	  };
	
	  HTML5Backend.prototype.teardown = function teardown() {
	    if (typeof window === 'undefined') {
	      return;
	    }
	
	    this.constructor.isSetUp = false;
	    this.removeEventListeners(window);
	    this.clearCurrentDragSourceNode();
	  };
	
	  HTML5Backend.prototype.addEventListeners = function addEventListeners(target) {
	    target.addEventListener('dragstart', this.handleTopDragStart);
	    target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
	    target.addEventListener('dragend', this.handleTopDragEndCapture, true);
	    target.addEventListener('dragenter', this.handleTopDragEnter);
	    target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
	    target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	    target.addEventListener('dragover', this.handleTopDragOver);
	    target.addEventListener('dragover', this.handleTopDragOverCapture, true);
	    target.addEventListener('drop', this.handleTopDrop);
	    target.addEventListener('drop', this.handleTopDropCapture, true);
	  };
	
	  HTML5Backend.prototype.removeEventListeners = function removeEventListeners(target) {
	    target.removeEventListener('dragstart', this.handleTopDragStart);
	    target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
	    target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
	    target.removeEventListener('dragenter', this.handleTopDragEnter);
	    target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
	    target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
	    target.removeEventListener('dragover', this.handleTopDragOver);
	    target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
	    target.removeEventListener('drop', this.handleTopDrop);
	    target.removeEventListener('drop', this.handleTopDropCapture, true);
	  };
	
	  HTML5Backend.prototype.connectDragPreview = function connectDragPreview(sourceId, node, options) {
	    var _this = this;
	
	    this.sourcePreviewNodeOptions[sourceId] = options;
	    this.sourcePreviewNodes[sourceId] = node;
	
	    return function () {
	      delete _this.sourcePreviewNodes[sourceId];
	      delete _this.sourcePreviewNodeOptions[sourceId];
	    };
	  };
	
	  HTML5Backend.prototype.connectDragSource = function connectDragSource(sourceId, node, options) {
	    var _this2 = this;
	
	    this.sourceNodes[sourceId] = node;
	    this.sourceNodeOptions[sourceId] = options;
	
	    var handleDragStart = function handleDragStart(e) {
	      return _this2.handleDragStart(e, sourceId);
	    };
	    var handleSelectStart = function handleSelectStart(e) {
	      return _this2.handleSelectStart(e, sourceId);
	    };
	
	    node.setAttribute('draggable', true);
	    node.addEventListener('dragstart', handleDragStart);
	    node.addEventListener('selectstart', handleSelectStart);
	
	    return function () {
	      delete _this2.sourceNodes[sourceId];
	      delete _this2.sourceNodeOptions[sourceId];
	
	      node.removeEventListener('dragstart', handleDragStart);
	      node.removeEventListener('selectstart', handleSelectStart);
	      node.setAttribute('draggable', false);
	    };
	  };
	
	  HTML5Backend.prototype.connectDropTarget = function connectDropTarget(targetId, node) {
	    var _this3 = this;
	
	    var handleDragEnter = function handleDragEnter(e) {
	      return _this3.handleDragEnter(e, targetId);
	    };
	    var handleDragOver = function handleDragOver(e) {
	      return _this3.handleDragOver(e, targetId);
	    };
	    var handleDrop = function handleDrop(e) {
	      return _this3.handleDrop(e, targetId);
	    };
	
	    node.addEventListener('dragenter', handleDragEnter);
	    node.addEventListener('dragover', handleDragOver);
	    node.addEventListener('drop', handleDrop);
	
	    return function () {
	      node.removeEventListener('dragenter', handleDragEnter);
	      node.removeEventListener('dragover', handleDragOver);
	      node.removeEventListener('drop', handleDrop);
	    };
	  };
	
	  HTML5Backend.prototype.getCurrentSourceNodeOptions = function getCurrentSourceNodeOptions() {
	    var sourceId = this.monitor.getSourceId();
	    var sourceNodeOptions = this.sourceNodeOptions[sourceId];
	
	    return _lodashObjectDefaults2['default'](sourceNodeOptions || {}, {
	      dropEffect: 'move'
	    });
	  };
	
	  HTML5Backend.prototype.getCurrentDropEffect = function getCurrentDropEffect() {
	    if (this.isDraggingNativeItem()) {
	      // It makes more sense to default to 'copy' for native resources
	      return 'copy';
	    }
	
	    return this.getCurrentSourceNodeOptions().dropEffect;
	  };
	
	  HTML5Backend.prototype.getCurrentSourcePreviewNodeOptions = function getCurrentSourcePreviewNodeOptions() {
	    var sourceId = this.monitor.getSourceId();
	    var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];
	
	    return _lodashObjectDefaults2['default'](sourcePreviewNodeOptions || {}, {
	      anchorX: 0.5,
	      anchorY: 0.5,
	      captureDraggingState: false
	    });
	  };
	
	  HTML5Backend.prototype.getSourceClientOffset = function getSourceClientOffset(sourceId) {
	    return _OffsetUtils.getNodeClientOffset(this.sourceNodes[sourceId]);
	  };
	
	  HTML5Backend.prototype.isDraggingNativeItem = function isDraggingNativeItem() {
	    var itemType = this.monitor.getItemType();
	    return Object.keys(NativeTypes).some(function (key) {
	      return NativeTypes[key] === itemType;
	    });
	  };
	
	  HTML5Backend.prototype.beginDragNativeItem = function beginDragNativeItem(type) {
	    this.clearCurrentDragSourceNode();
	
	    var SourceType = _NativeDragSources.createNativeDragSource(type);
	    this.currentNativeSource = new SourceType();
	    this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
	    this.actions.beginDrag([this.currentNativeHandle]);
	
	    // If mousemove fires, the drag is over but browser failed to tell us.
	    window.addEventListener('mousemove', this.endDragNativeItem, true);
	  };
	
	  HTML5Backend.prototype.endDragNativeItem = function endDragNativeItem() {
	    if (!this.isDraggingNativeItem()) {
	      return;
	    }
	
	    window.removeEventListener('mousemove', this.endDragNativeItem, true);
	
	    this.actions.endDrag();
	    this.registry.removeSource(this.currentNativeHandle);
	    this.currentNativeHandle = null;
	    this.currentNativeSource = null;
	  };
	
	  HTML5Backend.prototype.endDragIfSourceWasRemovedFromDOM = function endDragIfSourceWasRemovedFromDOM() {
	    var node = this.currentDragSourceNode;
	    if (document.body.contains(node)) {
	      return;
	    }
	
	    if (this.clearCurrentDragSourceNode()) {
	      this.actions.endDrag();
	    }
	  };
	
	  HTML5Backend.prototype.setCurrentDragSourceNode = function setCurrentDragSourceNode(node) {
	    this.clearCurrentDragSourceNode();
	    this.currentDragSourceNode = node;
	    this.currentDragSourceNodeOffset = _OffsetUtils.getNodeClientOffset(node);
	    this.currentDragSourceNodeOffsetChanged = false;
	
	    // Receiving a mouse event in the middle of a dragging operation
	    // means it has ended and the drag source node disappeared from DOM,
	    // so the browser didn't dispatch the dragend event.
	    window.addEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	  };
	
	  HTML5Backend.prototype.clearCurrentDragSourceNode = function clearCurrentDragSourceNode() {
	    if (this.currentDragSourceNode) {
	      this.currentDragSourceNode = null;
	      this.currentDragSourceNodeOffset = null;
	      this.currentDragSourceNodeOffsetChanged = false;
	      window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
	      return true;
	    }
	
	    return false;
	  };
	
	  HTML5Backend.prototype.checkIfCurrentDragSourceRectChanged = function checkIfCurrentDragSourceRectChanged() {
	    var node = this.currentDragSourceNode;
	    if (!node) {
	      return false;
	    }
	
	    if (this.currentDragSourceNodeOffsetChanged) {
	      return true;
	    }
	
	    this.currentDragSourceNodeOffsetChanged = !_shallowEqual2['default'](_OffsetUtils.getNodeClientOffset(node), this.currentDragSourceNodeOffset);
	
	    return this.currentDragSourceNodeOffsetChanged;
	  };
	
	  HTML5Backend.prototype.handleTopDragStartCapture = function handleTopDragStartCapture() {
	    this.clearCurrentDragSourceNode();
	    this.dragStartSourceIds = [];
	  };
	
	  HTML5Backend.prototype.handleDragStart = function handleDragStart(e, sourceId) {
	    this.dragStartSourceIds.unshift(sourceId);
	  };
	
	  HTML5Backend.prototype.handleTopDragStart = function handleTopDragStart(e) {
	    var _this4 = this;
	
	    var dragStartSourceIds = this.dragStartSourceIds;
	
	    this.dragStartSourceIds = null;
	
	    var clientOffset = _OffsetUtils.getEventClientOffset(e);
	
	    // Don't publish the source just yet (see why below)
	    this.actions.beginDrag(dragStartSourceIds, {
	      publishSource: false,
	      getSourceClientOffset: this.getSourceClientOffset,
	      clientOffset: clientOffset
	    });
	
	    var dataTransfer = e.dataTransfer;
	
	    var nativeType = _NativeDragSources.matchNativeItemType(dataTransfer);
	
	    if (this.monitor.isDragging()) {
	      if (typeof dataTransfer.setDragImage === 'function') {
	        // Use custom drag image if user specifies it.
	        // If child drag source refuses drag but parent agrees,
	        // use parent's node as drag image. Neither works in IE though.
	        var sourceId = this.monitor.getSourceId();
	        var sourceNode = this.sourceNodes[sourceId];
	        var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;
	
	        var _getCurrentSourcePreviewNodeOptions = this.getCurrentSourcePreviewNodeOptions();
	
	        var anchorX = _getCurrentSourcePreviewNodeOptions.anchorX;
	        var anchorY = _getCurrentSourcePreviewNodeOptions.anchorY;
	
	        var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
	        var dragPreviewOffset = _OffsetUtils.getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint);
	        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
	      }
	
	      try {
	        // Firefox won't drag without setting data
	        dataTransfer.setData('application/json', {});
	      } catch (err) {}
	      // IE doesn't support MIME types in setData
	
	      // Store drag source node so we can check whether
	      // it is removed from DOM and trigger endDrag manually.
	      this.setCurrentDragSourceNode(e.target);
	
	      // Now we are ready to publish the drag source.. or are we not?
	
	      var _getCurrentSourcePreviewNodeOptions2 = this.getCurrentSourcePreviewNodeOptions();
	
	      var captureDraggingState = _getCurrentSourcePreviewNodeOptions2.captureDraggingState;
	
	      if (!captureDraggingState) {
	        // Usually we want to publish it in the next tick so that browser
	        // is able to screenshot the current (not yet dragging) state.
	        //
	        // It also neatly avoids a situation where render() returns null
	        // in the same tick for the source element, and browser freaks out.
	        setTimeout(function () {
	          return _this4.actions.publishDragSource();
	        });
	      } else {
	        // In some cases the user may want to override this behavior, e.g.
	        // to work around IE not supporting custom drag previews.
	        //
	        // When using a custom drag layer, the only way to prevent
	        // the default drag preview from drawing in IE is to screenshot
	        // the dragging state in which the node itself has zero opacity
	        // and height. In this case, though, returning null from render()
	        // will abruptly end the dragging, which is not obvious.
	        //
	        // This is the reason such behavior is strictly opt-in.
	        this.actions.publishDragSource();
	      }
	    } else if (nativeType) {
	      // A native item (such as URL) dragged from inside the document
	      this.beginDragNativeItem(nativeType);
	    } else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
	      // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
	      // Just let it drag. It's a native type (URL or text) and will be picked up in dragenter handler.
	      return;
	    } else {
	      // If by this time no drag source reacted, tell browser not to drag.
	      e.preventDefault();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragEndCapture = function handleTopDragEndCapture() {
	    if (this.clearCurrentDragSourceNode()) {
	      // Firefox can dispatch this event in an infinite loop
	      // if dragend handler does something like showing an alert.
	      // Only proceed if we have not handled it already.
	      this.actions.endDrag();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragEnterCapture = function handleTopDragEnterCapture(e) {
	    this.dragEnterTargetIds = [];
	
	    var isFirstEnter = this.enterLeaveCounter.enter(e.target);
	    if (!isFirstEnter || this.monitor.isDragging()) {
	      return;
	    }
	
	    var dataTransfer = e.dataTransfer;
	
	    var nativeType = _NativeDragSources.matchNativeItemType(dataTransfer);
	
	    if (nativeType) {
	      // A native item (such as file or URL) dragged from outside the document
	      this.beginDragNativeItem(nativeType);
	    }
	  };
	
	  HTML5Backend.prototype.handleDragEnter = function handleDragEnter(e, targetId) {
	    this.dragEnterTargetIds.unshift(targetId);
	  };
	
	  HTML5Backend.prototype.handleTopDragEnter = function handleTopDragEnter(e) {
	    var _this5 = this;
	
	    var dragEnterTargetIds = this.dragEnterTargetIds;
	
	    this.dragEnterTargetIds = [];
	
	    if (!this.monitor.isDragging()) {
	      // This is probably a native item type we don't understand.
	      return;
	    }
	
	    if (!_BrowserDetector.isFirefox()) {
	      // Don't emit hover in `dragenter` on Firefox due to an edge case.
	      // If the target changes position as the result of `dragenter`, Firefox
	      // will still happily dispatch `dragover` despite target being no longer
	      // there. The easy solution is to only fire `hover` in `dragover` on FF.
	      this.actions.hover(dragEnterTargetIds, {
	        clientOffset: _OffsetUtils.getEventClientOffset(e)
	      });
	    }
	
	    var canDrop = dragEnterTargetIds.some(function (targetId) {
	      return _this5.monitor.canDropOnTarget(targetId);
	    });
	
	    if (canDrop) {
	      // IE requires this to fire dragover events
	      e.preventDefault();
	      e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragOverCapture = function handleTopDragOverCapture() {
	    this.dragOverTargetIds = [];
	  };
	
	  HTML5Backend.prototype.handleDragOver = function handleDragOver(e, targetId) {
	    this.dragOverTargetIds.unshift(targetId);
	  };
	
	  HTML5Backend.prototype.handleTopDragOver = function handleTopDragOver(e) {
	    var _this6 = this;
	
	    var dragOverTargetIds = this.dragOverTargetIds;
	
	    this.dragOverTargetIds = [];
	
	    if (!this.monitor.isDragging()) {
	      // This is probably a native item type we don't understand.
	      // Prevent default "drop and blow away the whole document" action.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = 'none';
	      return;
	    }
	
	    this.actions.hover(dragOverTargetIds, {
	      clientOffset: _OffsetUtils.getEventClientOffset(e)
	    });
	
	    var canDrop = dragOverTargetIds.some(function (targetId) {
	      return _this6.monitor.canDropOnTarget(targetId);
	    });
	
	    if (canDrop) {
	      // Show user-specified drop effect.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = this.getCurrentDropEffect();
	    } else if (this.isDraggingNativeItem()) {
	      // Don't show a nice cursor but still prevent default
	      // "drop and blow away the whole document" action.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = 'none';
	    } else if (this.checkIfCurrentDragSourceRectChanged()) {
	      // Prevent animating to incorrect position.
	      // Drop effect must be other than 'none' to prevent animation.
	      e.preventDefault();
	      e.dataTransfer.dropEffect = 'move';
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDragLeaveCapture = function handleTopDragLeaveCapture(e) {
	    if (this.isDraggingNativeItem()) {
	      e.preventDefault();
	    }
	
	    var isLastLeave = this.enterLeaveCounter.leave(e.target);
	    if (!isLastLeave) {
	      return;
	    }
	
	    if (this.isDraggingNativeItem()) {
	      this.endDragNativeItem();
	    }
	  };
	
	  HTML5Backend.prototype.handleTopDropCapture = function handleTopDropCapture(e) {
	    this.dropTargetIds = [];
	    e.preventDefault();
	
	    if (this.isDraggingNativeItem()) {
	      this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
	    }
	
	    this.enterLeaveCounter.reset();
	  };
	
	  HTML5Backend.prototype.handleDrop = function handleDrop(e, targetId) {
	    this.dropTargetIds.unshift(targetId);
	  };
	
	  HTML5Backend.prototype.handleTopDrop = function handleTopDrop(e) {
	    var dropTargetIds = this.dropTargetIds;
	
	    this.dropTargetIds = [];
	
	    this.actions.hover(dropTargetIds, {
	      clientOffset: _OffsetUtils.getEventClientOffset(e)
	    });
	    this.actions.drop();
	
	    if (this.isDraggingNativeItem()) {
	      this.endDragNativeItem();
	    } else {
	      this.endDragIfSourceWasRemovedFromDOM();
	    }
	  };
	
	  HTML5Backend.prototype.handleSelectStart = function handleSelectStart(e) {
	    // Prevent selection on IE
	    // and instead ask it to consider dragging.
	    if (typeof e.target.dragDrop === 'function') {
	      e.preventDefault();
	      e.target.dragDrop();
	    }
	  };
	
	  return HTML5Backend;
	})();
	
	exports['default'] = HTML5Backend;
	module.exports = exports['default'];

/***/ },
/* 199 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MonotonicInterpolant = (function () {
	  function MonotonicInterpolant(xs, ys) {
	    _classCallCheck(this, MonotonicInterpolant);
	
	    var length = xs.length;
	
	    // Rearrange xs and ys so that xs is sorted
	    var indexes = [];
	    for (var i = 0; i < length; i++) {
	      indexes.push(i);
	    }
	    indexes.sort(function (a, b) {
	      return xs[a] < xs[b] ? -1 : 1;
	    });
	
	    // Get consecutive differences and slopes
	    var dys = [];
	    var dxs = [];
	    var ms = [];
	    var dx = undefined;
	    var dy = undefined;
	    for (var i = 0; i < length - 1; i++) {
	      dx = xs[i + 1] - xs[i];
	      dy = ys[i + 1] - ys[i];
	      dxs.push(dx);
	      dys.push(dy);
	      ms.push(dy / dx);
	    }
	
	    // Get degree-1 coefficients
	    var c1s = [ms[0]];
	    for (var i = 0; i < dxs.length - 1; i++) {
	      var _m = ms[i];
	      var mNext = ms[i + 1];
	      if (_m * mNext <= 0) {
	        c1s.push(0);
	      } else {
	        dx = dxs[i];
	        var dxNext = dxs[i + 1];
	        var common = dx + dxNext;
	        c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
	      }
	    }
	    c1s.push(ms[ms.length - 1]);
	
	    // Get degree-2 and degree-3 coefficients
	    var c2s = [];
	    var c3s = [];
	    var m = undefined;
	    for (var i = 0; i < c1s.length - 1; i++) {
	      m = ms[i];
	      var c1 = c1s[i];
	      var invDx = 1 / dxs[i];
	      var common = c1 + c1s[i + 1] - m - m;
	      c2s.push((m - c1 - common) * invDx);
	      c3s.push(common * invDx * invDx);
	    }
	
	    this.xs = xs;
	    this.ys = ys;
	    this.c1s = c1s;
	    this.c2s = c2s;
	    this.c3s = c3s;
	  }
	
	  MonotonicInterpolant.prototype.interpolate = function interpolate(x) {
	    var xs = this.xs;
	    var ys = this.ys;
	    var c1s = this.c1s;
	    var c2s = this.c2s;
	    var c3s = this.c3s;
	
	    // The rightmost point in the dataset should give an exact result
	    var i = xs.length - 1;
	    if (x === xs[i]) {
	      return ys[i];
	    }
	
	    // Search for the interval x is in, returning the corresponding y if x is one of the original xs
	    var low = 0;
	    var high = c3s.length - 1;
	    var mid = undefined;
	    while (low <= high) {
	      mid = Math.floor(0.5 * (low + high));
	      var xHere = xs[mid];
	      if (xHere < x) {
	        low = mid + 1;
	      } else if (xHere > x) {
	        high = mid - 1;
	      } else {
	        return ys[mid];
	      }
	    }
	    i = Math.max(0, high);
	
	    // Interpolate
	    var diff = x - xs[i];
	    var diffSq = diff * diff;
	    return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
	  };
	
	  return MonotonicInterpolant;
	})();
	
	exports["default"] = MonotonicInterpolant;
	module.exports = exports["default"];

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _nativeTypesConfig;
	
	exports.createNativeDragSource = createNativeDragSource;
	exports.matchNativeItemType = matchNativeItemType;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _NativeTypes = __webpack_require__(59);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	  var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
	    return resultSoFar || dataTransfer.getData(typeToTry);
	  }, null);
	
	  return result != null ? // eslint-disable-line eqeqeq
	  result : defaultValue;
	}
	
	var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	  exposeProperty: 'files',
	  matchesTypes: ['Files'],
	  getData: function getData(dataTransfer) {
	    return Array.prototype.slice.call(dataTransfer.files);
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	  exposeProperty: 'urls',
	  matchesTypes: ['Url', 'text/uri-list'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	  }
	}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	  exposeProperty: 'text',
	  matchesTypes: ['Text', 'text/plain'],
	  getData: function getData(dataTransfer, matchesTypes) {
	    return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	  }
	}), _nativeTypesConfig);
	
	function createNativeDragSource(type) {
	  var _nativeTypesConfig$type = nativeTypesConfig[type];
	  var exposeProperty = _nativeTypesConfig$type.exposeProperty;
	  var matchesTypes = _nativeTypesConfig$type.matchesTypes;
	  var getData = _nativeTypesConfig$type.getData;
	
	  return (function () {
	    function NativeDragSource() {
	      _classCallCheck(this, NativeDragSource);
	
	      this.item = Object.defineProperties({}, _defineProperty({}, exposeProperty, {
	        get: function get() {
	          console.warn( // eslint-disable-line no-console
	          'Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
	          return null;
	        },
	        configurable: true,
	        enumerable: true
	      }));
	    }
	
	    NativeDragSource.prototype.mutateItemByReadingDataTransfer = function mutateItemByReadingDataTransfer(dataTransfer) {
	      delete this.item[exposeProperty];
	      this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
	    };
	
	    NativeDragSource.prototype.canDrag = function canDrag() {
	      return true;
	    };
	
	    NativeDragSource.prototype.beginDrag = function beginDrag() {
	      return this.item;
	    };
	
	    NativeDragSource.prototype.isDragging = function isDragging(monitor, handle) {
	      return handle === monitor.getSourceId();
	    };
	
	    NativeDragSource.prototype.endDrag = function endDrag() {};
	
	    return NativeDragSource;
	  })();
	}
	
	function matchNativeItemType(dataTransfer) {
	  var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
	
	  return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
	    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
	
	    return matchesTypes.some(function (t) {
	      return dataTransferTypes.indexOf(t) > -1;
	    });
	  })[0] || null;
	}

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getNodeClientOffset = getNodeClientOffset;
	exports.getEventClientOffset = getEventClientOffset;
	exports.getDragPreviewOffset = getDragPreviewOffset;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _BrowserDetector = __webpack_require__(96);
	
	var _MonotonicInterpolant = __webpack_require__(199);
	
	var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);
	
	var ELEMENT_NODE = 1;
	
	function getNodeClientOffset(node) {
	  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
	
	  if (!el) {
	    return null;
	  }
	
	  var _el$getBoundingClientRect = el.getBoundingClientRect();
	
	  var top = _el$getBoundingClientRect.top;
	  var left = _el$getBoundingClientRect.left;
	
	  return { x: left, y: top };
	}
	
	function getEventClientOffset(e) {
	  return {
	    x: e.clientX,
	    y: e.clientY
	  };
	}
	
	function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint) {
	  // The browsers will use the image intrinsic size under different conditions.
	  // Firefox only cares if it's an image, but WebKit also wants it to be detached.
	  var isImage = dragPreview.nodeName === 'IMG' && (_BrowserDetector.isFirefox() || !document.documentElement.contains(dragPreview));
	  var dragPreviewNode = isImage ? sourceNode : dragPreview;
	
	  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	  var offsetFromDragPreview = {
	    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
	    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	  };
	
	  var sourceWidth = sourceNode.offsetWidth;
	  var sourceHeight = sourceNode.offsetHeight;
	  var anchorX = anchorPoint.anchorX;
	  var anchorY = anchorPoint.anchorY;
	
	  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
	
	  // Work around @2x coordinate discrepancies in browsers
	  if (_BrowserDetector.isSafari() && isImage) {
	    dragPreviewHeight /= window.devicePixelRatio;
	    dragPreviewWidth /= window.devicePixelRatio;
	  } else if (_BrowserDetector.isFirefox() && !isImage) {
	    dragPreviewHeight *= window.devicePixelRatio;
	    dragPreviewWidth *= window.devicePixelRatio;
	  }
	
	  // Interpolate coordinates depending on anchor point
	  // If you know a simpler way to do this, let me know
	  var interpolantX = new _MonotonicInterpolant2['default']([0, 0.5, 1], [
	  // Dock to the left
	  offsetFromDragPreview.x,
	  // Align at the center
	  offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
	  // Dock to the right
	  offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
	  var interpolantY = new _MonotonicInterpolant2['default']([0, 0.5, 1], [
	  // Dock to the top
	  offsetFromDragPreview.y,
	  // Align at the center
	  offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
	  // Dock to the bottom
	  offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
	  var x = interpolantX.interpolate(anchorX);
	  var y = interpolantY.interpolate(anchorY);
	
	  // Work around Safari 8 positioning bug
	  if (_BrowserDetector.isSafari() && isImage) {
	    // We'll have to wait for @3x to see if this is entirely correct
	    y += (window.devicePixelRatio - 1) * dragPreviewHeight;
	  }
	
	  return { x: x, y: y };
	}

/***/ },
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getEmptyImage;
	var emptyImage = undefined;
	
	function getEmptyImage() {
	  if (!emptyImage) {
	    emptyImage = new Image();
	    emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	  }
	
	  return emptyImage;
	}
	
	module.exports = exports['default'];

/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createHTML5Backend;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _HTML5Backend = __webpack_require__(198);
	
	var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);
	
	var _getEmptyImage = __webpack_require__(202);
	
	var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);
	
	var _NativeTypes = __webpack_require__(59);
	
	var NativeTypes = _interopRequireWildcard(_NativeTypes);
	
	exports.NativeTypes = NativeTypes;
	exports.getEmptyImage = _getEmptyImage2['default'];
	
	function createHTML5Backend(manager) {
	  return new _HTML5Backend2['default'](manager);
	}

/***/ },
/* 204 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	
	    var valA = objA[keysA[i]];
	    var valB = objB[keysA[i]];
	
	    if (valA !== valB) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports["default"];

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(216),
	    baseUniq = __webpack_require__(218),
	    restParam = __webpack_require__(38);
	
	/**
	 * Creates an array of unique values, in order, from all of the provided arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([1, 2], [4, 2], [2, 1]);
	 * // => [1, 2, 4]
	 */
	var union = restParam(function(arrays) {
	  return baseUniq(baseFlatten(arrays, false, true));
	});
	
	module.exports = union;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(215),
	    isArrayLike = __webpack_require__(28),
	    restParam = __webpack_require__(38);
	
	/**
	 * Creates an array excluding all provided values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	var without = restParam(function(array, values) {
	  return isArrayLike(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(208);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is coerced to a string and used as the
	 * cache key. The `func` is invoked with the `this` binding of the memoized
	 * function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoizing function.
	 * @example
	 *
	 * var upperCase = _.memoize(function(string) {
	 *   return string.toUpperCase();
	 * });
	 *
	 * upperCase('fred');
	 * // => 'FRED'
	 *
	 * // modifying the result cache
	 * upperCase.cache.set('fred', 'BARNEY');
	 * upperCase('fred');
	 * // => 'BARNEY'
	 *
	 * // replacing `_.memoize.Cache`
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'barney' };
	 * var identity = _.memoize(_.identity);
	 *
	 * identity(object);
	 * // => { 'user': 'fred' }
	 * identity(other);
	 * // => { 'user': 'fred' }
	 *
	 * _.memoize.Cache = WeakMap;
	 * var identity = _.memoize(_.identity);
	 *
	 * identity(object);
	 * // => { 'user': 'fred' }
	 * identity(other);
	 * // => { 'user': 'barney' }
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new memoize.Cache;
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var mapDelete = __webpack_require__(226),
	    mapGet = __webpack_require__(227),
	    mapHas = __webpack_require__(228),
	    mapSet = __webpack_require__(229);
	
	/**
	 * Creates a cache object to store key/value pairs.
	 *
	 * @private
	 * @static
	 * @name Cache
	 * @memberOf _.memoize
	 */
	function MapCache() {
	  this.__data__ = {};
	}
	
	// Add functions to the `Map` cache.
	MapCache.prototype['delete'] = mapDelete;
	MapCache.prototype.get = mapGet;
	MapCache.prototype.has = mapHas;
	MapCache.prototype.set = mapSet;
	
	module.exports = MapCache;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(220),
	    getNative = __webpack_require__(39);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 210 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 211 */
/***/ function(module, exports) {

	/**
	 * Used by `_.defaults` to customize its `_.assign` use.
	 *
	 * @private
	 * @param {*} objectValue The destination object property value.
	 * @param {*} sourceValue The source object property value.
	 * @returns {*} Returns the value to assign to the destination object.
	 */
	function assignDefaults(objectValue, sourceValue) {
	  return objectValue === undefined ? sourceValue : objectValue;
	}
	
	module.exports = assignDefaults;


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(100);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	module.exports = assignWith;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(214),
	    keys = __webpack_require__(100);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 214 */
/***/ function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(97),
	    cacheIndexOf = __webpack_require__(98),
	    createCache = __webpack_require__(99);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.difference` which accepts a single array
	 * of values to exclude.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values) {
	  var length = array ? array.length : 0,
	      result = [];
	
	  if (!length) {
	    return result;
	  }
	  var index = -1,
	      indexOf = baseIndexOf,
	      isCommon = true,
	      cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	      valuesLength = values.length;
	
	  if (cache) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	    values = cache;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index];
	
	    if (isCommon && value === value) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === value) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (indexOf(values, value, 0) < 0) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(210),
	    isArguments = __webpack_require__(61),
	    isArray = __webpack_require__(62),
	    isArrayLike = __webpack_require__(28),
	    isObjectLike = __webpack_require__(41);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(97),
	    cacheIndexOf = __webpack_require__(98),
	    createCache = __webpack_require__(99);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(236);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(219),
	    isIterateeCall = __webpack_require__(225),
	    restParam = __webpack_require__(38);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var restParam = __webpack_require__(38);
	
	/**
	 * Creates a `_.defaults` or `_.defaultsDeep` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Function} Returns the new defaults function.
	 */
	function createDefaults(assigner, customizer) {
	  return restParam(function(args) {
	    var object = args[0];
	    if (object == null) {
	      return object;
	    }
	    args.push(customizer);
	    return assigner.apply(undefined, args);
	  });
	}
	
	module.exports = createDefaults;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(217);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 224 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(28),
	    isIndex = __webpack_require__(60),
	    isObject = __webpack_require__(21);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 226 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	 */
	function mapDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = mapDelete;


/***/ },
/* 227 */
/***/ function(module, exports) {

	/**
	 * Gets the cached value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the cached value.
	 */
	function mapGet(key) {
	  return key == '__proto__' ? undefined : this.__data__[key];
	}
	
	module.exports = mapGet;


/***/ },
/* 228 */
/***/ function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a cached value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapHas(key) {
	  return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	}
	
	module.exports = mapHas;


/***/ },
/* 229 */
/***/ function(module, exports) {

	/**
	 * Sets `value` to `key` of the cache.
	 *
	 * @private
	 * @name set
	 * @memberOf _.memoize.Cache
	 * @param {string} key The key of the value to cache.
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache object.
	 */
	function mapSet(key, value) {
	  if (key != '__proto__') {
	    this.__data__[key] = value;
	  }
	  return this;
	}
	
	module.exports = mapSet;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(61),
	    isArray = __webpack_require__(62),
	    isIndex = __webpack_require__(60),
	    isLength = __webpack_require__(40),
	    keysIn = __webpack_require__(235);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(21);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(231),
	    isObjectLike = __webpack_require__(41);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var assignWith = __webpack_require__(212),
	    baseAssign = __webpack_require__(213),
	    createAssigner = __webpack_require__(221);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it's invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var assign = __webpack_require__(233),
	    assignDefaults = __webpack_require__(211),
	    createDefaults = __webpack_require__(222);
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object for all destination properties that resolve to `undefined`. Once a
	 * property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var defaults = createDefaults(assign, assignDefaults);
	
	module.exports = defaults;


/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(61),
	    isArray = __webpack_require__(62),
	    isIndex = __webpack_require__(60),
	    isLength = __webpack_require__(40),
	    isObject = __webpack_require__(21);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 236 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slice = Array.prototype.slice;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = DragDropContext;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _dndCore = __webpack_require__(260);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(43);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	function DragDropContext(backendOrModule) {
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DragDropContext', 'backend'].concat(_slice.call(arguments)));
	
	  // Auto-detect ES6 default export for people still using ES5
	  var backend = undefined;
	  if (typeof backendOrModule === 'object' && typeof backendOrModule['default'] === 'function') {
	    backend = backendOrModule['default'];
	  } else {
	    backend = backendOrModule;
	  }
	
	  _invariant2['default'](typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-drop-context.html');
	
	  var childContext = {
	    dragDropManager: new _dndCore.DragDropManager(backend)
	  };
	
	  return function decorateContext(DecoratedComponent) {
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    return (function (_Component) {
	      _inherits(DragDropContextContainer, _Component);
	
	      function DragDropContextContainer() {
	        _classCallCheck(this, DragDropContextContainer);
	
	        _Component.apply(this, arguments);
	      }
	
	      DragDropContextContainer.prototype.getDecoratedComponentInstance = function getDecoratedComponentInstance() {
	        return this.refs.child;
	      };
	
	      DragDropContextContainer.prototype.getManager = function getManager() {
	        return childContext.dragDropManager;
	      };
	
	      DragDropContextContainer.prototype.getChildContext = function getChildContext() {
	        return childContext;
	      };
	
	      DragDropContextContainer.prototype.render = function render() {
	        return _react2['default'].createElement(DecoratedComponent, _extends({}, this.props, {
	          ref: 'child' }));
	      };
	
	      _createClass(DragDropContextContainer, null, [{
	        key: 'DecoratedComponent',
	        value: DecoratedComponent,
	        enumerable: true
	      }, {
	        key: 'displayName',
	        value: 'DragDropContext(' + displayName + ')',
	        enumerable: true
	      }, {
	        key: 'childContextTypes',
	        value: {
	          dragDropManager: _react.PropTypes.object.isRequired
	        },
	        enumerable: true
	      }]);
	
	      return DragDropContextContainer;
	    })(_react.Component);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slice = Array.prototype.slice;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports['default'] = DragLayer;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsShallowEqual = __webpack_require__(63);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsShallowEqualScalar = __webpack_require__(103);
	
	var _utilsShallowEqualScalar2 = _interopRequireDefault(_utilsShallowEqualScalar);
	
	var _lodashLangIsPlainObject = __webpack_require__(24);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(43);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	function DragLayer(collect) {
	  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DragLayer', 'collect[, options]'].concat(_slice.call(arguments)));
	  _invariant2['default'](typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer ' + 'to be a function that collects props to inject into the component. ', 'Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-layer.html', collect);
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](options), 'Expected "options" provided as the second argument to DragLayer to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-layer.html', options);
	
	  return function decorateLayer(DecoratedComponent) {
	    var _options$arePropsEqual = options.arePropsEqual;
	    var arePropsEqual = _options$arePropsEqual === undefined ? _utilsShallowEqualScalar2['default'] : _options$arePropsEqual;
	
	    var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';
	
	    return (function (_Component) {
	      _inherits(DragLayerContainer, _Component);
	
	      DragLayerContainer.prototype.getDecoratedComponentInstance = function getDecoratedComponentInstance() {
	        return this.refs.child;
	      };
	
	      DragLayerContainer.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        return !arePropsEqual(nextProps, this.props) || !_utilsShallowEqual2['default'](nextState, this.state);
	      };
	
	      _createClass(DragLayerContainer, null, [{
	        key: 'DecoratedComponent',
	        value: DecoratedComponent,
	        enumerable: true
	      }, {
	        key: 'displayName',
	        value: 'DragLayer(' + displayName + ')',
	        enumerable: true
	      }, {
	        key: 'contextTypes',
	        value: {
	          dragDropManager: _react.PropTypes.object.isRequired
	        },
	        enumerable: true
	      }]);
	
	      function DragLayerContainer(props, context) {
	        _classCallCheck(this, DragLayerContainer);
	
	        _Component.call(this, props);
	        this.handleChange = this.handleChange.bind(this);
	
	        this.manager = context.dragDropManager;
	        _invariant2['default'](typeof this.manager === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);
	
	        this.state = this.getCurrentState();
	      }
	
	      DragLayerContainer.prototype.componentDidMount = function componentDidMount() {
	        var monitor = this.manager.getMonitor();
	        this.unsubscribe = monitor.subscribeToOffsetChange(this.handleChange);
	      };
	
	      DragLayerContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.unsubscribe();
	      };
	
	      DragLayerContainer.prototype.handleChange = function handleChange() {
	        var nextState = this.getCurrentState();
	        if (!_utilsShallowEqual2['default'](nextState, this.state)) {
	          this.setState(nextState);
	        }
	      };
	
	      DragLayerContainer.prototype.getCurrentState = function getCurrentState() {
	        var monitor = this.manager.getMonitor();
	        return collect(monitor);
	      };
	
	      DragLayerContainer.prototype.render = function render() {
	        return _react2['default'].createElement(DecoratedComponent, _extends({}, this.props, this.state, {
	          ref: 'child' }));
	      };
	
	      return DragLayerContainer;
	    })(_react.Component);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports['default'] = DragSource;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(24);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(43);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(101);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerSource = __webpack_require__(249);
	
	var _registerSource2 = _interopRequireDefault(_registerSource);
	
	var _createSourceFactory = __webpack_require__(244);
	
	var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);
	
	var _createSourceMonitor = __webpack_require__(245);
	
	var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);
	
	var _createSourceConnector = __webpack_require__(243);
	
	var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);
	
	var _utilsIsValidType = __webpack_require__(102);
	
	var _utilsIsValidType2 = _interopRequireDefault(_utilsIsValidType);
	
	function DragSource(type, spec, collect) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(_slice.call(arguments)));
	  var getType = type;
	  if (typeof type !== 'function') {
	    _invariant2['default'](_utilsIsValidType2['default'](type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', type);
	    getType = function () {
	      return type;
	    };
	  }
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', spec);
	  var createSource = _createSourceFactory2['default'](spec);
	  _invariant2['default'](typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', collect);
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', collect);
	
	  return function decorateSource(DecoratedComponent) {
	    return _decorateHandler2['default']({
	      connectBackend: function connectBackend(backend, sourceId) {
	        return backend.connectDragSource(sourceId);
	      },
	      containerDisplayName: 'DragSource',
	      createHandler: createSource,
	      registerHandler: _registerSource2['default'],
	      createMonitor: _createSourceMonitor2['default'],
	      createConnector: _createSourceConnector2['default'],
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports['default'] = DropTarget;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(24);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var _utilsCheckDecoratorArguments = __webpack_require__(43);
	
	var _utilsCheckDecoratorArguments2 = _interopRequireDefault(_utilsCheckDecoratorArguments);
	
	var _decorateHandler = __webpack_require__(101);
	
	var _decorateHandler2 = _interopRequireDefault(_decorateHandler);
	
	var _registerTarget = __webpack_require__(250);
	
	var _registerTarget2 = _interopRequireDefault(_registerTarget);
	
	var _createTargetFactory = __webpack_require__(247);
	
	var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);
	
	var _createTargetMonitor = __webpack_require__(248);
	
	var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);
	
	var _createTargetConnector = __webpack_require__(246);
	
	var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);
	
	var _utilsIsValidType = __webpack_require__(102);
	
	var _utilsIsValidType2 = _interopRequireDefault(_utilsIsValidType);
	
	function DropTarget(type, spec, collect) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  _utilsCheckDecoratorArguments2['default'].apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(_slice.call(arguments)));
	  var getType = type;
	  if (typeof type !== 'function') {
	    _invariant2['default'](_utilsIsValidType2['default'](type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target.html', type);
	    getType = function () {
	      return type;
	    };
	  }
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target.html', spec);
	  var createTarget = _createTargetFactory2['default'](spec);
	  _invariant2['default'](typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target.html', collect);
	  _invariant2['default'](_lodashLangIsPlainObject2['default'](options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target.html', collect);
	
	  return function decorateTarget(DecoratedComponent) {
	    return _decorateHandler2['default']({
	      connectBackend: function connectBackend(backend, targetId) {
	        return backend.connectDropTarget(targetId);
	      },
	      containerDisplayName: 'DropTarget',
	      createHandler: createTarget,
	      registerHandler: _registerTarget2['default'],
	      createMonitor: _createTargetMonitor2['default'],
	      createConnector: _createTargetConnector2['default'],
	      DecoratedComponent: DecoratedComponent,
	      getType: getType,
	      collect: collect,
	      options: options
	    });
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindConnector;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _bindConnectorMethod2 = __webpack_require__(242);
	
	var _bindConnectorMethod3 = _interopRequireDefault(_bindConnectorMethod2);
	
	var _disposables = __webpack_require__(64);
	
	function bindConnector(connector, handlerId) {
	  var compositeDisposable = new _disposables.CompositeDisposable();
	  var handlerConnector = {};
	
	  Object.keys(connector).forEach(function (key) {
	    var _bindConnectorMethod = _bindConnectorMethod3['default'](handlerId, connector[key]);
	
	    var disposable = _bindConnectorMethod.disposable;
	    var ref = _bindConnectorMethod.ref;
	
	    compositeDisposable.add(disposable);
	    handlerConnector[key] = function () {
	      return ref;
	    };
	  });
	
	  return {
	    disposable: compositeDisposable,
	    handlerConnector: handlerConnector
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindConnectorMethod;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _utilsShallowEqual = __webpack_require__(63);
	
	var _utilsShallowEqual2 = _interopRequireDefault(_utilsShallowEqual);
	
	var _utilsCloneWithRef = __webpack_require__(251);
	
	var _utilsCloneWithRef2 = _interopRequireDefault(_utilsCloneWithRef);
	
	var _disposables = __webpack_require__(64);
	
	var _react = __webpack_require__(2);
	
	function areOptionsEqual(currentOptions, nextOptions) {
	  if (currentOptions === nextOptions) {
	    return true;
	  }
	
	  return currentOptions !== null && nextOptions !== null && _utilsShallowEqual2['default'](currentOptions, nextOptions);
	}
	
	function bindConnectorMethod(handlerId, connect) {
	  var disposable = new _disposables.SerialDisposable();
	
	  var currentNode = null;
	  var currentOptions = null;
	
	  function ref() {
	    var nextWhatever = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	    var nextOptions = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];
	
	    // If passed a ReactElement, clone it and attach this function as a ref.
	    // This helps us achieve a neat API where user doesn't even know that refs
	    // are being used under the hood.
	    if (_react.isValidElement(nextWhatever)) {
	      // Custom components can no longer be wrapped directly in React DnD 2.0
	      // so that we don't need to depend on findDOMNode() from react-dom.
	      if (typeof nextWhatever.type !== 'string') {
	        var displayName = nextWhatever.type.displayName || nextWhatever.type.name || 'the component';
	        throw new Error('Only native element nodes can now be passed to ' + connect.name + '(). ' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
	      }
	
	      var nextElement = nextWhatever;
	      return _utilsCloneWithRef2['default'](nextElement, function (inst) {
	        return ref(inst, nextOptions);
	      });
	    }
	
	    // At this point we can only receive DOM nodes.
	    var nextNode = nextWhatever;
	
	    // If nothing changed, bail out of re-connecting the node to the backend.
	    if (nextNode === currentNode && areOptionsEqual(currentOptions, nextOptions)) {
	      return;
	    }
	
	    currentNode = nextNode;
	    currentOptions = nextOptions;
	
	    if (!nextNode) {
	      disposable.setDisposable(null);
	      return;
	    }
	
	    // Re-connect the node to the backend.
	    var currentDispose = connect(handlerId, nextNode, nextOptions);
	    disposable.setDisposable(new _disposables.Disposable(currentDispose));
	  }
	
	  return {
	    ref: ref,
	    disposable: disposable
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 243 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createSourceConnector;
	
	function createSourceConnector(backend) {
	  return {
	    dragSource: function connectDragSource() {
	      return backend.connectDragSource.apply(backend, arguments);
	    },
	    dragPreview: function connectDragPreview() {
	      return backend.connectDragPreview.apply(backend, arguments);
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createSourceFactory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(24);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'canDrag', 'isDragging', 'endDrag'];
	var REQUIRED_SPEC_METHODS = ['beginDrag'];
	
	function createSourceFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    _invariant2['default'](ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    _invariant2['default'](typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	  REQUIRED_SPEC_METHODS.forEach(function (key) {
	    _invariant2['default'](typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	  });
	
	  var Source = (function () {
	    function Source(monitor) {
	      _classCallCheck(this, Source);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    Source.prototype.receiveProps = function receiveProps(props) {
	      this.props = props;
	    };
	
	    Source.prototype.receiveComponent = function receiveComponent(component) {
	      this.component = component;
	    };
	
	    Source.prototype.canDrag = function canDrag() {
	      if (!spec.canDrag) {
	        return true;
	      }
	
	      return spec.canDrag(this.props, this.monitor);
	    };
	
	    Source.prototype.isDragging = function isDragging(globalMonitor, sourceId) {
	      if (!spec.isDragging) {
	        return sourceId === globalMonitor.getSourceId();
	      }
	
	      return spec.isDragging(this.props, this.monitor);
	    };
	
	    Source.prototype.beginDrag = function beginDrag() {
	      var item = spec.beginDrag(this.props, this.monitor, this.component);
	      if (false) {
	        _invariant2['default'](_lodashLangIsPlainObject2['default'](item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source.html', item);
	      }
	      return item;
	    };
	
	    Source.prototype.endDrag = function endDrag() {
	      if (!spec.endDrag) {
	        return;
	      }
	
	      spec.endDrag(this.props, this.monitor, this.component);
	    };
	
	    return Source;
	  })();
	
	  return function createSource(monitor) {
	    return new Source(monitor);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createSourceMonitor;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var isCallingCanDrag = false;
	var isCallingIsDragging = false;
	
	var SourceMonitor = (function () {
	  function SourceMonitor(manager) {
	    _classCallCheck(this, SourceMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  SourceMonitor.prototype.receiveHandlerId = function receiveHandlerId(sourceId) {
	    this.sourceId = sourceId;
	  };
	
	  SourceMonitor.prototype.canDrag = function canDrag() {
	    _invariant2['default'](!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source-monitor.html');
	
	    try {
	      isCallingCanDrag = true;
	      return this.internalMonitor.canDragSource(this.sourceId);
	    } finally {
	      isCallingCanDrag = false;
	    }
	  };
	
	  SourceMonitor.prototype.isDragging = function isDragging() {
	    _invariant2['default'](!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drag-source-monitor.html');
	
	    try {
	      isCallingIsDragging = true;
	      return this.internalMonitor.isDraggingSource(this.sourceId);
	    } finally {
	      isCallingIsDragging = false;
	    }
	  };
	
	  SourceMonitor.prototype.getItemType = function getItemType() {
	    return this.internalMonitor.getItemType();
	  };
	
	  SourceMonitor.prototype.getItem = function getItem() {
	    return this.internalMonitor.getItem();
	  };
	
	  SourceMonitor.prototype.getDropResult = function getDropResult() {
	    return this.internalMonitor.getDropResult();
	  };
	
	  SourceMonitor.prototype.didDrop = function didDrop() {
	    return this.internalMonitor.didDrop();
	  };
	
	  SourceMonitor.prototype.getInitialClientOffset = function getInitialClientOffset() {
	    return this.internalMonitor.getInitialClientOffset();
	  };
	
	  SourceMonitor.prototype.getInitialSourceClientOffset = function getInitialSourceClientOffset() {
	    return this.internalMonitor.getInitialSourceClientOffset();
	  };
	
	  SourceMonitor.prototype.getSourceClientOffset = function getSourceClientOffset() {
	    return this.internalMonitor.getSourceClientOffset();
	  };
	
	  SourceMonitor.prototype.getClientOffset = function getClientOffset() {
	    return this.internalMonitor.getClientOffset();
	  };
	
	  SourceMonitor.prototype.getDifferenceFromInitialOffset = function getDifferenceFromInitialOffset() {
	    return this.internalMonitor.getDifferenceFromInitialOffset();
	  };
	
	  return SourceMonitor;
	})();
	
	function createSourceMonitor(manager) {
	  return new SourceMonitor(manager);
	}
	
	module.exports = exports['default'];

/***/ },
/* 246 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createTargetConnector;
	
	function createTargetConnector(backend) {
	  return {
	    dropTarget: function connectDropTarget() {
	      return backend.connectDropTarget.apply(backend, arguments);
	    }
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createTargetFactory;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _lodashLangIsPlainObject = __webpack_require__(24);
	
	var _lodashLangIsPlainObject2 = _interopRequireDefault(_lodashLangIsPlainObject);
	
	var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];
	
	function createTargetFactory(spec) {
	  Object.keys(spec).forEach(function (key) {
	    _invariant2['default'](ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
	    _invariant2['default'](typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	  });
	
	  var Target = (function () {
	    function Target(monitor) {
	      _classCallCheck(this, Target);
	
	      this.monitor = monitor;
	      this.props = null;
	      this.component = null;
	    }
	
	    Target.prototype.receiveProps = function receiveProps(props) {
	      this.props = props;
	    };
	
	    Target.prototype.receiveMonitor = function receiveMonitor(monitor) {
	      this.monitor = monitor;
	    };
	
	    Target.prototype.receiveComponent = function receiveComponent(component) {
	      this.component = component;
	    };
	
	    Target.prototype.canDrop = function canDrop() {
	      if (!spec.canDrop) {
	        return true;
	      }
	
	      return spec.canDrop(this.props, this.monitor);
	    };
	
	    Target.prototype.hover = function hover() {
	      if (!spec.hover) {
	        return;
	      }
	
	      spec.hover(this.props, this.monitor, this.component);
	    };
	
	    Target.prototype.drop = function drop() {
	      if (!spec.drop) {
	        return;
	      }
	
	      var dropResult = spec.drop(this.props, this.monitor, this.component);
	      if (false) {
	        _invariant2['default'](typeof dropResult === 'undefined' || _lodashLangIsPlainObject2['default'](dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target.html', dropResult);
	      }
	      return dropResult;
	    };
	
	    return Target;
	  })();
	
	  return function createTarget(monitor) {
	    return new Target(monitor);
	  };
	}
	
	module.exports = exports['default'];

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createTargetMonitor;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var isCallingCanDrop = false;
	
	var TargetMonitor = (function () {
	  function TargetMonitor(manager) {
	    _classCallCheck(this, TargetMonitor);
	
	    this.internalMonitor = manager.getMonitor();
	  }
	
	  TargetMonitor.prototype.receiveHandlerId = function receiveHandlerId(targetId) {
	    this.targetId = targetId;
	  };
	
	  TargetMonitor.prototype.canDrop = function canDrop() {
	    _invariant2['default'](!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://gaearon.github.io/react-dnd/docs-drop-target-monitor.html');
	
	    try {
	      isCallingCanDrop = true;
	      return this.internalMonitor.canDropOnTarget(this.targetId);
	    } finally {
	      isCallingCanDrop = false;
	    }
	  };
	
	  TargetMonitor.prototype.isOver = function isOver(options) {
	    return this.internalMonitor.isOverTarget(this.targetId, options);
	  };
	
	  TargetMonitor.prototype.getItemType = function getItemType() {
	    return this.internalMonitor.getItemType();
	  };
	
	  TargetMonitor.prototype.getItem = function getItem() {
	    return this.internalMonitor.getItem();
	  };
	
	  TargetMonitor.prototype.getDropResult = function getDropResult() {
	    return this.internalMonitor.getDropResult();
	  };
	
	  TargetMonitor.prototype.didDrop = function didDrop() {
	    return this.internalMonitor.didDrop();
	  };
	
	  TargetMonitor.prototype.getInitialClientOffset = function getInitialClientOffset() {
	    return this.internalMonitor.getInitialClientOffset();
	  };
	
	  TargetMonitor.prototype.getInitialSourceClientOffset = function getInitialSourceClientOffset() {
	    return this.internalMonitor.getInitialSourceClientOffset();
	  };
	
	  TargetMonitor.prototype.getSourceClientOffset = function getSourceClientOffset() {
	    return this.internalMonitor.getSourceClientOffset();
	  };
	
	  TargetMonitor.prototype.getClientOffset = function getClientOffset() {
	    return this.internalMonitor.getClientOffset();
	  };
	
	  TargetMonitor.prototype.getDifferenceFromInitialOffset = function getDifferenceFromInitialOffset() {
	    return this.internalMonitor.getDifferenceFromInitialOffset();
	  };
	
	  return TargetMonitor;
	})();
	
	function createTargetMonitor(manager) {
	  return new TargetMonitor(manager);
	}
	
	module.exports = exports['default'];

/***/ },
/* 249 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = registerSource;
	
	function registerSource(type, source, manager) {
	  var registry = manager.getRegistry();
	  var sourceId = registry.addSource(type, source);
	
	  function unregisterSource() {
	    registry.removeSource(sourceId);
	  }
	
	  return {
	    handlerId: sourceId,
	    unregister: unregisterSource
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 250 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = registerTarget;
	
	function registerTarget(type, target, manager) {
	  var registry = manager.getRegistry();
	  var targetId = registry.addTarget(type, target);
	
	  function unregisterTarget() {
	    registry.removeTarget(targetId);
	  }
	
	  return {
	    handlerId: targetId,
	    unregister: unregisterTarget
	  };
	}
	
	module.exports = exports["default"];

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = cloneWithRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(2);
	
	function cloneWithRef(element, newRef) {
	  var previousRef = element.ref;
	  _invariant2['default'](typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
	
	  return _react.cloneElement(element, {
	    ref: function ref(instance) {
	      newRef(instance);
	
	      if (previousRef) {
	        previousRef(instance);
	      }
	    }
	  });
	}
	
	module.exports = exports['default'];

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(65);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	/**
	 * Represents a group of disposable resources that are disposed together.
	 */
	
	var CompositeDisposable = (function () {
	  function CompositeDisposable() {
	    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
	      disposables[_key] = arguments[_key];
	    }
	
	    _classCallCheck(this, CompositeDisposable);
	
	    if (Array.isArray(disposables[0]) && disposables.length === 1) {
	      disposables = disposables[0];
	    }
	
	    for (var i = 0; i < disposables.length; i++) {
	      if (!_isDisposable2['default'](disposables[i])) {
	        throw new Error('Expected a disposable');
	      }
	    }
	
	    this.disposables = disposables;
	    this.isDisposed = false;
	  }
	
	  /**
	   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
	   * @param {Disposable} item Disposable to add.
	   */
	
	  CompositeDisposable.prototype.add = function add(item) {
	    if (this.isDisposed) {
	      item.dispose();
	    } else {
	      this.disposables.push(item);
	    }
	  };
	
	  /**
	   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
	   * @param {Disposable} item Disposable to remove.
	   * @returns {Boolean} true if found; false otherwise.
	   */
	
	  CompositeDisposable.prototype.remove = function remove(item) {
	    if (this.isDisposed) {
	      return false;
	    }
	
	    var index = this.disposables.indexOf(item);
	    if (index === -1) {
	      return false;
	    }
	
	    this.disposables.splice(index, 1);
	    item.dispose();
	    return true;
	  };
	
	  /**
	   * Disposes all disposables in the group and removes them from the group.
	   */
	
	  CompositeDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    var len = this.disposables.length;
	    var currentDisposables = new Array(len);
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i] = this.disposables[i];
	    }
	
	    this.isDisposed = true;
	    this.disposables = [];
	    this.length = 0;
	
	    for (var i = 0; i < len; i++) {
	      currentDisposables[i].dispose();
	    }
	  };
	
	  return CompositeDisposable;
	})();
	
	exports['default'] = CompositeDisposable;
	module.exports = exports['default'];

/***/ },
/* 253 */
/***/ function(module, exports) {

	"use strict";
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.__esModule = true;
	var noop = function noop() {};
	
	/**
	 * The basic disposable.
	 */
	
	var Disposable = (function () {
	  function Disposable(action) {
	    _classCallCheck(this, Disposable);
	
	    this.isDisposed = false;
	    this.action = action || noop;
	  }
	
	  Disposable.prototype.dispose = function dispose() {
	    if (!this.isDisposed) {
	      this.action.call(null);
	      this.isDisposed = true;
	    }
	  };
	
	  _createClass(Disposable, null, [{
	    key: "empty",
	    enumerable: true,
	    value: { dispose: noop }
	  }]);
	
	  return Disposable;
	})();
	
	exports["default"] = Disposable;
	module.exports = exports["default"];

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	exports.__esModule = true;
	
	var _isDisposable = __webpack_require__(65);
	
	var _isDisposable2 = _interopRequireWildcard(_isDisposable);
	
	var SerialDisposable = (function () {
	  function SerialDisposable() {
	    _classCallCheck(this, SerialDisposable);
	
	    this.isDisposed = false;
	    this.current = null;
	  }
	
	  /**
	   * Gets the underlying disposable.
	   * @return The underlying disposable.
	   */
	
	  SerialDisposable.prototype.getDisposable = function getDisposable() {
	    return this.current;
	  };
	
	  /**
	   * Sets the underlying disposable.
	   * @param {Disposable} value The new underlying disposable.
	   */
	
	  SerialDisposable.prototype.setDisposable = function setDisposable() {
	    var value = arguments[0] === undefined ? null : arguments[0];
	
	    if (value != null && !_isDisposable2['default'](value)) {
	      throw new Error('Expected either an empty value or a valid disposable');
	    }
	
	    var isDisposed = this.isDisposed;
	    var previous = undefined;
	
	    if (!isDisposed) {
	      previous = this.current;
	      this.current = value;
	    }
	
	    if (previous) {
	      previous.dispose();
	    }
	
	    if (isDisposed && value) {
	      value.dispose();
	    }
	  };
	
	  /**
	   * Disposes the underlying disposable as well as all future replacements.
	   */
	
	  SerialDisposable.prototype.dispose = function dispose() {
	    if (this.isDisposed) {
	      return;
	    }
	
	    this.isDisposed = true;
	    var previous = this.current;
	    this.current = null;
	
	    if (previous) {
	      previous.dispose();
	    }
	  };
	
	  return SerialDisposable;
	})();
	
	exports['default'] = SerialDisposable;
	module.exports = exports['default'];

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _reduxLibCreateStore = __webpack_require__(265);
	
	var _reduxLibCreateStore2 = _interopRequireDefault(_reduxLibCreateStore);
	
	var _reducers = __webpack_require__(262);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _actionsDragDrop = __webpack_require__(44);
	
	var dragDropActions = _interopRequireWildcard(_actionsDragDrop);
	
	var _DragDropMonitor = __webpack_require__(256);
	
	var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);
	
	var _HandlerRegistry = __webpack_require__(104);
	
	var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
	var DragDropManager = (function () {
	  function DragDropManager(createBackend) {
	    _classCallCheck(this, DragDropManager);
	
	    var store = _reduxLibCreateStore2['default'](_reducers2['default']);
	
	    this.store = store;
	    this.monitor = new _DragDropMonitor2['default'](store);
	    this.registry = this.monitor.registry;
	    this.backend = createBackend(this);
	
	    store.subscribe(this.handleRefCountChange.bind(this));
	  }
	
	  DragDropManager.prototype.handleRefCountChange = function handleRefCountChange() {
	    var shouldSetUp = this.store.getState().refCount > 0;
	    if (shouldSetUp && !this.isSetUp) {
	      this.backend.setup();
	      this.isSetUp = true;
	    } else if (!shouldSetUp && this.isSetUp) {
	      this.backend.teardown();
	      this.isSetUp = false;
	    }
	  };
	
	  DragDropManager.prototype.getMonitor = function getMonitor() {
	    return this.monitor;
	  };
	
	  DragDropManager.prototype.getBackend = function getBackend() {
	    return this.backend;
	  };
	
	  DragDropManager.prototype.getRegistry = function getRegistry() {
	    return this.registry;
	  };
	
	  DragDropManager.prototype.getActions = function getActions() {
	    var manager = this;
	    var dispatch = this.store.dispatch;
	
	    function bindActionCreator(actionCreator) {
	      return function () {
	        var action = actionCreator.apply(manager, arguments);
	        if (typeof action !== 'undefined') {
	          dispatch(action);
	        }
	      };
	    }
	
	    return Object.keys(dragDropActions).filter(function (key) {
	      return typeof dragDropActions[key] === 'function';
	    }).reduce(function (boundActions, key) {
	      boundActions[key] = bindActionCreator(dragDropActions[key]);
	      return boundActions;
	    }, {});
	  };
	
	  return DragDropManager;
	})();
	
	exports['default'] = DragDropManager;
	module.exports = exports['default'];

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _invariant = __webpack_require__(8);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _utilsMatchesType = __webpack_require__(107);
	
	var _utilsMatchesType2 = _interopRequireDefault(_utilsMatchesType);
	
	var _lodashLangIsArray = __webpack_require__(22);
	
	var _lodashLangIsArray2 = _interopRequireDefault(_lodashLangIsArray);
	
	var _HandlerRegistry = __webpack_require__(104);
	
	var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);
	
	var _reducersDragOffset = __webpack_require__(106);
	
	var _reducersDirtyHandlerIds = __webpack_require__(105);
	
	var DragDropMonitor = (function () {
	  function DragDropMonitor(store) {
	    _classCallCheck(this, DragDropMonitor);
	
	    this.store = store;
	    this.registry = new _HandlerRegistry2['default'](store);
	  }
	
	  DragDropMonitor.prototype.subscribeToStateChange = function subscribeToStateChange(listener) {
	    var _this = this;
	
	    var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var handlerIds = _ref.handlerIds;
	
	    _invariant2['default'](typeof listener === 'function', 'listener must be a function.');
	    _invariant2['default'](typeof handlerIds === 'undefined' || _lodashLangIsArray2['default'](handlerIds), 'handlerIds, when specified, must be an array of strings.');
	
	    var handleChange = function handleChange() {
	      if (_reducersDirtyHandlerIds.areDirty(_this.store.getState().dirtyHandlerIds, handlerIds)) {
	        listener();
	      }
	    };
	
	    return this.store.subscribe(handleChange);
	  };
	
	  DragDropMonitor.prototype.subscribeToOffsetChange = function subscribeToOffsetChange(listener) {
	    var _this2 = this;
	
	    _invariant2['default'](typeof listener === 'function', 'listener must be a function.');
	
	    var previousState = this.store.getState().dragOffset;
	    var handleChange = function handleChange() {
	      var nextState = _this2.store.getState().dragOffset;
	      if (nextState === previousState) {
	        return;
	      }
	
	      previousState = nextState;
	      listener();
	    };
	
	    return this.store.subscribe(handleChange);
	  };
	
	  DragDropMonitor.prototype.canDragSource = function canDragSource(sourceId) {
	    var source = this.registry.getSource(sourceId);
	    _invariant2['default'](source, 'Expected to find a valid source.');
	
	    if (this.isDragging()) {
	      return false;
	    }
	
	    return source.canDrag(this, sourceId);
	  };
	
	  DragDropMonitor.prototype.canDropOnTarget = function canDropOnTarget(targetId) {
	    var target = this.registry.getTarget(targetId);
	    _invariant2['default'](target, 'Expected to find a valid target.');
	
	    if (!this.isDragging() || this.didDrop()) {
	      return false;
	    }
	
	    var targetType = this.registry.getTargetType(targetId);
	    var draggedItemType = this.getItemType();
	    return _utilsMatchesType2['default'](targetType, draggedItemType) && target.canDrop(this, targetId);
	  };
	
	  DragDropMonitor.prototype.isDragging = function isDragging() {
	    return Boolean(this.getItemType());
	  };
	
	  DragDropMonitor.prototype.isDraggingSource = function isDraggingSource(sourceId) {
	    var source = this.registry.getSource(sourceId, true);
	    _invariant2['default'](source, 'Expected to find a valid source.');
	
	    if (!this.isDragging() || !this.isSourcePublic()) {
	      return false;
	    }
	
	    var sourceType = this.registry.getSourceType(sourceId);
	    var draggedItemType = this.getItemType();
	    if (sourceType !== draggedItemType) {
	      return false;
	    }
	
	    return source.isDragging(this, sourceId);
	  };
	
	  DragDropMonitor.prototype.isOverTarget = function isOverTarget(targetId) {
	    var _ref2 = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    var _ref2$shallow = _ref2.shallow;
	    var shallow = _ref2$shallow === undefined ? false : _ref2$shallow;
	
	    if (!this.isDragging()) {
	      return false;
	    }
	
	    var targetType = this.registry.getTargetType(targetId);
	    var draggedItemType = this.getItemType();
	    if (!_utilsMatchesType2['default'](targetType, draggedItemType)) {
	      return false;
	    }
	
	    var targetIds = this.getTargetIds();
	    if (!targetIds.length) {
	      return false;
	    }
	
	    var index = targetIds.indexOf(targetId);
	    if (shallow) {
	      return index === targetIds.length - 1;
	    } else {
	      return index > -1;
	    }
	  };
	
	  DragDropMonitor.prototype.getItemType = function getItemType() {
	    return this.store.getState().dragOperation.itemType;
	  };
	
	  DragDropMonitor.prototype.getItem = function getItem() {
	    return this.store.getState().dragOperation.item;
	  };
	
	  DragDropMonitor.prototype.getSourceId = function getSourceId() {
	    return this.store.getState().dragOperation.sourceId;
	  };
	
	  DragDropMonitor.prototype.getTargetIds = function getTargetIds() {
	    return this.store.getState().dragOperation.targetIds;
	  };
	
	  DragDropMonitor.prototype.getDropResult = function getDropResult() {
	    return this.store.getState().dragOperation.dropResult;
	  };
	
	  DragDropMonitor.prototype.didDrop = function didDrop() {
	    return this.store.getState().dragOperation.didDrop;
	  };
	
	  DragDropMonitor.prototype.isSourcePublic = function isSourcePublic() {
	    return this.store.getState().dragOperation.isSourcePublic;
	  };
	
	  DragDropMonitor.prototype.getInitialClientOffset = function getInitialClientOffset() {
	    return this.store.getState().dragOffset.initialClientOffset;
	  };
	
	  DragDropMonitor.prototype.getInitialSourceClientOffset = function getInitialSourceClientOffset() {
	    return this.store.getState().dragOffset.initialSourceClientOffset;
	  };
	
	  DragDropMonitor.prototype.getClientOffset = function getClientOffset() {
	    return this.store.getState().dragOffset.clientOffset;
	  };
	
	  DragDropMonitor.prototype.getSourceClientOffset = function getSourceClientOffset() {
	    return _reducersDragOffset.getSourceClientOffset(this.store.getState().dragOffset);
	  };
	
	  DragDropMonitor.prototype.getDifferenceFromInitialOffset = function getDifferenceFromInitialOffset() {
	    return _reducersDragOffset.getDifferenceFromInitialOffset(this.store.getState().dragOffset);
	  };
	
	  return DragDropMonitor;
	})();
	
	exports['default'] = DragDropMonitor;
	module.exports = exports['default'];

/***/ },
/* 257 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DragSource = (function () {
	  function DragSource() {
	    _classCallCheck(this, DragSource);
	  }
	
	  DragSource.prototype.canDrag = function canDrag() {
	    return true;
	  };
	
	  DragSource.prototype.isDragging = function isDragging(monitor, handle) {
	    return handle === monitor.getSourceId();
	  };
	
	  DragSource.prototype.endDrag = function endDrag() {};
	
	  return DragSource;
	})();
	
	exports["default"] = DragSource;
	module.exports = exports["default"];

/***/ },
/* 258 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var DropTarget = (function () {
	  function DropTarget() {
	    _classCallCheck(this, DropTarget);
	  }
	
	  DropTarget.prototype.canDrop = function canDrop() {
	    return true;
	  };
	
	  DropTarget.prototype.hover = function hover() {};
	
	  DropTarget.prototype.drop = function drop() {};
	
	  return DropTarget;
	})();
	
	exports["default"] = DropTarget;
	module.exports = exports["default"];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = createBackend;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodashUtilityNoop = __webpack_require__(287);
	
	var _lodashUtilityNoop2 = _interopRequireDefault(_lodashUtilityNoop);
	
	var TestBackend = (function () {
	  function TestBackend(manager) {
	    _classCallCheck(this, TestBackend);
	
	    this.actions = manager.getActions();
	  }
	
	  TestBackend.prototype.setup = function setup() {
	    this.didCallSetup = true;
	  };
	
	  TestBackend.prototype.teardown = function teardown() {
	    this.didCallTeardown = true;
	  };
	
	  TestBackend.prototype.connectDragSource = function connectDragSource() {
	    return _lodashUtilityNoop2['default'];
	  };
	
	  TestBackend.prototype.connectDragPreview = function connectDragPreview() {
	    return _lodashUtilityNoop2['default'];
	  };
	
	  TestBackend.prototype.connectDropTarget = function connectDropTarget() {
	    return _lodashUtilityNoop2['default'];
	  };
	
	  TestBackend.prototype.simulateBeginDrag = function simulateBeginDrag(sourceIds, options) {
	    this.actions.beginDrag(sourceIds, options);
	  };
	
	  TestBackend.prototype.simulatePublishDragSource = function simulatePublishDragSource() {
	    this.actions.publishDragSource();
	  };
	
	  TestBackend.prototype.simulateHover = function simulateHover(targetIds, options) {
	    this.actions.hover(targetIds, options);
	  };
	
	  TestBackend.prototype.simulateDrop = function simulateDrop() {
	    this.actions.drop();
	  };
	
	  TestBackend.prototype.simulateEndDrag = function simulateEndDrag() {
	    this.actions.endDrag();
	  };
	
	  return TestBackend;
	})();
	
	function createBackend(manager) {
	  return new TestBackend(manager);
	}
	
	module.exports = exports['default'];

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _DragDropManager = __webpack_require__(255);
	
	exports.DragDropManager = _interopRequire(_DragDropManager);
	
	var _DragSource = __webpack_require__(257);
	
	exports.DragSource = _interopRequire(_DragSource);
	
	var _DropTarget = __webpack_require__(258);
	
	exports.DropTarget = _interopRequire(_DropTarget);
	
	var _backendsCreateTestBackend = __webpack_require__(259);
	
	exports.createTestBackend = _interopRequire(_backendsCreateTestBackend);

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = dragOperation;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _actionsDragDrop = __webpack_require__(44);
	
	var _actionsRegistry = __webpack_require__(45);
	
	var _lodashArrayWithout = __webpack_require__(270);
	
	var _lodashArrayWithout2 = _interopRequireDefault(_lodashArrayWithout);
	
	var initialState = {
	  itemType: null,
	  item: null,
	  sourceId: null,
	  targetIds: [],
	  dropResult: null,
	  didDrop: false,
	  isSourcePublic: null
	};
	
	function dragOperation(state, action) {
	  if (state === undefined) state = initialState;
	
	  switch (action.type) {
	    case _actionsDragDrop.BEGIN_DRAG:
	      return _extends({}, state, {
	        itemType: action.itemType,
	        item: action.item,
	        sourceId: action.sourceId,
	        isSourcePublic: action.isSourcePublic,
	        dropResult: null,
	        didDrop: false
	      });
	    case _actionsDragDrop.PUBLISH_DRAG_SOURCE:
	      return _extends({}, state, {
	        isSourcePublic: true
	      });
	    case _actionsDragDrop.HOVER:
	      return _extends({}, state, {
	        targetIds: action.targetIds
	      });
	    case _actionsDragDrop.PUBLISH_DRAG_SOURCE:
	      return _extends({}, state, {
	        isSourcePublic: true
	      });
	    case _actionsRegistry.REMOVE_TARGET:
	      if (state.targetIds.indexOf(action.targetId) === -1) {
	        return state;
	      }
	      return _extends({}, state, {
	        targetIds: _lodashArrayWithout2['default'](state.targetIds, action.targetId)
	      });
	    case _actionsDragDrop.DROP:
	      return _extends({}, state, {
	        dropResult: action.dropResult,
	        didDrop: true,
	        targetIds: []
	      });
	    case _actionsDragDrop.END_DRAG:
	      return _extends({}, state, {
	        itemType: null,
	        item: null,
	        sourceId: null,
	        dropResult: null,
	        didDrop: false,
	        isSourcePublic: null,
	        targetIds: []
	      });
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _dragOffset = __webpack_require__(106);
	
	var _dragOffset2 = _interopRequireDefault(_dragOffset);
	
	var _dragOperation = __webpack_require__(261);
	
	var _dragOperation2 = _interopRequireDefault(_dragOperation);
	
	var _refCount = __webpack_require__(263);
	
	var _refCount2 = _interopRequireDefault(_refCount);
	
	var _dirtyHandlerIds = __webpack_require__(105);
	
	var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);
	
	exports['default'] = function (state, action) {
	  if (state === undefined) state = {};
	
	  return {
	    dirtyHandlerIds: _dirtyHandlerIds2['default'](state.dirtyHandlerIds, action, state.dragOperation),
	    dragOffset: _dragOffset2['default'](state.dragOffset, action),
	    refCount: _refCount2['default'](state.refCount, action),
	    dragOperation: _dragOperation2['default'](state.dragOperation, action)
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = refCount;
	
	var _actionsRegistry = __webpack_require__(45);
	
	function refCount(state, action) {
	  if (state === undefined) state = 0;
	
	  switch (action.type) {
	    case _actionsRegistry.ADD_SOURCE:
	    case _actionsRegistry.ADD_TARGET:
	      return state + 1;
	    case _actionsRegistry.REMOVE_SOURCE:
	    case _actionsRegistry.REMOVE_TARGET:
	      return state - 1;
	    default:
	      return state;
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 264 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getNextUniqueId;
	var nextUniqueId = 0;
	
	function getNextUniqueId() {
	  return nextUniqueId++;
	}
	
	module.exports = exports["default"];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(268);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all states changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  };
	}

/***/ },
/* 266 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 267 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var isHostObject = __webpack_require__(266),
	    isObjectLike = __webpack_require__(267);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var getPrototypeOf = Object.getPrototypeOf;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = objectProto;
	  if (typeof value.constructor == 'function') {
	    proto = getPrototypeOf(value);
	  }
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(66),
	    cacheIndexOf = __webpack_require__(67),
	    createCache = __webpack_require__(68),
	    isArrayLike = __webpack_require__(46),
	    restParam = __webpack_require__(108);
	
	/**
	 * Creates an array of unique values that are included in all of the provided
	 * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of shared values.
	 * @example
	 * _.intersection([1, 2], [4, 2], [2, 1]);
	 * // => [2]
	 */
	var intersection = restParam(function(arrays) {
	  var othLength = arrays.length,
	      othIndex = othLength,
	      caches = Array(length),
	      indexOf = baseIndexOf,
	      isCommon = true,
	      result = [];
	
	  while (othIndex--) {
	    var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	    caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	  }
	  var array = arrays[0],
	      index = -1,
	      length = array ? array.length : 0,
	      seen = caches[0];
	
	  outer:
	  while (++index < length) {
	    value = array[index];
	    if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	      var othIndex = othLength;
	      while (--othIndex) {
	        var cache = caches[othIndex];
	        if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	          continue outer;
	        }
	      }
	      if (seen) {
	        seen.push(value);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	});
	
	module.exports = intersection;


/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(109),
	    isArrayLike = __webpack_require__(46),
	    restParam = __webpack_require__(108);
	
	/**
	 * Creates an array excluding all provided values using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to filter.
	 * @param {...*} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.without([1, 2, 1, 3], 1, 2);
	 * // => [3]
	 */
	var without = restParam(function(array, values) {
	  return isArrayLike(array)
	    ? baseDifference(array, values)
	    : [];
	});
	
	module.exports = without;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(273),
	    baseDifference = __webpack_require__(109),
	    baseUniq = __webpack_require__(277),
	    isArrayLike = __webpack_require__(46);
	
	/**
	 * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	 * of the provided arrays.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of values.
	 * @example
	 *
	 * _.xor([1, 2], [4, 2]);
	 * // => [1, 4]
	 */
	function xor() {
	  var index = -1,
	      length = arguments.length;
	
	  while (++index < length) {
	    var array = arguments[index];
	    if (isArrayLike(array)) {
	      var result = result
	        ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	        : array;
	    }
	  }
	  return result ? baseUniq(result) : [];
	}
	
	module.exports = xor;


/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(278),
	    getNative = __webpack_require__(69);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 273 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(279);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(274),
	    keysIn = __webpack_require__(286);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ },
/* 276 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(66),
	    cacheIndexOf = __webpack_require__(67),
	    createCache = __webpack_require__(68);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(283);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(276);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 281 */
/***/ function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ },
/* 282 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(23);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(284),
	    isObjectLike = __webpack_require__(47);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(110),
	    isArray = __webpack_require__(22),
	    isIndex = __webpack_require__(282),
	    isLength = __webpack_require__(70),
	    isObject = __webpack_require__(23);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 287 */
/***/ function(module, exports) {

	/**
	 * A no-operation function that returns `undefined` regardless of the
	 * arguments it receives.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.noop(object) === undefined;
	 * // => true
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(7);
	
	var findDOMNode = __webpack_require__(79);
	var focusNode = __webpack_require__(142);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var EventPropagators = __webpack_require__(30);
	var ExecutionEnvironment = __webpack_require__(6);
	var FallbackCompositionState = __webpack_require__(297);
	var SyntheticCompositionEvent = __webpack_require__(327);
	var SyntheticInputEvent = __webpack_require__(330);
	
	var keyOf = __webpack_require__(17);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(112);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactPerf = __webpack_require__(10);
	
	var camelizeStyleName = __webpack_require__(344);
	var dangerousStyleValue = __webpack_require__(335);
	var hyphenateStyleName = __webpack_require__(349);
	var memoizeStringOnly = __webpack_require__(353);
	var warning = __webpack_require__(4);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var EventPluginHub = __webpack_require__(29);
	var EventPropagators = __webpack_require__(30);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactUpdates = __webpack_require__(11);
	var SyntheticEvent = __webpack_require__(20);
	
	var getEventTarget = __webpack_require__(82);
	var isEventSupported = __webpack_require__(85);
	var isTextInputElement = __webpack_require__(139);
	var keyOf = __webpack_require__(17);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 292 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var createNodesFromMarkup = __webpack_require__(346);
	var emptyFunction = __webpack_require__(12);
	var getMarkupWrap = __webpack_require__(144);
	var invariant = __webpack_require__(1);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(17);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var EventPropagators = __webpack_require__(30);
	var SyntheticMouseEvent = __webpack_require__(51);
	
	var ReactMount = __webpack_require__(7);
	var keyOf = __webpack_require__(17);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var ReactErrorUtils = __webpack_require__(127);
	
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(16);
	
	var assign = __webpack_require__(3);
	var getTextContentAccessor = __webpack_require__(138);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	var ExecutionEnvironment = __webpack_require__(6);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: MUST_USE_ATTRIBUTE,
	    autoCorrect: MUST_USE_ATTRIBUTE,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoComplete: 'autocomplete',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(118);
	var ReactDOMServer = __webpack_require__(309);
	var ReactIsomorphic = __webpack_require__(314);
	
	var assign = __webpack_require__(3);
	var deprecated = __webpack_require__(336);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(31);
	
	var findDOMNode = __webpack_require__(79);
	var warning = __webpack_require__(4);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(19);
	
	var instantiateReactComponent = __webpack_require__(84);
	var shouldUpdateReactComponent = __webpack_require__(87);
	var traverseAllChildren = __webpack_require__(88);
	var warning = __webpack_require__(4);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(75);
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactElement = __webpack_require__(9);
	var ReactInstanceMap = __webpack_require__(31);
	var ReactPerf = __webpack_require__(10);
	var ReactPropTypeLocations = __webpack_require__(50);
	var ReactPropTypeLocationNames = __webpack_require__(49);
	var ReactReconciler = __webpack_require__(19);
	var ReactUpdateQueue = __webpack_require__(77);
	
	var assign = __webpack_require__(3);
	var emptyObject = __webpack_require__(33);
	var invariant = __webpack_require__(1);
	var shouldUpdateReactComponent = __webpack_require__(87);
	var warning = __webpack_require__(4);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 303 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(288);
	var CSSPropertyOperations = __webpack_require__(290);
	var DOMProperty = __webpack_require__(25);
	var DOMPropertyOperations = __webpack_require__(72);
	var EventConstants = __webpack_require__(13);
	var ReactBrowserEventEmitter = __webpack_require__(48);
	var ReactComponentBrowserEnvironment = __webpack_require__(74);
	var ReactDOMButton = __webpack_require__(303);
	var ReactDOMInput = __webpack_require__(306);
	var ReactDOMOption = __webpack_require__(307);
	var ReactDOMSelect = __webpack_require__(120);
	var ReactDOMTextarea = __webpack_require__(310);
	var ReactMount = __webpack_require__(7);
	var ReactMultiChild = __webpack_require__(315);
	var ReactPerf = __webpack_require__(10);
	var ReactUpdateQueue = __webpack_require__(77);
	
	var assign = __webpack_require__(3);
	var canDefineProperty = __webpack_require__(53);
	var escapeTextContentForBrowser = __webpack_require__(54);
	var invariant = __webpack_require__(1);
	var isEventSupported = __webpack_require__(85);
	var keyOf = __webpack_require__(17);
	var setInnerHTML = __webpack_require__(55);
	var setTextContent = __webpack_require__(86);
	var shallowEqual = __webpack_require__(145);
	var validateDOMNesting = __webpack_require__(89);
	var warning = __webpack_require__(4);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(9);
	var ReactElementValidator = __webpack_require__(124);
	
	var mapObject = __webpack_require__(352);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(76);
	var LinkedValueUtils = __webpack_require__(73);
	var ReactMount = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(11);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(115);
	var ReactDOMSelect = __webpack_require__(120);
	
	var assign = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    if (content) {
	      nativeProps.children = content;
	    }
	
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var getNodeForCharacterOffset = __webpack_require__(339);
	var getTextContentAccessor = __webpack_require__(138);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(123);
	var ReactServerRendering = __webpack_require__(320);
	var ReactVersion = __webpack_require__(78);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(73);
	var ReactDOMIDOperations = __webpack_require__(76);
	var ReactUpdates = __webpack_require__(11);
	
	var assign = __webpack_require__(3);
	var invariant = __webpack_require__(1);
	var warning = __webpack_require__(4);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(29);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(140);
	var ExecutionEnvironment = __webpack_require__(6);
	var PooledClass = __webpack_require__(16);
	var ReactInstanceHandles = __webpack_require__(26);
	var ReactMount = __webpack_require__(7);
	var ReactUpdates = __webpack_require__(11);
	
	var assign = __webpack_require__(3);
	var getEventTarget = __webpack_require__(82);
	var getUnboundedScrollPosition = __webpack_require__(347);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	var EventPluginHub = __webpack_require__(29);
	var ReactComponentEnvironment = __webpack_require__(75);
	var ReactClass = __webpack_require__(116);
	var ReactEmptyComponent = __webpack_require__(125);
	var ReactBrowserEventEmitter = __webpack_require__(48);
	var ReactNativeComponent = __webpack_require__(131);
	var ReactPerf = __webpack_require__(10);
	var ReactRootIndex = __webpack_require__(134);
	var ReactUpdates = __webpack_require__(11);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(115);
	var ReactComponent = __webpack_require__(117);
	var ReactClass = __webpack_require__(116);
	var ReactDOMFactories = __webpack_require__(305);
	var ReactElement = __webpack_require__(9);
	var ReactElementValidator = __webpack_require__(124);
	var ReactPropTypes = __webpack_require__(133);
	var ReactVersion = __webpack_require__(78);
	
	var assign = __webpack_require__(3);
	var onlyChild = __webpack_require__(340);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(75);
	var ReactMultiChildUpdateTypes = __webpack_require__(130);
	
	var ReactCurrentOwner = __webpack_require__(14);
	var ReactReconciler = __webpack_require__(19);
	var ReactChildReconciler = __webpack_require__(301);
	
	var flattenChildren = __webpack_require__(337);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(71);
	var PooledClass = __webpack_require__(16);
	var ReactBrowserEventEmitter = __webpack_require__(48);
	var ReactDOMFeatureFlags = __webpack_require__(119);
	var ReactInputSelection = __webpack_require__(128);
	var Transaction = __webpack_require__(52);
	
	var assign = __webpack_require__(3);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(316);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 319 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(122);
	var ReactElement = __webpack_require__(9);
	var ReactInstanceHandles = __webpack_require__(26);
	var ReactMarkupChecksum = __webpack_require__(129);
	var ReactServerBatchingStrategy = __webpack_require__(319);
	var ReactServerRenderingTransaction = __webpack_require__(321);
	var ReactUpdates = __webpack_require__(11);
	
	var emptyObject = __webpack_require__(33);
	var instantiateReactComponent = __webpack_require__(84);
	var invariant = __webpack_require__(1);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(16);
	var CallbackQueue = __webpack_require__(71);
	var Transaction = __webpack_require__(52);
	
	var assign = __webpack_require__(3);
	var emptyFunction = __webpack_require__(12);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var EventPropagators = __webpack_require__(30);
	var ExecutionEnvironment = __webpack_require__(6);
	var ReactInputSelection = __webpack_require__(128);
	var SyntheticEvent = __webpack_require__(20);
	
	var getActiveElement = __webpack_require__(143);
	var isTextInputElement = __webpack_require__(139);
	var keyOf = __webpack_require__(17);
	var shallowEqual = __webpack_require__(145);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 324 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(13);
	var EventListener = __webpack_require__(140);
	var EventPropagators = __webpack_require__(30);
	var ReactMount = __webpack_require__(7);
	var SyntheticClipboardEvent = __webpack_require__(326);
	var SyntheticEvent = __webpack_require__(20);
	var SyntheticFocusEvent = __webpack_require__(329);
	var SyntheticKeyboardEvent = __webpack_require__(331);
	var SyntheticMouseEvent = __webpack_require__(51);
	var SyntheticDragEvent = __webpack_require__(328);
	var SyntheticTouchEvent = __webpack_require__(332);
	var SyntheticUIEvent = __webpack_require__(32);
	var SyntheticWheelEvent = __webpack_require__(333);
	
	var emptyFunction = __webpack_require__(12);
	var getEventCharCode = __webpack_require__(80);
	var invariant = __webpack_require__(1);
	var keyOf = __webpack_require__(17);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(20);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(20);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(51);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(20);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	
	var getEventCharCode = __webpack_require__(80);
	var getEventKey = __webpack_require__(338);
	var getEventModifierState = __webpack_require__(81);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(32);
	
	var getEventModifierState = __webpack_require__(81);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(51);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(112);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(3);
	var warning = __webpack_require__(4);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(88);
	var warning = __webpack_require__(4);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(80);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 339 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(9);
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(54);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(7);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 343 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(343);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(354);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(6);
	
	var createArrayFromMixed = __webpack_require__(345);
	var getMarkupWrap = __webpack_require__(144);
	var invariant = __webpack_require__(1);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 347 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 348 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(348);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 350 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(350);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 352 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 353 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(1);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var lookup = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	
	;(function (exports) {
		'use strict';
	
	  var Arr = (typeof Uint8Array !== 'undefined')
	    ? Uint8Array
	    : Array
	
		var PLUS   = '+'.charCodeAt(0)
		var SLASH  = '/'.charCodeAt(0)
		var NUMBER = '0'.charCodeAt(0)
		var LOWER  = 'a'.charCodeAt(0)
		var UPPER  = 'A'.charCodeAt(0)
		var PLUS_URL_SAFE = '-'.charCodeAt(0)
		var SLASH_URL_SAFE = '_'.charCodeAt(0)
	
		function decode (elt) {
			var code = elt.charCodeAt(0)
			if (code === PLUS ||
			    code === PLUS_URL_SAFE)
				return 62 // '+'
			if (code === SLASH ||
			    code === SLASH_URL_SAFE)
				return 63 // '/'
			if (code < NUMBER)
				return -1 //no match
			if (code < NUMBER + 10)
				return code - NUMBER + 26 + 26
			if (code < UPPER + 26)
				return code - UPPER
			if (code < LOWER + 26)
				return code - LOWER + 26
		}
	
		function b64ToByteArray (b64) {
			var i, j, l, tmp, placeHolders, arr
	
			if (b64.length % 4 > 0) {
				throw new Error('Invalid string. Length must be a multiple of 4')
			}
	
			// the number of equal signs (place holders)
			// if there are two placeholders, than the two characters before it
			// represent one byte
			// if there is only one, then the three characters before it represent 2 bytes
			// this is just a cheap hack to not do indexOf twice
			var len = b64.length
			placeHolders = '=' === b64.charAt(len - 2) ? 2 : '=' === b64.charAt(len - 1) ? 1 : 0
	
			// base64 is 4/3 + up to two characters of the original data
			arr = new Arr(b64.length * 3 / 4 - placeHolders)
	
			// if there are placeholders, only get up to the last complete 4 chars
			l = placeHolders > 0 ? b64.length - 4 : b64.length
	
			var L = 0
	
			function push (v) {
				arr[L++] = v
			}
	
			for (i = 0, j = 0; i < l; i += 4, j += 3) {
				tmp = (decode(b64.charAt(i)) << 18) | (decode(b64.charAt(i + 1)) << 12) | (decode(b64.charAt(i + 2)) << 6) | decode(b64.charAt(i + 3))
				push((tmp & 0xFF0000) >> 16)
				push((tmp & 0xFF00) >> 8)
				push(tmp & 0xFF)
			}
	
			if (placeHolders === 2) {
				tmp = (decode(b64.charAt(i)) << 2) | (decode(b64.charAt(i + 1)) >> 4)
				push(tmp & 0xFF)
			} else if (placeHolders === 1) {
				tmp = (decode(b64.charAt(i)) << 10) | (decode(b64.charAt(i + 1)) << 4) | (decode(b64.charAt(i + 2)) >> 2)
				push((tmp >> 8) & 0xFF)
				push(tmp & 0xFF)
			}
	
			return arr
		}
	
		function uint8ToBase64 (uint8) {
			var i,
				extraBytes = uint8.length % 3, // if we have 1 byte left, pad 2 bytes
				output = "",
				temp, length
	
			function encode (num) {
				return lookup.charAt(num)
			}
	
			function tripletToBase64 (num) {
				return encode(num >> 18 & 0x3F) + encode(num >> 12 & 0x3F) + encode(num >> 6 & 0x3F) + encode(num & 0x3F)
			}
	
			// go through the array every three bytes, we'll deal with trailing stuff later
			for (i = 0, length = uint8.length - extraBytes; i < length; i += 3) {
				temp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
				output += tripletToBase64(temp)
			}
	
			// pad the end with zeros, but make sure to not forget the extra bytes
			switch (extraBytes) {
				case 1:
					temp = uint8[uint8.length - 1]
					output += encode(temp >> 2)
					output += encode((temp << 4) & 0x3F)
					output += '=='
					break
				case 2:
					temp = (uint8[uint8.length - 2] << 8) + (uint8[uint8.length - 1])
					output += encode(temp >> 10)
					output += encode((temp >> 4) & 0x3F)
					output += encode((temp << 2) & 0x3F)
					output += '='
					break
			}
	
			return output
		}
	
		exports.toByteArray = b64ToByteArray
		exports.fromByteArray = uint8ToBase64
	}( false ? (this.base64js = {}) : exports))


/***/ },
/* 356 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 357 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 358 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};


/***/ },
/* 359 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return map(objectKeys(obj), function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (isArray(obj[k])) {
	        return map(obj[k], function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};
	
	var isArray = Array.isArray || function (xs) {
	  return Object.prototype.toString.call(xs) === '[object Array]';
	};
	
	function map (xs, f) {
	  if (xs.map) return xs.map(f);
	  var res = [];
	  for (var i = 0; i < xs.length; i++) {
	    res.push(f(xs[i], i));
	  }
	  return res;
	}
	
	var objectKeys = Object.keys || function (obj) {
	  var res = [];
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
	  }
	  return res;
	};


/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(358);
	exports.encode = exports.stringify = __webpack_require__(359);


/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/